(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0c14"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0c14"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("10cKx", function(module, exports) {
module.exports = $;

});

parcelRegister("4sa5r", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";

var $25lfa = parcelRequire("25lfa");

var $jaL9i = parcelRequire("jaL9i");

var $bw8Od = parcelRequire("bw8Od");

var $4fFEF = parcelRequire("4fFEF");
function $33e199f976d0aeaa$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $33e199f976d0aeaa$var$BigIntSupported = typeof BigInt !== "undefined";
var $33e199f976d0aeaa$var$SymbolSupported = typeof Symbol !== "undefined";
var $33e199f976d0aeaa$var$ObjectToString = $33e199f976d0aeaa$var$uncurryThis(Object.prototype.toString);
var $33e199f976d0aeaa$var$numberValue = $33e199f976d0aeaa$var$uncurryThis(Number.prototype.valueOf);
var $33e199f976d0aeaa$var$stringValue = $33e199f976d0aeaa$var$uncurryThis(String.prototype.valueOf);
var $33e199f976d0aeaa$var$booleanValue = $33e199f976d0aeaa$var$uncurryThis(Boolean.prototype.valueOf);
if ($33e199f976d0aeaa$var$BigIntSupported) var $33e199f976d0aeaa$var$bigIntValue = $33e199f976d0aeaa$var$uncurryThis(BigInt.prototype.valueOf);
if ($33e199f976d0aeaa$var$SymbolSupported) var $33e199f976d0aeaa$var$symbolValue = $33e199f976d0aeaa$var$uncurryThis(Symbol.prototype.valueOf);
function $33e199f976d0aeaa$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== "object") return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $25lfa;
module.exports.isGeneratorFunction = $jaL9i;
module.exports.isTypedArray = $4fFEF;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $33e199f976d0aeaa$var$isPromise(input) {
    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
}
module.exports.isPromise = $33e199f976d0aeaa$var$isPromise;
function $33e199f976d0aeaa$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $4fFEF(value) || $33e199f976d0aeaa$var$isDataView(value);
}
module.exports.isArrayBufferView = $33e199f976d0aeaa$var$isArrayBufferView;
function $33e199f976d0aeaa$var$isUint8Array(value) {
    return $bw8Od(value) === "Uint8Array";
}
module.exports.isUint8Array = $33e199f976d0aeaa$var$isUint8Array;
function $33e199f976d0aeaa$var$isUint8ClampedArray(value) {
    return $bw8Od(value) === "Uint8ClampedArray";
}
module.exports.isUint8ClampedArray = $33e199f976d0aeaa$var$isUint8ClampedArray;
function $33e199f976d0aeaa$var$isUint16Array(value) {
    return $bw8Od(value) === "Uint16Array";
}
module.exports.isUint16Array = $33e199f976d0aeaa$var$isUint16Array;
function $33e199f976d0aeaa$var$isUint32Array(value) {
    return $bw8Od(value) === "Uint32Array";
}
module.exports.isUint32Array = $33e199f976d0aeaa$var$isUint32Array;
function $33e199f976d0aeaa$var$isInt8Array(value) {
    return $bw8Od(value) === "Int8Array";
}
module.exports.isInt8Array = $33e199f976d0aeaa$var$isInt8Array;
function $33e199f976d0aeaa$var$isInt16Array(value) {
    return $bw8Od(value) === "Int16Array";
}
module.exports.isInt16Array = $33e199f976d0aeaa$var$isInt16Array;
function $33e199f976d0aeaa$var$isInt32Array(value) {
    return $bw8Od(value) === "Int32Array";
}
module.exports.isInt32Array = $33e199f976d0aeaa$var$isInt32Array;
function $33e199f976d0aeaa$var$isFloat32Array(value) {
    return $bw8Od(value) === "Float32Array";
}
module.exports.isFloat32Array = $33e199f976d0aeaa$var$isFloat32Array;
function $33e199f976d0aeaa$var$isFloat64Array(value) {
    return $bw8Od(value) === "Float64Array";
}
module.exports.isFloat64Array = $33e199f976d0aeaa$var$isFloat64Array;
function $33e199f976d0aeaa$var$isBigInt64Array(value) {
    return $bw8Od(value) === "BigInt64Array";
}
module.exports.isBigInt64Array = $33e199f976d0aeaa$var$isBigInt64Array;
function $33e199f976d0aeaa$var$isBigUint64Array(value) {
    return $bw8Od(value) === "BigUint64Array";
}
module.exports.isBigUint64Array = $33e199f976d0aeaa$var$isBigUint64Array;
function $33e199f976d0aeaa$var$isMapToString(value) {
    return $33e199f976d0aeaa$var$ObjectToString(value) === "[object Map]";
}
$33e199f976d0aeaa$var$isMapToString.working = typeof Map !== "undefined" && $33e199f976d0aeaa$var$isMapToString(new Map());
function $33e199f976d0aeaa$var$isMap(value) {
    if (typeof Map === "undefined") return false;
    return $33e199f976d0aeaa$var$isMapToString.working ? $33e199f976d0aeaa$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $33e199f976d0aeaa$var$isMap;
function $33e199f976d0aeaa$var$isSetToString(value) {
    return $33e199f976d0aeaa$var$ObjectToString(value) === "[object Set]";
}
$33e199f976d0aeaa$var$isSetToString.working = typeof Set !== "undefined" && $33e199f976d0aeaa$var$isSetToString(new Set());
function $33e199f976d0aeaa$var$isSet(value) {
    if (typeof Set === "undefined") return false;
    return $33e199f976d0aeaa$var$isSetToString.working ? $33e199f976d0aeaa$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $33e199f976d0aeaa$var$isSet;
function $33e199f976d0aeaa$var$isWeakMapToString(value) {
    return $33e199f976d0aeaa$var$ObjectToString(value) === "[object WeakMap]";
}
$33e199f976d0aeaa$var$isWeakMapToString.working = typeof WeakMap !== "undefined" && $33e199f976d0aeaa$var$isWeakMapToString(new WeakMap());
function $33e199f976d0aeaa$var$isWeakMap(value) {
    if (typeof WeakMap === "undefined") return false;
    return $33e199f976d0aeaa$var$isWeakMapToString.working ? $33e199f976d0aeaa$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $33e199f976d0aeaa$var$isWeakMap;
function $33e199f976d0aeaa$var$isWeakSetToString(value) {
    return $33e199f976d0aeaa$var$ObjectToString(value) === "[object WeakSet]";
}
$33e199f976d0aeaa$var$isWeakSetToString.working = typeof WeakSet !== "undefined" && $33e199f976d0aeaa$var$isWeakSetToString(new WeakSet());
function $33e199f976d0aeaa$var$isWeakSet(value) {
    return $33e199f976d0aeaa$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $33e199f976d0aeaa$var$isWeakSet;
function $33e199f976d0aeaa$var$isArrayBufferToString(value) {
    return $33e199f976d0aeaa$var$ObjectToString(value) === "[object ArrayBuffer]";
}
$33e199f976d0aeaa$var$isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && $33e199f976d0aeaa$var$isArrayBufferToString(new ArrayBuffer());
function $33e199f976d0aeaa$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === "undefined") return false;
    return $33e199f976d0aeaa$var$isArrayBufferToString.working ? $33e199f976d0aeaa$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $33e199f976d0aeaa$var$isArrayBuffer;
function $33e199f976d0aeaa$var$isDataViewToString(value) {
    return $33e199f976d0aeaa$var$ObjectToString(value) === "[object DataView]";
}
$33e199f976d0aeaa$var$isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && $33e199f976d0aeaa$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $33e199f976d0aeaa$var$isDataView(value) {
    if (typeof DataView === "undefined") return false;
    return $33e199f976d0aeaa$var$isDataViewToString.working ? $33e199f976d0aeaa$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $33e199f976d0aeaa$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $33e199f976d0aeaa$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
function $33e199f976d0aeaa$var$isSharedArrayBufferToString(value) {
    return $33e199f976d0aeaa$var$ObjectToString(value) === "[object SharedArrayBuffer]";
}
function $33e199f976d0aeaa$var$isSharedArrayBuffer(value) {
    if (typeof $33e199f976d0aeaa$var$SharedArrayBufferCopy === "undefined") return false;
    if (typeof $33e199f976d0aeaa$var$isSharedArrayBufferToString.working === "undefined") $33e199f976d0aeaa$var$isSharedArrayBufferToString.working = $33e199f976d0aeaa$var$isSharedArrayBufferToString(new $33e199f976d0aeaa$var$SharedArrayBufferCopy());
    return $33e199f976d0aeaa$var$isSharedArrayBufferToString.working ? $33e199f976d0aeaa$var$isSharedArrayBufferToString(value) : value instanceof $33e199f976d0aeaa$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $33e199f976d0aeaa$var$isSharedArrayBuffer;
function $33e199f976d0aeaa$var$isAsyncFunction(value) {
    return $33e199f976d0aeaa$var$ObjectToString(value) === "[object AsyncFunction]";
}
module.exports.isAsyncFunction = $33e199f976d0aeaa$var$isAsyncFunction;
function $33e199f976d0aeaa$var$isMapIterator(value) {
    return $33e199f976d0aeaa$var$ObjectToString(value) === "[object Map Iterator]";
}
module.exports.isMapIterator = $33e199f976d0aeaa$var$isMapIterator;
function $33e199f976d0aeaa$var$isSetIterator(value) {
    return $33e199f976d0aeaa$var$ObjectToString(value) === "[object Set Iterator]";
}
module.exports.isSetIterator = $33e199f976d0aeaa$var$isSetIterator;
function $33e199f976d0aeaa$var$isGeneratorObject(value) {
    return $33e199f976d0aeaa$var$ObjectToString(value) === "[object Generator]";
}
module.exports.isGeneratorObject = $33e199f976d0aeaa$var$isGeneratorObject;
function $33e199f976d0aeaa$var$isWebAssemblyCompiledModule(value) {
    return $33e199f976d0aeaa$var$ObjectToString(value) === "[object WebAssembly.Module]";
}
module.exports.isWebAssemblyCompiledModule = $33e199f976d0aeaa$var$isWebAssemblyCompiledModule;
function $33e199f976d0aeaa$var$isNumberObject(value) {
    return $33e199f976d0aeaa$var$checkBoxedPrimitive(value, $33e199f976d0aeaa$var$numberValue);
}
module.exports.isNumberObject = $33e199f976d0aeaa$var$isNumberObject;
function $33e199f976d0aeaa$var$isStringObject(value) {
    return $33e199f976d0aeaa$var$checkBoxedPrimitive(value, $33e199f976d0aeaa$var$stringValue);
}
module.exports.isStringObject = $33e199f976d0aeaa$var$isStringObject;
function $33e199f976d0aeaa$var$isBooleanObject(value) {
    return $33e199f976d0aeaa$var$checkBoxedPrimitive(value, $33e199f976d0aeaa$var$booleanValue);
}
module.exports.isBooleanObject = $33e199f976d0aeaa$var$isBooleanObject;
function $33e199f976d0aeaa$var$isBigIntObject(value) {
    return $33e199f976d0aeaa$var$BigIntSupported && $33e199f976d0aeaa$var$checkBoxedPrimitive(value, $33e199f976d0aeaa$var$bigIntValue);
}
module.exports.isBigIntObject = $33e199f976d0aeaa$var$isBigIntObject;
function $33e199f976d0aeaa$var$isSymbolObject(value) {
    return $33e199f976d0aeaa$var$SymbolSupported && $33e199f976d0aeaa$var$checkBoxedPrimitive(value, $33e199f976d0aeaa$var$symbolValue);
}
module.exports.isSymbolObject = $33e199f976d0aeaa$var$isSymbolObject;
function $33e199f976d0aeaa$var$isBoxedPrimitive(value) {
    return $33e199f976d0aeaa$var$isNumberObject(value) || $33e199f976d0aeaa$var$isStringObject(value) || $33e199f976d0aeaa$var$isBooleanObject(value) || $33e199f976d0aeaa$var$isBigIntObject(value) || $33e199f976d0aeaa$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $33e199f976d0aeaa$var$isBoxedPrimitive;
function $33e199f976d0aeaa$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== "undefined" && ($33e199f976d0aeaa$var$isArrayBuffer(value) || $33e199f976d0aeaa$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $33e199f976d0aeaa$var$isAnyArrayBuffer;
[
    "isProxy",
    "isExternal",
    "isModuleNamespaceObject"
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + " is not supported in userland");
        }
    });
});

});
parcelRegister("25lfa", function(module, exports) {
"use strict";

var $184c86f118ab5653$var$hasToStringTag = (parcelRequire("4Yp5o"))();

var $l28vI = parcelRequire("l28vI");
var $184c86f118ab5653$var$$toString = $l28vI("Object.prototype.toString");
var $184c86f118ab5653$var$isStandardArguments = function isArguments(value) {
    if ($184c86f118ab5653$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $184c86f118ab5653$var$$toString(value) === "[object Arguments]";
};
var $184c86f118ab5653$var$isLegacyArguments = function isArguments(value) {
    if ($184c86f118ab5653$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $184c86f118ab5653$var$$toString(value) !== "[object Array]" && $184c86f118ab5653$var$$toString(value.callee) === "[object Function]";
};
var $184c86f118ab5653$var$supportsStandardArguments = function() {
    return $184c86f118ab5653$var$isStandardArguments(arguments);
}();
$184c86f118ab5653$var$isStandardArguments.isLegacyArguments = $184c86f118ab5653$var$isLegacyArguments; // for tests
module.exports = $184c86f118ab5653$var$supportsStandardArguments ? $184c86f118ab5653$var$isStandardArguments : $184c86f118ab5653$var$isLegacyArguments;

});
parcelRegister("4Yp5o", function(module, exports) {
"use strict";

var $e6ibc = parcelRequire("e6ibc");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $e6ibc() && !!Symbol.toStringTag;
};

});
parcelRegister("e6ibc", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("l28vI", function(module, exports) {
"use strict";

var $5XoKB = parcelRequire("5XoKB");

var $jS9v3 = parcelRequire("jS9v3");
var $f50062e307a9927c$var$$indexOf = $jS9v3($5XoKB("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $5XoKB(name, !!allowMissing);
    if (typeof intrinsic === "function" && $f50062e307a9927c$var$$indexOf(name, ".prototype.") > -1) return $jS9v3(intrinsic);
    return intrinsic;
};

});
parcelRegister("5XoKB", function(module, exports) {
"use strict";
var $4565a9698af8efed$var$undefined1;

var $f6Akk = parcelRequire("f6Akk");

var $fpQns = parcelRequire("fpQns");

var $ag3DL = parcelRequire("ag3DL");

var $eFn1R = parcelRequire("eFn1R");

var $6TBlj = parcelRequire("6TBlj");

var $OG0Ue = parcelRequire("OG0Ue");

var $fK7Rv = parcelRequire("fK7Rv");
var $4565a9698af8efed$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $4565a9698af8efed$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $4565a9698af8efed$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $4565a9698af8efed$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($4565a9698af8efed$var$$gOPD) try {
    $4565a9698af8efed$var$$gOPD({}, "");
} catch (e) {
    $4565a9698af8efed$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $4565a9698af8efed$var$throwTypeError = function() {
    throw new $OG0Ue();
};
var $4565a9698af8efed$var$ThrowTypeError = $4565a9698af8efed$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $4565a9698af8efed$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $4565a9698af8efed$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $4565a9698af8efed$var$throwTypeError;
        }
    }
}() : $4565a9698af8efed$var$throwTypeError;

var $4565a9698af8efed$var$hasSymbols = (parcelRequire("1zrnp"))();

var $4565a9698af8efed$var$hasProto = (parcelRequire("8mH7E"))();
var $4565a9698af8efed$var$getProto = Object.getPrototypeOf || ($4565a9698af8efed$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $4565a9698af8efed$var$needsEval = {};
var $4565a9698af8efed$var$TypedArray = typeof Uint8Array === "undefined" || !$4565a9698af8efed$var$getProto ? undefined : $4565a9698af8efed$var$getProto(Uint8Array);
var $4565a9698af8efed$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $4565a9698af8efed$var$hasSymbols && $4565a9698af8efed$var$getProto ? $4565a9698af8efed$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $4565a9698af8efed$var$needsEval,
    "%AsyncGenerator%": $4565a9698af8efed$var$needsEval,
    "%AsyncGeneratorFunction%": $4565a9698af8efed$var$needsEval,
    "%AsyncIteratorPrototype%": $4565a9698af8efed$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $f6Akk,
    "%eval%": eval,
    "%EvalError%": $fpQns,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $4565a9698af8efed$var$$Function,
    "%GeneratorFunction%": $4565a9698af8efed$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $4565a9698af8efed$var$hasSymbols && $4565a9698af8efed$var$getProto ? $4565a9698af8efed$var$getProto($4565a9698af8efed$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$4565a9698af8efed$var$hasSymbols || !$4565a9698af8efed$var$getProto ? undefined : $4565a9698af8efed$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $ag3DL,
    "%ReferenceError%": $eFn1R,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$4565a9698af8efed$var$hasSymbols || !$4565a9698af8efed$var$getProto ? undefined : $4565a9698af8efed$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $4565a9698af8efed$var$hasSymbols && $4565a9698af8efed$var$getProto ? $4565a9698af8efed$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $4565a9698af8efed$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $6TBlj,
    "%ThrowTypeError%": $4565a9698af8efed$var$ThrowTypeError,
    "%TypedArray%": $4565a9698af8efed$var$TypedArray,
    "%TypeError%": $OG0Ue,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $fK7Rv,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($4565a9698af8efed$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $4565a9698af8efed$var$errorProto = $4565a9698af8efed$var$getProto($4565a9698af8efed$var$getProto(e));
    $4565a9698af8efed$var$INTRINSICS["%Error.prototype%"] = $4565a9698af8efed$var$errorProto;
}
var $4565a9698af8efed$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $4565a9698af8efed$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $4565a9698af8efed$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $4565a9698af8efed$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $4565a9698af8efed$var$getProto) value = $4565a9698af8efed$var$getProto(gen.prototype);
    }
    $4565a9698af8efed$var$INTRINSICS[name] = value;
    return value;
};
var $4565a9698af8efed$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $dY0J9 = parcelRequire("dY0J9");

var $l8o8U = parcelRequire("l8o8U");
var $4565a9698af8efed$var$$concat = $dY0J9.call(Function.call, Array.prototype.concat);
var $4565a9698af8efed$var$$spliceApply = $dY0J9.call(Function.apply, Array.prototype.splice);
var $4565a9698af8efed$var$$replace = $dY0J9.call(Function.call, String.prototype.replace);
var $4565a9698af8efed$var$$strSlice = $dY0J9.call(Function.call, String.prototype.slice);
var $4565a9698af8efed$var$$exec = $dY0J9.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $4565a9698af8efed$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $4565a9698af8efed$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $4565a9698af8efed$var$stringToPath = function stringToPath(string) {
    var first = $4565a9698af8efed$var$$strSlice(string, 0, 1);
    var last = $4565a9698af8efed$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $6TBlj("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $6TBlj("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $4565a9698af8efed$var$$replace(string, $4565a9698af8efed$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $4565a9698af8efed$var$$replace(subString, $4565a9698af8efed$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $4565a9698af8efed$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($l8o8U($4565a9698af8efed$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $4565a9698af8efed$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($l8o8U($4565a9698af8efed$var$INTRINSICS, intrinsicName)) {
        var value = $4565a9698af8efed$var$INTRINSICS[intrinsicName];
        if (value === $4565a9698af8efed$var$needsEval) value = $4565a9698af8efed$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $OG0Ue("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $6TBlj("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $OG0Ue("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $OG0Ue('"allowMissing" argument must be a boolean');
    if ($4565a9698af8efed$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $6TBlj("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $4565a9698af8efed$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $4565a9698af8efed$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $4565a9698af8efed$var$$spliceApply(parts, $4565a9698af8efed$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $4565a9698af8efed$var$$strSlice(part, 0, 1);
        var last = $4565a9698af8efed$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $6TBlj("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($l8o8U($4565a9698af8efed$var$INTRINSICS, intrinsicRealName)) value = $4565a9698af8efed$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $OG0Ue("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($4565a9698af8efed$var$$gOPD && i + 1 >= parts.length) {
                var desc = $4565a9698af8efed$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $l8o8U(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $4565a9698af8efed$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("f6Akk", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("fpQns", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("ag3DL", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("eFn1R", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("6TBlj", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("OG0Ue", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("fK7Rv", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("1zrnp", function(module, exports) {
"use strict";
var $124e4bbb3f3c510d$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $e6ibc = parcelRequire("e6ibc");
module.exports = function hasNativeSymbols() {
    if (typeof $124e4bbb3f3c510d$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $124e4bbb3f3c510d$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $e6ibc();
};

});

parcelRegister("8mH7E", function(module, exports) {
"use strict";
var $6171d3ff235c4b4e$var$test = {
    __proto__: null,
    foo: {}
};
var $6171d3ff235c4b4e$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $6171d3ff235c4b4e$var$test
    }).foo === $6171d3ff235c4b4e$var$test.foo && !($6171d3ff235c4b4e$var$test instanceof $6171d3ff235c4b4e$var$$Object);
};

});

parcelRegister("dY0J9", function(module, exports) {
"use strict";

var $a9gvA = parcelRequire("a9gvA");
module.exports = Function.prototype.bind || $a9gvA;

});
parcelRegister("a9gvA", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $76378ce80e32fd91$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $76378ce80e32fd91$var$toStr = Object.prototype.toString;
var $76378ce80e32fd91$var$max = Math.max;
var $76378ce80e32fd91$var$funcType = "[object Function]";
var $76378ce80e32fd91$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $76378ce80e32fd91$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $76378ce80e32fd91$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $76378ce80e32fd91$var$toStr.apply(target) !== $76378ce80e32fd91$var$funcType) throw new TypeError($76378ce80e32fd91$var$ERROR_MESSAGE + target);
    var args = $76378ce80e32fd91$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $76378ce80e32fd91$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $76378ce80e32fd91$var$concatty(args, arguments));
    };
    var boundLength = $76378ce80e32fd91$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $76378ce80e32fd91$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("l8o8U", function(module, exports) {
"use strict";
var $f62d1296f319593b$var$call = Function.prototype.call;
var $f62d1296f319593b$var$$hasOwn = Object.prototype.hasOwnProperty;

var $dY0J9 = parcelRequire("dY0J9");
/** @type {import('.')} */ module.exports = $dY0J9.call($f62d1296f319593b$var$call, $f62d1296f319593b$var$$hasOwn);

});


parcelRegister("jS9v3", function(module, exports) {
"use strict";

var $dY0J9 = parcelRequire("dY0J9");

var $5XoKB = parcelRequire("5XoKB");

var $8hAll = parcelRequire("8hAll");

var $OG0Ue = parcelRequire("OG0Ue");
var $e77a6dec9495dcaa$var$$apply = $5XoKB("%Function.prototype.apply%");
var $e77a6dec9495dcaa$var$$call = $5XoKB("%Function.prototype.call%");
var $e77a6dec9495dcaa$var$$reflectApply = $5XoKB("%Reflect.apply%", true) || $dY0J9.call($e77a6dec9495dcaa$var$$call, $e77a6dec9495dcaa$var$$apply);

var $7dXGV = parcelRequire("7dXGV");
var $e77a6dec9495dcaa$var$$max = $5XoKB("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $OG0Ue("a function is required");
    var func = $e77a6dec9495dcaa$var$$reflectApply($dY0J9, $e77a6dec9495dcaa$var$$call, arguments);
    return $8hAll(func, 1 + $e77a6dec9495dcaa$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $e77a6dec9495dcaa$var$applyBind = function applyBind() {
    return $e77a6dec9495dcaa$var$$reflectApply($dY0J9, $e77a6dec9495dcaa$var$$apply, arguments);
};
if ($7dXGV) $7dXGV(module.exports, "apply", {
    value: $e77a6dec9495dcaa$var$applyBind
});
else module.exports.apply = $e77a6dec9495dcaa$var$applyBind;

});
parcelRegister("8hAll", function(module, exports) {
"use strict";

var $5XoKB = parcelRequire("5XoKB");

var $1FJER = parcelRequire("1FJER");

var $607c1a4d22289651$var$hasDescriptors = (parcelRequire("8CDym"))();

var $eJu2D = parcelRequire("eJu2D");

var $OG0Ue = parcelRequire("OG0Ue");
var $607c1a4d22289651$var$$floor = $5XoKB("%Math.floor%");
/** @typedef {(...args: unknown[]) => unknown} Func */ /** @type {<T extends Func = Func>(fn: T, length: number, loose?: boolean) => T} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $OG0Ue("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $607c1a4d22289651$var$$floor(length) !== length) throw new $OG0Ue("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $eJu2D) {
        var desc = $eJu2D(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($607c1a4d22289651$var$hasDescriptors) $1FJER(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $1FJER(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("1FJER", function(module, exports) {
"use strict";

var $7dXGV = parcelRequire("7dXGV");

var $6TBlj = parcelRequire("6TBlj");

var $OG0Ue = parcelRequire("OG0Ue");

var $eJu2D = parcelRequire("eJu2D");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $OG0Ue("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $OG0Ue("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $OG0Ue("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $OG0Ue("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $OG0Ue("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $OG0Ue("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$eJu2D && $eJu2D(obj, property);
    if ($7dXGV) $7dXGV(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $6TBlj("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("7dXGV", function(module, exports) {
"use strict";

var $5XoKB = parcelRequire("5XoKB");
/** @type {import('.')} */ var $54280cbbb5bff3df$var$$defineProperty = $5XoKB("%Object.defineProperty%", true) || false;
if ($54280cbbb5bff3df$var$$defineProperty) try {
    $54280cbbb5bff3df$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $54280cbbb5bff3df$var$$defineProperty = false;
}
module.exports = $54280cbbb5bff3df$var$$defineProperty;

});

parcelRegister("eJu2D", function(module, exports) {
"use strict";

var $5XoKB = parcelRequire("5XoKB");
var $ab9c92447e4858f1$var$$gOPD = $5XoKB("%Object.getOwnPropertyDescriptor%", true);
if ($ab9c92447e4858f1$var$$gOPD) try {
    $ab9c92447e4858f1$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $ab9c92447e4858f1$var$$gOPD = null;
}
module.exports = $ab9c92447e4858f1$var$$gOPD;

});


parcelRegister("8CDym", function(module, exports) {
"use strict";

var $7dXGV = parcelRequire("7dXGV");
var $64708dc9f5193715$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$7dXGV;
};
$64708dc9f5193715$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$7dXGV) return null;
    try {
        return $7dXGV([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $64708dc9f5193715$var$hasPropertyDescriptors;

});





parcelRegister("jaL9i", function(module, exports) {
"use strict";
var $df53864bd77edbcb$var$toStr = Object.prototype.toString;
var $df53864bd77edbcb$var$fnToStr = Function.prototype.toString;
var $df53864bd77edbcb$var$isFnRegex = /^\s*(?:function)?\*/;

var $df53864bd77edbcb$var$hasToStringTag = (parcelRequire("4Yp5o"))();
var $df53864bd77edbcb$var$getProto = Object.getPrototypeOf;
var $df53864bd77edbcb$var$getGeneratorFunc = function() {
    if (!$df53864bd77edbcb$var$hasToStringTag) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var $df53864bd77edbcb$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if ($df53864bd77edbcb$var$isFnRegex.test($df53864bd77edbcb$var$fnToStr.call(fn))) return true;
    if (!$df53864bd77edbcb$var$hasToStringTag) {
        var str = $df53864bd77edbcb$var$toStr.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!$df53864bd77edbcb$var$getProto) return false;
    if (typeof $df53864bd77edbcb$var$GeneratorFunction === "undefined") {
        var generatorFunc = $df53864bd77edbcb$var$getGeneratorFunc();
        $df53864bd77edbcb$var$GeneratorFunction = generatorFunc ? $df53864bd77edbcb$var$getProto(generatorFunc) : false;
    }
    return $df53864bd77edbcb$var$getProto(fn) === $df53864bd77edbcb$var$GeneratorFunction;
};

});

parcelRegister("bw8Od", function(module, exports) {
"use strict";

var $9Y285 = parcelRequire("9Y285");

var $lsTls = parcelRequire("lsTls");

var $jS9v3 = parcelRequire("jS9v3");

var $l28vI = parcelRequire("l28vI");

var $eJu2D = parcelRequire("eJu2D");
var $862984235fa1b97b$var$$toString = $l28vI("Object.prototype.toString");

var $862984235fa1b97b$var$hasToStringTag = (parcelRequire("4Yp5o"))();
var $862984235fa1b97b$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $862984235fa1b97b$var$typedArrays = $lsTls();
var $862984235fa1b97b$var$$slice = $l28vI("String.prototype.slice");
var $862984235fa1b97b$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
var $862984235fa1b97b$var$$indexOf = $l28vI("Array.prototype.indexOf", true) || /** @type {(array: readonly unknown[], value: unknown) => keyof array} */ function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {Int8Array | Uint8Array | Uint8ClampedArray | Int16Array | Uint16Array | Int32Array | Uint32Array | Float32Array | Float64Array | BigInt64Array | BigUint64Array} TypedArray */ /** @typedef {'Int8Array' | 'Uint8Array' | 'Uint8ClampedArray' | 'Int16Array' | 'Uint16Array' | 'Int32Array' | 'Uint32Array' | 'Float32Array' | 'Float64Array' | 'BigInt64Array' | 'BigUint64Array'} TypedArrayName */ /** @type {{ [k in `\$${TypedArrayName}`]?: (receiver: TypedArray) => string | typeof Uint8Array.prototype.slice.call | typeof Uint8Array.prototype.set.call } & { __proto__: null }} */ var $862984235fa1b97b$var$cache = {
    __proto__: null
};
if ($862984235fa1b97b$var$hasToStringTag && $eJu2D && $862984235fa1b97b$var$getPrototypeOf) $9Y285($862984235fa1b97b$var$typedArrays, function(typedArray) {
    var arr = new $862984235fa1b97b$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $862984235fa1b97b$var$getPrototypeOf(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $eJu2D(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $862984235fa1b97b$var$getPrototypeOf(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $eJu2D(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $862984235fa1b97b$var$cache["$" + typedArray] = $jS9v3(descriptor.get);
    }
});
else $9Y285($862984235fa1b97b$var$typedArrays, function(typedArray) {
    var arr = new $862984235fa1b97b$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) // @ts-expect-error TODO: fix
    $862984235fa1b97b$var$cache["$" + typedArray] = $jS9v3(fn);
});
/** @type {import('.')} */ var $862984235fa1b97b$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<tryAllTypedArrays>} */ var found = false;
    $9Y285(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, typeof cache>} */ /** @type {any} */ $862984235fa1b97b$var$cache, /** @type {(getter: typeof cache, name: `\$${TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            if ("$" + getter(value) === typedArray) found = $862984235fa1b97b$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ var $862984235fa1b97b$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<tryAllSlices>} */ var found = false;
    $9Y285(// eslint-disable-next-line no-extra-parens
    /** @type {any} */ $862984235fa1b97b$var$cache, /** @type {(getter: typeof cache, name: `\$${TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            getter(value);
            found = $862984235fa1b97b$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!$862984235fa1b97b$var$hasToStringTag) {
        var tag = $862984235fa1b97b$var$$slice($862984235fa1b97b$var$$toString(value), 8, -1);
        if ($862984235fa1b97b$var$$indexOf($862984235fa1b97b$var$typedArrays, tag) > -1) return tag;
        if (tag !== "Object") return false;
        // node < 0.6 hits here on real Typed Arrays
        return $862984235fa1b97b$var$trySlices(value);
    }
    if (!$eJu2D) return null;
     // unknown engine
    return $862984235fa1b97b$var$tryTypedArrays(value);
};

});
parcelRegister("9Y285", function(module, exports) {
"use strict";

var $3Jutl = parcelRequire("3Jutl");
var $741b5e87f77901ca$var$toStr = Object.prototype.toString;
var $741b5e87f77901ca$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $741b5e87f77901ca$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($741b5e87f77901ca$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $741b5e87f77901ca$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $741b5e87f77901ca$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($741b5e87f77901ca$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $741b5e87f77901ca$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$3Jutl(iterator)) throw new TypeError("iterator must be a function");
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($741b5e87f77901ca$var$toStr.call(list) === "[object Array]") $741b5e87f77901ca$var$forEachArray(list, iterator, receiver);
    else if (typeof list === "string") $741b5e87f77901ca$var$forEachString(list, iterator, receiver);
    else $741b5e87f77901ca$var$forEachObject(list, iterator, receiver);
};
module.exports = $741b5e87f77901ca$var$forEach;

});
parcelRegister("3Jutl", function(module, exports) {
"use strict";
var $2b7d363d3364a494$var$fnToStr = Function.prototype.toString;
var $2b7d363d3364a494$var$reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
var $2b7d363d3364a494$var$badArrayLike;
var $2b7d363d3364a494$var$isCallableMarker;
if (typeof $2b7d363d3364a494$var$reflectApply === "function" && typeof Object.defineProperty === "function") try {
    $2b7d363d3364a494$var$badArrayLike = Object.defineProperty({}, "length", {
        get: function() {
            throw $2b7d363d3364a494$var$isCallableMarker;
        }
    });
    $2b7d363d3364a494$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $2b7d363d3364a494$var$reflectApply(function() {
        throw 42;
    }, null, $2b7d363d3364a494$var$badArrayLike);
} catch (_) {
    if (_ !== $2b7d363d3364a494$var$isCallableMarker) $2b7d363d3364a494$var$reflectApply = null;
}
else $2b7d363d3364a494$var$reflectApply = null;
var $2b7d363d3364a494$var$constructorRegex = /^\s*class\b/;
var $2b7d363d3364a494$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $2b7d363d3364a494$var$fnToStr.call(value);
        return $2b7d363d3364a494$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $2b7d363d3364a494$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($2b7d363d3364a494$var$isES6ClassFn(value)) return false;
        $2b7d363d3364a494$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $2b7d363d3364a494$var$toStr = Object.prototype.toString;
var $2b7d363d3364a494$var$objectClass = "[object Object]";
var $2b7d363d3364a494$var$fnClass = "[object Function]";
var $2b7d363d3364a494$var$genClass = "[object GeneratorFunction]";
var $2b7d363d3364a494$var$ddaClass = "[object HTMLAllCollection]"; // IE 11
var $2b7d363d3364a494$var$ddaClass2 = "[object HTML document.all class]";
var $2b7d363d3364a494$var$ddaClass3 = "[object HTMLCollection]"; // IE 9-10
var $2b7d363d3364a494$var$hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $2b7d363d3364a494$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $2b7d363d3364a494$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === "object") {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $2b7d363d3364a494$var$all = document.all;
    if ($2b7d363d3364a494$var$toStr.call($2b7d363d3364a494$var$all) === $2b7d363d3364a494$var$toStr.call(document.all)) $2b7d363d3364a494$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($2b7d363d3364a494$var$isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) try {
            var str = $2b7d363d3364a494$var$toStr.call(value);
            return (str === $2b7d363d3364a494$var$ddaClass || str === $2b7d363d3364a494$var$ddaClass2 || str === $2b7d363d3364a494$var$ddaClass3 // opera 12.16
             || str === $2b7d363d3364a494$var$objectClass // IE 6-8
            ) && value("") == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $2b7d363d3364a494$var$reflectApply ? function isCallable(value) {
    if ($2b7d363d3364a494$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    try {
        $2b7d363d3364a494$var$reflectApply(value, null, $2b7d363d3364a494$var$badArrayLike);
    } catch (e) {
        if (e !== $2b7d363d3364a494$var$isCallableMarker) return false;
    }
    return !$2b7d363d3364a494$var$isES6ClassFn(value) && $2b7d363d3364a494$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($2b7d363d3364a494$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    if ($2b7d363d3364a494$var$hasToStringTag) return $2b7d363d3364a494$var$tryFunctionObject(value);
    if ($2b7d363d3364a494$var$isES6ClassFn(value)) return false;
    var strClass = $2b7d363d3364a494$var$toStr.call(value);
    if (strClass !== $2b7d363d3364a494$var$fnClass && strClass !== $2b7d363d3364a494$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $2b7d363d3364a494$var$tryFunctionObject(value);
};

});


parcelRegister("lsTls", function(module, exports) {
"use strict";

var $58y0d = parcelRequire("58y0d");
var $fa0724e4ad0d85ae$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $58y0d.length; i++)if (typeof $fa0724e4ad0d85ae$var$g[$58y0d[i]] === "function") // @ts-expect-error
    out[out.length] = $58y0d[i];
    return out;
};

});
parcelRegister("58y0d", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = [
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
];

});



parcelRegister("4fFEF", function(module, exports) {
"use strict";

var $bw8Od = parcelRequire("bw8Od");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$bw8Od(value);
};

});


parcelRegister("7Tl5t", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

});

parcelRegister("9M38k", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("dB6J2", function(module, exports) {

(function(root, factory) {
    "use strict";
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("error-stack-parser", [
        "stackframe"
    ], factory);
    else module.exports = factory((parcelRequire("jkCGW")));
})(module.exports, function ErrorStackParser(StackFrame) {
    "use strict";
    var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+:\d+/;
    var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+:\d+|\(native\))/m;
    var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code])?$/;
    return {
        /**
         * Given an Error object, extract the most information from it.
         *
         * @param {Error} error object
         * @return {Array} of StackFrames
         */ parse: function ErrorStackParser$$parse(error) {
            if (typeof error.stacktrace !== "undefined" || typeof error["opera#sourceloc"] !== "undefined") return this.parseOpera(error);
            else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) return this.parseV8OrIE(error);
            else if (error.stack) return this.parseFFOrSafari(error);
            else throw new Error("Cannot parse given Error object");
        },
        // Separate line and column numbers from a string of the form: (URI:Line:Column)
        extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
            // Fail-fast but return locations like "(native)"
            if (urlLike.indexOf(":") === -1) return [
                urlLike
            ];
            var regExp = /(.+?)(?::(\d+))?(?::(\d+))?$/;
            var parts = regExp.exec(urlLike.replace(/[()]/g, ""));
            return [
                parts[1],
                parts[2] || undefined,
                parts[3] || undefined
            ];
        },
        parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
            var filtered = error.stack.split("\n").filter(function(line) {
                return !!line.match(CHROME_IE_STACK_REGEXP);
            }, this);
            return filtered.map(function(line) {
                if (line.indexOf("(eval ") > -1) // Throw away eval information until we implement stacktrace.js/stackframe#8
                line = line.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(,.*$)/g, "");
                var sanitizedLine = line.replace(/^\s+/, "").replace(/\(eval code/g, "(").replace(/^.*?\s+/, "");
                // capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
                // case it has spaces in it, as the string is split on \s+ later on
                var location = sanitizedLine.match(/ (\(.+\)$)/);
                // remove the parenthesized location from the line, if it was matched
                sanitizedLine = location ? sanitizedLine.replace(location[0], "") : sanitizedLine;
                // if a location was matched, pass it to extractLocation() otherwise pass all sanitizedLine
                // because this line doesn't have function name
                var locationParts = this.extractLocation(location ? location[1] : sanitizedLine);
                var functionName = location && sanitizedLine || undefined;
                var fileName = [
                    "eval",
                    "<anonymous>"
                ].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];
                return new StackFrame({
                    functionName: functionName,
                    fileName: fileName,
                    lineNumber: locationParts[1],
                    columnNumber: locationParts[2],
                    source: line
                });
            }, this);
        },
        parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
            var filtered = error.stack.split("\n").filter(function(line) {
                return !line.match(SAFARI_NATIVE_CODE_REGEXP);
            }, this);
            return filtered.map(function(line) {
                // Throw away eval information until we implement stacktrace.js/stackframe#8
                if (line.indexOf(" > eval") > -1) line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1");
                if (line.indexOf("@") === -1 && line.indexOf(":") === -1) // Safari eval frames only have function names and nothing else
                return new StackFrame({
                    functionName: line
                });
                else {
                    var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
                    var matches = line.match(functionNameRegex);
                    var functionName = matches && matches[1] ? matches[1] : undefined;
                    var locationParts = this.extractLocation(line.replace(functionNameRegex, ""));
                    return new StackFrame({
                        functionName: functionName,
                        fileName: locationParts[0],
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }
            }, this);
        },
        parseOpera: function ErrorStackParser$$parseOpera(e) {
            if (!e.stacktrace || e.message.indexOf("\n") > -1 && e.message.split("\n").length > e.stacktrace.split("\n").length) return this.parseOpera9(e);
            else if (!e.stack) return this.parseOpera10(e);
            else return this.parseOpera11(e);
        },
        parseOpera9: function ErrorStackParser$$parseOpera9(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
            var lines = e.message.split("\n");
            var result = [];
            for(var i = 2, len = lines.length; i < len; i += 2){
                var match = lineRE.exec(lines[i]);
                if (match) result.push(new StackFrame({
                    fileName: match[2],
                    lineNumber: match[1],
                    source: lines[i]
                }));
            }
            return result;
        },
        parseOpera10: function ErrorStackParser$$parseOpera10(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
            var lines = e.stacktrace.split("\n");
            var result = [];
            for(var i = 0, len = lines.length; i < len; i += 2){
                var match = lineRE.exec(lines[i]);
                if (match) result.push(new StackFrame({
                    functionName: match[3] || undefined,
                    fileName: match[2],
                    lineNumber: match[1],
                    source: lines[i]
                }));
            }
            return result;
        },
        // Opera 10.65+ Error.stack very similar to FF/Safari
        parseOpera11: function ErrorStackParser$$parseOpera11(error) {
            var filtered = error.stack.split("\n").filter(function(line) {
                return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
            }, this);
            return filtered.map(function(line) {
                var tokens = line.split("@");
                var locationParts = this.extractLocation(tokens.pop());
                var functionCall = tokens.shift() || "";
                var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || undefined;
                var argsRaw;
                if (functionCall.match(/\(([^)]*)\)/)) argsRaw = functionCall.replace(/^[^(]+\(([^)]*)\)$/, "$1");
                var args = argsRaw === undefined || argsRaw === "[arguments not available]" ? undefined : argsRaw.split(",");
                return new StackFrame({
                    functionName: functionName,
                    args: args,
                    fileName: locationParts[0],
                    lineNumber: locationParts[1],
                    columnNumber: locationParts[2],
                    source: line
                });
            }, this);
        }
    };
});

});
parcelRegister("jkCGW", function(module, exports) {
(function(root, factory) {
    "use strict";
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("stackframe", [], factory);
    else module.exports = factory();
})(module.exports, function() {
    "use strict";
    function _isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
    function _capitalize(str) {
        return str.charAt(0).toUpperCase() + str.substring(1);
    }
    function _getter(p) {
        return function() {
            return this[p];
        };
    }
    var booleanProps = [
        "isConstructor",
        "isEval",
        "isNative",
        "isToplevel"
    ];
    var numericProps = [
        "columnNumber",
        "lineNumber"
    ];
    var stringProps = [
        "fileName",
        "functionName",
        "source"
    ];
    var arrayProps = [
        "args"
    ];
    var objectProps = [
        "evalOrigin"
    ];
    var props = booleanProps.concat(numericProps, stringProps, arrayProps, objectProps);
    function StackFrame(obj) {
        if (!obj) return;
        for(var i = 0; i < props.length; i++)if (obj[props[i]] !== undefined) this["set" + _capitalize(props[i])](obj[props[i]]);
    }
    StackFrame.prototype = {
        getArgs: function() {
            return this.args;
        },
        setArgs: function(v) {
            if (Object.prototype.toString.call(v) !== "[object Array]") throw new TypeError("Args must be an Array");
            this.args = v;
        },
        getEvalOrigin: function() {
            return this.evalOrigin;
        },
        setEvalOrigin: function(v) {
            if (v instanceof StackFrame) this.evalOrigin = v;
            else if (v instanceof Object) this.evalOrigin = new StackFrame(v);
            else throw new TypeError("Eval Origin must be an Object or StackFrame");
        },
        toString: function() {
            var fileName = this.getFileName() || "";
            var lineNumber = this.getLineNumber() || "";
            var columnNumber = this.getColumnNumber() || "";
            var functionName = this.getFunctionName() || "";
            if (this.getIsEval()) {
                if (fileName) return "[eval] (" + fileName + ":" + lineNumber + ":" + columnNumber + ")";
                return "[eval]:" + lineNumber + ":" + columnNumber;
            }
            if (functionName) return functionName + " (" + fileName + ":" + lineNumber + ":" + columnNumber + ")";
            return fileName + ":" + lineNumber + ":" + columnNumber;
        }
    };
    StackFrame.fromString = function StackFrame$$fromString(str) {
        var argsStartIndex = str.indexOf("(");
        var argsEndIndex = str.lastIndexOf(")");
        var functionName = str.substring(0, argsStartIndex);
        var args = str.substring(argsStartIndex + 1, argsEndIndex).split(",");
        var locationString = str.substring(argsEndIndex + 1);
        if (locationString.indexOf("@") === 0) {
            var parts = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(locationString, "");
            var fileName = parts[1];
            var lineNumber = parts[2];
            var columnNumber = parts[3];
        }
        return new StackFrame({
            functionName: functionName,
            args: args || undefined,
            fileName: fileName,
            lineNumber: lineNumber || undefined,
            columnNumber: columnNumber || undefined
        });
    };
    for(var i = 0; i < booleanProps.length; i++){
        StackFrame.prototype["get" + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
        StackFrame.prototype["set" + _capitalize(booleanProps[i])] = function(p) {
            return function(v) {
                this[p] = Boolean(v);
            };
        }(booleanProps[i]);
    }
    for(var j = 0; j < numericProps.length; j++){
        StackFrame.prototype["get" + _capitalize(numericProps[j])] = _getter(numericProps[j]);
        StackFrame.prototype["set" + _capitalize(numericProps[j])] = function(p) {
            return function(v) {
                if (!_isNumber(v)) throw new TypeError(p + " must be a Number");
                this[p] = Number(v);
            };
        }(numericProps[j]);
    }
    for(var k = 0; k < stringProps.length; k++){
        StackFrame.prototype["get" + _capitalize(stringProps[k])] = _getter(stringProps[k]);
        StackFrame.prototype["set" + _capitalize(stringProps[k])] = function(p) {
            return function(v) {
                this[p] = String(v);
            };
        }(stringProps[k]);
    }
    return StackFrame;
});

});


parcelRegister("kaS8w", function(module, exports) {

(function(root, factory) {
    "use strict";
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("stack-generator", [
        "stackframe"
    ], factory);
    else module.exports = factory((parcelRequire("jkCGW")));
})(module.exports, function(StackFrame) {
    return {
        backtrace: function StackGenerator$$backtrace(opts) {
            var stack = [];
            var maxStackSize = 10;
            if (typeof opts === "object" && typeof opts.maxStackSize === "number") maxStackSize = opts.maxStackSize;
            var curr = arguments.callee;
            while(curr && stack.length < maxStackSize && curr["arguments"]){
                // Allow V8 optimizations
                var args = new Array(curr["arguments"].length);
                for(var i = 0; i < args.length; ++i)args[i] = curr["arguments"][i];
                if (/function(?:\s+([\w$]+))+\s*\(/.test(curr.toString())) stack.push(new StackFrame({
                    functionName: RegExp.$1 || undefined,
                    args: args
                }));
                else stack.push(new StackFrame({
                    args: args
                }));
                try {
                    curr = curr.caller;
                } catch (e) {
                    break;
                }
            }
            return stack;
        }
    };
});

});

parcelRegister("6F6u5", function(module, exports) {


(function(root, factory) {
    "use strict";
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("stacktrace-gps", [
        "source-map",
        "stackframe"
    ], factory);
    else module.exports = factory((parcelRequire("81QgN")), (parcelRequire("jkCGW")));
})(module.exports, function(SourceMap, StackFrame) {
    "use strict";
    /**
     * Make a X-Domain request to url and callback.
     *
     * @param {String} url
     * @returns {Promise} with response text if fulfilled
     */ function _xdr(url) {
        return new Promise(function(resolve, reject) {
            var req = new XMLHttpRequest();
            req.open("get", url);
            req.onerror = reject;
            req.onreadystatechange = function onreadystatechange() {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 300 || url.substr(0, 7) === "file://" && req.responseText) resolve(req.responseText);
                    else reject(new Error("HTTP status: " + req.status + " retrieving " + url));
                }
            };
            req.send();
        });
    }
    /**
     * Convert a Base64-encoded string into its original representation.
     * Used for inline sourcemaps.
     *
     * @param {String} b64str Base-64 encoded string
     * @returns {String} original representation of the base64-encoded string.
     */ function _atob(b64str) {
        if (typeof window !== "undefined" && window.atob) return window.atob(b64str);
        else throw new Error("You must supply a polyfill for window.atob in this environment");
    }
    function _parseJson(string) {
        if (typeof JSON !== "undefined" && JSON.parse) return JSON.parse(string);
        else throw new Error("You must supply a polyfill for JSON.parse in this environment");
    }
    function _findFunctionName(source, lineNumber /*, columnNumber*/ ) {
        var syntaxes = [
            // {name} = function ({args}) TODO args capture
            /['"]?([$_A-Za-z][$_A-Za-z0-9]*)['"]?\s*[:=]\s*function\b/,
            // function {name}({args}) m[1]=name m[2]=args
            /function\s+([^('"`]*?)\s*\(([^)]*)\)/,
            // {name} = eval()
            /['"]?([$_A-Za-z][$_A-Za-z0-9]*)['"]?\s*[:=]\s*(?:eval|new Function)\b/,
            // fn_name() {
            /\b(?!(?:if|for|switch|while|with|catch)\b)(?:(?:static)\s+)?(\S+)\s*\(.*?\)\s*\{/,
            // {name} = () => {
            /['"]?([$_A-Za-z][$_A-Za-z0-9]*)['"]?\s*[:=]\s*\(.*?\)\s*=>/
        ];
        var lines = source.split("\n");
        // Walk backwards in the source lines until we find the line which matches one of the patterns above
        var code = "";
        var maxLines = Math.min(lineNumber, 20);
        for(var i = 0; i < maxLines; ++i){
            // lineNo is 1-based, source[] is 0-based
            var line = lines[lineNumber - i - 1];
            var commentPos = line.indexOf("//");
            if (commentPos >= 0) line = line.substr(0, commentPos);
            if (line) {
                code = line + code;
                var len = syntaxes.length;
                for(var index = 0; index < len; index++){
                    var m = syntaxes[index].exec(code);
                    if (m && m[1]) return m[1];
                }
            }
        }
        return undefined;
    }
    function _ensureSupportedEnvironment() {
        if (typeof Object.defineProperty !== "function" || typeof Object.create !== "function") throw new Error("Unable to consume source maps in older browsers");
    }
    function _ensureStackFrameIsLegit(stackframe) {
        if (typeof stackframe !== "object") throw new TypeError("Given StackFrame is not an object");
        else if (typeof stackframe.fileName !== "string") throw new TypeError("Given file name is not a String");
        else if (typeof stackframe.lineNumber !== "number" || stackframe.lineNumber % 1 !== 0 || stackframe.lineNumber < 1) throw new TypeError("Given line number must be a positive integer");
        else if (typeof stackframe.columnNumber !== "number" || stackframe.columnNumber % 1 !== 0 || stackframe.columnNumber < 0) throw new TypeError("Given column number must be a non-negative integer");
        return true;
    }
    function _findSourceMappingURL(source) {
        var sourceMappingUrlRegExp = /\/\/[#@] ?sourceMappingURL=([^\s'"]+)\s*$/mg;
        var lastSourceMappingUrl;
        var matchSourceMappingUrl;
        // eslint-disable-next-line no-cond-assign
        while(matchSourceMappingUrl = sourceMappingUrlRegExp.exec(source))lastSourceMappingUrl = matchSourceMappingUrl[1];
        if (lastSourceMappingUrl) return lastSourceMappingUrl;
        else throw new Error("sourceMappingURL not found");
    }
    function _extractLocationInfoFromSourceMapSource(stackframe, sourceMapConsumer, sourceCache) {
        return new Promise(function(resolve, reject) {
            var loc = sourceMapConsumer.originalPositionFor({
                line: stackframe.lineNumber,
                column: stackframe.columnNumber
            });
            if (loc.source) {
                // cache mapped sources
                var mappedSource = sourceMapConsumer.sourceContentFor(loc.source);
                if (mappedSource) sourceCache[loc.source] = mappedSource;
                resolve(// given stackframe and source location, update stackframe
                new StackFrame({
                    functionName: loc.name || stackframe.functionName,
                    args: stackframe.args,
                    fileName: loc.source,
                    lineNumber: loc.line,
                    columnNumber: loc.column
                }));
            } else reject(new Error("Could not get original source for given stackframe and source map"));
        });
    }
    /**
     * @constructor
     * @param {Object} opts
     *      opts.sourceCache = {url: "Source String"} => preload source cache
     *      opts.sourceMapConsumerCache = {/path/file.js.map: SourceMapConsumer}
     *      opts.offline = True to prevent network requests.
     *              Best effort without sources or source maps.
     *      opts.ajax = Promise returning function to make X-Domain requests
     */ return function StackTraceGPS(opts) {
        if (!(this instanceof StackTraceGPS)) return new StackTraceGPS(opts);
        opts = opts || {};
        this.sourceCache = opts.sourceCache || {};
        this.sourceMapConsumerCache = opts.sourceMapConsumerCache || {};
        this.ajax = opts.ajax || _xdr;
        this._atob = opts.atob || _atob;
        this._get = function _get(location) {
            return new Promise((function(resolve, reject) {
                var isDataUrl = location.substr(0, 5) === "data:";
                if (this.sourceCache[location]) resolve(this.sourceCache[location]);
                else if (opts.offline && !isDataUrl) reject(new Error("Cannot make network requests in offline mode"));
                else if (isDataUrl) {
                    // data URLs can have parameters.
                    // see http://tools.ietf.org/html/rfc2397
                    var supportedEncodingRegexp = /^data:application\/json;([\w=:"-]+;)*base64,/;
                    var match = location.match(supportedEncodingRegexp);
                    if (match) {
                        var sourceMapStart = match[0].length;
                        var encodedSource = location.substr(sourceMapStart);
                        var source = this._atob(encodedSource);
                        this.sourceCache[location] = source;
                        resolve(source);
                    } else reject(new Error("The encoding of the inline sourcemap is not supported"));
                } else {
                    var xhrPromise = this.ajax(location, {
                        method: "get"
                    });
                    // Cache the Promise to prevent duplicate in-flight requests
                    this.sourceCache[location] = xhrPromise;
                    xhrPromise.then(resolve, reject);
                }
            }).bind(this));
        };
        /**
         * Creating SourceMapConsumers is expensive, so this wraps the creation of a
         * SourceMapConsumer in a per-instance cache.
         *
         * @param {String} sourceMappingURL = URL to fetch source map from
         * @param {String} defaultSourceRoot = Default source root for source map if undefined
         * @returns {Promise} that resolves a SourceMapConsumer
         */ this._getSourceMapConsumer = function _getSourceMapConsumer(sourceMappingURL, defaultSourceRoot) {
            return new Promise((function(resolve) {
                if (this.sourceMapConsumerCache[sourceMappingURL]) resolve(this.sourceMapConsumerCache[sourceMappingURL]);
                else {
                    var sourceMapConsumerPromise = new Promise((function(resolve, reject) {
                        return this._get(sourceMappingURL).then(function(sourceMapSource) {
                            if (typeof sourceMapSource === "string") sourceMapSource = _parseJson(sourceMapSource.replace(/^\)\]\}'/, ""));
                            if (typeof sourceMapSource.sourceRoot === "undefined") sourceMapSource.sourceRoot = defaultSourceRoot;
                            resolve(new SourceMap.SourceMapConsumer(sourceMapSource));
                        }).catch(reject);
                    }).bind(this));
                    this.sourceMapConsumerCache[sourceMappingURL] = sourceMapConsumerPromise;
                    resolve(sourceMapConsumerPromise);
                }
            }).bind(this));
        };
        /**
         * Given a StackFrame, enhance function name and use source maps for a
         * better StackFrame.
         *
         * @param {StackFrame} stackframe object
         * @returns {Promise} that resolves with with source-mapped StackFrame
         */ this.pinpoint = function StackTraceGPS$$pinpoint(stackframe) {
            return new Promise((function(resolve, reject) {
                this.getMappedLocation(stackframe).then((function(mappedStackFrame) {
                    function resolveMappedStackFrame() {
                        resolve(mappedStackFrame);
                    }
                    this.findFunctionName(mappedStackFrame).then(resolve, resolveMappedStackFrame)["catch"](resolveMappedStackFrame);
                }).bind(this), reject);
            }).bind(this));
        };
        /**
         * Given a StackFrame, guess function name from location information.
         *
         * @param {StackFrame} stackframe
         * @returns {Promise} that resolves with enhanced StackFrame.
         */ this.findFunctionName = function StackTraceGPS$$findFunctionName(stackframe) {
            return new Promise((function(resolve, reject) {
                _ensureStackFrameIsLegit(stackframe);
                this._get(stackframe.fileName).then(function getSourceCallback(source) {
                    var lineNumber = stackframe.lineNumber;
                    var columnNumber = stackframe.columnNumber;
                    var guessedFunctionName = _findFunctionName(source, lineNumber, columnNumber);
                    // Only replace functionName if we found something
                    if (guessedFunctionName) resolve(new StackFrame({
                        functionName: guessedFunctionName,
                        args: stackframe.args,
                        fileName: stackframe.fileName,
                        lineNumber: lineNumber,
                        columnNumber: columnNumber
                    }));
                    else resolve(stackframe);
                }, reject)["catch"](reject);
            }).bind(this));
        };
        /**
         * Given a StackFrame, seek source-mapped location and return new enhanced StackFrame.
         *
         * @param {StackFrame} stackframe
         * @returns {Promise} that resolves with enhanced StackFrame.
         */ this.getMappedLocation = function StackTraceGPS$$getMappedLocation(stackframe) {
            return new Promise((function(resolve, reject) {
                _ensureSupportedEnvironment();
                _ensureStackFrameIsLegit(stackframe);
                var sourceCache = this.sourceCache;
                var fileName = stackframe.fileName;
                this._get(fileName).then((function(source) {
                    var sourceMappingURL = _findSourceMappingURL(source);
                    var isDataUrl = sourceMappingURL.substr(0, 5) === "data:";
                    var defaultSourceRoot = fileName.substring(0, fileName.lastIndexOf("/") + 1);
                    if (sourceMappingURL[0] !== "/" && !isDataUrl && !/^https?:\/\/|^\/\//i.test(sourceMappingURL)) sourceMappingURL = defaultSourceRoot + sourceMappingURL;
                    return this._getSourceMapConsumer(sourceMappingURL, defaultSourceRoot).then(function(sourceMapConsumer) {
                        return _extractLocationInfoFromSourceMapSource(stackframe, sourceMapConsumer, sourceCache).then(resolve)["catch"](function() {
                            resolve(stackframe);
                        });
                    });
                }).bind(this), reject)["catch"](reject);
            }).bind(this));
        };
    };
});

});
parcelRegister("81QgN", function(module, exports) {

$parcel$export(module.exports, "SourceMapConsumer", function () { return $5d86f66af175eb82$export$194e92554d04abdd; }, function (v) { return $5d86f66af175eb82$export$194e92554d04abdd = v; });
$parcel$export(module.exports, "BasicSourceMapConsumer", function () { return $5d86f66af175eb82$export$bef6691594139a79; }, function (v) { return $5d86f66af175eb82$export$bef6691594139a79 = v; });
$parcel$export(module.exports, "IndexedSourceMapConsumer", function () { return $5d86f66af175eb82$export$823525094e5b803c; }, function (v) { return $5d86f66af175eb82$export$823525094e5b803c = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $5d86f66af175eb82$export$194e92554d04abdd;
var $5d86f66af175eb82$export$bef6691594139a79;
var $5d86f66af175eb82$export$823525094e5b803c;

var $3EQ3z = parcelRequire("3EQ3z");

var $5ZqSJ = parcelRequire("5ZqSJ");

var $2l96M = parcelRequire("2l96M");
var $5d86f66af175eb82$require$ArraySet = $2l96M.ArraySet;

var $eaDVs = parcelRequire("eaDVs");

var $liUSf = parcelRequire("liUSf");
var $5d86f66af175eb82$require$quickSort = $liUSf.quickSort;
function $5d86f66af175eb82$var$SourceMapConsumer(aSourceMap) {
    var sourceMap = aSourceMap;
    if (typeof aSourceMap === "string") sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ""));
    return sourceMap.sections != null ? new $5d86f66af175eb82$var$IndexedSourceMapConsumer(sourceMap) : new $5d86f66af175eb82$var$BasicSourceMapConsumer(sourceMap);
}
$5d86f66af175eb82$var$SourceMapConsumer.fromSourceMap = function(aSourceMap) {
    return $5d86f66af175eb82$var$BasicSourceMapConsumer.fromSourceMap(aSourceMap);
};
/**
 * The version of the source mapping spec that we are consuming.
 */ $5d86f66af175eb82$var$SourceMapConsumer.prototype._version = 3;
// `__generatedMappings` and `__originalMappings` are arrays that hold the
// parsed mapping coordinates from the source map's "mappings" attribute. They
// are lazily instantiated, accessed via the `_generatedMappings` and
// `_originalMappings` getters respectively, and we only parse the mappings
// and create these arrays once queried for a source location. We jump through
// these hoops because there can be many thousands of mappings, and parsing
// them is expensive, so we only want to do it if we must.
//
// Each object in the arrays is of the form:
//
//     {
//       generatedLine: The line number in the generated code,
//       generatedColumn: The column number in the generated code,
//       source: The path to the original source file that generated this
//               chunk of code,
//       originalLine: The line number in the original source that
//                     corresponds to this chunk of generated code,
//       originalColumn: The column number in the original source that
//                       corresponds to this chunk of generated code,
//       name: The name of the original symbol which generated this chunk of
//             code.
//     }
//
// All properties except for `generatedLine` and `generatedColumn` can be
// `null`.
//
// `_generatedMappings` is ordered by the generated positions.
//
// `_originalMappings` is ordered by the original positions.
$5d86f66af175eb82$var$SourceMapConsumer.prototype.__generatedMappings = null;
Object.defineProperty($5d86f66af175eb82$var$SourceMapConsumer.prototype, "_generatedMappings", {
    get: function() {
        if (!this.__generatedMappings) this._parseMappings(this._mappings, this.sourceRoot);
        return this.__generatedMappings;
    }
});
$5d86f66af175eb82$var$SourceMapConsumer.prototype.__originalMappings = null;
Object.defineProperty($5d86f66af175eb82$var$SourceMapConsumer.prototype, "_originalMappings", {
    get: function() {
        if (!this.__originalMappings) this._parseMappings(this._mappings, this.sourceRoot);
        return this.__originalMappings;
    }
});
$5d86f66af175eb82$var$SourceMapConsumer.prototype._charIsMappingSeparator = function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
    var c = aStr.charAt(index);
    return c === ";" || c === ",";
};
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */ $5d86f66af175eb82$var$SourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    throw new Error("Subclasses must implement _parseMappings");
};
$5d86f66af175eb82$var$SourceMapConsumer.GENERATED_ORDER = 1;
$5d86f66af175eb82$var$SourceMapConsumer.ORIGINAL_ORDER = 2;
$5d86f66af175eb82$var$SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
$5d86f66af175eb82$var$SourceMapConsumer.LEAST_UPPER_BOUND = 2;
/**
 * Iterate over each mapping between an original source/line/column and a
 * generated line/column in this source map.
 *
 * @param Function aCallback
 *        The function that is called with each mapping.
 * @param Object aContext
 *        Optional. If specified, this object will be the value of `this` every
 *        time that `aCallback` is called.
 * @param aOrder
 *        Either `SourceMapConsumer.GENERATED_ORDER` or
 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
 *        iterate over the mappings sorted by the generated file's line/column
 *        order or the original's source/line/column order, respectively. Defaults to
 *        `SourceMapConsumer.GENERATED_ORDER`.
 */ $5d86f66af175eb82$var$SourceMapConsumer.prototype.eachMapping = function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
    var context = aContext || null;
    var order = aOrder || $5d86f66af175eb82$var$SourceMapConsumer.GENERATED_ORDER;
    var mappings;
    switch(order){
        case $5d86f66af175eb82$var$SourceMapConsumer.GENERATED_ORDER:
            mappings = this._generatedMappings;
            break;
        case $5d86f66af175eb82$var$SourceMapConsumer.ORIGINAL_ORDER:
            mappings = this._originalMappings;
            break;
        default:
            throw new Error("Unknown order of iteration.");
    }
    var sourceRoot = this.sourceRoot;
    mappings.map(function(mapping) {
        var source = mapping.source === null ? null : this._sources.at(mapping.source);
        if (source != null && sourceRoot != null) source = $3EQ3z.join(sourceRoot, source);
        return {
            source: source,
            generatedLine: mapping.generatedLine,
            generatedColumn: mapping.generatedColumn,
            originalLine: mapping.originalLine,
            originalColumn: mapping.originalColumn,
            name: mapping.name === null ? null : this._names.at(mapping.name)
        };
    }, this).forEach(aCallback, context);
};
/**
 * Returns all generated line and column information for the original source,
 * line, and column provided. If no column is provided, returns all mappings
 * corresponding to a either the line we are searching for or the next
 * closest line that has any mappings. Otherwise, returns all mappings
 * corresponding to the given line and either the column we are searching for
 * or the next closest column that has any offsets.
 *
 * The only argument is an object with the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.
 *   - column: Optional. the column number in the original source.
 *
 * and an array of objects is returned, each with the following properties:
 *
 *   - line: The line number in the generated source, or null.
 *   - column: The column number in the generated source, or null.
 */ $5d86f66af175eb82$var$SourceMapConsumer.prototype.allGeneratedPositionsFor = function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
    var line = $3EQ3z.getArg(aArgs, "line");
    // When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
    // returns the index of the closest mapping less than the needle. By
    // setting needle.originalColumn to 0, we thus find the last mapping for
    // the given line, provided such a mapping exists.
    var needle = {
        source: $3EQ3z.getArg(aArgs, "source"),
        originalLine: line,
        originalColumn: $3EQ3z.getArg(aArgs, "column", 0)
    };
    if (this.sourceRoot != null) needle.source = $3EQ3z.relative(this.sourceRoot, needle.source);
    if (!this._sources.has(needle.source)) return [];
    needle.source = this._sources.indexOf(needle.source);
    var mappings = [];
    var index = this._findMapping(needle, this._originalMappings, "originalLine", "originalColumn", $3EQ3z.compareByOriginalPositions, $5ZqSJ.LEAST_UPPER_BOUND);
    if (index >= 0) {
        var mapping = this._originalMappings[index];
        if (aArgs.column === undefined) {
            var originalLine = mapping.originalLine;
            // Iterate until either we run out of mappings, or we run into
            // a mapping for a different line than the one we found. Since
            // mappings are sorted, this is guaranteed to find all mappings for
            // the line we found.
            while(mapping && mapping.originalLine === originalLine){
                mappings.push({
                    line: $3EQ3z.getArg(mapping, "generatedLine", null),
                    column: $3EQ3z.getArg(mapping, "generatedColumn", null),
                    lastColumn: $3EQ3z.getArg(mapping, "lastGeneratedColumn", null)
                });
                mapping = this._originalMappings[++index];
            }
        } else {
            var originalColumn = mapping.originalColumn;
            // Iterate until either we run out of mappings, or we run into
            // a mapping for a different line than the one we were searching for.
            // Since mappings are sorted, this is guaranteed to find all mappings for
            // the line we are searching for.
            while(mapping && mapping.originalLine === line && mapping.originalColumn == originalColumn){
                mappings.push({
                    line: $3EQ3z.getArg(mapping, "generatedLine", null),
                    column: $3EQ3z.getArg(mapping, "generatedColumn", null),
                    lastColumn: $3EQ3z.getArg(mapping, "lastGeneratedColumn", null)
                });
                mapping = this._originalMappings[++index];
            }
        }
    }
    return mappings;
};
$5d86f66af175eb82$export$194e92554d04abdd = $5d86f66af175eb82$var$SourceMapConsumer;
/**
 * A BasicSourceMapConsumer instance represents a parsed source map which we can
 * query for information about the original file positions by giving it a file
 * position in the generated source.
 *
 * The only parameter is the raw source map (either as a JSON string, or
 * already parsed to an object). According to the spec, source maps have the
 * following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - sources: An array of URLs to the original source files.
 *   - names: An array of identifiers which can be referrenced by individual mappings.
 *   - sourceRoot: Optional. The URL root from which all sources are relative.
 *   - sourcesContent: Optional. An array of contents of the original source files.
 *   - mappings: A string of base64 VLQs which contain the actual mappings.
 *   - file: Optional. The generated file this source map is associated with.
 *
 * Here is an example source map, taken from the source map spec[0]:
 *
 *     {
 *       version : 3,
 *       file: "out.js",
 *       sourceRoot : "",
 *       sources: ["foo.js", "bar.js"],
 *       names: ["src", "maps", "are", "fun"],
 *       mappings: "AA,AB;;ABCDE;"
 *     }
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
 */ function $5d86f66af175eb82$var$BasicSourceMapConsumer(aSourceMap) {
    var sourceMap = aSourceMap;
    if (typeof aSourceMap === "string") sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ""));
    var version = $3EQ3z.getArg(sourceMap, "version");
    var sources = $3EQ3z.getArg(sourceMap, "sources");
    // Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
    // requires the array) to play nice here.
    var names = $3EQ3z.getArg(sourceMap, "names", []);
    var sourceRoot = $3EQ3z.getArg(sourceMap, "sourceRoot", null);
    var sourcesContent = $3EQ3z.getArg(sourceMap, "sourcesContent", null);
    var mappings = $3EQ3z.getArg(sourceMap, "mappings");
    var file = $3EQ3z.getArg(sourceMap, "file", null);
    // Once again, Sass deviates from the spec and supplies the version as a
    // string rather than a number, so we use loose equality checking here.
    if (version != this._version) throw new Error("Unsupported version: " + version);
    sources = sources.map(String)// Some source maps produce relative source paths like "./foo.js" instead of
    // "foo.js".  Normalize these first so that future comparisons will succeed.
    // See bugzil.la/1090768.
    .map($3EQ3z.normalize)// Always ensure that absolute sources are internally stored relative to
    // the source root, if the source root is absolute. Not doing this would
    // be particularly problematic when the source root is a prefix of the
    // source (valid, but why??). See github issue #199 and bugzil.la/1188982.
    .map(function(source) {
        return sourceRoot && $3EQ3z.isAbsolute(sourceRoot) && $3EQ3z.isAbsolute(source) ? $3EQ3z.relative(sourceRoot, source) : source;
    });
    // Pass `true` below to allow duplicate names and sources. While source maps
    // are intended to be compressed and deduplicated, the TypeScript compiler
    // sometimes generates source maps with duplicates in them. See Github issue
    // #72 and bugzil.la/889492.
    this._names = $5d86f66af175eb82$require$ArraySet.fromArray(names.map(String), true);
    this._sources = $5d86f66af175eb82$require$ArraySet.fromArray(sources, true);
    this.sourceRoot = sourceRoot;
    this.sourcesContent = sourcesContent;
    this._mappings = mappings;
    this.file = file;
}
$5d86f66af175eb82$var$BasicSourceMapConsumer.prototype = Object.create($5d86f66af175eb82$var$SourceMapConsumer.prototype);
$5d86f66af175eb82$var$BasicSourceMapConsumer.prototype.consumer = $5d86f66af175eb82$var$SourceMapConsumer;
/**
 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
 *
 * @param SourceMapGenerator aSourceMap
 *        The source map that will be consumed.
 * @returns BasicSourceMapConsumer
 */ $5d86f66af175eb82$var$BasicSourceMapConsumer.fromSourceMap = function SourceMapConsumer_fromSourceMap(aSourceMap) {
    var smc = Object.create($5d86f66af175eb82$var$BasicSourceMapConsumer.prototype);
    var names = smc._names = $5d86f66af175eb82$require$ArraySet.fromArray(aSourceMap._names.toArray(), true);
    var sources = smc._sources = $5d86f66af175eb82$require$ArraySet.fromArray(aSourceMap._sources.toArray(), true);
    smc.sourceRoot = aSourceMap._sourceRoot;
    smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(), smc.sourceRoot);
    smc.file = aSourceMap._file;
    // Because we are modifying the entries (by converting string sources and
    // names to indices into the sources and names ArraySets), we have to make
    // a copy of the entry or else bad things happen. Shared mutable state
    // strikes again! See github issue #191.
    var generatedMappings = aSourceMap._mappings.toArray().slice();
    var destGeneratedMappings = smc.__generatedMappings = [];
    var destOriginalMappings = smc.__originalMappings = [];
    for(var i = 0, length = generatedMappings.length; i < length; i++){
        var srcMapping = generatedMappings[i];
        var destMapping = new $5d86f66af175eb82$var$Mapping;
        destMapping.generatedLine = srcMapping.generatedLine;
        destMapping.generatedColumn = srcMapping.generatedColumn;
        if (srcMapping.source) {
            destMapping.source = sources.indexOf(srcMapping.source);
            destMapping.originalLine = srcMapping.originalLine;
            destMapping.originalColumn = srcMapping.originalColumn;
            if (srcMapping.name) destMapping.name = names.indexOf(srcMapping.name);
            destOriginalMappings.push(destMapping);
        }
        destGeneratedMappings.push(destMapping);
    }
    $5d86f66af175eb82$require$quickSort(smc.__originalMappings, $3EQ3z.compareByOriginalPositions);
    return smc;
};
/**
 * The version of the source mapping spec that we are consuming.
 */ $5d86f66af175eb82$var$BasicSourceMapConsumer.prototype._version = 3;
/**
 * The list of original sources.
 */ Object.defineProperty($5d86f66af175eb82$var$BasicSourceMapConsumer.prototype, "sources", {
    get: function() {
        return this._sources.toArray().map(function(s) {
            return this.sourceRoot != null ? $3EQ3z.join(this.sourceRoot, s) : s;
        }, this);
    }
});
/**
 * Provide the JIT with a nice shape / hidden class.
 */ function $5d86f66af175eb82$var$Mapping() {
    this.generatedLine = 0;
    this.generatedColumn = 0;
    this.source = null;
    this.originalLine = null;
    this.originalColumn = null;
    this.name = null;
}
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */ $5d86f66af175eb82$var$BasicSourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    var generatedLine = 1;
    var previousGeneratedColumn = 0;
    var previousOriginalLine = 0;
    var previousOriginalColumn = 0;
    var previousSource = 0;
    var previousName = 0;
    var length = aStr.length;
    var index = 0;
    var cachedSegments = {};
    var temp = {};
    var originalMappings = [];
    var generatedMappings = [];
    var mapping, str, segment, end, value;
    while(index < length){
        if (aStr.charAt(index) === ";") {
            generatedLine++;
            index++;
            previousGeneratedColumn = 0;
        } else if (aStr.charAt(index) === ",") index++;
        else {
            mapping = new $5d86f66af175eb82$var$Mapping();
            mapping.generatedLine = generatedLine;
            // Because each offset is encoded relative to the previous one,
            // many segments often have the same encoding. We can exploit this
            // fact by caching the parsed variable length fields of each segment,
            // allowing us to avoid a second parse if we encounter the same
            // segment again.
            for(end = index; end < length; end++){
                if (this._charIsMappingSeparator(aStr, end)) break;
            }
            str = aStr.slice(index, end);
            segment = cachedSegments[str];
            if (segment) index += str.length;
            else {
                segment = [];
                while(index < end){
                    $eaDVs.decode(aStr, index, temp);
                    value = temp.value;
                    index = temp.rest;
                    segment.push(value);
                }
                if (segment.length === 2) throw new Error("Found a source, but no line and column");
                if (segment.length === 3) throw new Error("Found a source and line, but no column");
                cachedSegments[str] = segment;
            }
            // Generated column.
            mapping.generatedColumn = previousGeneratedColumn + segment[0];
            previousGeneratedColumn = mapping.generatedColumn;
            if (segment.length > 1) {
                // Original source.
                mapping.source = previousSource + segment[1];
                previousSource += segment[1];
                // Original line.
                mapping.originalLine = previousOriginalLine + segment[2];
                previousOriginalLine = mapping.originalLine;
                // Lines are stored 0-based
                mapping.originalLine += 1;
                // Original column.
                mapping.originalColumn = previousOriginalColumn + segment[3];
                previousOriginalColumn = mapping.originalColumn;
                if (segment.length > 4) {
                    // Original name.
                    mapping.name = previousName + segment[4];
                    previousName += segment[4];
                }
            }
            generatedMappings.push(mapping);
            if (typeof mapping.originalLine === "number") originalMappings.push(mapping);
        }
    }
    $5d86f66af175eb82$require$quickSort(generatedMappings, $3EQ3z.compareByGeneratedPositionsDeflated);
    this.__generatedMappings = generatedMappings;
    $5d86f66af175eb82$require$quickSort(originalMappings, $3EQ3z.compareByOriginalPositions);
    this.__originalMappings = originalMappings;
};
/**
 * Find the mapping that best matches the hypothetical "needle" mapping that
 * we are searching for in the given "haystack" of mappings.
 */ $5d86f66af175eb82$var$BasicSourceMapConsumer.prototype._findMapping = function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName, aColumnName, aComparator, aBias) {
    // To return the position we are searching for, we must first find the
    // mapping for the given position and then return the opposite position it
    // points to. Because the mappings are sorted, we can use binary search to
    // find the best mapping.
    if (aNeedle[aLineName] <= 0) throw new TypeError("Line must be greater than or equal to 1, got " + aNeedle[aLineName]);
    if (aNeedle[aColumnName] < 0) throw new TypeError("Column must be greater than or equal to 0, got " + aNeedle[aColumnName]);
    return $5ZqSJ.search(aNeedle, aMappings, aComparator, aBias);
};
/**
 * Compute the last column for each generated mapping. The last column is
 * inclusive.
 */ $5d86f66af175eb82$var$BasicSourceMapConsumer.prototype.computeColumnSpans = function SourceMapConsumer_computeColumnSpans() {
    for(var index = 0; index < this._generatedMappings.length; ++index){
        var mapping = this._generatedMappings[index];
        // Mappings do not contain a field for the last generated columnt. We
        // can come up with an optimistic estimate, however, by assuming that
        // mappings are contiguous (i.e. given two consecutive mappings, the
        // first mapping ends where the second one starts).
        if (index + 1 < this._generatedMappings.length) {
            var nextMapping = this._generatedMappings[index + 1];
            if (mapping.generatedLine === nextMapping.generatedLine) {
                mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
                continue;
            }
        }
        // The last mapping for each line spans the entire line.
        mapping.lastGeneratedColumn = Infinity;
    }
};
/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.
 *   - column: The column number in the generated source.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.
 *   - column: The column number in the original source, or null.
 *   - name: The original identifier, or null.
 */ $5d86f66af175eb82$var$BasicSourceMapConsumer.prototype.originalPositionFor = function SourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
        generatedLine: $3EQ3z.getArg(aArgs, "line"),
        generatedColumn: $3EQ3z.getArg(aArgs, "column")
    };
    var index = this._findMapping(needle, this._generatedMappings, "generatedLine", "generatedColumn", $3EQ3z.compareByGeneratedPositionsDeflated, $3EQ3z.getArg(aArgs, "bias", $5d86f66af175eb82$var$SourceMapConsumer.GREATEST_LOWER_BOUND));
    if (index >= 0) {
        var mapping = this._generatedMappings[index];
        if (mapping.generatedLine === needle.generatedLine) {
            var source = $3EQ3z.getArg(mapping, "source", null);
            if (source !== null) {
                source = this._sources.at(source);
                if (this.sourceRoot != null) source = $3EQ3z.join(this.sourceRoot, source);
            }
            var name = $3EQ3z.getArg(mapping, "name", null);
            if (name !== null) name = this._names.at(name);
            return {
                source: source,
                line: $3EQ3z.getArg(mapping, "originalLine", null),
                column: $3EQ3z.getArg(mapping, "originalColumn", null),
                name: name
            };
        }
    }
    return {
        source: null,
        line: null,
        column: null,
        name: null
    };
};
/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */ $5d86f66af175eb82$var$BasicSourceMapConsumer.prototype.hasContentsOfAllSources = function BasicSourceMapConsumer_hasContentsOfAllSources() {
    if (!this.sourcesContent) return false;
    return this.sourcesContent.length >= this._sources.size() && !this.sourcesContent.some(function(sc) {
        return sc == null;
    });
};
/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */ $5d86f66af175eb82$var$BasicSourceMapConsumer.prototype.sourceContentFor = function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    if (!this.sourcesContent) return null;
    if (this.sourceRoot != null) aSource = $3EQ3z.relative(this.sourceRoot, aSource);
    if (this._sources.has(aSource)) return this.sourcesContent[this._sources.indexOf(aSource)];
    var url;
    if (this.sourceRoot != null && (url = $3EQ3z.urlParse(this.sourceRoot))) {
        // XXX: file:// URIs and absolute paths lead to unexpected behavior for
        // many users. We can help them out when they expect file:// URIs to
        // behave like it would if they were running a local HTTP server. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
        var fileUriAbsPath = aSource.replace(/^file:\/\//, "");
        if (url.scheme == "file" && this._sources.has(fileUriAbsPath)) return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)];
        if ((!url.path || url.path == "/") && this._sources.has("/" + aSource)) return this.sourcesContent[this._sources.indexOf("/" + aSource)];
    }
    // This function is used recursively from
    // IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
    // don't want to throw if we can't find the source - we just want to
    // return null, so we provide a flag to exit gracefully.
    if (nullOnMissing) return null;
    else throw new Error('"' + aSource + '" is not in the SourceMap.');
};
/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.
 *   - column: The column number in the original source.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.
 *   - column: The column number in the generated source, or null.
 */ $5d86f66af175eb82$var$BasicSourceMapConsumer.prototype.generatedPositionFor = function SourceMapConsumer_generatedPositionFor(aArgs) {
    var source = $3EQ3z.getArg(aArgs, "source");
    if (this.sourceRoot != null) source = $3EQ3z.relative(this.sourceRoot, source);
    if (!this._sources.has(source)) return {
        line: null,
        column: null,
        lastColumn: null
    };
    source = this._sources.indexOf(source);
    var needle = {
        source: source,
        originalLine: $3EQ3z.getArg(aArgs, "line"),
        originalColumn: $3EQ3z.getArg(aArgs, "column")
    };
    var index = this._findMapping(needle, this._originalMappings, "originalLine", "originalColumn", $3EQ3z.compareByOriginalPositions, $3EQ3z.getArg(aArgs, "bias", $5d86f66af175eb82$var$SourceMapConsumer.GREATEST_LOWER_BOUND));
    if (index >= 0) {
        var mapping = this._originalMappings[index];
        if (mapping.source === needle.source) return {
            line: $3EQ3z.getArg(mapping, "generatedLine", null),
            column: $3EQ3z.getArg(mapping, "generatedColumn", null),
            lastColumn: $3EQ3z.getArg(mapping, "lastGeneratedColumn", null)
        };
    }
    return {
        line: null,
        column: null,
        lastColumn: null
    };
};
$5d86f66af175eb82$export$bef6691594139a79 = $5d86f66af175eb82$var$BasicSourceMapConsumer;
/**
 * An IndexedSourceMapConsumer instance represents a parsed source map which
 * we can query for information. It differs from BasicSourceMapConsumer in
 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
 * input.
 *
 * The only parameter is a raw source map (either as a JSON string, or already
 * parsed to an object). According to the spec for indexed source maps, they
 * have the following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - file: Optional. The generated file this source map is associated with.
 *   - sections: A list of section definitions.
 *
 * Each value under the "sections" field has two fields:
 *   - offset: The offset into the original specified at which this section
 *       begins to apply, defined as an object with a "line" and "column"
 *       field.
 *   - map: A source map definition. This source map could also be indexed,
 *       but doesn't have to be.
 *
 * Instead of the "map" field, it's also possible to have a "url" field
 * specifying a URL to retrieve a source map from, but that's currently
 * unsupported.
 *
 * Here's an example source map, taken from the source map spec[0], but
 * modified to omit a section which uses the "url" field.
 *
 *  {
 *    version : 3,
 *    file: "app.js",
 *    sections: [{
 *      offset: {line:100, column:10},
 *      map: {
 *        version : 3,
 *        file: "section.js",
 *        sources: ["foo.js", "bar.js"],
 *        names: ["src", "maps", "are", "fun"],
 *        mappings: "AAAA,E;;ABCDE;"
 *      }
 *    }],
 *  }
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
 */ function $5d86f66af175eb82$var$IndexedSourceMapConsumer(aSourceMap) {
    var sourceMap = aSourceMap;
    if (typeof aSourceMap === "string") sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ""));
    var version = $3EQ3z.getArg(sourceMap, "version");
    var sections = $3EQ3z.getArg(sourceMap, "sections");
    if (version != this._version) throw new Error("Unsupported version: " + version);
    this._sources = new $5d86f66af175eb82$require$ArraySet();
    this._names = new $5d86f66af175eb82$require$ArraySet();
    var lastOffset = {
        line: -1,
        column: 0
    };
    this._sections = sections.map(function(s) {
        if (s.url) // The url field will require support for asynchronicity.
        // See https://github.com/mozilla/source-map/issues/16
        throw new Error("Support for url field in sections not implemented.");
        var offset = $3EQ3z.getArg(s, "offset");
        var offsetLine = $3EQ3z.getArg(offset, "line");
        var offsetColumn = $3EQ3z.getArg(offset, "column");
        if (offsetLine < lastOffset.line || offsetLine === lastOffset.line && offsetColumn < lastOffset.column) throw new Error("Section offsets must be ordered and non-overlapping.");
        lastOffset = offset;
        return {
            generatedOffset: {
                // The offset fields are 0-based, but we use 1-based indices when
                // encoding/decoding from VLQ.
                generatedLine: offsetLine + 1,
                generatedColumn: offsetColumn + 1
            },
            consumer: new $5d86f66af175eb82$var$SourceMapConsumer($3EQ3z.getArg(s, "map"))
        };
    });
}
$5d86f66af175eb82$var$IndexedSourceMapConsumer.prototype = Object.create($5d86f66af175eb82$var$SourceMapConsumer.prototype);
$5d86f66af175eb82$var$IndexedSourceMapConsumer.prototype.constructor = $5d86f66af175eb82$var$SourceMapConsumer;
/**
 * The version of the source mapping spec that we are consuming.
 */ $5d86f66af175eb82$var$IndexedSourceMapConsumer.prototype._version = 3;
/**
 * The list of original sources.
 */ Object.defineProperty($5d86f66af175eb82$var$IndexedSourceMapConsumer.prototype, "sources", {
    get: function() {
        var sources = [];
        for(var i = 0; i < this._sections.length; i++)for(var j = 0; j < this._sections[i].consumer.sources.length; j++)sources.push(this._sections[i].consumer.sources[j]);
        return sources;
    }
});
/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.
 *   - column: The column number in the generated source.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.
 *   - column: The column number in the original source, or null.
 *   - name: The original identifier, or null.
 */ $5d86f66af175eb82$var$IndexedSourceMapConsumer.prototype.originalPositionFor = function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
        generatedLine: $3EQ3z.getArg(aArgs, "line"),
        generatedColumn: $3EQ3z.getArg(aArgs, "column")
    };
    // Find the section containing the generated position we're trying to map
    // to an original position.
    var sectionIndex = $5ZqSJ.search(needle, this._sections, function(needle, section) {
        var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
        if (cmp) return cmp;
        return needle.generatedColumn - section.generatedOffset.generatedColumn;
    });
    var section = this._sections[sectionIndex];
    if (!section) return {
        source: null,
        line: null,
        column: null,
        name: null
    };
    return section.consumer.originalPositionFor({
        line: needle.generatedLine - (section.generatedOffset.generatedLine - 1),
        column: needle.generatedColumn - (section.generatedOffset.generatedLine === needle.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
        bias: aArgs.bias
    });
};
/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */ $5d86f66af175eb82$var$IndexedSourceMapConsumer.prototype.hasContentsOfAllSources = function IndexedSourceMapConsumer_hasContentsOfAllSources() {
    return this._sections.every(function(s) {
        return s.consumer.hasContentsOfAllSources();
    });
};
/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */ $5d86f66af175eb82$var$IndexedSourceMapConsumer.prototype.sourceContentFor = function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    for(var i = 0; i < this._sections.length; i++){
        var section = this._sections[i];
        var content = section.consumer.sourceContentFor(aSource, true);
        if (content) return content;
    }
    if (nullOnMissing) return null;
    else throw new Error('"' + aSource + '" is not in the SourceMap.');
};
/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.
 *   - column: The column number in the original source.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.
 *   - column: The column number in the generated source, or null.
 */ $5d86f66af175eb82$var$IndexedSourceMapConsumer.prototype.generatedPositionFor = function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
    for(var i = 0; i < this._sections.length; i++){
        var section = this._sections[i];
        // Only consider this section if the requested source is in the list of
        // sources of the consumer.
        if (section.consumer.sources.indexOf($3EQ3z.getArg(aArgs, "source")) === -1) continue;
        var generatedPosition = section.consumer.generatedPositionFor(aArgs);
        if (generatedPosition) {
            var ret = {
                line: generatedPosition.line + (section.generatedOffset.generatedLine - 1),
                column: generatedPosition.column + (section.generatedOffset.generatedLine === generatedPosition.line ? section.generatedOffset.generatedColumn - 1 : 0)
            };
            return ret;
        }
    }
    return {
        line: null,
        column: null
    };
};
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */ $5d86f66af175eb82$var$IndexedSourceMapConsumer.prototype._parseMappings = function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    this.__generatedMappings = [];
    this.__originalMappings = [];
    for(var i = 0; i < this._sections.length; i++){
        var section = this._sections[i];
        var sectionMappings = section.consumer._generatedMappings;
        for(var j = 0; j < sectionMappings.length; j++){
            var mapping = sectionMappings[j];
            var source = section.consumer._sources.at(mapping.source);
            if (section.consumer.sourceRoot !== null) source = $3EQ3z.join(section.consumer.sourceRoot, source);
            this._sources.add(source);
            source = this._sources.indexOf(source);
            var name = section.consumer._names.at(mapping.name);
            this._names.add(name);
            name = this._names.indexOf(name);
            // The mappings coming from the consumer for the section have
            // generated positions relative to the start of the section, so we
            // need to offset them to be relative to the start of the concatenated
            // generated file.
            var adjustedMapping = {
                source: source,
                generatedLine: mapping.generatedLine + (section.generatedOffset.generatedLine - 1),
                generatedColumn: mapping.generatedColumn + (section.generatedOffset.generatedLine === mapping.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
                originalLine: mapping.originalLine,
                originalColumn: mapping.originalColumn,
                name: name
            };
            this.__generatedMappings.push(adjustedMapping);
            if (typeof adjustedMapping.originalLine === "number") this.__originalMappings.push(adjustedMapping);
        }
    }
    $5d86f66af175eb82$require$quickSort(this.__generatedMappings, $3EQ3z.compareByGeneratedPositionsDeflated);
    $5d86f66af175eb82$require$quickSort(this.__originalMappings, $3EQ3z.compareByOriginalPositions);
};
$5d86f66af175eb82$export$823525094e5b803c = $5d86f66af175eb82$var$IndexedSourceMapConsumer;

});
parcelRegister("3EQ3z", function(module, exports) {

$parcel$export(module.exports, "getArg", function () { return $2a9d7ce1b98b11ff$export$6e45e70adce70bb2; }, function (v) { return $2a9d7ce1b98b11ff$export$6e45e70adce70bb2 = v; });
$parcel$export(module.exports, "urlParse", function () { return $2a9d7ce1b98b11ff$export$d6e833647f7f5f17; }, function (v) { return $2a9d7ce1b98b11ff$export$d6e833647f7f5f17 = v; });
$parcel$export(module.exports, "isAbsolute", function () { return $2a9d7ce1b98b11ff$export$e434c7255acda994; }, function (v) { return $2a9d7ce1b98b11ff$export$e434c7255acda994 = v; });
$parcel$export(module.exports, "normalize", function () { return $2a9d7ce1b98b11ff$export$a3295358bff77e; }, function (v) { return $2a9d7ce1b98b11ff$export$a3295358bff77e = v; });
$parcel$export(module.exports, "join", function () { return $2a9d7ce1b98b11ff$export$f7e2c8231c57a8bd; }, function (v) { return $2a9d7ce1b98b11ff$export$f7e2c8231c57a8bd = v; });
$parcel$export(module.exports, "relative", function () { return $2a9d7ce1b98b11ff$export$f0e7d1106eeabbe6; }, function (v) { return $2a9d7ce1b98b11ff$export$f0e7d1106eeabbe6 = v; });
$parcel$export(module.exports, "toSetString", function () { return $2a9d7ce1b98b11ff$export$be0fa1163fa7a4c; }, function (v) { return $2a9d7ce1b98b11ff$export$be0fa1163fa7a4c = v; });
$parcel$export(module.exports, "compareByOriginalPositions", function () { return $2a9d7ce1b98b11ff$export$273077902de92ff2; }, function (v) { return $2a9d7ce1b98b11ff$export$273077902de92ff2 = v; });
$parcel$export(module.exports, "compareByGeneratedPositionsDeflated", function () { return $2a9d7ce1b98b11ff$export$b7acf533941302f6; }, function (v) { return $2a9d7ce1b98b11ff$export$b7acf533941302f6 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ /**
 * This is a helper function for getting values from parameter/options
 * objects.
 *
 * @param args The object we are extracting values from
 * @param name The name of the property we are getting.
 * @param defaultValue An optional value to return if the property is missing
 * from the object. If this is not specified and the property is missing, an
 * error will be thrown.
 */ var $2a9d7ce1b98b11ff$export$6e45e70adce70bb2;
var $2a9d7ce1b98b11ff$export$d6e833647f7f5f17;
var $2a9d7ce1b98b11ff$export$2ec9abc2d2cac192;
var $2a9d7ce1b98b11ff$export$a3295358bff77e;
var $2a9d7ce1b98b11ff$export$f7e2c8231c57a8bd;
var $2a9d7ce1b98b11ff$export$e434c7255acda994;
var $2a9d7ce1b98b11ff$export$f0e7d1106eeabbe6;
var $2a9d7ce1b98b11ff$export$be0fa1163fa7a4c;
var $2a9d7ce1b98b11ff$export$1fc47c3d4c3302a1;
var $2a9d7ce1b98b11ff$export$273077902de92ff2;
var $2a9d7ce1b98b11ff$export$b7acf533941302f6;
var $2a9d7ce1b98b11ff$export$f9c43907549d61f1;
function $2a9d7ce1b98b11ff$var$getArg(aArgs, aName, aDefaultValue) {
    if (aName in aArgs) return aArgs[aName];
    else if (arguments.length === 3) return aDefaultValue;
    else throw new Error('"' + aName + '" is a required argument.');
}
$2a9d7ce1b98b11ff$export$6e45e70adce70bb2 = $2a9d7ce1b98b11ff$var$getArg;
var $2a9d7ce1b98b11ff$var$urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.]*)(?::(\d+))?(\S*)$/;
var $2a9d7ce1b98b11ff$var$dataUrlRegexp = /^data:.+\,.+$/;
function $2a9d7ce1b98b11ff$var$urlParse(aUrl) {
    var match = aUrl.match($2a9d7ce1b98b11ff$var$urlRegexp);
    if (!match) return null;
    return {
        scheme: match[1],
        auth: match[2],
        host: match[3],
        port: match[4],
        path: match[5]
    };
}
$2a9d7ce1b98b11ff$export$d6e833647f7f5f17 = $2a9d7ce1b98b11ff$var$urlParse;
function $2a9d7ce1b98b11ff$var$urlGenerate(aParsedUrl) {
    var url = "";
    if (aParsedUrl.scheme) url += aParsedUrl.scheme + ":";
    url += "//";
    if (aParsedUrl.auth) url += aParsedUrl.auth + "@";
    if (aParsedUrl.host) url += aParsedUrl.host;
    if (aParsedUrl.port) url += ":" + aParsedUrl.port;
    if (aParsedUrl.path) url += aParsedUrl.path;
    return url;
}
$2a9d7ce1b98b11ff$export$2ec9abc2d2cac192 = $2a9d7ce1b98b11ff$var$urlGenerate;
/**
 * Normalizes a path, or the path portion of a URL:
 *
 * - Replaces consecutive slashes with one slash.
 * - Removes unnecessary '.' parts.
 * - Removes unnecessary '<dir>/..' parts.
 *
 * Based on code in the Node.js 'path' core module.
 *
 * @param aPath The path or url to normalize.
 */ function $2a9d7ce1b98b11ff$var$normalize(aPath) {
    var path = aPath;
    var url = $2a9d7ce1b98b11ff$var$urlParse(aPath);
    if (url) {
        if (!url.path) return aPath;
        path = url.path;
    }
    var isAbsolute = $2a9d7ce1b98b11ff$export$e434c7255acda994(path);
    var parts = path.split(/\/+/);
    for(var part, up = 0, i = parts.length - 1; i >= 0; i--){
        part = parts[i];
        if (part === ".") parts.splice(i, 1);
        else if (part === "..") up++;
        else if (up > 0) {
            if (part === "") {
                // The first part is blank if the path is absolute. Trying to go
                // above the root is a no-op. Therefore we can remove all '..' parts
                // directly after the root.
                parts.splice(i + 1, up);
                up = 0;
            } else {
                parts.splice(i, 2);
                up--;
            }
        }
    }
    path = parts.join("/");
    if (path === "") path = isAbsolute ? "/" : ".";
    if (url) {
        url.path = path;
        return $2a9d7ce1b98b11ff$var$urlGenerate(url);
    }
    return path;
}
$2a9d7ce1b98b11ff$export$a3295358bff77e = $2a9d7ce1b98b11ff$var$normalize;
/**
 * Joins two paths/URLs.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be joined with the root.
 *
 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
 *   first.
 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
 *   is updated with the result and aRoot is returned. Otherwise the result
 *   is returned.
 *   - If aPath is absolute, the result is aPath.
 *   - Otherwise the two paths are joined with a slash.
 * - Joining for example 'http://' and 'www.example.com' is also supported.
 */ function $2a9d7ce1b98b11ff$var$join(aRoot, aPath) {
    if (aRoot === "") aRoot = ".";
    if (aPath === "") aPath = ".";
    var aPathUrl = $2a9d7ce1b98b11ff$var$urlParse(aPath);
    var aRootUrl = $2a9d7ce1b98b11ff$var$urlParse(aRoot);
    if (aRootUrl) aRoot = aRootUrl.path || "/";
    // `join(foo, '//www.example.org')`
    if (aPathUrl && !aPathUrl.scheme) {
        if (aRootUrl) aPathUrl.scheme = aRootUrl.scheme;
        return $2a9d7ce1b98b11ff$var$urlGenerate(aPathUrl);
    }
    if (aPathUrl || aPath.match($2a9d7ce1b98b11ff$var$dataUrlRegexp)) return aPath;
    // `join('http://', 'www.example.com')`
    if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
        aRootUrl.host = aPath;
        return $2a9d7ce1b98b11ff$var$urlGenerate(aRootUrl);
    }
    var joined = aPath.charAt(0) === "/" ? aPath : $2a9d7ce1b98b11ff$var$normalize(aRoot.replace(/\/+$/, "") + "/" + aPath);
    if (aRootUrl) {
        aRootUrl.path = joined;
        return $2a9d7ce1b98b11ff$var$urlGenerate(aRootUrl);
    }
    return joined;
}
$2a9d7ce1b98b11ff$export$f7e2c8231c57a8bd = $2a9d7ce1b98b11ff$var$join;
$2a9d7ce1b98b11ff$export$e434c7255acda994 = function(aPath) {
    return aPath.charAt(0) === "/" || !!aPath.match($2a9d7ce1b98b11ff$var$urlRegexp);
};
/**
 * Make a path relative to a URL or another path.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be made relative to aRoot.
 */ function $2a9d7ce1b98b11ff$var$relative(aRoot, aPath) {
    if (aRoot === "") aRoot = ".";
    aRoot = aRoot.replace(/\/$/, "");
    // It is possible for the path to be above the root. In this case, simply
    // checking whether the root is a prefix of the path won't work. Instead, we
    // need to remove components from the root one by one, until either we find
    // a prefix that fits, or we run out of components to remove.
    var level = 0;
    while(aPath.indexOf(aRoot + "/") !== 0){
        var index = aRoot.lastIndexOf("/");
        if (index < 0) return aPath;
        // If the only part of the root that is left is the scheme (i.e. http://,
        // file:///, etc.), one or more slashes (/), or simply nothing at all, we
        // have exhausted all components, so the path is not relative to the root.
        aRoot = aRoot.slice(0, index);
        if (aRoot.match(/^([^\/]+:\/)?\/*$/)) return aPath;
        ++level;
    }
    // Make sure we add a "../" for each component we removed from the root.
    return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
}
$2a9d7ce1b98b11ff$export$f0e7d1106eeabbe6 = $2a9d7ce1b98b11ff$var$relative;
var $2a9d7ce1b98b11ff$var$supportsNullProto = function() {
    var obj = Object.create(null);
    return !("__proto__" in obj);
}();
function $2a9d7ce1b98b11ff$var$identity(s) {
    return s;
}
/**
 * Because behavior goes wacky when you set `__proto__` on objects, we
 * have to prefix all the strings in our set with an arbitrary character.
 *
 * See https://github.com/mozilla/source-map/pull/31 and
 * https://github.com/mozilla/source-map/issues/30
 *
 * @param String aStr
 */ function $2a9d7ce1b98b11ff$var$toSetString(aStr) {
    if ($2a9d7ce1b98b11ff$var$isProtoString(aStr)) return "$" + aStr;
    return aStr;
}
$2a9d7ce1b98b11ff$export$be0fa1163fa7a4c = $2a9d7ce1b98b11ff$var$supportsNullProto ? $2a9d7ce1b98b11ff$var$identity : $2a9d7ce1b98b11ff$var$toSetString;
function $2a9d7ce1b98b11ff$var$fromSetString(aStr) {
    if ($2a9d7ce1b98b11ff$var$isProtoString(aStr)) return aStr.slice(1);
    return aStr;
}
$2a9d7ce1b98b11ff$export$1fc47c3d4c3302a1 = $2a9d7ce1b98b11ff$var$supportsNullProto ? $2a9d7ce1b98b11ff$var$identity : $2a9d7ce1b98b11ff$var$fromSetString;
function $2a9d7ce1b98b11ff$var$isProtoString(s) {
    if (!s) return false;
    var length = s.length;
    if (length < 9 /* "__proto__".length */ ) return false;
    if (s.charCodeAt(length - 1) !== 95 /* '_' */  || s.charCodeAt(length - 2) !== 95 /* '_' */  || s.charCodeAt(length - 3) !== 111 /* 'o' */  || s.charCodeAt(length - 4) !== 116 /* 't' */  || s.charCodeAt(length - 5) !== 111 /* 'o' */  || s.charCodeAt(length - 6) !== 114 /* 'r' */  || s.charCodeAt(length - 7) !== 112 /* 'p' */  || s.charCodeAt(length - 8) !== 95 /* '_' */  || s.charCodeAt(length - 9) !== 95 /* '_' */ ) return false;
    for(var i = length - 10; i >= 0; i--){
        if (s.charCodeAt(i) !== 36 /* '$' */ ) return false;
    }
    return true;
}
/**
 * Comparator between two mappings where the original positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same original source/line/column, but different generated
 * line and column the same. Useful when searching for a mapping with a
 * stubbed out mapping.
 */ function $2a9d7ce1b98b11ff$var$compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
    var cmp = mappingA.source - mappingB.source;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0 || onlyCompareOriginal) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    return mappingA.name - mappingB.name;
}
$2a9d7ce1b98b11ff$export$273077902de92ff2 = $2a9d7ce1b98b11ff$var$compareByOriginalPositions;
/**
 * Comparator between two mappings with deflated source and name indices where
 * the generated positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same generated line and column, but different
 * source/name/original line and column the same. Useful when searching for a
 * mapping with a stubbed out mapping.
 */ function $2a9d7ce1b98b11ff$var$compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0 || onlyCompareGenerated) return cmp;
    cmp = mappingA.source - mappingB.source;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return mappingA.name - mappingB.name;
}
$2a9d7ce1b98b11ff$export$b7acf533941302f6 = $2a9d7ce1b98b11ff$var$compareByGeneratedPositionsDeflated;
function $2a9d7ce1b98b11ff$var$strcmp(aStr1, aStr2) {
    if (aStr1 === aStr2) return 0;
    if (aStr1 > aStr2) return 1;
    return -1;
}
/**
 * Comparator between two mappings with inflated source and name strings where
 * the generated positions are compared.
 */ function $2a9d7ce1b98b11ff$var$compareByGeneratedPositionsInflated(mappingA, mappingB) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = $2a9d7ce1b98b11ff$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return $2a9d7ce1b98b11ff$var$strcmp(mappingA.name, mappingB.name);
}
$2a9d7ce1b98b11ff$export$f9c43907549d61f1 = $2a9d7ce1b98b11ff$var$compareByGeneratedPositionsInflated;

});

parcelRegister("5ZqSJ", function(module, exports) {

$parcel$export(module.exports, "GREATEST_LOWER_BOUND", function () { return $45c780677afc8316$export$4ecd616dce182dff; }, function (v) { return $45c780677afc8316$export$4ecd616dce182dff = v; });
$parcel$export(module.exports, "LEAST_UPPER_BOUND", function () { return $45c780677afc8316$export$b99fbecff261243; }, function (v) { return $45c780677afc8316$export$b99fbecff261243 = v; });
$parcel$export(module.exports, "search", function () { return $45c780677afc8316$export$d76128d007d19019; }, function (v) { return $45c780677afc8316$export$d76128d007d19019 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $45c780677afc8316$export$4ecd616dce182dff;
var $45c780677afc8316$export$b99fbecff261243;
/**
 * This is an implementation of binary search which will always try and return
 * the index of the closest element if there is no exact hit. This is because
 * mappings between original and generated line/col pairs are single points,
 * and there is an implicit region between each of them, so a miss just means
 * that you aren't on the very start of a region.
 *
 * @param aNeedle The element you are looking for.
 * @param aHaystack The array that is being searched.
 * @param aCompare A function which takes the needle and an element in the
 *     array and returns -1, 0, or 1 depending on whether the needle is less
 *     than, equal to, or greater than the element, respectively.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
 */ var $45c780677afc8316$export$d76128d007d19019;
$45c780677afc8316$export$4ecd616dce182dff = 1;
$45c780677afc8316$export$b99fbecff261243 = 2;
/**
 * Recursive implementation of binary search.
 *
 * @param aLow Indices here and lower do not contain the needle.
 * @param aHigh Indices here and higher do not contain the needle.
 * @param aNeedle The element being searched for.
 * @param aHaystack The non-empty array being searched.
 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 */ function $45c780677afc8316$var$recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
    // This function terminates when one of the following is true:
    //
    //   1. We find the exact element we are looking for.
    //
    //   2. We did not find the exact element, but we can return the index of
    //      the next-closest element.
    //
    //   3. We did not find the exact element, and there is no next-closest
    //      element than the one we are searching for, so we return -1.
    var mid = Math.floor((aHigh - aLow) / 2) + aLow;
    var cmp = aCompare(aNeedle, aHaystack[mid], true);
    if (cmp === 0) // Found the element we are looking for.
    return mid;
    else if (cmp > 0) {
        // Our needle is greater than aHaystack[mid].
        if (aHigh - mid > 1) // The element is in the upper half.
        return $45c780677afc8316$var$recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
        // The exact needle element was not found in this haystack. Determine if
        // we are in termination case (3) or (2) and return the appropriate thing.
        if (aBias == $45c780677afc8316$export$b99fbecff261243) return aHigh < aHaystack.length ? aHigh : -1;
        else return mid;
    } else {
        // Our needle is less than aHaystack[mid].
        if (mid - aLow > 1) // The element is in the lower half.
        return $45c780677afc8316$var$recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
        // we are in termination case (3) or (2) and return the appropriate thing.
        if (aBias == $45c780677afc8316$export$b99fbecff261243) return mid;
        else return aLow < 0 ? -1 : aLow;
    }
}
$45c780677afc8316$export$d76128d007d19019 = function search(aNeedle, aHaystack, aCompare, aBias) {
    if (aHaystack.length === 0) return -1;
    var index = $45c780677afc8316$var$recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack, aCompare, aBias || $45c780677afc8316$export$4ecd616dce182dff);
    if (index < 0) return -1;
    // We have found either the exact element, or the next-closest element than
    // the one we are searching for. However, there may be more than one such
    // element. Make sure we always return the smallest of these.
    while(index - 1 >= 0){
        if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) break;
        --index;
    }
    return index;
};

});

parcelRegister("2l96M", function(module, exports) {

$parcel$export(module.exports, "ArraySet", function () { return $1b449ba461b59935$export$605bbf5ea7b60ba3; }, function (v) { return $1b449ba461b59935$export$605bbf5ea7b60ba3 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $1b449ba461b59935$export$605bbf5ea7b60ba3;

var $3EQ3z = parcelRequire("3EQ3z");
var $1b449ba461b59935$var$has = Object.prototype.hasOwnProperty;
/**
 * A data structure which is a combination of an array and a set. Adding a new
 * member is O(1), testing for membership is O(1), and finding the index of an
 * element is O(1). Removing elements from the set is not supported. Only
 * strings are supported for membership.
 */ function $1b449ba461b59935$var$ArraySet() {
    this._array = [];
    this._set = Object.create(null);
}
/**
 * Static method for creating ArraySet instances from an existing array.
 */ $1b449ba461b59935$var$ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
    var set = new $1b449ba461b59935$var$ArraySet();
    for(var i = 0, len = aArray.length; i < len; i++)set.add(aArray[i], aAllowDuplicates);
    return set;
};
/**
 * Return how many unique items are in this ArraySet. If duplicates have been
 * added, than those do not count towards the size.
 *
 * @returns Number
 */ $1b449ba461b59935$var$ArraySet.prototype.size = function ArraySet_size() {
    return Object.getOwnPropertyNames(this._set).length;
};
/**
 * Add the given string to this set.
 *
 * @param String aStr
 */ $1b449ba461b59935$var$ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
    var sStr = $3EQ3z.toSetString(aStr);
    var isDuplicate = $1b449ba461b59935$var$has.call(this._set, sStr);
    var idx = this._array.length;
    if (!isDuplicate || aAllowDuplicates) this._array.push(aStr);
    if (!isDuplicate) this._set[sStr] = idx;
};
/**
 * Is the given string a member of this set?
 *
 * @param String aStr
 */ $1b449ba461b59935$var$ArraySet.prototype.has = function ArraySet_has(aStr) {
    var sStr = $3EQ3z.toSetString(aStr);
    return $1b449ba461b59935$var$has.call(this._set, sStr);
};
/**
 * What is the index of the given string in the array?
 *
 * @param String aStr
 */ $1b449ba461b59935$var$ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
    var sStr = $3EQ3z.toSetString(aStr);
    if ($1b449ba461b59935$var$has.call(this._set, sStr)) return this._set[sStr];
    throw new Error('"' + aStr + '" is not in the set.');
};
/**
 * What is the element at the given index?
 *
 * @param Number aIdx
 */ $1b449ba461b59935$var$ArraySet.prototype.at = function ArraySet_at(aIdx) {
    if (aIdx >= 0 && aIdx < this._array.length) return this._array[aIdx];
    throw new Error("No element indexed by " + aIdx);
};
/**
 * Returns the array representation of this set (which has the proper indices
 * indicated by indexOf). Note that this is a copy of the internal array used
 * for storing the members so that no one can mess with internal state.
 */ $1b449ba461b59935$var$ArraySet.prototype.toArray = function ArraySet_toArray() {
    return this._array.slice();
};
$1b449ba461b59935$export$605bbf5ea7b60ba3 = $1b449ba461b59935$var$ArraySet;

});

parcelRegister("eaDVs", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $a510f845d70a9a11$export$2f872c0f2117be69; }, function (v) { return $a510f845d70a9a11$export$2f872c0f2117be69 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 *
 * Based on the Base 64 VLQ implementation in Closure Compiler:
 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
 *
 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 *  * Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above
 *    copyright notice, this list of conditions and the following
 *    disclaimer in the documentation and/or other materials provided
 *    with the distribution.
 *  * Neither the name of Google Inc. nor the names of its
 *    contributors may be used to endorse or promote products derived
 *    from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /**
 * Returns the base 64 VLQ encoded value.
 */ var $a510f845d70a9a11$export$c564cdbbe6da493;
/**
 * Decodes the next base 64 VLQ value from the given string and returns the
 * value and the rest of the string via the out parameter.
 */ var $a510f845d70a9a11$export$2f872c0f2117be69;

var $4o0bd = parcelRequire("4o0bd");
// A single base 64 digit can contain 6 bits of data. For the base 64 variable
// length quantities we use in the source map spec, the first bit is the sign,
// the next four bits are the actual value, and the 6th bit is the
// continuation bit. The continuation bit tells us whether there are more
// digits in this value following this digit.
//
//   Continuation
//   |    Sign
//   |    |
//   V    V
//   101011
var $a510f845d70a9a11$var$VLQ_BASE_SHIFT = 5;
// binary: 100000
var $a510f845d70a9a11$var$VLQ_BASE = 1 << $a510f845d70a9a11$var$VLQ_BASE_SHIFT;
// binary: 011111
var $a510f845d70a9a11$var$VLQ_BASE_MASK = $a510f845d70a9a11$var$VLQ_BASE - 1;
// binary: 100000
var $a510f845d70a9a11$var$VLQ_CONTINUATION_BIT = $a510f845d70a9a11$var$VLQ_BASE;
/**
 * Converts from a two-complement value to a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
 */ function $a510f845d70a9a11$var$toVLQSigned(aValue) {
    return aValue < 0 ? (-aValue << 1) + 1 : (aValue << 1) + 0;
}
/**
 * Converts to a two-complement value from a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
 */ function $a510f845d70a9a11$var$fromVLQSigned(aValue) {
    var isNegative = (aValue & 1) === 1;
    var shifted = aValue >> 1;
    return isNegative ? -shifted : shifted;
}
$a510f845d70a9a11$export$c564cdbbe6da493 = function base64VLQ_encode(aValue) {
    var encoded = "";
    var digit;
    var vlq = $a510f845d70a9a11$var$toVLQSigned(aValue);
    do {
        digit = vlq & $a510f845d70a9a11$var$VLQ_BASE_MASK;
        vlq >>>= $a510f845d70a9a11$var$VLQ_BASE_SHIFT;
        if (vlq > 0) // There are still more digits in this value, so we must make sure the
        // continuation bit is marked.
        digit |= $a510f845d70a9a11$var$VLQ_CONTINUATION_BIT;
        encoded += $4o0bd.encode(digit);
    }while (vlq > 0);
    return encoded;
};
$a510f845d70a9a11$export$2f872c0f2117be69 = function base64VLQ_decode(aStr, aIndex, aOutParam) {
    var strLen = aStr.length;
    var result = 0;
    var shift = 0;
    var continuation, digit;
    do {
        if (aIndex >= strLen) throw new Error("Expected more digits in base 64 VLQ value.");
        digit = $4o0bd.decode(aStr.charCodeAt(aIndex++));
        if (digit === -1) throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
        continuation = !!(digit & $a510f845d70a9a11$var$VLQ_CONTINUATION_BIT);
        digit &= $a510f845d70a9a11$var$VLQ_BASE_MASK;
        result = result + (digit << shift);
        shift += $a510f845d70a9a11$var$VLQ_BASE_SHIFT;
    }while (continuation);
    aOutParam.value = $a510f845d70a9a11$var$fromVLQSigned(result);
    aOutParam.rest = aIndex;
};

});
parcelRegister("4o0bd", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $33198b0ecedcf354$export$c564cdbbe6da493; }, function (v) { return $33198b0ecedcf354$export$c564cdbbe6da493 = v; });
$parcel$export(module.exports, "decode", function () { return $33198b0ecedcf354$export$2f872c0f2117be69; }, function (v) { return $33198b0ecedcf354$export$2f872c0f2117be69 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ /**
 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
 */ var $33198b0ecedcf354$export$c564cdbbe6da493;
/**
 * Decode a single base 64 character code digit to an integer. Returns -1 on
 * failure.
 */ var $33198b0ecedcf354$export$2f872c0f2117be69;
var $33198b0ecedcf354$var$intToCharMap = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
$33198b0ecedcf354$export$c564cdbbe6da493 = function(number) {
    if (0 <= number && number < $33198b0ecedcf354$var$intToCharMap.length) return $33198b0ecedcf354$var$intToCharMap[number];
    throw new TypeError("Must be between 0 and 63: " + number);
};
$33198b0ecedcf354$export$2f872c0f2117be69 = function(charCode) {
    var bigA = 65; // 'A'
    var bigZ = 90; // 'Z'
    var littleA = 97; // 'a'
    var littleZ = 122; // 'z'
    var zero = 48; // '0'
    var nine = 57; // '9'
    var plus = 43; // '+'
    var slash = 47; // '/'
    var littleOffset = 26;
    var numberOffset = 52;
    // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
    if (bigA <= charCode && charCode <= bigZ) return charCode - bigA;
    // 26 - 51: abcdefghijklmnopqrstuvwxyz
    if (littleA <= charCode && charCode <= littleZ) return charCode - littleA + littleOffset;
    // 52 - 61: 0123456789
    if (zero <= charCode && charCode <= nine) return charCode - zero + numberOffset;
    // 62: +
    if (charCode == plus) return 62;
    // 63: /
    if (charCode == slash) return 63;
    // Invalid base64 digit.
    return -1;
};

});


parcelRegister("liUSf", function(module, exports) {

$parcel$export(module.exports, "quickSort", function () { return $f8276566a2f56d07$export$866270269b9544a5; }, function (v) { return $f8276566a2f56d07$export$866270269b9544a5 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ // It turns out that some (most?) JavaScript engines don't self-host
// `Array.prototype.sort`. This makes sense because C++ will likely remain
// faster than JS when doing raw CPU-intensive sorting. However, when using a
// custom comparator function, calling back and forth between the VM's C++ and
// JIT'd JS is rather slow *and* loses JIT type information, resulting in
// worse generated code for the comparator function than would be optimal. In
// fact, when sorting with a comparator, these costs outweigh the benefits of
// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
// a ~3500ms mean speed-up in `bench/bench.html`.
/**
 * Swap the elements indexed by `x` and `y` in the array `ary`.
 *
 * @param {Array} ary
 *        The array.
 * @param {Number} x
 *        The index of the first item.
 * @param {Number} y
 *        The index of the second item.
 */ /**
 * Sort the given array in-place with the given comparator function.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 */ var $f8276566a2f56d07$export$866270269b9544a5;
function $f8276566a2f56d07$var$swap(ary, x, y) {
    var temp = ary[x];
    ary[x] = ary[y];
    ary[y] = temp;
}
/**
 * Returns a random integer within the range `low .. high` inclusive.
 *
 * @param {Number} low
 *        The lower bound on the range.
 * @param {Number} high
 *        The upper bound on the range.
 */ function $f8276566a2f56d07$var$randomIntInRange(low, high) {
    return Math.round(low + Math.random() * (high - low));
}
/**
 * The Quick Sort algorithm.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 * @param {Number} p
 *        Start index of the array
 * @param {Number} r
 *        End index of the array
 */ function $f8276566a2f56d07$var$doQuickSort(ary, comparator, p, r) {
    // If our lower bound is less than our upper bound, we (1) partition the
    // array into two pieces and (2) recurse on each half. If it is not, this is
    // the empty array and our base case.
    if (p < r) {
        // (1) Partitioning.
        //
        // The partitioning chooses a pivot between `p` and `r` and moves all
        // elements that are less than or equal to the pivot to the before it, and
        // all the elements that are greater than it after it. The effect is that
        // once partition is done, the pivot is in the exact place it will be when
        // the array is put in sorted order, and it will not need to be moved
        // again. This runs in O(n) time.
        // Always choose a random pivot so that an input array which is reverse
        // sorted does not cause O(n^2) running time.
        var pivotIndex = $f8276566a2f56d07$var$randomIntInRange(p, r);
        var i = p - 1;
        $f8276566a2f56d07$var$swap(ary, pivotIndex, r);
        var pivot = ary[r];
        // Immediately after `j` is incremented in this loop, the following hold
        // true:
        //
        //   * Every element in `ary[p .. i]` is less than or equal to the pivot.
        //
        //   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
        for(var j = p; j < r; j++)if (comparator(ary[j], pivot) <= 0) {
            i += 1;
            $f8276566a2f56d07$var$swap(ary, i, j);
        }
        $f8276566a2f56d07$var$swap(ary, i + 1, j);
        var q = i + 1;
        // (2) Recurse on each half.
        $f8276566a2f56d07$var$doQuickSort(ary, comparator, p, q - 1);
        $f8276566a2f56d07$var$doQuickSort(ary, comparator, q + 1, r);
    }
}
$f8276566a2f56d07$export$866270269b9544a5 = function(ary, comparator) {
    $f8276566a2f56d07$var$doQuickSort(ary, comparator, 0, ary.length - 1);
};

});



parcelRegister("jBGyA", function(module, exports) {
(function() {
    var debug = false;
    var root = this;
    var EXIF = function(obj) {
        if (obj instanceof EXIF) return obj;
        if (!(this instanceof EXIF)) return new EXIF(obj);
        this.EXIFwrapped = obj;
    };
    if (0, module.exports) exports = module.exports = EXIF;
    exports.EXIF = EXIF;
    var ExifTags = EXIF.Tags = {
        // version tags
        0x9000: "ExifVersion",
        0xA000: "FlashpixVersion",
        // colorspace tags
        0xA001: "ColorSpace",
        // image configuration
        0xA002: "PixelXDimension",
        0xA003: "PixelYDimension",
        0x9101: "ComponentsConfiguration",
        0x9102: "CompressedBitsPerPixel",
        // user information
        0x927C: "MakerNote",
        0x9286: "UserComment",
        // related file
        0xA004: "RelatedSoundFile",
        // date and time
        0x9003: "DateTimeOriginal",
        0x9004: "DateTimeDigitized",
        0x9290: "SubsecTime",
        0x9291: "SubsecTimeOriginal",
        0x9292: "SubsecTimeDigitized",
        // picture-taking conditions
        0x829A: "ExposureTime",
        0x829D: "FNumber",
        0x8822: "ExposureProgram",
        0x8824: "SpectralSensitivity",
        0x8827: "ISOSpeedRatings",
        0x8828: "OECF",
        0x9201: "ShutterSpeedValue",
        0x9202: "ApertureValue",
        0x9203: "BrightnessValue",
        0x9204: "ExposureBias",
        0x9205: "MaxApertureValue",
        0x9206: "SubjectDistance",
        0x9207: "MeteringMode",
        0x9208: "LightSource",
        0x9209: "Flash",
        0x9214: "SubjectArea",
        0x920A: "FocalLength",
        0xA20B: "FlashEnergy",
        0xA20C: "SpatialFrequencyResponse",
        0xA20E: "FocalPlaneXResolution",
        0xA20F: "FocalPlaneYResolution",
        0xA210: "FocalPlaneResolutionUnit",
        0xA214: "SubjectLocation",
        0xA215: "ExposureIndex",
        0xA217: "SensingMethod",
        0xA300: "FileSource",
        0xA301: "SceneType",
        0xA302: "CFAPattern",
        0xA401: "CustomRendered",
        0xA402: "ExposureMode",
        0xA403: "WhiteBalance",
        0xA404: "DigitalZoomRation",
        0xA405: "FocalLengthIn35mmFilm",
        0xA406: "SceneCaptureType",
        0xA407: "GainControl",
        0xA408: "Contrast",
        0xA409: "Saturation",
        0xA40A: "Sharpness",
        0xA40B: "DeviceSettingDescription",
        0xA40C: "SubjectDistanceRange",
        // other tags
        0xA005: "InteroperabilityIFDPointer",
        0xA420: "ImageUniqueID" // Identifier assigned uniquely to each image
    };
    var TiffTags = EXIF.TiffTags = {
        0x0100: "ImageWidth",
        0x0101: "ImageHeight",
        0x8769: "ExifIFDPointer",
        0x8825: "GPSInfoIFDPointer",
        0xA005: "InteroperabilityIFDPointer",
        0x0102: "BitsPerSample",
        0x0103: "Compression",
        0x0106: "PhotometricInterpretation",
        0x0112: "Orientation",
        0x0115: "SamplesPerPixel",
        0x011C: "PlanarConfiguration",
        0x0212: "YCbCrSubSampling",
        0x0213: "YCbCrPositioning",
        0x011A: "XResolution",
        0x011B: "YResolution",
        0x0128: "ResolutionUnit",
        0x0111: "StripOffsets",
        0x0116: "RowsPerStrip",
        0x0117: "StripByteCounts",
        0x0201: "JPEGInterchangeFormat",
        0x0202: "JPEGInterchangeFormatLength",
        0x012D: "TransferFunction",
        0x013E: "WhitePoint",
        0x013F: "PrimaryChromaticities",
        0x0211: "YCbCrCoefficients",
        0x0214: "ReferenceBlackWhite",
        0x0132: "DateTime",
        0x010E: "ImageDescription",
        0x010F: "Make",
        0x0110: "Model",
        0x0131: "Software",
        0x013B: "Artist",
        0x8298: "Copyright"
    };
    var GPSTags = EXIF.GPSTags = {
        0x0000: "GPSVersionID",
        0x0001: "GPSLatitudeRef",
        0x0002: "GPSLatitude",
        0x0003: "GPSLongitudeRef",
        0x0004: "GPSLongitude",
        0x0005: "GPSAltitudeRef",
        0x0006: "GPSAltitude",
        0x0007: "GPSTimeStamp",
        0x0008: "GPSSatellites",
        0x0009: "GPSStatus",
        0x000A: "GPSMeasureMode",
        0x000B: "GPSDOP",
        0x000C: "GPSSpeedRef",
        0x000D: "GPSSpeed",
        0x000E: "GPSTrackRef",
        0x000F: "GPSTrack",
        0x0010: "GPSImgDirectionRef",
        0x0011: "GPSImgDirection",
        0x0012: "GPSMapDatum",
        0x0013: "GPSDestLatitudeRef",
        0x0014: "GPSDestLatitude",
        0x0015: "GPSDestLongitudeRef",
        0x0016: "GPSDestLongitude",
        0x0017: "GPSDestBearingRef",
        0x0018: "GPSDestBearing",
        0x0019: "GPSDestDistanceRef",
        0x001A: "GPSDestDistance",
        0x001B: "GPSProcessingMethod",
        0x001C: "GPSAreaInformation",
        0x001D: "GPSDateStamp",
        0x001E: "GPSDifferential"
    };
    // EXIF 2.3 Spec
    var IFD1Tags = EXIF.IFD1Tags = {
        0x0100: "ImageWidth",
        0x0101: "ImageHeight",
        0x0102: "BitsPerSample",
        0x0103: "Compression",
        0x0106: "PhotometricInterpretation",
        0x0111: "StripOffsets",
        0x0112: "Orientation",
        0x0115: "SamplesPerPixel",
        0x0116: "RowsPerStrip",
        0x0117: "StripByteCounts",
        0x011A: "XResolution",
        0x011B: "YResolution",
        0x011C: "PlanarConfiguration",
        0x0128: "ResolutionUnit",
        0x0201: "JpegIFOffset",
        0x0202: "JpegIFByteCount",
        0x0211: "YCbCrCoefficients",
        0x0212: "YCbCrSubSampling",
        0x0213: "YCbCrPositioning",
        0x0214: "ReferenceBlackWhite"
    };
    var StringValues = EXIF.StringValues = {
        ExposureProgram: {
            0: "Not defined",
            1: "Manual",
            2: "Normal program",
            3: "Aperture priority",
            4: "Shutter priority",
            5: "Creative program",
            6: "Action program",
            7: "Portrait mode",
            8: "Landscape mode"
        },
        MeteringMode: {
            0: "Unknown",
            1: "Average",
            2: "CenterWeightedAverage",
            3: "Spot",
            4: "MultiSpot",
            5: "Pattern",
            6: "Partial",
            255: "Other"
        },
        LightSource: {
            0: "Unknown",
            1: "Daylight",
            2: "Fluorescent",
            3: "Tungsten (incandescent light)",
            4: "Flash",
            9: "Fine weather",
            10: "Cloudy weather",
            11: "Shade",
            12: "Daylight fluorescent (D 5700 - 7100K)",
            13: "Day white fluorescent (N 4600 - 5400K)",
            14: "Cool white fluorescent (W 3900 - 4500K)",
            15: "White fluorescent (WW 3200 - 3700K)",
            17: "Standard light A",
            18: "Standard light B",
            19: "Standard light C",
            20: "D55",
            21: "D65",
            22: "D75",
            23: "D50",
            24: "ISO studio tungsten",
            255: "Other"
        },
        Flash: {
            0x0000: "Flash did not fire",
            0x0001: "Flash fired",
            0x0005: "Strobe return light not detected",
            0x0007: "Strobe return light detected",
            0x0009: "Flash fired, compulsory flash mode",
            0x000D: "Flash fired, compulsory flash mode, return light not detected",
            0x000F: "Flash fired, compulsory flash mode, return light detected",
            0x0010: "Flash did not fire, compulsory flash mode",
            0x0018: "Flash did not fire, auto mode",
            0x0019: "Flash fired, auto mode",
            0x001D: "Flash fired, auto mode, return light not detected",
            0x001F: "Flash fired, auto mode, return light detected",
            0x0020: "No flash function",
            0x0041: "Flash fired, red-eye reduction mode",
            0x0045: "Flash fired, red-eye reduction mode, return light not detected",
            0x0047: "Flash fired, red-eye reduction mode, return light detected",
            0x0049: "Flash fired, compulsory flash mode, red-eye reduction mode",
            0x004D: "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
            0x004F: "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
            0x0059: "Flash fired, auto mode, red-eye reduction mode",
            0x005D: "Flash fired, auto mode, return light not detected, red-eye reduction mode",
            0x005F: "Flash fired, auto mode, return light detected, red-eye reduction mode"
        },
        SensingMethod: {
            1: "Not defined",
            2: "One-chip color area sensor",
            3: "Two-chip color area sensor",
            4: "Three-chip color area sensor",
            5: "Color sequential area sensor",
            7: "Trilinear sensor",
            8: "Color sequential linear sensor"
        },
        SceneCaptureType: {
            0: "Standard",
            1: "Landscape",
            2: "Portrait",
            3: "Night scene"
        },
        SceneType: {
            1: "Directly photographed"
        },
        CustomRendered: {
            0: "Normal process",
            1: "Custom process"
        },
        WhiteBalance: {
            0: "Auto white balance",
            1: "Manual white balance"
        },
        GainControl: {
            0: "None",
            1: "Low gain up",
            2: "High gain up",
            3: "Low gain down",
            4: "High gain down"
        },
        Contrast: {
            0: "Normal",
            1: "Soft",
            2: "Hard"
        },
        Saturation: {
            0: "Normal",
            1: "Low saturation",
            2: "High saturation"
        },
        Sharpness: {
            0: "Normal",
            1: "Soft",
            2: "Hard"
        },
        SubjectDistanceRange: {
            0: "Unknown",
            1: "Macro",
            2: "Close view",
            3: "Distant view"
        },
        FileSource: {
            3: "DSC"
        },
        Components: {
            0: "",
            1: "Y",
            2: "Cb",
            3: "Cr",
            4: "R",
            5: "G",
            6: "B"
        }
    };
    function addEvent(element, event, handler) {
        if (element.addEventListener) element.addEventListener(event, handler, false);
        else if (element.attachEvent) element.attachEvent("on" + event, handler);
    }
    function imageHasData(img) {
        return !!img.exifdata;
    }
    function base64ToArrayBuffer(base64, contentType) {
        contentType = contentType || base64.match(/^data\:([^\;]+)\;base64,/mi)[1] || ""; // e.g. 'data:image/jpeg;base64,...' => 'image/jpeg'
        base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, "");
        var binary = atob(base64);
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);
        for(var i = 0; i < len; i++)view[i] = binary.charCodeAt(i);
        return buffer;
    }
    function objectURLToBlob(url, callback) {
        var http = new XMLHttpRequest();
        http.open("GET", url, true);
        http.responseType = "blob";
        http.onload = function(e) {
            if (this.status == 200 || this.status === 0) callback(this.response);
        };
        http.send();
    }
    function getImageData(img, callback) {
        function handleBinaryFile(binFile) {
            var data = findEXIFinJPEG(binFile);
            img.exifdata = data || {};
            var iptcdata = findIPTCinJPEG(binFile);
            img.iptcdata = iptcdata || {};
            if (EXIF.isXmpEnabled) {
                var xmpdata = findXMPinJPEG(binFile);
                img.xmpdata = xmpdata || {};
            }
            if (callback) callback.call(img);
        }
        if (img.src) {
            if (/^data\:/i.test(img.src)) {
                var arrayBuffer = base64ToArrayBuffer(img.src);
                handleBinaryFile(arrayBuffer);
            } else if (/^blob\:/i.test(img.src)) {
                var fileReader = new FileReader();
                fileReader.onload = function(e) {
                    handleBinaryFile(e.target.result);
                };
                objectURLToBlob(img.src, function(blob) {
                    fileReader.readAsArrayBuffer(blob);
                });
            } else {
                var http = new XMLHttpRequest();
                http.onload = function() {
                    if (this.status == 200 || this.status === 0) handleBinaryFile(http.response);
                    else throw "Could not load image";
                    http = null;
                };
                http.open("GET", img.src, true);
                http.responseType = "arraybuffer";
                http.send(null);
            }
        } else if (self.FileReader && (img instanceof self.Blob || img instanceof self.File)) {
            var fileReader = new FileReader();
            fileReader.onload = function(e) {
                if (debug) console.log("Got file of length " + e.target.result.byteLength);
                handleBinaryFile(e.target.result);
            };
            fileReader.readAsArrayBuffer(img);
        }
    }
    function findEXIFinJPEG(file) {
        var dataView = new DataView(file);
        if (debug) console.log("Got file of length " + file.byteLength);
        if (dataView.getUint8(0) != 0xFF || dataView.getUint8(1) != 0xD8) {
            if (debug) console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }
        var offset = 2, length = file.byteLength, marker;
        while(offset < length){
            if (dataView.getUint8(offset) != 0xFF) {
                if (debug) console.log("Not a valid marker at offset " + offset + ", found: " + dataView.getUint8(offset));
                return false; // not a valid marker, something is wrong
            }
            marker = dataView.getUint8(offset + 1);
            if (debug) console.log(marker);
            // we could implement handling for other markers here,
            // but we're only looking for 0xFFE1 for EXIF data
            if (marker == 225) {
                if (debug) console.log("Found 0xFFE1 marker");
                return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2);
            // offset += 2 + file.getShortAt(offset+2, true);
            } else offset += 2 + dataView.getUint16(offset + 2);
        }
    }
    function findIPTCinJPEG(file) {
        var dataView = new DataView(file);
        if (debug) console.log("Got file of length " + file.byteLength);
        if (dataView.getUint8(0) != 0xFF || dataView.getUint8(1) != 0xD8) {
            if (debug) console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }
        var offset = 2, length = file.byteLength;
        var isFieldSegmentStart = function(dataView, offset) {
            return dataView.getUint8(offset) === 0x38 && dataView.getUint8(offset + 1) === 0x42 && dataView.getUint8(offset + 2) === 0x49 && dataView.getUint8(offset + 3) === 0x4D && dataView.getUint8(offset + 4) === 0x04 && dataView.getUint8(offset + 5) === 0x04;
        };
        while(offset < length){
            if (isFieldSegmentStart(dataView, offset)) {
                // Get the length of the name header (which is padded to an even number of bytes)
                var nameHeaderLength = dataView.getUint8(offset + 7);
                if (nameHeaderLength % 2 !== 0) nameHeaderLength += 1;
                // Check for pre photoshop 6 format
                if (nameHeaderLength === 0) // Always 4
                nameHeaderLength = 4;
                var startOffset = offset + 8 + nameHeaderLength;
                var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);
                return readIPTCData(file, startOffset, sectionLength);
            }
            // Not the marker, continue searching
            offset++;
        }
    }
    var IptcFieldMap = {
        0x78: "caption",
        0x6E: "credit",
        0x19: "keywords",
        0x37: "dateCreated",
        0x50: "byline",
        0x55: "bylineTitle",
        0x7A: "captionWriter",
        0x69: "headline",
        0x74: "copyright",
        0x0F: "category"
    };
    function readIPTCData(file, startOffset, sectionLength) {
        var dataView = new DataView(file);
        var data = {};
        var fieldValue, fieldName, dataSize, segmentType, segmentSize;
        var segmentStartPos = startOffset;
        while(segmentStartPos < startOffset + sectionLength){
            if (dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos + 1) === 0x02) {
                segmentType = dataView.getUint8(segmentStartPos + 2);
                if (segmentType in IptcFieldMap) {
                    dataSize = dataView.getInt16(segmentStartPos + 3);
                    segmentSize = dataSize + 5;
                    fieldName = IptcFieldMap[segmentType];
                    fieldValue = getStringFromDB(dataView, segmentStartPos + 5, dataSize);
                    // Check if we already stored a value with this name
                    if (data.hasOwnProperty(fieldName)) {
                        // Value already stored with this name, create multivalue field
                        if (data[fieldName] instanceof Array) data[fieldName].push(fieldValue);
                        else data[fieldName] = [
                            data[fieldName],
                            fieldValue
                        ];
                    } else data[fieldName] = fieldValue;
                }
            }
            segmentStartPos++;
        }
        return data;
    }
    function readTags(file, tiffStart, dirStart, strings, bigEnd) {
        var entries = file.getUint16(dirStart, !bigEnd), tags = {}, entryOffset, tag, i;
        for(i = 0; i < entries; i++){
            entryOffset = dirStart + i * 12 + 2;
            tag = strings[file.getUint16(entryOffset, !bigEnd)];
            if (!tag && debug) console.log("Unknown tag: " + file.getUint16(entryOffset, !bigEnd));
            tags[tag] = readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
        }
        return tags;
    }
    function readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd) {
        var type = file.getUint16(entryOffset + 2, !bigEnd), numValues = file.getUint32(entryOffset + 4, !bigEnd), valueOffset = file.getUint32(entryOffset + 8, !bigEnd) + tiffStart, offset, vals, val, n1, numerator, denominator;
        switch(type){
            case 1:
            case 7:
                if (numValues == 1) return file.getUint8(entryOffset + 8, !bigEnd);
                else {
                    offset = numValues > 4 ? valueOffset : entryOffset + 8;
                    vals = [];
                    for(n1 = 0; n1 < numValues; n1++)vals[n1] = file.getUint8(offset + n1);
                    return vals;
                }
            case 2:
                offset = numValues > 4 ? valueOffset : entryOffset + 8;
                return getStringFromDB(file, offset, numValues - 1);
            case 3:
                if (numValues == 1) return file.getUint16(entryOffset + 8, !bigEnd);
                else {
                    offset = numValues > 2 ? valueOffset : entryOffset + 8;
                    vals = [];
                    for(n1 = 0; n1 < numValues; n1++)vals[n1] = file.getUint16(offset + 2 * n1, !bigEnd);
                    return vals;
                }
            case 4:
                if (numValues == 1) return file.getUint32(entryOffset + 8, !bigEnd);
                else {
                    vals = [];
                    for(n1 = 0; n1 < numValues; n1++)vals[n1] = file.getUint32(valueOffset + 4 * n1, !bigEnd);
                    return vals;
                }
            case 5:
                if (numValues == 1) {
                    numerator = file.getUint32(valueOffset, !bigEnd);
                    denominator = file.getUint32(valueOffset + 4, !bigEnd);
                    val = new Number(numerator / denominator);
                    val.numerator = numerator;
                    val.denominator = denominator;
                    return val;
                } else {
                    vals = [];
                    for(n1 = 0; n1 < numValues; n1++){
                        numerator = file.getUint32(valueOffset + 8 * n1, !bigEnd);
                        denominator = file.getUint32(valueOffset + 4 + 8 * n1, !bigEnd);
                        vals[n1] = new Number(numerator / denominator);
                        vals[n1].numerator = numerator;
                        vals[n1].denominator = denominator;
                    }
                    return vals;
                }
            case 9:
                if (numValues == 1) return file.getInt32(entryOffset + 8, !bigEnd);
                else {
                    vals = [];
                    for(n1 = 0; n1 < numValues; n1++)vals[n1] = file.getInt32(valueOffset + 4 * n1, !bigEnd);
                    return vals;
                }
            case 10:
                if (numValues == 1) return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset + 4, !bigEnd);
                else {
                    vals = [];
                    for(n1 = 0; n1 < numValues; n1++)vals[n1] = file.getInt32(valueOffset + 8 * n1, !bigEnd) / file.getInt32(valueOffset + 4 + 8 * n1, !bigEnd);
                    return vals;
                }
        }
    }
    /**
    * Given an IFD (Image File Directory) start offset
    * returns an offset to next IFD or 0 if it's the last IFD.
    */ function getNextIFDOffset(dataView, dirStart, bigEnd) {
        //the first 2bytes means the number of directory entries contains in this IFD
        var entries = dataView.getUint16(dirStart, !bigEnd);
        // After last directory entry, there is a 4bytes of data,
        // it means an offset to next IFD.
        // If its value is '0x00000000', it means this is the last IFD and there is no linked IFD.
        return dataView.getUint32(dirStart + 2 + entries * 12, !bigEnd); // each entry is 12 bytes long
    }
    function readThumbnailImage(dataView, tiffStart, firstIFDOffset, bigEnd) {
        // get the IFD1 offset
        var IFD1OffsetPointer = getNextIFDOffset(dataView, tiffStart + firstIFDOffset, bigEnd);
        if (!IFD1OffsetPointer) // console.log('******** IFD1Offset is empty, image thumb not found ********');
        return {};
        else if (IFD1OffsetPointer > dataView.byteLength) // console.log('******** IFD1Offset is outside the bounds of the DataView ********');
        return {};
        // console.log('*******  thumbnail IFD offset (IFD1) is: %s', IFD1OffsetPointer);
        var thumbTags = readTags(dataView, tiffStart, tiffStart + IFD1OffsetPointer, IFD1Tags, bigEnd);
        // EXIF 2.3 specification for JPEG format thumbnail
        // If the value of Compression(0x0103) Tag in IFD1 is '6', thumbnail image format is JPEG.
        // Most of Exif image uses JPEG format for thumbnail. In that case, you can get offset of thumbnail
        // by JpegIFOffset(0x0201) Tag in IFD1, size of thumbnail by JpegIFByteCount(0x0202) Tag.
        // Data format is ordinary JPEG format, starts from 0xFFD8 and ends by 0xFFD9. It seems that
        // JPEG format and 160x120pixels of size are recommended thumbnail format for Exif2.1 or later.
        if (thumbTags["Compression"]) // console.log('Thumbnail image found!');
        switch(thumbTags["Compression"]){
            case 6:
                // console.log('Thumbnail image format is JPEG');
                if (thumbTags.JpegIFOffset && thumbTags.JpegIFByteCount) {
                    // extract the thumbnail
                    var tOffset = tiffStart + thumbTags.JpegIFOffset;
                    var tLength = thumbTags.JpegIFByteCount;
                    thumbTags["blob"] = new Blob([
                        new Uint8Array(dataView.buffer, tOffset, tLength)
                    ], {
                        type: "image/jpeg"
                    });
                }
                break;
            case 1:
                console.log("Thumbnail image format is TIFF, which is not implemented.");
                break;
            default:
                console.log("Unknown thumbnail image format '%s'", thumbTags["Compression"]);
        }
        else if (thumbTags["PhotometricInterpretation"] == 2) console.log("Thumbnail image format is RGB, which is not implemented.");
        return thumbTags;
    }
    function getStringFromDB(buffer, start, length) {
        var outstr = "";
        for(n = start; n < start + length; n++)outstr += String.fromCharCode(buffer.getUint8(n));
        return outstr;
    }
    function readEXIFData(file, start) {
        if (getStringFromDB(file, start, 4) != "Exif") {
            if (debug) console.log("Not valid EXIF data! " + getStringFromDB(file, start, 4));
            return false;
        }
        var bigEnd, tags, tag, exifData, gpsData, tiffOffset = start + 6;
        // test for TIFF validity and endianness
        if (file.getUint16(tiffOffset) == 0x4949) bigEnd = false;
        else if (file.getUint16(tiffOffset) == 0x4D4D) bigEnd = true;
        else {
            if (debug) console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)");
            return false;
        }
        if (file.getUint16(tiffOffset + 2, !bigEnd) != 0x002A) {
            if (debug) console.log("Not valid TIFF data! (no 0x002A)");
            return false;
        }
        var firstIFDOffset = file.getUint32(tiffOffset + 4, !bigEnd);
        if (firstIFDOffset < 0x00000008) {
            if (debug) console.log("Not valid TIFF data! (First offset less than 8)", file.getUint32(tiffOffset + 4, !bigEnd));
            return false;
        }
        tags = readTags(file, tiffOffset, tiffOffset + firstIFDOffset, TiffTags, bigEnd);
        if (tags.ExifIFDPointer) {
            exifData = readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, ExifTags, bigEnd);
            for(tag in exifData){
                switch(tag){
                    case "LightSource":
                    case "Flash":
                    case "MeteringMode":
                    case "ExposureProgram":
                    case "SensingMethod":
                    case "SceneCaptureType":
                    case "SceneType":
                    case "CustomRendered":
                    case "WhiteBalance":
                    case "GainControl":
                    case "Contrast":
                    case "Saturation":
                    case "Sharpness":
                    case "SubjectDistanceRange":
                    case "FileSource":
                        exifData[tag] = StringValues[tag][exifData[tag]];
                        break;
                    case "ExifVersion":
                    case "FlashpixVersion":
                        exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
                        break;
                    case "ComponentsConfiguration":
                        exifData[tag] = StringValues.Components[exifData[tag][0]] + StringValues.Components[exifData[tag][1]] + StringValues.Components[exifData[tag][2]] + StringValues.Components[exifData[tag][3]];
                        break;
                }
                tags[tag] = exifData[tag];
            }
        }
        if (tags.GPSInfoIFDPointer) {
            gpsData = readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, GPSTags, bigEnd);
            for(tag in gpsData){
                switch(tag){
                    case "GPSVersionID":
                        gpsData[tag] = gpsData[tag][0] + "." + gpsData[tag][1] + "." + gpsData[tag][2] + "." + gpsData[tag][3];
                        break;
                }
                tags[tag] = gpsData[tag];
            }
        }
        // extract thumbnail
        tags["thumbnail"] = readThumbnailImage(file, tiffOffset, firstIFDOffset, bigEnd);
        return tags;
    }
    function findXMPinJPEG(file) {
        if (!("DOMParser" in self)) // console.warn('XML parsing not supported without DOMParser');
        return;
        var dataView = new DataView(file);
        if (debug) console.log("Got file of length " + file.byteLength);
        if (dataView.getUint8(0) != 0xFF || dataView.getUint8(1) != 0xD8) {
            if (debug) console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }
        var offset = 2, length = file.byteLength, dom = new DOMParser();
        while(offset < length - 4)if (getStringFromDB(dataView, offset, 4) == "http") {
            var startOffset = offset - 1;
            var sectionLength = dataView.getUint16(offset - 2) - 1;
            var xmpString = getStringFromDB(dataView, startOffset, sectionLength);
            var xmpEndIndex = xmpString.indexOf("xmpmeta>") + 8;
            xmpString = xmpString.substring(xmpString.indexOf("<x:xmpmeta"), xmpEndIndex);
            var indexOfXmp = xmpString.indexOf("x:xmpmeta") + 10;
            //Many custom written programs embed xmp/xml without any namespace. Following are some of them.
            //Without these namespaces, XML is thought to be invalid by parsers
            xmpString = xmpString.slice(0, indexOfXmp) + 'xmlns:Iptc4xmpCore="http://iptc.org/std/Iptc4xmpCore/1.0/xmlns/" ' + 'xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" ' + 'xmlns:tiff="http://ns.adobe.com/tiff/1.0/" ' + 'xmlns:plus="http://schemas.android.com/apk/lib/com.google.android.gms.plus" ' + 'xmlns:ext="http://www.gettyimages.com/xsltExtension/1.0" ' + 'xmlns:exif="http://ns.adobe.com/exif/1.0/" ' + 'xmlns:stEvt="http://ns.adobe.com/xap/1.0/sType/ResourceEvent#" ' + 'xmlns:stRef="http://ns.adobe.com/xap/1.0/sType/ResourceRef#" ' + 'xmlns:crs="http://ns.adobe.com/camera-raw-settings/1.0/" ' + 'xmlns:xapGImg="http://ns.adobe.com/xap/1.0/g/img/" ' + 'xmlns:Iptc4xmpExt="http://iptc.org/std/Iptc4xmpExt/2008-02-29/" ' + xmpString.slice(indexOfXmp);
            var domDocument = dom.parseFromString(xmpString, "text/xml");
            return xml2Object(domDocument);
        } else offset++;
    }
    function xml2json(xml) {
        var json = {};
        if (xml.nodeType == 1) {
            if (xml.attributes.length > 0) {
                json["@attributes"] = {};
                for(var j = 0; j < xml.attributes.length; j++){
                    var attribute = xml.attributes.item(j);
                    json["@attributes"][attribute.nodeName] = attribute.nodeValue;
                }
            }
        } else if (xml.nodeType == 3) return xml.nodeValue;
        // deal with children
        if (xml.hasChildNodes()) for(var i = 0; i < xml.childNodes.length; i++){
            var child = xml.childNodes.item(i);
            var nodeName = child.nodeName;
            if (json[nodeName] == null) json[nodeName] = xml2json(child);
            else {
                if (json[nodeName].push == null) {
                    var old = json[nodeName];
                    json[nodeName] = [];
                    json[nodeName].push(old);
                }
                json[nodeName].push(xml2json(child));
            }
        }
        return json;
    }
    function xml2Object(xml) {
        try {
            var obj = {};
            if (xml.children.length > 0) for(var i = 0; i < xml.children.length; i++){
                var item = xml.children.item(i);
                var attributes = item.attributes;
                for(var idx in attributes){
                    var itemAtt = attributes[idx];
                    var dataKey = itemAtt.nodeName;
                    var dataValue = itemAtt.nodeValue;
                    if (dataKey !== undefined) obj[dataKey] = dataValue;
                }
                var nodeName = item.nodeName;
                if (typeof obj[nodeName] == "undefined") obj[nodeName] = xml2json(item);
                else {
                    if (typeof obj[nodeName].push == "undefined") {
                        var old = obj[nodeName];
                        obj[nodeName] = [];
                        obj[nodeName].push(old);
                    }
                    obj[nodeName].push(xml2json(item));
                }
            }
            else obj = xml.textContent;
            return obj;
        } catch (e) {
            console.log(e.message);
        }
    }
    EXIF.enableXmp = function() {
        EXIF.isXmpEnabled = true;
    };
    EXIF.disableXmp = function() {
        EXIF.isXmpEnabled = false;
    };
    EXIF.getData = function(img, callback) {
        if ((self.Image && img instanceof self.Image || self.HTMLImageElement && img instanceof self.HTMLImageElement) && !img.complete) return false;
        if (!imageHasData(img)) getImageData(img, callback);
        else if (callback) callback.call(img);
        return true;
    };
    EXIF.getTag = function(img, tag) {
        if (!imageHasData(img)) return;
        return img.exifdata[tag];
    };
    EXIF.getIptcTag = function(img, tag) {
        if (!imageHasData(img)) return;
        return img.iptcdata[tag];
    };
    EXIF.getAllTags = function(img) {
        if (!imageHasData(img)) return {};
        var a, data = img.exifdata, tags = {};
        for(a in data)if (data.hasOwnProperty(a)) tags[a] = data[a];
        return tags;
    };
    EXIF.getAllIptcTags = function(img) {
        if (!imageHasData(img)) return {};
        var a, data = img.iptcdata, tags = {};
        for(a in data)if (data.hasOwnProperty(a)) tags[a] = data[a];
        return tags;
    };
    EXIF.pretty = function(img) {
        if (!imageHasData(img)) return "";
        var a, data = img.exifdata, strPretty = "";
        for(a in data)if (data.hasOwnProperty(a)) {
            if (typeof data[a] == "object") {
                if (data[a] instanceof Number) strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
                else strPretty += a + " : [" + data[a].length + " values]\r\n";
            } else strPretty += a + " : " + data[a] + "\r\n";
        }
        return strPretty;
    };
    EXIF.readFromBinaryFile = function(file) {
        return findEXIFinJPEG(file);
    };
    if (typeof define === "function" && define.amd) define("exif-js", [], function() {
        return EXIF;
    });
}).call(this);

});

parcelRegister("g5acy", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $bb5506cc58c54722$var$Stream;

var $dG33B = parcelRequire("dG33B");
var $bb5506cc58c54722$require$EE = $dG33B.EventEmitter;

var $9M38k = parcelRequire("9M38k");
$9M38k($bb5506cc58c54722$var$Stream, $bb5506cc58c54722$require$EE);

$bb5506cc58c54722$var$Stream.Readable = (parcelRequire("gI7KH"));

$bb5506cc58c54722$var$Stream.Writable = (parcelRequire("h57Ja"));

$bb5506cc58c54722$var$Stream.Duplex = (parcelRequire("djKha"));

$bb5506cc58c54722$var$Stream.Transform = (parcelRequire("jwvFo"));

$bb5506cc58c54722$var$Stream.PassThrough = (parcelRequire("dPjGZ"));

$bb5506cc58c54722$var$Stream.finished = (parcelRequire("8flRm"));

$bb5506cc58c54722$var$Stream.pipeline = (parcelRequire("1K5UB"));
// Backwards-compat with node 0.4.x
$bb5506cc58c54722$var$Stream.Stream = $bb5506cc58c54722$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $bb5506cc58c54722$var$Stream() {
    $bb5506cc58c54722$require$EE.call(this);
}
$bb5506cc58c54722$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($bb5506cc58c54722$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("dG33B", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $9f5191ad6e142a03$var$R = typeof Reflect === "object" ? Reflect : null;
var $9f5191ad6e142a03$var$ReflectApply = $9f5191ad6e142a03$var$R && typeof $9f5191ad6e142a03$var$R.apply === "function" ? $9f5191ad6e142a03$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $9f5191ad6e142a03$var$ReflectOwnKeys;
if ($9f5191ad6e142a03$var$R && typeof $9f5191ad6e142a03$var$R.ownKeys === "function") $9f5191ad6e142a03$var$ReflectOwnKeys = $9f5191ad6e142a03$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $9f5191ad6e142a03$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $9f5191ad6e142a03$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $9f5191ad6e142a03$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $9f5191ad6e142a03$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $9f5191ad6e142a03$var$EventEmitter() {
    $9f5191ad6e142a03$var$EventEmitter.init.call(this);
}
module.exports = $9f5191ad6e142a03$var$EventEmitter;
module.exports.once = $9f5191ad6e142a03$var$once;
// Backwards-compat with node 0.10.x
$9f5191ad6e142a03$var$EventEmitter.EventEmitter = $9f5191ad6e142a03$var$EventEmitter;
$9f5191ad6e142a03$var$EventEmitter.prototype._events = undefined;
$9f5191ad6e142a03$var$EventEmitter.prototype._eventsCount = 0;
$9f5191ad6e142a03$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $9f5191ad6e142a03$var$defaultMaxListeners = 10;
function $9f5191ad6e142a03$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($9f5191ad6e142a03$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $9f5191ad6e142a03$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $9f5191ad6e142a03$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $9f5191ad6e142a03$var$defaultMaxListeners = arg;
    }
});
$9f5191ad6e142a03$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$9f5191ad6e142a03$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $9f5191ad6e142a03$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $9f5191ad6e142a03$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $9f5191ad6e142a03$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$9f5191ad6e142a03$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $9f5191ad6e142a03$var$_getMaxListeners(this);
};
$9f5191ad6e142a03$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $9f5191ad6e142a03$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $9f5191ad6e142a03$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$9f5191ad6e142a03$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $9f5191ad6e142a03$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $9f5191ad6e142a03$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $9f5191ad6e142a03$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $9f5191ad6e142a03$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$9f5191ad6e142a03$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $9f5191ad6e142a03$var$_addListener(this, type, listener, false);
};
$9f5191ad6e142a03$var$EventEmitter.prototype.on = $9f5191ad6e142a03$var$EventEmitter.prototype.addListener;
$9f5191ad6e142a03$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $9f5191ad6e142a03$var$_addListener(this, type, listener, true);
};
function $9f5191ad6e142a03$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $9f5191ad6e142a03$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $9f5191ad6e142a03$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$9f5191ad6e142a03$var$EventEmitter.prototype.once = function once(type, listener) {
    $9f5191ad6e142a03$var$checkListener(listener);
    this.on(type, $9f5191ad6e142a03$var$_onceWrap(this, type, listener));
    return this;
};
$9f5191ad6e142a03$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $9f5191ad6e142a03$var$checkListener(listener);
    this.prependListener(type, $9f5191ad6e142a03$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$9f5191ad6e142a03$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $9f5191ad6e142a03$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $9f5191ad6e142a03$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$9f5191ad6e142a03$var$EventEmitter.prototype.off = $9f5191ad6e142a03$var$EventEmitter.prototype.removeListener;
$9f5191ad6e142a03$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $9f5191ad6e142a03$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $9f5191ad6e142a03$var$unwrapListeners(evlistener) : $9f5191ad6e142a03$var$arrayClone(evlistener, evlistener.length);
}
$9f5191ad6e142a03$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $9f5191ad6e142a03$var$_listeners(this, type, true);
};
$9f5191ad6e142a03$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $9f5191ad6e142a03$var$_listeners(this, type, false);
};
$9f5191ad6e142a03$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $9f5191ad6e142a03$var$listenerCount.call(emitter, type);
};
$9f5191ad6e142a03$var$EventEmitter.prototype.listenerCount = $9f5191ad6e142a03$var$listenerCount;
function $9f5191ad6e142a03$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$9f5191ad6e142a03$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $9f5191ad6e142a03$var$ReflectOwnKeys(this._events) : [];
};
function $9f5191ad6e142a03$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $9f5191ad6e142a03$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $9f5191ad6e142a03$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $9f5191ad6e142a03$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $9f5191ad6e142a03$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $9f5191ad6e142a03$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $9f5191ad6e142a03$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $9f5191ad6e142a03$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $9f5191ad6e142a03$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("gI7KH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $6qd2L = parcelRequire("6qd2L");
"use strict";
module.exports = $c2a6c4da35c537b3$var$Readable;
/*<replacement>*/ var $c2a6c4da35c537b3$var$Duplex;
/*</replacement>*/ $c2a6c4da35c537b3$var$Readable.ReadableState = $c2a6c4da35c537b3$var$ReadableState;

var $dG33B = parcelRequire("dG33B");
var $c2a6c4da35c537b3$require$EE = $dG33B.EventEmitter;
var $c2a6c4da35c537b3$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jIePF = parcelRequire("jIePF");

var $3aNd6 = parcelRequire("3aNd6");
var $c2a6c4da35c537b3$require$Buffer = $3aNd6.Buffer;
var $c2a6c4da35c537b3$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $c2a6c4da35c537b3$var$_uint8ArrayToBuffer(chunk) {
    return $c2a6c4da35c537b3$require$Buffer.from(chunk);
}
function $c2a6c4da35c537b3$var$_isUint8Array(obj) {
    return $c2a6c4da35c537b3$require$Buffer.isBuffer(obj) || obj instanceof $c2a6c4da35c537b3$var$OurUint8Array;
}

var $1wVs5 = parcelRequire("1wVs5");
var $c2a6c4da35c537b3$var$debug;
if ($1wVs5 && $1wVs5.debuglog) $c2a6c4da35c537b3$var$debug = $1wVs5.debuglog("stream");
else $c2a6c4da35c537b3$var$debug = function debug() {};

var $aitIl = parcelRequire("aitIl");

var $ezAkG = parcelRequire("ezAkG");

var $gV8Xw = parcelRequire("gV8Xw");
var $c2a6c4da35c537b3$var$getHighWaterMark = $gV8Xw.getHighWaterMark;

var $h1zie = parcelRequire("h1zie");
var $c2a6c4da35c537b3$require$_require$codes = $h1zie.codes;
var $c2a6c4da35c537b3$var$ERR_INVALID_ARG_TYPE = $c2a6c4da35c537b3$require$_require$codes.ERR_INVALID_ARG_TYPE, $c2a6c4da35c537b3$var$ERR_STREAM_PUSH_AFTER_EOF = $c2a6c4da35c537b3$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $c2a6c4da35c537b3$var$ERR_METHOD_NOT_IMPLEMENTED = $c2a6c4da35c537b3$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $c2a6c4da35c537b3$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $c2a6c4da35c537b3$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $c2a6c4da35c537b3$var$StringDecoder;
var $c2a6c4da35c537b3$var$createReadableStreamAsyncIterator;
var $c2a6c4da35c537b3$var$from;

(parcelRequire("9M38k"))($c2a6c4da35c537b3$var$Readable, $jIePF);
var $c2a6c4da35c537b3$var$errorOrDestroy = $ezAkG.errorOrDestroy;
var $c2a6c4da35c537b3$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $c2a6c4da35c537b3$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $c2a6c4da35c537b3$var$ReadableState(options, stream, isDuplex) {
    $c2a6c4da35c537b3$var$Duplex = $c2a6c4da35c537b3$var$Duplex || (parcelRequire("djKha"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $c2a6c4da35c537b3$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $c2a6c4da35c537b3$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $aitIl();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$c2a6c4da35c537b3$var$StringDecoder) $c2a6c4da35c537b3$var$StringDecoder = (parcelRequire("g6ehz")).StringDecoder;
        this.decoder = new $c2a6c4da35c537b3$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $c2a6c4da35c537b3$var$Readable(options) {
    $c2a6c4da35c537b3$var$Duplex = $c2a6c4da35c537b3$var$Duplex || (parcelRequire("djKha"));
    if (!(this instanceof $c2a6c4da35c537b3$var$Readable)) return new $c2a6c4da35c537b3$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $c2a6c4da35c537b3$var$Duplex;
    this._readableState = new $c2a6c4da35c537b3$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $jIePF.call(this);
}
Object.defineProperty($c2a6c4da35c537b3$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$c2a6c4da35c537b3$var$Readable.prototype.destroy = $ezAkG.destroy;
$c2a6c4da35c537b3$var$Readable.prototype._undestroy = $ezAkG.undestroy;
$c2a6c4da35c537b3$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$c2a6c4da35c537b3$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $c2a6c4da35c537b3$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $c2a6c4da35c537b3$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$c2a6c4da35c537b3$var$Readable.prototype.unshift = function(chunk) {
    return $c2a6c4da35c537b3$var$readableAddChunk(this, chunk, null, true, false);
};
function $c2a6c4da35c537b3$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $c2a6c4da35c537b3$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $c2a6c4da35c537b3$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $c2a6c4da35c537b3$var$chunkInvalid(state, chunk);
        if (er) $c2a6c4da35c537b3$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $c2a6c4da35c537b3$require$Buffer.prototype) chunk = $c2a6c4da35c537b3$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $c2a6c4da35c537b3$var$errorOrDestroy(stream, new $c2a6c4da35c537b3$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $c2a6c4da35c537b3$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $c2a6c4da35c537b3$var$errorOrDestroy(stream, new $c2a6c4da35c537b3$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $c2a6c4da35c537b3$var$addChunk(stream, state, chunk, false);
                    else $c2a6c4da35c537b3$var$maybeReadMore(stream, state);
                } else $c2a6c4da35c537b3$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $c2a6c4da35c537b3$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $c2a6c4da35c537b3$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $c2a6c4da35c537b3$var$emitReadable(stream);
    }
    $c2a6c4da35c537b3$var$maybeReadMore(stream, state);
}
function $c2a6c4da35c537b3$var$chunkInvalid(state, chunk) {
    var er;
    if (!$c2a6c4da35c537b3$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $c2a6c4da35c537b3$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$c2a6c4da35c537b3$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$c2a6c4da35c537b3$var$Readable.prototype.setEncoding = function(enc) {
    if (!$c2a6c4da35c537b3$var$StringDecoder) $c2a6c4da35c537b3$var$StringDecoder = (parcelRequire("g6ehz")).StringDecoder;
    var decoder = new $c2a6c4da35c537b3$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $c2a6c4da35c537b3$var$MAX_HWM = 0x40000000;
function $c2a6c4da35c537b3$var$computeNewHighWaterMark(n) {
    if (n >= $c2a6c4da35c537b3$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $c2a6c4da35c537b3$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c2a6c4da35c537b3$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $c2a6c4da35c537b3$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$c2a6c4da35c537b3$var$Readable.prototype.read = function(n) {
    $c2a6c4da35c537b3$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $c2a6c4da35c537b3$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $c2a6c4da35c537b3$var$endReadable(this);
        else $c2a6c4da35c537b3$var$emitReadable(this);
        return null;
    }
    n = $c2a6c4da35c537b3$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $c2a6c4da35c537b3$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $c2a6c4da35c537b3$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $c2a6c4da35c537b3$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $c2a6c4da35c537b3$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $c2a6c4da35c537b3$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $c2a6c4da35c537b3$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $c2a6c4da35c537b3$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $c2a6c4da35c537b3$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $c2a6c4da35c537b3$var$onEofChunk(stream, state) {
    $c2a6c4da35c537b3$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $c2a6c4da35c537b3$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $c2a6c4da35c537b3$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $c2a6c4da35c537b3$var$emitReadable(stream) {
    var state = stream._readableState;
    $c2a6c4da35c537b3$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $c2a6c4da35c537b3$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $6qd2L.nextTick($c2a6c4da35c537b3$var$emitReadable_, stream);
    }
}
function $c2a6c4da35c537b3$var$emitReadable_(stream) {
    var state = stream._readableState;
    $c2a6c4da35c537b3$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $c2a6c4da35c537b3$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $c2a6c4da35c537b3$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $6qd2L.nextTick($c2a6c4da35c537b3$var$maybeReadMore_, stream, state);
    }
}
function $c2a6c4da35c537b3$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $c2a6c4da35c537b3$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$c2a6c4da35c537b3$var$Readable.prototype._read = function(n) {
    $c2a6c4da35c537b3$var$errorOrDestroy(this, new $c2a6c4da35c537b3$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$c2a6c4da35c537b3$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $c2a6c4da35c537b3$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $6qd2L.stdout && dest !== $6qd2L.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $6qd2L.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $c2a6c4da35c537b3$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $c2a6c4da35c537b3$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $c2a6c4da35c537b3$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $c2a6c4da35c537b3$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $c2a6c4da35c537b3$var$debug("ondata");
        var ret = dest.write(chunk);
        $c2a6c4da35c537b3$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $c2a6c4da35c537b3$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $c2a6c4da35c537b3$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $c2a6c4da35c537b3$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($c2a6c4da35c537b3$var$EElistenerCount(dest, "error") === 0) $c2a6c4da35c537b3$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $c2a6c4da35c537b3$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $c2a6c4da35c537b3$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $c2a6c4da35c537b3$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $c2a6c4da35c537b3$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $c2a6c4da35c537b3$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $c2a6c4da35c537b3$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $c2a6c4da35c537b3$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $c2a6c4da35c537b3$var$flow(src);
        }
    };
}
$c2a6c4da35c537b3$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $c2a6c4da35c537b3$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$c2a6c4da35c537b3$var$Readable.prototype.on = function(ev, fn) {
    var res = $jIePF.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $c2a6c4da35c537b3$var$debug("on readable", state.length, state.reading);
            if (state.length) $c2a6c4da35c537b3$var$emitReadable(this);
            else if (!state.reading) $6qd2L.nextTick($c2a6c4da35c537b3$var$nReadingNextTick, this);
        }
    }
    return res;
};
$c2a6c4da35c537b3$var$Readable.prototype.addListener = $c2a6c4da35c537b3$var$Readable.prototype.on;
$c2a6c4da35c537b3$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jIePF.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $6qd2L.nextTick($c2a6c4da35c537b3$var$updateReadableListening, this);
    return res;
};
$c2a6c4da35c537b3$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jIePF.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $6qd2L.nextTick($c2a6c4da35c537b3$var$updateReadableListening, this);
    return res;
};
function $c2a6c4da35c537b3$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $c2a6c4da35c537b3$var$nReadingNextTick(self1) {
    $c2a6c4da35c537b3$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$c2a6c4da35c537b3$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $c2a6c4da35c537b3$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $c2a6c4da35c537b3$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $c2a6c4da35c537b3$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $6qd2L.nextTick($c2a6c4da35c537b3$var$resume_, stream, state);
    }
}
function $c2a6c4da35c537b3$var$resume_(stream, state) {
    $c2a6c4da35c537b3$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $c2a6c4da35c537b3$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$c2a6c4da35c537b3$var$Readable.prototype.pause = function() {
    $c2a6c4da35c537b3$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $c2a6c4da35c537b3$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $c2a6c4da35c537b3$var$flow(stream) {
    var state = stream._readableState;
    $c2a6c4da35c537b3$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$c2a6c4da35c537b3$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $c2a6c4da35c537b3$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $c2a6c4da35c537b3$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $c2a6c4da35c537b3$var$kProxyEvents.length; n++)stream.on($c2a6c4da35c537b3$var$kProxyEvents[n], this.emit.bind(this, $c2a6c4da35c537b3$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $c2a6c4da35c537b3$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $c2a6c4da35c537b3$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($c2a6c4da35c537b3$var$createReadableStreamAsyncIterator === undefined) $c2a6c4da35c537b3$var$createReadableStreamAsyncIterator = (parcelRequire("5QtK4"));
    return $c2a6c4da35c537b3$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($c2a6c4da35c537b3$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($c2a6c4da35c537b3$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($c2a6c4da35c537b3$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$c2a6c4da35c537b3$var$Readable._fromList = $c2a6c4da35c537b3$var$fromList;
Object.defineProperty($c2a6c4da35c537b3$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c2a6c4da35c537b3$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $c2a6c4da35c537b3$var$endReadable(stream) {
    var state = stream._readableState;
    $c2a6c4da35c537b3$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $6qd2L.nextTick($c2a6c4da35c537b3$var$endReadableNT, state, stream);
    }
}
function $c2a6c4da35c537b3$var$endReadableNT(state, stream) {
    $c2a6c4da35c537b3$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $c2a6c4da35c537b3$var$Readable.from = function(iterable, opts) {
    if ($c2a6c4da35c537b3$var$from === undefined) $c2a6c4da35c537b3$var$from = (parcelRequire("adKWq"));
    return $c2a6c4da35c537b3$var$from($c2a6c4da35c537b3$var$Readable, iterable, opts);
};
function $c2a6c4da35c537b3$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("6qd2L", function(module, exports) {
// shim for using process in browser
var $4acf49f6c3e67aec$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4acf49f6c3e67aec$var$cachedSetTimeout;
var $4acf49f6c3e67aec$var$cachedClearTimeout;
function $4acf49f6c3e67aec$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $4acf49f6c3e67aec$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        else $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        else $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    }
})();
function $4acf49f6c3e67aec$var$runTimeout(fun) {
    if ($4acf49f6c3e67aec$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedSetTimeout === $4acf49f6c3e67aec$var$defaultSetTimout || !$4acf49f6c3e67aec$var$cachedSetTimeout) && setTimeout) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4acf49f6c3e67aec$var$runClearTimeout(marker) {
    if ($4acf49f6c3e67aec$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedClearTimeout === $4acf49f6c3e67aec$var$defaultClearTimeout || !$4acf49f6c3e67aec$var$cachedClearTimeout) && clearTimeout) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4acf49f6c3e67aec$var$queue = [];
var $4acf49f6c3e67aec$var$draining = false;
var $4acf49f6c3e67aec$var$currentQueue;
var $4acf49f6c3e67aec$var$queueIndex = -1;
function $4acf49f6c3e67aec$var$cleanUpNextTick() {
    if (!$4acf49f6c3e67aec$var$draining || !$4acf49f6c3e67aec$var$currentQueue) return;
    $4acf49f6c3e67aec$var$draining = false;
    if ($4acf49f6c3e67aec$var$currentQueue.length) $4acf49f6c3e67aec$var$queue = $4acf49f6c3e67aec$var$currentQueue.concat($4acf49f6c3e67aec$var$queue);
    else $4acf49f6c3e67aec$var$queueIndex = -1;
    if ($4acf49f6c3e67aec$var$queue.length) $4acf49f6c3e67aec$var$drainQueue();
}
function $4acf49f6c3e67aec$var$drainQueue() {
    if ($4acf49f6c3e67aec$var$draining) return;
    var timeout = $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$cleanUpNextTick);
    $4acf49f6c3e67aec$var$draining = true;
    var len = $4acf49f6c3e67aec$var$queue.length;
    while(len){
        $4acf49f6c3e67aec$var$currentQueue = $4acf49f6c3e67aec$var$queue;
        $4acf49f6c3e67aec$var$queue = [];
        while(++$4acf49f6c3e67aec$var$queueIndex < len)if ($4acf49f6c3e67aec$var$currentQueue) $4acf49f6c3e67aec$var$currentQueue[$4acf49f6c3e67aec$var$queueIndex].run();
        $4acf49f6c3e67aec$var$queueIndex = -1;
        len = $4acf49f6c3e67aec$var$queue.length;
    }
    $4acf49f6c3e67aec$var$currentQueue = null;
    $4acf49f6c3e67aec$var$draining = false;
    $4acf49f6c3e67aec$var$runClearTimeout(timeout);
}
$4acf49f6c3e67aec$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4acf49f6c3e67aec$var$queue.push(new $4acf49f6c3e67aec$var$Item(fun, args));
    if ($4acf49f6c3e67aec$var$queue.length === 1 && !$4acf49f6c3e67aec$var$draining) $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$drainQueue);
};
// v8 likes predictible objects
function $4acf49f6c3e67aec$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4acf49f6c3e67aec$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4acf49f6c3e67aec$var$process.title = "browser";
$4acf49f6c3e67aec$var$process.browser = true;
$4acf49f6c3e67aec$var$process.env = {};
$4acf49f6c3e67aec$var$process.argv = [];
$4acf49f6c3e67aec$var$process.version = ""; // empty string to avoid regexp issues
$4acf49f6c3e67aec$var$process.versions = {};
function $4acf49f6c3e67aec$var$noop() {}
$4acf49f6c3e67aec$var$process.on = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.addListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.once = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.off = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeAllListeners = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.emit = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependOnceListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.listeners = function(name) {
    return [];
};
$4acf49f6c3e67aec$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$4acf49f6c3e67aec$var$process.cwd = function() {
    return "/";
};
$4acf49f6c3e67aec$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$4acf49f6c3e67aec$var$process.umask = function() {
    return 0;
};

});

parcelRegister("jIePF", function(module, exports) {

module.exports = (parcelRequire("dG33B")).EventEmitter;

});

parcelRegister("3aNd6", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $24f87a6f86a8996f$export$a143d493d941bafc; }, function (v) { return $24f87a6f86a8996f$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a; }, function (v) { return $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $24f87a6f86a8996f$export$f99ded8fe4b79145; }, function (v) { return $24f87a6f86a8996f$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $24f87a6f86a8996f$export$599f31c3813fae4d; }, function (v) { return $24f87a6f86a8996f$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $24f87a6f86a8996f$export$a143d493d941bafc;
var $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a;
var $24f87a6f86a8996f$export$f99ded8fe4b79145;
var $24f87a6f86a8996f$export$599f31c3813fae4d;
"use strict";

var $5d11t = parcelRequire("5d11t");

var $7rddL = parcelRequire("7rddL");
const $24f87a6f86a8996f$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$24f87a6f86a8996f$export$a143d493d941bafc = $24f87a6f86a8996f$var$Buffer;
$24f87a6f86a8996f$export$e4cf37d7f6fb9e0a = $24f87a6f86a8996f$var$SlowBuffer;
$24f87a6f86a8996f$export$f99ded8fe4b79145 = 50;
const $24f87a6f86a8996f$var$K_MAX_LENGTH = 0x7fffffff;
$24f87a6f86a8996f$export$599f31c3813fae4d = $24f87a6f86a8996f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT = $24f87a6f86a8996f$var$typedArraySupport();
if (!$24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $24f87a6f86a8996f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $24f87a6f86a8996f$var$createBuffer(length) {
    if (length > $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $24f87a6f86a8996f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $24f87a6f86a8996f$var$allocUnsafe(arg);
    }
    return $24f87a6f86a8996f$var$from(arg, encodingOrOffset, length);
}
$24f87a6f86a8996f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $24f87a6f86a8996f$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $24f87a6f86a8996f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $24f87a6f86a8996f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($24f87a6f86a8996f$var$isInstance(value, ArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, ArrayBuffer)) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($24f87a6f86a8996f$var$isInstance(value, SharedArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, SharedArrayBuffer))) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $24f87a6f86a8996f$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $24f87a6f86a8996f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $24f87a6f86a8996f$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $24f87a6f86a8996f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $24f87a6f86a8996f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer, Uint8Array);
function $24f87a6f86a8996f$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $24f87a6f86a8996f$var$alloc(size, fill, encoding) {
    $24f87a6f86a8996f$var$assertSize(size);
    if (size <= 0) return $24f87a6f86a8996f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $24f87a6f86a8996f$var$createBuffer(size).fill(fill, encoding) : $24f87a6f86a8996f$var$createBuffer(size).fill(fill);
    return $24f87a6f86a8996f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $24f87a6f86a8996f$var$Buffer.alloc = function(size, fill, encoding) {
    return $24f87a6f86a8996f$var$alloc(size, fill, encoding);
};
function $24f87a6f86a8996f$var$allocUnsafe(size) {
    $24f87a6f86a8996f$var$assertSize(size);
    return $24f87a6f86a8996f$var$createBuffer(size < 0 ? 0 : $24f87a6f86a8996f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $24f87a6f86a8996f$var$Buffer.allocUnsafe = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $24f87a6f86a8996f$var$Buffer.allocUnsafeSlow = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
function $24f87a6f86a8996f$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $24f87a6f86a8996f$var$byteLength(string, encoding) | 0;
    let buf = $24f87a6f86a8996f$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $24f87a6f86a8996f$var$checked(array.length) | 0;
    const buf = $24f87a6f86a8996f$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayView(arrayView) {
    if ($24f87a6f86a8996f$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $24f87a6f86a8996f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $24f87a6f86a8996f$var$fromArrayLike(arrayView);
}
function $24f87a6f86a8996f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
function $24f87a6f86a8996f$var$fromObject(obj) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(obj)) {
        const len = $24f87a6f86a8996f$var$checked(obj.length) | 0;
        const buf = $24f87a6f86a8996f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $24f87a6f86a8996f$var$numberIsNaN(obj.length)) return $24f87a6f86a8996f$var$createBuffer(0);
        return $24f87a6f86a8996f$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $24f87a6f86a8996f$var$fromArrayLike(obj.data);
}
function $24f87a6f86a8996f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $24f87a6f86a8996f$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $24f87a6f86a8996f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $24f87a6f86a8996f$var$Buffer.alloc(+length);
}
$24f87a6f86a8996f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $24f87a6f86a8996f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$24f87a6f86a8996f$var$Buffer.compare = function compare(a, b) {
    if ($24f87a6f86a8996f$var$isInstance(a, Uint8Array)) a = $24f87a6f86a8996f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($24f87a6f86a8996f$var$isInstance(b, Uint8Array)) b = $24f87a6f86a8996f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(a) || !$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$24f87a6f86a8996f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$24f87a6f86a8996f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $24f87a6f86a8996f$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $24f87a6f86a8996f$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($24f87a6f86a8996f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) buf = $24f87a6f86a8996f$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $24f87a6f86a8996f$var$byteLength(string, encoding) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $24f87a6f86a8996f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $24f87a6f86a8996f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $24f87a6f86a8996f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$24f87a6f86a8996f$var$Buffer.byteLength = $24f87a6f86a8996f$var$byteLength;
function $24f87a6f86a8996f$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $24f87a6f86a8996f$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8Slice(this, start, end);
        case "ascii":
            return $24f87a6f86a8996f$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $24f87a6f86a8996f$var$latin1Slice(this, start, end);
        case "base64":
            return $24f87a6f86a8996f$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $24f87a6f86a8996f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$24f87a6f86a8996f$var$Buffer.prototype._isBuffer = true;
function $24f87a6f86a8996f$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$24f87a6f86a8996f$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$24f87a6f86a8996f$var$swap(this, i, i + 1);
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $24f87a6f86a8996f$var$swap(this, i, i + 3);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $24f87a6f86a8996f$var$swap(this, i, i + 7);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 6);
        $24f87a6f86a8996f$var$swap(this, i + 2, i + 5);
        $24f87a6f86a8996f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $24f87a6f86a8996f$var$utf8Slice(this, 0, length);
    return $24f87a6f86a8996f$var$slowToString.apply(this, arguments);
};
$24f87a6f86a8996f$var$Buffer.prototype.toLocaleString = $24f87a6f86a8996f$var$Buffer.prototype.toString;
$24f87a6f86a8996f$var$Buffer.prototype.equals = function equals(b) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $24f87a6f86a8996f$var$Buffer.compare(this, b) === 0;
};
$24f87a6f86a8996f$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $24f87a6f86a8996f$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($24f87a6f86a8996f$var$customInspectSymbol) $24f87a6f86a8996f$var$Buffer.prototype[$24f87a6f86a8996f$var$customInspectSymbol] = $24f87a6f86a8996f$var$Buffer.prototype.inspect;
$24f87a6f86a8996f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($24f87a6f86a8996f$var$isInstance(target, Uint8Array)) target = $24f87a6f86a8996f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $24f87a6f86a8996f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($24f87a6f86a8996f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $24f87a6f86a8996f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $24f87a6f86a8996f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$24f87a6f86a8996f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$24f87a6f86a8996f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $24f87a6f86a8996f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($24f87a6f86a8996f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $24f87a6f86a8996f$var$utf8Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $24f87a6f86a8996f$var$asciiWrite(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$asciiToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$base64Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$base64ToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$ucs2Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$24f87a6f86a8996f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $24f87a6f86a8996f$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $24f87a6f86a8996f$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $24f87a6f86a8996f$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $24f87a6f86a8996f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$24f87a6f86a8996f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $24f87a6f86a8996f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $5d11t.fromByteArray(buf);
    else return $5d11t.fromByteArray(buf.slice(start, end));
}
function $24f87a6f86a8996f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $24f87a6f86a8996f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $24f87a6f86a8996f$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $24f87a6f86a8996f$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $24f87a6f86a8996f$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $24f87a6f86a8996f$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $24f87a6f86a8996f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $24f87a6f86a8996f$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$24f87a6f86a8996f$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $24f87a6f86a8996f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $24f87a6f86a8996f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$24f87a6f86a8996f$var$Buffer.prototype.readUintLE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUintBE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint8 = $24f87a6f86a8996f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$24f87a6f86a8996f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$24f87a6f86a8996f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $7rddL.read(this, offset, true, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $7rddL.read(this, offset, false, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $7rddL.read(this, offset, true, 52, 8);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $7rddL.read(this, offset, false, 52, 8);
};
function $24f87a6f86a8996f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$24f87a6f86a8996f$var$Buffer.prototype.writeUintLE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUintBE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint8 = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $24f87a6f86a8996f$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $24f87a6f86a8996f$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $24f87a6f86a8996f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7rddL.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, false, noAssert);
};
function $24f87a6f86a8996f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7rddL.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$24f87a6f86a8996f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$24f87a6f86a8996f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $24f87a6f86a8996f$var$Buffer.isBuffer(val) ? val : $24f87a6f86a8996f$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $24f87a6f86a8996f$var$errors = {};
function $24f87a6f86a8996f$var$E(sym, getMessage, Base) {
    $24f87a6f86a8996f$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$24f87a6f86a8996f$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$24f87a6f86a8996f$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$24f87a6f86a8996f$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $24f87a6f86a8996f$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $24f87a6f86a8996f$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $24f87a6f86a8996f$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength) {
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $24f87a6f86a8996f$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength);
}
function $24f87a6f86a8996f$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $24f87a6f86a8996f$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $24f87a6f86a8996f$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $24f87a6f86a8996f$var$validateNumber(value, type);
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $24f87a6f86a8996f$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $24f87a6f86a8996f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $24f87a6f86a8996f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($24f87a6f86a8996f$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $24f87a6f86a8996f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $24f87a6f86a8996f$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $24f87a6f86a8996f$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $24f87a6f86a8996f$var$base64ToBytes(str) {
    return $5d11t.toByteArray($24f87a6f86a8996f$var$base64clean(str));
}
function $24f87a6f86a8996f$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $24f87a6f86a8996f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $24f87a6f86a8996f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $24f87a6f86a8996f$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $24f87a6f86a8996f$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $24f87a6f86a8996f$var$BufferBigIntNotDefined : fn;
}
function $24f87a6f86a8996f$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("5d11t", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $3caef5c332c7293f$export$d622b2ad8d90c771; }, function (v) { return $3caef5c332c7293f$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $3caef5c332c7293f$export$6100ba28696e12de; }, function (v) { return $3caef5c332c7293f$export$6100ba28696e12de = v; });
var $3caef5c332c7293f$export$a48f0734ac7c2329;
var $3caef5c332c7293f$export$d622b2ad8d90c771;
var $3caef5c332c7293f$export$6100ba28696e12de;
"use strict";
$3caef5c332c7293f$export$a48f0734ac7c2329 = $3caef5c332c7293f$var$byteLength;
$3caef5c332c7293f$export$d622b2ad8d90c771 = $3caef5c332c7293f$var$toByteArray;
$3caef5c332c7293f$export$6100ba28696e12de = $3caef5c332c7293f$var$fromByteArray;
var $3caef5c332c7293f$var$lookup = [];
var $3caef5c332c7293f$var$revLookup = [];
var $3caef5c332c7293f$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $3caef5c332c7293f$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $3caef5c332c7293f$var$i = 0, $3caef5c332c7293f$var$len = $3caef5c332c7293f$var$code.length; $3caef5c332c7293f$var$i < $3caef5c332c7293f$var$len; ++$3caef5c332c7293f$var$i){
    $3caef5c332c7293f$var$lookup[$3caef5c332c7293f$var$i] = $3caef5c332c7293f$var$code[$3caef5c332c7293f$var$i];
    $3caef5c332c7293f$var$revLookup[$3caef5c332c7293f$var$code.charCodeAt($3caef5c332c7293f$var$i)] = $3caef5c332c7293f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3caef5c332c7293f$var$revLookup["-".charCodeAt(0)] = 62;
$3caef5c332c7293f$var$revLookup["_".charCodeAt(0)] = 63;
function $3caef5c332c7293f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $3caef5c332c7293f$var$byteLength(b64) {
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$toByteArray(b64) {
    var tmp;
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3caef5c332c7293f$var$Arr($3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 18 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 2 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 10 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3caef5c332c7293f$var$tripletToBase64(num) {
    return $3caef5c332c7293f$var$lookup[num >> 18 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 12 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 6 & 0x3F] + $3caef5c332c7293f$var$lookup[num & 0x3F];
}
function $3caef5c332c7293f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3caef5c332c7293f$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $3caef5c332c7293f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3caef5c332c7293f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 2] + $3caef5c332c7293f$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 10] + $3caef5c332c7293f$var$lookup[tmp >> 4 & 0x3F] + $3caef5c332c7293f$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("7rddL", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $56a54f6ebabce67d$export$aafa59e2e03f2942; }, function (v) { return $56a54f6ebabce67d$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $56a54f6ebabce67d$export$68d8715fc104d294; }, function (v) { return $56a54f6ebabce67d$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $56a54f6ebabce67d$export$aafa59e2e03f2942;
var $56a54f6ebabce67d$export$68d8715fc104d294;
$56a54f6ebabce67d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$56a54f6ebabce67d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("1wVs5", function(module, exports) {
"use strict";

});

parcelRegister("aitIl", function(module, exports) {
"use strict";
function $77f2a2759da6e934$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $77f2a2759da6e934$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $77f2a2759da6e934$var$ownKeys(Object(source), !0).forEach(function(key) {
            $77f2a2759da6e934$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $77f2a2759da6e934$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $77f2a2759da6e934$var$_defineProperty(obj, key, value) {
    key = $77f2a2759da6e934$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $77f2a2759da6e934$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $77f2a2759da6e934$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $77f2a2759da6e934$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $77f2a2759da6e934$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $77f2a2759da6e934$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $77f2a2759da6e934$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $77f2a2759da6e934$var$_toPropertyKey(arg) {
    var key = $77f2a2759da6e934$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $77f2a2759da6e934$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $3aNd6 = parcelRequire("3aNd6");
var $77f2a2759da6e934$var$Buffer = $3aNd6.Buffer;

var $1wVs5 = parcelRequire("1wVs5");
var $77f2a2759da6e934$var$inspect = $1wVs5.inspect;
var $77f2a2759da6e934$var$custom = $77f2a2759da6e934$var$inspect && $77f2a2759da6e934$var$inspect.custom || "inspect";
function $77f2a2759da6e934$var$copyBuffer(src, target, offset) {
    $77f2a2759da6e934$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $77f2a2759da6e934$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $77f2a2759da6e934$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $77f2a2759da6e934$var$Buffer.alloc(0);
                var ret = $77f2a2759da6e934$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $77f2a2759da6e934$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $77f2a2759da6e934$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $77f2a2759da6e934$var$custom,
            value: function value(_, options) {
                return $77f2a2759da6e934$var$inspect(this, $77f2a2759da6e934$var$_objectSpread($77f2a2759da6e934$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("ezAkG", function(module, exports) {

var $6qd2L = parcelRequire("6qd2L");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $a9c0847d6e89179a$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $6qd2L.nextTick($a9c0847d6e89179a$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $6qd2L.nextTick($a9c0847d6e89179a$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $6qd2L.nextTick($a9c0847d6e89179a$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $6qd2L.nextTick($a9c0847d6e89179a$var$emitErrorAndCloseNT, _this, err);
            } else $6qd2L.nextTick($a9c0847d6e89179a$var$emitCloseNT, _this);
        } else if (cb) {
            $6qd2L.nextTick($a9c0847d6e89179a$var$emitCloseNT, _this);
            cb(err);
        } else $6qd2L.nextTick($a9c0847d6e89179a$var$emitCloseNT, _this);
    });
    return this;
}
function $a9c0847d6e89179a$var$emitErrorAndCloseNT(self, err) {
    $a9c0847d6e89179a$var$emitErrorNT(self, err);
    $a9c0847d6e89179a$var$emitCloseNT(self);
}
function $a9c0847d6e89179a$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $a9c0847d6e89179a$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $a9c0847d6e89179a$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $a9c0847d6e89179a$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $a9c0847d6e89179a$var$destroy,
    undestroy: $a9c0847d6e89179a$var$undestroy,
    errorOrDestroy: $a9c0847d6e89179a$var$errorOrDestroy
};

});

parcelRegister("gV8Xw", function(module, exports) {
"use strict";

var $c518eb45148d8890$var$ERR_INVALID_OPT_VALUE = (parcelRequire("h1zie")).codes.ERR_INVALID_OPT_VALUE;
function $c518eb45148d8890$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $c518eb45148d8890$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $c518eb45148d8890$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $c518eb45148d8890$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $c518eb45148d8890$var$getHighWaterMark
};

});
parcelRegister("h1zie", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $c64de81e4e97ea9e$export$e45cb6485273080e; }, function (v) { return $c64de81e4e97ea9e$export$e45cb6485273080e = v; });
var $c64de81e4e97ea9e$export$e45cb6485273080e;
"use strict";
function $c64de81e4e97ea9e$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $c64de81e4e97ea9e$var$codes = {};
function $c64de81e4e97ea9e$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $c64de81e4e97ea9e$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $c64de81e4e97ea9e$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $c64de81e4e97ea9e$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $c64de81e4e97ea9e$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $c64de81e4e97ea9e$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $c64de81e4e97ea9e$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$c64de81e4e97ea9e$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$c64de81e4e97ea9e$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $c64de81e4e97ea9e$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($c64de81e4e97ea9e$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($c64de81e4e97ea9e$var$oneOf(expected, "type"));
    else {
        var type = $c64de81e4e97ea9e$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($c64de81e4e97ea9e$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$c64de81e4e97ea9e$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$c64de81e4e97ea9e$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$c64de81e4e97ea9e$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$c64de81e4e97ea9e$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$c64de81e4e97ea9e$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$c64de81e4e97ea9e$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$c64de81e4e97ea9e$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$c64de81e4e97ea9e$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$c64de81e4e97ea9e$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$c64de81e4e97ea9e$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$c64de81e4e97ea9e$export$e45cb6485273080e = $c64de81e4e97ea9e$var$codes;

});


parcelRegister("djKha", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $6qd2L = parcelRequire("6qd2L");
"use strict";
/*<replacement>*/ var $9b20f226c17442c8$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $9b20f226c17442c8$var$Duplex;

var $gI7KH = parcelRequire("gI7KH");

var $h57Ja = parcelRequire("h57Ja");

(parcelRequire("9M38k"))($9b20f226c17442c8$var$Duplex, $gI7KH);
// Allow the keys array to be GC'ed.
var $9b20f226c17442c8$var$keys = $9b20f226c17442c8$var$objectKeys($h57Ja.prototype);
for(var $9b20f226c17442c8$var$v = 0; $9b20f226c17442c8$var$v < $9b20f226c17442c8$var$keys.length; $9b20f226c17442c8$var$v++){
    var $9b20f226c17442c8$var$method = $9b20f226c17442c8$var$keys[$9b20f226c17442c8$var$v];
    if (!$9b20f226c17442c8$var$Duplex.prototype[$9b20f226c17442c8$var$method]) $9b20f226c17442c8$var$Duplex.prototype[$9b20f226c17442c8$var$method] = $h57Ja.prototype[$9b20f226c17442c8$var$method];
}
function $9b20f226c17442c8$var$Duplex(options) {
    if (!(this instanceof $9b20f226c17442c8$var$Duplex)) return new $9b20f226c17442c8$var$Duplex(options);
    $gI7KH.call(this, options);
    $h57Ja.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $9b20f226c17442c8$var$onend);
        }
    }
}
Object.defineProperty($9b20f226c17442c8$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($9b20f226c17442c8$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($9b20f226c17442c8$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $9b20f226c17442c8$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $6qd2L.nextTick($9b20f226c17442c8$var$onEndNT, this);
}
function $9b20f226c17442c8$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($9b20f226c17442c8$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("h57Ja", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $6qd2L = parcelRequire("6qd2L");
"use strict";
module.exports = $c6f8e5d76a81e4c1$var$Writable;
/* <replacement> */ function $c6f8e5d76a81e4c1$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $c6f8e5d76a81e4c1$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $c6f8e5d76a81e4c1$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $c6f8e5d76a81e4c1$var$Duplex;
/*</replacement>*/ $c6f8e5d76a81e4c1$var$Writable.WritableState = $c6f8e5d76a81e4c1$var$WritableState;

/*<replacement>*/ var $c6f8e5d76a81e4c1$var$internalUtil = {
    deprecate: (parcelRequire("3ZPxO"))
};

var $jIePF = parcelRequire("jIePF");

var $3aNd6 = parcelRequire("3aNd6");
var $c6f8e5d76a81e4c1$require$Buffer = $3aNd6.Buffer;
var $c6f8e5d76a81e4c1$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $c6f8e5d76a81e4c1$var$_uint8ArrayToBuffer(chunk) {
    return $c6f8e5d76a81e4c1$require$Buffer.from(chunk);
}
function $c6f8e5d76a81e4c1$var$_isUint8Array(obj) {
    return $c6f8e5d76a81e4c1$require$Buffer.isBuffer(obj) || obj instanceof $c6f8e5d76a81e4c1$var$OurUint8Array;
}

var $ezAkG = parcelRequire("ezAkG");

var $gV8Xw = parcelRequire("gV8Xw");
var $c6f8e5d76a81e4c1$var$getHighWaterMark = $gV8Xw.getHighWaterMark;

var $h1zie = parcelRequire("h1zie");
var $c6f8e5d76a81e4c1$require$_require$codes = $h1zie.codes;
var $c6f8e5d76a81e4c1$var$ERR_INVALID_ARG_TYPE = $c6f8e5d76a81e4c1$require$_require$codes.ERR_INVALID_ARG_TYPE, $c6f8e5d76a81e4c1$var$ERR_METHOD_NOT_IMPLEMENTED = $c6f8e5d76a81e4c1$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $c6f8e5d76a81e4c1$var$ERR_MULTIPLE_CALLBACK = $c6f8e5d76a81e4c1$require$_require$codes.ERR_MULTIPLE_CALLBACK, $c6f8e5d76a81e4c1$var$ERR_STREAM_CANNOT_PIPE = $c6f8e5d76a81e4c1$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $c6f8e5d76a81e4c1$var$ERR_STREAM_DESTROYED = $c6f8e5d76a81e4c1$require$_require$codes.ERR_STREAM_DESTROYED, $c6f8e5d76a81e4c1$var$ERR_STREAM_NULL_VALUES = $c6f8e5d76a81e4c1$require$_require$codes.ERR_STREAM_NULL_VALUES, $c6f8e5d76a81e4c1$var$ERR_STREAM_WRITE_AFTER_END = $c6f8e5d76a81e4c1$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $c6f8e5d76a81e4c1$var$ERR_UNKNOWN_ENCODING = $c6f8e5d76a81e4c1$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $c6f8e5d76a81e4c1$var$errorOrDestroy = $ezAkG.errorOrDestroy;

(parcelRequire("9M38k"))($c6f8e5d76a81e4c1$var$Writable, $jIePF);
function $c6f8e5d76a81e4c1$var$nop() {}

function $c6f8e5d76a81e4c1$var$WritableState(options, stream, isDuplex) {
    $c6f8e5d76a81e4c1$var$Duplex = $c6f8e5d76a81e4c1$var$Duplex || (parcelRequire("djKha"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $c6f8e5d76a81e4c1$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $c6f8e5d76a81e4c1$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $c6f8e5d76a81e4c1$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $c6f8e5d76a81e4c1$var$CorkedRequest(this);
}
$c6f8e5d76a81e4c1$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($c6f8e5d76a81e4c1$var$WritableState.prototype, "buffer", {
            get: $c6f8e5d76a81e4c1$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $c6f8e5d76a81e4c1$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $c6f8e5d76a81e4c1$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($c6f8e5d76a81e4c1$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($c6f8e5d76a81e4c1$var$realHasInstance.call(this, object)) return true;
            if (this !== $c6f8e5d76a81e4c1$var$Writable) return false;
            return object && object._writableState instanceof $c6f8e5d76a81e4c1$var$WritableState;
        }
    });
} else $c6f8e5d76a81e4c1$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $c6f8e5d76a81e4c1$var$Writable(options) {
    $c6f8e5d76a81e4c1$var$Duplex = $c6f8e5d76a81e4c1$var$Duplex || (parcelRequire("djKha"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $c6f8e5d76a81e4c1$var$Duplex;
    if (!isDuplex && !$c6f8e5d76a81e4c1$var$realHasInstance.call($c6f8e5d76a81e4c1$var$Writable, this)) return new $c6f8e5d76a81e4c1$var$Writable(options);
    this._writableState = new $c6f8e5d76a81e4c1$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $jIePF.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$c6f8e5d76a81e4c1$var$Writable.prototype.pipe = function() {
    $c6f8e5d76a81e4c1$var$errorOrDestroy(this, new $c6f8e5d76a81e4c1$var$ERR_STREAM_CANNOT_PIPE());
};
function $c6f8e5d76a81e4c1$var$writeAfterEnd(stream, cb) {
    var er = new $c6f8e5d76a81e4c1$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $c6f8e5d76a81e4c1$var$errorOrDestroy(stream, er);
    $6qd2L.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $c6f8e5d76a81e4c1$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $c6f8e5d76a81e4c1$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $c6f8e5d76a81e4c1$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $c6f8e5d76a81e4c1$var$errorOrDestroy(stream, er);
        $6qd2L.nextTick(cb, er);
        return false;
    }
    return true;
}
$c6f8e5d76a81e4c1$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $c6f8e5d76a81e4c1$var$_isUint8Array(chunk);
    if (isBuf && !$c6f8e5d76a81e4c1$require$Buffer.isBuffer(chunk)) chunk = $c6f8e5d76a81e4c1$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $c6f8e5d76a81e4c1$var$nop;
    if (state.ending) $c6f8e5d76a81e4c1$var$writeAfterEnd(this, cb);
    else if (isBuf || $c6f8e5d76a81e4c1$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $c6f8e5d76a81e4c1$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$c6f8e5d76a81e4c1$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$c6f8e5d76a81e4c1$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $c6f8e5d76a81e4c1$var$clearBuffer(this, state);
    }
};
$c6f8e5d76a81e4c1$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $c6f8e5d76a81e4c1$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($c6f8e5d76a81e4c1$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $c6f8e5d76a81e4c1$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $c6f8e5d76a81e4c1$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($c6f8e5d76a81e4c1$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $c6f8e5d76a81e4c1$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $c6f8e5d76a81e4c1$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $c6f8e5d76a81e4c1$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $c6f8e5d76a81e4c1$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $c6f8e5d76a81e4c1$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $c6f8e5d76a81e4c1$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $6qd2L.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $6qd2L.nextTick($c6f8e5d76a81e4c1$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $c6f8e5d76a81e4c1$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $c6f8e5d76a81e4c1$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $c6f8e5d76a81e4c1$var$finishMaybe(stream, state);
    }
}
function $c6f8e5d76a81e4c1$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $c6f8e5d76a81e4c1$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $c6f8e5d76a81e4c1$var$ERR_MULTIPLE_CALLBACK();
    $c6f8e5d76a81e4c1$var$onwriteStateUpdate(state);
    if (er) $c6f8e5d76a81e4c1$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $c6f8e5d76a81e4c1$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $c6f8e5d76a81e4c1$var$clearBuffer(stream, state);
        if (sync) $6qd2L.nextTick($c6f8e5d76a81e4c1$var$afterWrite, stream, state, finished, cb);
        else $c6f8e5d76a81e4c1$var$afterWrite(stream, state, finished, cb);
    }
}
function $c6f8e5d76a81e4c1$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $c6f8e5d76a81e4c1$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $c6f8e5d76a81e4c1$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $c6f8e5d76a81e4c1$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $c6f8e5d76a81e4c1$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $c6f8e5d76a81e4c1$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $c6f8e5d76a81e4c1$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $c6f8e5d76a81e4c1$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$c6f8e5d76a81e4c1$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $c6f8e5d76a81e4c1$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$c6f8e5d76a81e4c1$var$Writable.prototype._writev = null;
$c6f8e5d76a81e4c1$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $c6f8e5d76a81e4c1$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($c6f8e5d76a81e4c1$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $c6f8e5d76a81e4c1$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $c6f8e5d76a81e4c1$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $c6f8e5d76a81e4c1$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $c6f8e5d76a81e4c1$var$finishMaybe(stream, state);
    });
}
function $c6f8e5d76a81e4c1$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $6qd2L.nextTick($c6f8e5d76a81e4c1$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $c6f8e5d76a81e4c1$var$finishMaybe(stream, state) {
    var need = $c6f8e5d76a81e4c1$var$needFinish(state);
    if (need) {
        $c6f8e5d76a81e4c1$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $c6f8e5d76a81e4c1$var$endWritable(stream, state, cb) {
    state.ending = true;
    $c6f8e5d76a81e4c1$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $6qd2L.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $c6f8e5d76a81e4c1$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($c6f8e5d76a81e4c1$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$c6f8e5d76a81e4c1$var$Writable.prototype.destroy = $ezAkG.destroy;
$c6f8e5d76a81e4c1$var$Writable.prototype._undestroy = $ezAkG.undestroy;
$c6f8e5d76a81e4c1$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("3ZPxO", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $2e8f0d3e23525401$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $2e8f0d3e23525401$var$deprecate(fn, msg) {
    if ($2e8f0d3e23525401$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($2e8f0d3e23525401$var$config("throwDeprecation")) throw new Error(msg);
            else if ($2e8f0d3e23525401$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $2e8f0d3e23525401$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRegister("g6ehz", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $bb88490a7c25ef82$export$63a7aa211a91ed69; }, function (v) { return $bb88490a7c25ef82$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $bb88490a7c25ef82$export$63a7aa211a91ed69;
"use strict";

var $2iVwY = parcelRequire("2iVwY");
var $bb88490a7c25ef82$require$Buffer = $2iVwY.Buffer;
/*</replacement>*/ var $bb88490a7c25ef82$var$isEncoding = $bb88490a7c25ef82$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $bb88490a7c25ef82$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $bb88490a7c25ef82$var$normalizeEncoding(enc) {
    var nenc = $bb88490a7c25ef82$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($bb88490a7c25ef82$require$Buffer.isEncoding === $bb88490a7c25ef82$var$isEncoding || !$bb88490a7c25ef82$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$bb88490a7c25ef82$export$63a7aa211a91ed69 = $bb88490a7c25ef82$var$StringDecoder;
function $bb88490a7c25ef82$var$StringDecoder(encoding) {
    this.encoding = $bb88490a7c25ef82$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $bb88490a7c25ef82$var$utf16Text;
            this.end = $bb88490a7c25ef82$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $bb88490a7c25ef82$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $bb88490a7c25ef82$var$base64Text;
            this.end = $bb88490a7c25ef82$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $bb88490a7c25ef82$var$simpleWrite;
            this.end = $bb88490a7c25ef82$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $bb88490a7c25ef82$require$Buffer.allocUnsafe(nb);
}
$bb88490a7c25ef82$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$bb88490a7c25ef82$var$StringDecoder.prototype.end = $bb88490a7c25ef82$var$utf8End;
// Returns only complete characters in a Buffer
$bb88490a7c25ef82$var$StringDecoder.prototype.text = $bb88490a7c25ef82$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$bb88490a7c25ef82$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $bb88490a7c25ef82$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $bb88490a7c25ef82$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $bb88490a7c25ef82$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $bb88490a7c25ef82$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $bb88490a7c25ef82$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $bb88490a7c25ef82$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $bb88490a7c25ef82$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $bb88490a7c25ef82$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $bb88490a7c25ef82$var$utf8Text(buf, i) {
    var total = $bb88490a7c25ef82$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $bb88490a7c25ef82$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $bb88490a7c25ef82$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $bb88490a7c25ef82$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $bb88490a7c25ef82$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $bb88490a7c25ef82$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $bb88490a7c25ef82$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $bb88490a7c25ef82$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});
parcelRegister("2iVwY", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $3aNd6 = parcelRequire("3aNd6");
var $1ad9e3a3bba0ff2c$var$Buffer = $3aNd6.Buffer;
// alternative to using Object.keys for old browsers
function $1ad9e3a3bba0ff2c$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1ad9e3a3bba0ff2c$var$Buffer.from && $1ad9e3a3bba0ff2c$var$Buffer.alloc && $1ad9e3a3bba0ff2c$var$Buffer.allocUnsafe && $1ad9e3a3bba0ff2c$var$Buffer.allocUnsafeSlow) module.exports = $3aNd6;
else {
    // Copy properties from require('buffer')
    $1ad9e3a3bba0ff2c$var$copyProps($3aNd6, module.exports);
    module.exports.Buffer = $1ad9e3a3bba0ff2c$var$SafeBuffer;
}
function $1ad9e3a3bba0ff2c$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1ad9e3a3bba0ff2c$var$Buffer(arg, encodingOrOffset, length);
}
$1ad9e3a3bba0ff2c$var$SafeBuffer.prototype = Object.create($1ad9e3a3bba0ff2c$var$Buffer.prototype);
// Copy static methods from Buffer
$1ad9e3a3bba0ff2c$var$copyProps($1ad9e3a3bba0ff2c$var$Buffer, $1ad9e3a3bba0ff2c$var$SafeBuffer);
$1ad9e3a3bba0ff2c$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $1ad9e3a3bba0ff2c$var$Buffer(arg, encodingOrOffset, length);
};
$1ad9e3a3bba0ff2c$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $1ad9e3a3bba0ff2c$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1ad9e3a3bba0ff2c$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $1ad9e3a3bba0ff2c$var$Buffer(size);
};
$1ad9e3a3bba0ff2c$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $3aNd6.SlowBuffer(size);
};

});


parcelRegister("5QtK4", function(module, exports) {

var $6qd2L = parcelRequire("6qd2L");
"use strict";
var $4418e13c55ec201d$var$_Object$setPrototypeO;
function $4418e13c55ec201d$var$_defineProperty(obj, key, value) {
    key = $4418e13c55ec201d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4418e13c55ec201d$var$_toPropertyKey(arg) {
    var key = $4418e13c55ec201d$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $4418e13c55ec201d$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $8flRm = parcelRequire("8flRm");
var $4418e13c55ec201d$var$kLastResolve = Symbol("lastResolve");
var $4418e13c55ec201d$var$kLastReject = Symbol("lastReject");
var $4418e13c55ec201d$var$kError = Symbol("error");
var $4418e13c55ec201d$var$kEnded = Symbol("ended");
var $4418e13c55ec201d$var$kLastPromise = Symbol("lastPromise");
var $4418e13c55ec201d$var$kHandlePromise = Symbol("handlePromise");
var $4418e13c55ec201d$var$kStream = Symbol("stream");
function $4418e13c55ec201d$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $4418e13c55ec201d$var$readAndResolve(iter) {
    var resolve = iter[$4418e13c55ec201d$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$4418e13c55ec201d$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$4418e13c55ec201d$var$kLastPromise] = null;
            iter[$4418e13c55ec201d$var$kLastResolve] = null;
            iter[$4418e13c55ec201d$var$kLastReject] = null;
            resolve($4418e13c55ec201d$var$createIterResult(data, false));
        }
    }
}
function $4418e13c55ec201d$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $6qd2L.nextTick($4418e13c55ec201d$var$readAndResolve, iter);
}
function $4418e13c55ec201d$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$4418e13c55ec201d$var$kEnded]) {
                resolve($4418e13c55ec201d$var$createIterResult(undefined, true));
                return;
            }
            iter[$4418e13c55ec201d$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $4418e13c55ec201d$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $4418e13c55ec201d$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($4418e13c55ec201d$var$_Object$setPrototypeO = {
    get stream () {
        return this[$4418e13c55ec201d$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$4418e13c55ec201d$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$4418e13c55ec201d$var$kEnded]) return Promise.resolve($4418e13c55ec201d$var$createIterResult(undefined, true));
        if (this[$4418e13c55ec201d$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $6qd2L.nextTick(function() {
                if (_this[$4418e13c55ec201d$var$kError]) reject(_this[$4418e13c55ec201d$var$kError]);
                else resolve($4418e13c55ec201d$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$4418e13c55ec201d$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($4418e13c55ec201d$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$4418e13c55ec201d$var$kStream].read();
            if (data !== null) return Promise.resolve($4418e13c55ec201d$var$createIterResult(data, false));
            promise = new Promise(this[$4418e13c55ec201d$var$kHandlePromise]);
        }
        this[$4418e13c55ec201d$var$kLastPromise] = promise;
        return promise;
    }
}, $4418e13c55ec201d$var$_defineProperty($4418e13c55ec201d$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $4418e13c55ec201d$var$_defineProperty($4418e13c55ec201d$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$4418e13c55ec201d$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($4418e13c55ec201d$var$createIterResult(undefined, true));
        });
    });
}), $4418e13c55ec201d$var$_Object$setPrototypeO), $4418e13c55ec201d$var$AsyncIteratorPrototype);
var $4418e13c55ec201d$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($4418e13c55ec201d$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $4418e13c55ec201d$var$_defineProperty(_Object$create, $4418e13c55ec201d$var$kStream, {
        value: stream,
        writable: true
    }), $4418e13c55ec201d$var$_defineProperty(_Object$create, $4418e13c55ec201d$var$kLastResolve, {
        value: null,
        writable: true
    }), $4418e13c55ec201d$var$_defineProperty(_Object$create, $4418e13c55ec201d$var$kLastReject, {
        value: null,
        writable: true
    }), $4418e13c55ec201d$var$_defineProperty(_Object$create, $4418e13c55ec201d$var$kError, {
        value: null,
        writable: true
    }), $4418e13c55ec201d$var$_defineProperty(_Object$create, $4418e13c55ec201d$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $4418e13c55ec201d$var$_defineProperty(_Object$create, $4418e13c55ec201d$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$4418e13c55ec201d$var$kStream].read();
            if (data) {
                iterator[$4418e13c55ec201d$var$kLastPromise] = null;
                iterator[$4418e13c55ec201d$var$kLastResolve] = null;
                iterator[$4418e13c55ec201d$var$kLastReject] = null;
                resolve($4418e13c55ec201d$var$createIterResult(data, false));
            } else {
                iterator[$4418e13c55ec201d$var$kLastResolve] = resolve;
                iterator[$4418e13c55ec201d$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$4418e13c55ec201d$var$kLastPromise] = null;
    $8flRm(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$4418e13c55ec201d$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$4418e13c55ec201d$var$kLastPromise] = null;
                iterator[$4418e13c55ec201d$var$kLastResolve] = null;
                iterator[$4418e13c55ec201d$var$kLastReject] = null;
                reject(err);
            }
            iterator[$4418e13c55ec201d$var$kError] = err;
            return;
        }
        var resolve = iterator[$4418e13c55ec201d$var$kLastResolve];
        if (resolve !== null) {
            iterator[$4418e13c55ec201d$var$kLastPromise] = null;
            iterator[$4418e13c55ec201d$var$kLastResolve] = null;
            iterator[$4418e13c55ec201d$var$kLastReject] = null;
            resolve($4418e13c55ec201d$var$createIterResult(undefined, true));
        }
        iterator[$4418e13c55ec201d$var$kEnded] = true;
    });
    stream.on("readable", $4418e13c55ec201d$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $4418e13c55ec201d$var$createReadableStreamAsyncIterator;

});
parcelRegister("8flRm", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $6010ae4e937bace6$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("h1zie")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $6010ae4e937bace6$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $6010ae4e937bace6$var$noop() {}
function $6010ae4e937bace6$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $6010ae4e937bace6$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $6010ae4e937bace6$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $6010ae4e937bace6$var$once(callback || $6010ae4e937bace6$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $6010ae4e937bace6$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $6010ae4e937bace6$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($6010ae4e937bace6$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $6010ae4e937bace6$var$eos;

});


parcelRegister("adKWq", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("jwvFo", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $e36991d36e78d746$var$Transform;

var $h1zie = parcelRequire("h1zie");
var $e36991d36e78d746$require$_require$codes = $h1zie.codes;
var $e36991d36e78d746$var$ERR_METHOD_NOT_IMPLEMENTED = $e36991d36e78d746$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $e36991d36e78d746$var$ERR_MULTIPLE_CALLBACK = $e36991d36e78d746$require$_require$codes.ERR_MULTIPLE_CALLBACK, $e36991d36e78d746$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $e36991d36e78d746$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $e36991d36e78d746$var$ERR_TRANSFORM_WITH_LENGTH_0 = $e36991d36e78d746$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $djKha = parcelRequire("djKha");

(parcelRequire("9M38k"))($e36991d36e78d746$var$Transform, $djKha);
function $e36991d36e78d746$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $e36991d36e78d746$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $e36991d36e78d746$var$Transform(options) {
    if (!(this instanceof $e36991d36e78d746$var$Transform)) return new $e36991d36e78d746$var$Transform(options);
    $djKha.call(this, options);
    this._transformState = {
        afterTransform: $e36991d36e78d746$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $e36991d36e78d746$var$prefinish);
}
function $e36991d36e78d746$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $e36991d36e78d746$var$done(_this, er, data);
    });
    else $e36991d36e78d746$var$done(this, null, null);
}
$e36991d36e78d746$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $djKha.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$e36991d36e78d746$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $e36991d36e78d746$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$e36991d36e78d746$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$e36991d36e78d746$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$e36991d36e78d746$var$Transform.prototype._destroy = function(err, cb) {
    $djKha.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $e36991d36e78d746$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $e36991d36e78d746$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $e36991d36e78d746$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("dPjGZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $a10f5046fdfbdcc7$var$PassThrough;

var $jwvFo = parcelRequire("jwvFo");

(parcelRequire("9M38k"))($a10f5046fdfbdcc7$var$PassThrough, $jwvFo);
function $a10f5046fdfbdcc7$var$PassThrough(options) {
    if (!(this instanceof $a10f5046fdfbdcc7$var$PassThrough)) return new $a10f5046fdfbdcc7$var$PassThrough(options);
    $jwvFo.call(this, options);
}
$a10f5046fdfbdcc7$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("1K5UB", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $144eac4f31149060$var$eos;
function $144eac4f31149060$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $h1zie = parcelRequire("h1zie");
var $144eac4f31149060$require$_require$codes = $h1zie.codes;
var $144eac4f31149060$var$ERR_MISSING_ARGS = $144eac4f31149060$require$_require$codes.ERR_MISSING_ARGS, $144eac4f31149060$var$ERR_STREAM_DESTROYED = $144eac4f31149060$require$_require$codes.ERR_STREAM_DESTROYED;
function $144eac4f31149060$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $144eac4f31149060$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $144eac4f31149060$var$destroyer(stream, reading, writing, callback) {
    callback = $144eac4f31149060$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($144eac4f31149060$var$eos === undefined) $144eac4f31149060$var$eos = (parcelRequire("8flRm"));
    $144eac4f31149060$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($144eac4f31149060$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $144eac4f31149060$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $144eac4f31149060$var$call(fn) {
    fn();
}
function $144eac4f31149060$var$pipe(from, to) {
    return from.pipe(to);
}
function $144eac4f31149060$var$popCallback(streams) {
    if (!streams.length) return $144eac4f31149060$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $144eac4f31149060$var$noop;
    return streams.pop();
}
function $144eac4f31149060$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $144eac4f31149060$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $144eac4f31149060$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $144eac4f31149060$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($144eac4f31149060$var$call);
            if (reading) return;
            destroys.forEach($144eac4f31149060$var$call);
            callback(error);
        });
    });
    return streams.reduce($144eac4f31149060$var$pipe);
}
module.exports = $144eac4f31149060$var$pipeline;

});



var $10cKx = parcelRequire("10cKx");
var $74a3d485b34dbdf7$exports = {};

/*!
 * jQuery Validation Plugin v1.20.0
 *
 * https://jqueryvalidation.org/
 *
 * Copyright (c) 2023 Jörn Zaefferer
 * Released under the MIT license
 */ (function(factory) {
    if (typeof define === "function" && define.amd) define([
        "jquery"
    ], factory);
    else if (0, $74a3d485b34dbdf7$exports) $74a3d485b34dbdf7$exports = factory((parcelRequire("10cKx")));
    else factory(jQuery);
})(function($) {
    $.extend($.fn, {
        // https://jqueryvalidation.org/validate/
        validate: function(options) {
            // If nothing is selected, return nothing; can't chain anyway
            if (!this.length) {
                if (options && options.debug && window.console) console.warn("Nothing selected, can't validate, returning nothing.");
                return;
            }
            // Check if a validator for this form was already created
            var validator = $.data(this[0], "validator");
            if (validator) return validator;
            // Add novalidate tag if HTML5.
            this.attr("novalidate", "novalidate");
            validator = new $.validator(options, this[0]);
            $.data(this[0], "validator", validator);
            if (validator.settings.onsubmit) {
                this.on("click.validate", ":submit", function(event) {
                    // Track the used submit button to properly handle scripted
                    // submits later.
                    validator.submitButton = event.currentTarget;
                    // Allow suppressing validation by adding a cancel class to the submit button
                    if ($(this).hasClass("cancel")) validator.cancelSubmit = true;
                    // Allow suppressing validation by adding the html5 formnovalidate attribute to the submit button
                    if ($(this).attr("formnovalidate") !== undefined) validator.cancelSubmit = true;
                });
                // Validate the form on submit
                this.on("submit.validate", function(event) {
                    if (validator.settings.debug) // Prevent form submit to be able to see console output
                    event.preventDefault();
                    function handle() {
                        var hidden, result;
                        // Insert a hidden input as a replacement for the missing submit button
                        // The hidden input is inserted in two cases:
                        //   - A user defined a `submitHandler`
                        //   - There was a pending request due to `remote` method and `stopRequest()`
                        //     was called to submit the form in case it's valid
                        if (validator.submitButton && (validator.settings.submitHandler || validator.formSubmitted)) hidden = $("<input type='hidden'/>").attr("name", validator.submitButton.name).val($(validator.submitButton).val()).appendTo(validator.currentForm);
                        if (validator.settings.submitHandler && !validator.settings.debug) {
                            result = validator.settings.submitHandler.call(validator, validator.currentForm, event);
                            if (hidden) // And clean up afterwards; thanks to no-block-scope, hidden can be referenced
                            hidden.remove();
                            if (result !== undefined) return result;
                            return false;
                        }
                        return true;
                    }
                    // Prevent submit for invalid forms or custom submit handlers
                    if (validator.cancelSubmit) {
                        validator.cancelSubmit = false;
                        return handle();
                    }
                    if (validator.form()) {
                        if (validator.pendingRequest) {
                            validator.formSubmitted = true;
                            return false;
                        }
                        return handle();
                    } else {
                        validator.focusInvalid();
                        return false;
                    }
                });
            }
            return validator;
        },
        // https://jqueryvalidation.org/valid/
        valid: function() {
            var valid, validator, errorList;
            if ($(this[0]).is("form")) valid = this.validate().form();
            else {
                errorList = [];
                valid = true;
                validator = $(this[0].form).validate();
                this.each(function() {
                    valid = validator.element(this) && valid;
                    if (!valid) errorList = errorList.concat(validator.errorList);
                });
                validator.errorList = errorList;
            }
            return valid;
        },
        // https://jqueryvalidation.org/rules/
        rules: function(command, argument) {
            var element = this[0], isContentEditable = typeof this.attr("contenteditable") !== "undefined" && this.attr("contenteditable") !== "false", settings, staticRules, existingRules, data, param, filtered;
            // If nothing is selected, return empty object; can't chain anyway
            if (element == null) return;
            if (!element.form && isContentEditable) {
                element.form = this.closest("form")[0];
                element.name = this.attr("name");
            }
            if (element.form == null) return;
            if (command) {
                settings = $.data(element.form, "validator").settings;
                staticRules = settings.rules;
                existingRules = $.validator.staticRules(element);
                switch(command){
                    case "add":
                        $.extend(existingRules, $.validator.normalizeRule(argument));
                        // Remove messages from rules, but allow them to be set separately
                        delete existingRules.messages;
                        staticRules[element.name] = existingRules;
                        if (argument.messages) settings.messages[element.name] = $.extend(settings.messages[element.name], argument.messages);
                        break;
                    case "remove":
                        if (!argument) {
                            delete staticRules[element.name];
                            return existingRules;
                        }
                        filtered = {};
                        $.each(argument.split(/\s/), function(index, method) {
                            filtered[method] = existingRules[method];
                            delete existingRules[method];
                        });
                        return filtered;
                }
            }
            data = $.validator.normalizeRules($.extend({}, $.validator.classRules(element), $.validator.attributeRules(element), $.validator.dataRules(element), $.validator.staticRules(element)), element);
            // Make sure required is at front
            if (data.required) {
                param = data.required;
                delete data.required;
                data = $.extend({
                    required: param
                }, data);
            }
            // Make sure remote is at back
            if (data.remote) {
                param = data.remote;
                delete data.remote;
                data = $.extend(data, {
                    remote: param
                });
            }
            return data;
        }
    });
    // JQuery trim is deprecated, provide a trim method based on String.prototype.trim
    var trim = function(str) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/trim#Polyfill
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
    };
    // Custom selectors
    $.extend($.expr.pseudos || $.expr[":"], {
        // https://jqueryvalidation.org/blank-selector/
        blank: function(a) {
            return !trim("" + $(a).val());
        },
        // https://jqueryvalidation.org/filled-selector/
        filled: function(a) {
            var val = $(a).val();
            return val !== null && !!trim("" + val);
        },
        // https://jqueryvalidation.org/unchecked-selector/
        unchecked: function(a) {
            return !$(a).prop("checked");
        }
    });
    // Constructor for validator
    $.validator = function(options, form) {
        this.settings = $.extend(true, {}, $.validator.defaults, options);
        this.currentForm = form;
        this.init();
    };
    // https://jqueryvalidation.org/jQuery.validator.format/
    $.validator.format = function(source, params) {
        if (arguments.length === 1) return function() {
            var args = $.makeArray(arguments);
            args.unshift(source);
            return $.validator.format.apply(this, args);
        };
        if (params === undefined) return source;
        if (arguments.length > 2 && params.constructor !== Array) params = $.makeArray(arguments).slice(1);
        if (params.constructor !== Array) params = [
            params
        ];
        $.each(params, function(i, n) {
            source = source.replace(new RegExp("\\{" + i + "\\}", "g"), function() {
                return n;
            });
        });
        return source;
    };
    $.extend($.validator, {
        defaults: {
            messages: {},
            groups: {},
            rules: {},
            errorClass: "error",
            pendingClass: "pending",
            validClass: "valid",
            errorElement: "label",
            focusCleanup: false,
            focusInvalid: true,
            errorContainer: $([]),
            errorLabelContainer: $([]),
            onsubmit: true,
            ignore: ":hidden",
            ignoreTitle: false,
            onfocusin: function(element) {
                this.lastActive = element;
                // Hide error label and remove error class on focus if enabled
                if (this.settings.focusCleanup) {
                    if (this.settings.unhighlight) this.settings.unhighlight.call(this, element, this.settings.errorClass, this.settings.validClass);
                    this.hideThese(this.errorsFor(element));
                }
            },
            onfocusout: function(element) {
                if (!this.checkable(element) && (element.name in this.submitted || !this.optional(element))) this.element(element);
            },
            onkeyup: function(element, event) {
                // Avoid revalidate the field when pressing one of the following keys
                // Shift       => 16
                // Ctrl        => 17
                // Alt         => 18
                // Caps lock   => 20
                // End         => 35
                // Home        => 36
                // Left arrow  => 37
                // Up arrow    => 38
                // Right arrow => 39
                // Down arrow  => 40
                // Insert      => 45
                // Num lock    => 144
                // AltGr key   => 225
                var excludedKeys = [
                    16,
                    17,
                    18,
                    20,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    45,
                    144,
                    225
                ];
                if (event.which === 9 && this.elementValue(element) === "" || $.inArray(event.keyCode, excludedKeys) !== -1) return;
                else if (element.name in this.submitted || element.name in this.invalid) this.element(element);
            },
            onclick: function(element) {
                // Click on selects, radiobuttons and checkboxes
                if (element.name in this.submitted) this.element(element);
                else if (element.parentNode.name in this.submitted) this.element(element.parentNode);
            },
            highlight: function(element, errorClass, validClass) {
                if (element.type === "radio") this.findByName(element.name).addClass(errorClass).removeClass(validClass);
                else $(element).addClass(errorClass).removeClass(validClass);
            },
            unhighlight: function(element, errorClass, validClass) {
                if (element.type === "radio") this.findByName(element.name).removeClass(errorClass).addClass(validClass);
                else $(element).removeClass(errorClass).addClass(validClass);
            }
        },
        // https://jqueryvalidation.org/jQuery.validator.setDefaults/
        setDefaults: function(settings) {
            $.extend($.validator.defaults, settings);
        },
        messages: {
            required: "This field is required.",
            remote: "Please fix this field.",
            email: "Please enter a valid email address.",
            url: "Please enter a valid URL.",
            date: "Please enter a valid date.",
            dateISO: "Please enter a valid date (ISO).",
            number: "Please enter a valid number.",
            digits: "Please enter only digits.",
            equalTo: "Please enter the same value again.",
            maxlength: $.validator.format("Please enter no more than {0} characters."),
            minlength: $.validator.format("Please enter at least {0} characters."),
            rangelength: $.validator.format("Please enter a value between {0} and {1} characters long."),
            range: $.validator.format("Please enter a value between {0} and {1}."),
            max: $.validator.format("Please enter a value less than or equal to {0}."),
            min: $.validator.format("Please enter a value greater than or equal to {0}."),
            step: $.validator.format("Please enter a multiple of {0}.")
        },
        autoCreateRanges: false,
        prototype: {
            init: function() {
                this.labelContainer = $(this.settings.errorLabelContainer);
                this.errorContext = this.labelContainer.length && this.labelContainer || $(this.currentForm);
                this.containers = $(this.settings.errorContainer).add(this.settings.errorLabelContainer);
                this.submitted = {};
                this.valueCache = {};
                this.pendingRequest = 0;
                this.pending = {};
                this.invalid = {};
                this.reset();
                var currentForm = this.currentForm, groups = this.groups = {}, rules;
                $.each(this.settings.groups, function(key, value) {
                    if (typeof value === "string") value = value.split(/\s/);
                    $.each(value, function(index, name) {
                        groups[name] = key;
                    });
                });
                rules = this.settings.rules;
                $.each(rules, function(key, value) {
                    rules[key] = $.validator.normalizeRule(value);
                });
                function delegate(event) {
                    var isContentEditable = typeof $(this).attr("contenteditable") !== "undefined" && $(this).attr("contenteditable") !== "false";
                    // Set form expando on contenteditable
                    if (!this.form && isContentEditable) {
                        this.form = $(this).closest("form")[0];
                        this.name = $(this).attr("name");
                    }
                    // Ignore the element if it belongs to another form. This will happen mainly
                    // when setting the `form` attribute of an input to the id of another form.
                    if (currentForm !== this.form) return;
                    var validator = $.data(this.form, "validator"), eventType = "on" + event.type.replace(/^validate/, ""), settings = validator.settings;
                    if (settings[eventType] && !$(this).is(settings.ignore)) settings[eventType].call(validator, this, event);
                }
                $(this.currentForm).on("focusin.validate focusout.validate keyup.validate", ":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'], [type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], [type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'], [type='radio'], [type='checkbox'], [contenteditable], [type='button']", delegate)// Support: Chrome, oldIE
                // "select" is provided as event.target when clicking a option
                .on("click.validate", "select, option, [type='radio'], [type='checkbox']", delegate);
                if (this.settings.invalidHandler) $(this.currentForm).on("invalid-form.validate", this.settings.invalidHandler);
            },
            // https://jqueryvalidation.org/Validator.form/
            form: function() {
                this.checkForm();
                $.extend(this.submitted, this.errorMap);
                this.invalid = $.extend({}, this.errorMap);
                if (!this.valid()) $(this.currentForm).triggerHandler("invalid-form", [
                    this
                ]);
                this.showErrors();
                return this.valid();
            },
            checkForm: function() {
                this.prepareForm();
                for(var i = 0, elements = this.currentElements = this.elements(); elements[i]; i++)this.check(elements[i]);
                return this.valid();
            },
            // https://jqueryvalidation.org/Validator.element/
            element: function(element) {
                var cleanElement = this.clean(element), checkElement = this.validationTargetFor(cleanElement), v = this, result = true, rs, group;
                if (checkElement === undefined) delete this.invalid[cleanElement.name];
                else {
                    this.prepareElement(checkElement);
                    this.currentElements = $(checkElement);
                    // If this element is grouped, then validate all group elements already
                    // containing a value
                    group = this.groups[checkElement.name];
                    if (group) $.each(this.groups, function(name, testgroup) {
                        if (testgroup === group && name !== checkElement.name) {
                            cleanElement = v.validationTargetFor(v.clean(v.findByName(name)));
                            if (cleanElement && cleanElement.name in v.invalid) {
                                v.currentElements.push(cleanElement);
                                result = v.check(cleanElement) && result;
                            }
                        }
                    });
                    rs = this.check(checkElement) !== false;
                    result = result && rs;
                    if (rs) this.invalid[checkElement.name] = false;
                    else this.invalid[checkElement.name] = true;
                    if (!this.numberOfInvalids()) // Hide error containers on last error
                    this.toHide = this.toHide.add(this.containers);
                    this.showErrors();
                    // Add aria-invalid status for screen readers
                    $(element).attr("aria-invalid", !rs);
                }
                return result;
            },
            // https://jqueryvalidation.org/Validator.showErrors/
            showErrors: function(errors) {
                if (errors) {
                    var validator = this;
                    // Add items to error list and map
                    $.extend(this.errorMap, errors);
                    this.errorList = $.map(this.errorMap, function(message, name) {
                        return {
                            message: message,
                            element: validator.findByName(name)[0]
                        };
                    });
                    // Remove items from success list
                    this.successList = $.grep(this.successList, function(element) {
                        return !(element.name in errors);
                    });
                }
                if (this.settings.showErrors) this.settings.showErrors.call(this, this.errorMap, this.errorList);
                else this.defaultShowErrors();
            },
            // https://jqueryvalidation.org/Validator.resetForm/
            resetForm: function() {
                if ($.fn.resetForm) $(this.currentForm).resetForm();
                this.invalid = {};
                this.submitted = {};
                this.prepareForm();
                this.hideErrors();
                var elements = this.elements().removeData("previousValue").removeAttr("aria-invalid");
                this.resetElements(elements);
            },
            resetElements: function(elements) {
                var i;
                if (this.settings.unhighlight) for(i = 0; elements[i]; i++){
                    this.settings.unhighlight.call(this, elements[i], this.settings.errorClass, "");
                    this.findByName(elements[i].name).removeClass(this.settings.validClass);
                }
                else elements.removeClass(this.settings.errorClass).removeClass(this.settings.validClass);
            },
            numberOfInvalids: function() {
                return this.objectLength(this.invalid);
            },
            objectLength: function(obj) {
                /* jshint unused: false */ var count = 0, i;
                for(i in obj)// This check allows counting elements with empty error
                // message as invalid elements
                if (obj[i] !== undefined && obj[i] !== null && obj[i] !== false) count++;
                return count;
            },
            hideErrors: function() {
                this.hideThese(this.toHide);
            },
            hideThese: function(errors) {
                errors.not(this.containers).text("");
                this.addWrapper(errors).hide();
            },
            valid: function() {
                return this.size() === 0;
            },
            size: function() {
                return this.errorList.length;
            },
            focusInvalid: function() {
                if (this.settings.focusInvalid) try {
                    $(this.findLastActive() || this.errorList.length && this.errorList[0].element || []).filter(":visible").trigger("focus")// Manually trigger focusin event; without it, focusin handler isn't called, findLastActive won't have anything to find
                    .trigger("focusin");
                } catch (e) {
                // Ignore IE throwing errors when focusing hidden elements
                }
            },
            findLastActive: function() {
                var lastActive = this.lastActive;
                return lastActive && $.grep(this.errorList, function(n) {
                    return n.element.name === lastActive.name;
                }).length === 1 && lastActive;
            },
            elements: function() {
                var validator = this, rulesCache = {};
                // Select all valid inputs inside the form (no submit or reset buttons)
                return $(this.currentForm).find("input, select, textarea, [contenteditable]").not(":submit, :reset, :image, :disabled").not(this.settings.ignore).filter(function() {
                    var name = this.name || $(this).attr("name"); // For contenteditable
                    var isContentEditable = typeof $(this).attr("contenteditable") !== "undefined" && $(this).attr("contenteditable") !== "false";
                    if (!name && validator.settings.debug && window.console) console.error("%o has no name assigned", this);
                    // Set form expando on contenteditable
                    if (isContentEditable) {
                        this.form = $(this).closest("form")[0];
                        this.name = name;
                    }
                    // Ignore elements that belong to other/nested forms
                    if (this.form !== validator.currentForm) return false;
                    // Select only the first element for each name, and only those with rules specified
                    if (name in rulesCache || !validator.objectLength($(this).rules())) return false;
                    rulesCache[name] = true;
                    return true;
                });
            },
            clean: function(selector) {
                return $(selector)[0];
            },
            errors: function() {
                var errorClass = this.settings.errorClass.split(" ").join(".");
                return $(this.settings.errorElement + "." + errorClass, this.errorContext);
            },
            resetInternals: function() {
                this.successList = [];
                this.errorList = [];
                this.errorMap = {};
                this.toShow = $([]);
                this.toHide = $([]);
            },
            reset: function() {
                this.resetInternals();
                this.currentElements = $([]);
            },
            prepareForm: function() {
                this.reset();
                this.toHide = this.errors().add(this.containers);
            },
            prepareElement: function(element) {
                this.reset();
                this.toHide = this.errorsFor(element);
            },
            elementValue: function(element) {
                var $element = $(element), type = element.type, isContentEditable = typeof $element.attr("contenteditable") !== "undefined" && $element.attr("contenteditable") !== "false", val, idx;
                if (type === "radio" || type === "checkbox") return this.findByName(element.name).filter(":checked").val();
                else if (type === "number" && typeof element.validity !== "undefined") return element.validity.badInput ? "NaN" : $element.val();
                if (isContentEditable) val = $element.text();
                else val = $element.val();
                if (type === "file") {
                    // Modern browser (chrome & safari)
                    if (val.substr(0, 12) === "C:\\fakepath\\") return val.substr(12);
                    // Legacy browsers
                    // Unix-based path
                    idx = val.lastIndexOf("/");
                    if (idx >= 0) return val.substr(idx + 1);
                    // Windows-based path
                    idx = val.lastIndexOf("\\");
                    if (idx >= 0) return val.substr(idx + 1);
                    // Just the file name
                    return val;
                }
                if (typeof val === "string") return val.replace(/\r/g, "");
                return val;
            },
            check: function(element) {
                element = this.validationTargetFor(this.clean(element));
                var rules = $(element).rules(), rulesCount = $.map(rules, function(n, i) {
                    return i;
                }).length, dependencyMismatch = false, val = this.elementValue(element), result, method, rule, normalizer;
                // Abort any pending Ajax request from a previous call to this method.
                this.abortRequest(element);
                // Prioritize the local normalizer defined for this element over the global one
                // if the former exists, otherwise user the global one in case it exists.
                if (typeof rules.normalizer === "function") normalizer = rules.normalizer;
                else if (typeof this.settings.normalizer === "function") normalizer = this.settings.normalizer;
                // If normalizer is defined, then call it to retreive the changed value instead
                // of using the real one.
                // Note that `this` in the normalizer is `element`.
                if (normalizer) {
                    val = normalizer.call(element, val);
                    // Delete the normalizer from rules to avoid treating it as a pre-defined method.
                    delete rules.normalizer;
                }
                for(method in rules){
                    rule = {
                        method: method,
                        parameters: rules[method]
                    };
                    try {
                        result = $.validator.methods[method].call(this, val, element, rule.parameters);
                        // If a method indicates that the field is optional and therefore valid,
                        // don't mark it as valid when there are no other rules
                        if (result === "dependency-mismatch" && rulesCount === 1) {
                            dependencyMismatch = true;
                            continue;
                        }
                        dependencyMismatch = false;
                        if (result === "pending") {
                            this.toHide = this.toHide.not(this.errorsFor(element));
                            return;
                        }
                        if (!result) {
                            this.formatAndAdd(element, rule);
                            return false;
                        }
                    } catch (e) {
                        if (this.settings.debug && window.console) console.log("Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.", e);
                        if (e instanceof TypeError) e.message += ".  Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.";
                        throw e;
                    }
                }
                if (dependencyMismatch) return;
                if (this.objectLength(rules)) this.successList.push(element);
                return true;
            },
            // Return the custom message for the given element and validation method
            // specified in the element's HTML5 data attribute
            // return the generic message if present and no method specific message is present
            customDataMessage: function(element, method) {
                return $(element).data("msg" + method.charAt(0).toUpperCase() + method.substring(1).toLowerCase()) || $(element).data("msg");
            },
            // Return the custom message for the given element name and validation method
            customMessage: function(name, method) {
                var m = this.settings.messages[name];
                return m && (m.constructor === String ? m : m[method]);
            },
            // Return the first defined argument, allowing empty strings
            findDefined: function() {
                for(var i = 0; i < arguments.length; i++){
                    if (arguments[i] !== undefined) return arguments[i];
                }
                return undefined;
            },
            // The second parameter 'rule' used to be a string, and extended to an object literal
            // of the following form:
            // rule = {
            //     method: "method name",
            //     parameters: "the given method parameters"
            // }
            //
            // The old behavior still supported, kept to maintain backward compatibility with
            // old code, and will be removed in the next major release.
            defaultMessage: function(element, rule) {
                if (typeof rule === "string") rule = {
                    method: rule
                };
                var message = this.findDefined(this.customMessage(element.name, rule.method), this.customDataMessage(element, rule.method), // 'title' is never undefined, so handle empty string as undefined
                !this.settings.ignoreTitle && element.title || undefined, $.validator.messages[rule.method], "<strong>Warning: No message defined for " + element.name + "</strong>"), theregex = /\$?\{(\d+)\}/g;
                if (typeof message === "function") message = message.call(this, rule.parameters, element);
                else if (theregex.test(message)) message = $.validator.format(message.replace(theregex, "{$1}"), rule.parameters);
                return message;
            },
            formatAndAdd: function(element, rule) {
                var message = this.defaultMessage(element, rule);
                this.errorList.push({
                    message: message,
                    element: element,
                    method: rule.method
                });
                this.errorMap[element.name] = message;
                this.submitted[element.name] = message;
            },
            addWrapper: function(toToggle) {
                if (this.settings.wrapper) toToggle = toToggle.add(toToggle.parent(this.settings.wrapper));
                return toToggle;
            },
            defaultShowErrors: function() {
                var i, elements, error;
                for(i = 0; this.errorList[i]; i++){
                    error = this.errorList[i];
                    if (this.settings.highlight) this.settings.highlight.call(this, error.element, this.settings.errorClass, this.settings.validClass);
                    this.showLabel(error.element, error.message);
                }
                if (this.errorList.length) this.toShow = this.toShow.add(this.containers);
                if (this.settings.success) for(i = 0; this.successList[i]; i++)this.showLabel(this.successList[i]);
                if (this.settings.unhighlight) for(i = 0, elements = this.validElements(); elements[i]; i++)this.settings.unhighlight.call(this, elements[i], this.settings.errorClass, this.settings.validClass);
                this.toHide = this.toHide.not(this.toShow);
                this.hideErrors();
                this.addWrapper(this.toShow).show();
            },
            validElements: function() {
                return this.currentElements.not(this.invalidElements());
            },
            invalidElements: function() {
                return $(this.errorList).map(function() {
                    return this.element;
                });
            },
            showLabel: function(element, message) {
                var place, group, errorID, v, error = this.errorsFor(element), elementID = this.idOrName(element), describedBy = $(element).attr("aria-describedby");
                if (error.length) {
                    // Refresh error/success class
                    error.removeClass(this.settings.validClass).addClass(this.settings.errorClass);
                    // Replace message on existing label
                    if (this.settings && this.settings.escapeHtml) error.text(message || "");
                    else error.html(message || "");
                } else {
                    // Create error element
                    error = $("<" + this.settings.errorElement + ">").attr("id", elementID + "-error").addClass(this.settings.errorClass);
                    if (this.settings && this.settings.escapeHtml) error.text(message || "");
                    else error.html(message || "");
                    // Maintain reference to the element to be placed into the DOM
                    place = error;
                    if (this.settings.wrapper) // Make sure the element is visible, even in IE
                    // actually showing the wrapped element is handled elsewhere
                    place = error.hide().show().wrap("<" + this.settings.wrapper + "/>").parent();
                    if (this.labelContainer.length) this.labelContainer.append(place);
                    else if (this.settings.errorPlacement) this.settings.errorPlacement.call(this, place, $(element));
                    else place.insertAfter(element);
                    // Link error back to the element
                    if (error.is("label")) // If the error is a label, then associate using 'for'
                    error.attr("for", elementID);
                    else if (error.parents("label[for='" + this.escapeCssMeta(elementID) + "']").length === 0) {
                        errorID = error.attr("id");
                        // Respect existing non-error aria-describedby
                        if (!describedBy) describedBy = errorID;
                        else if (!describedBy.match(new RegExp("\\b" + this.escapeCssMeta(errorID) + "\\b"))) // Add to end of list if not already present
                        describedBy += " " + errorID;
                        $(element).attr("aria-describedby", describedBy);
                        // If this element is grouped, then assign to all elements in the same group
                        group = this.groups[element.name];
                        if (group) {
                            v = this;
                            $.each(v.groups, function(name, testgroup) {
                                if (testgroup === group) $("[name='" + v.escapeCssMeta(name) + "']", v.currentForm).attr("aria-describedby", error.attr("id"));
                            });
                        }
                    }
                }
                if (!message && this.settings.success) {
                    error.text("");
                    if (typeof this.settings.success === "string") error.addClass(this.settings.success);
                    else this.settings.success(error, element);
                }
                this.toShow = this.toShow.add(error);
            },
            errorsFor: function(element) {
                var name = this.escapeCssMeta(this.idOrName(element)), describer = $(element).attr("aria-describedby"), selector = "label[for='" + name + "'], label[for='" + name + "'] *";
                // 'aria-describedby' should directly reference the error element
                if (describer) selector = selector + ", #" + this.escapeCssMeta(describer).replace(/\s+/g, ", #");
                return this.errors().filter(selector);
            },
            // See https://api.jquery.com/category/selectors/, for CSS
            // meta-characters that should be escaped in order to be used with JQuery
            // as a literal part of a name/id or any selector.
            escapeCssMeta: function(string) {
                if (string === undefined) return "";
                return string.replace(/([\\!"#$%&'()*+,./:;<=>?@\[\]^`{|}~])/g, "\\$1");
            },
            idOrName: function(element) {
                return this.groups[element.name] || (this.checkable(element) ? element.name : element.id || element.name);
            },
            validationTargetFor: function(element) {
                // If radio/checkbox, validate first element in group instead
                if (this.checkable(element)) element = this.findByName(element.name);
                // Always apply ignore filter
                return $(element).not(this.settings.ignore)[0];
            },
            checkable: function(element) {
                return /radio|checkbox/i.test(element.type);
            },
            findByName: function(name) {
                return $(this.currentForm).find("[name='" + this.escapeCssMeta(name) + "']");
            },
            getLength: function(value, element) {
                switch(element.nodeName.toLowerCase()){
                    case "select":
                        return $("option:selected", element).length;
                    case "input":
                        if (this.checkable(element)) return this.findByName(element.name).filter(":checked").length;
                }
                return value.length;
            },
            depend: function(param, element) {
                return this.dependTypes[typeof param] ? this.dependTypes[typeof param](param, element) : true;
            },
            dependTypes: {
                "boolean": function(param) {
                    return param;
                },
                "string": function(param, element) {
                    return !!$(param, element.form).length;
                },
                "function": function(param, element) {
                    return param(element);
                }
            },
            optional: function(element) {
                var val = this.elementValue(element);
                return !$.validator.methods.required.call(this, val, element) && "dependency-mismatch";
            },
            elementAjaxPort: function(element) {
                return "validate" + element.name;
            },
            startRequest: function(element) {
                if (!this.pending[element.name]) {
                    this.pendingRequest++;
                    $(element).addClass(this.settings.pendingClass);
                    this.pending[element.name] = true;
                }
            },
            stopRequest: function(element, valid) {
                this.pendingRequest--;
                // Sometimes synchronization fails, make sure pendingRequest is never < 0
                if (this.pendingRequest < 0) this.pendingRequest = 0;
                delete this.pending[element.name];
                $(element).removeClass(this.settings.pendingClass);
                if (valid && this.pendingRequest === 0 && this.formSubmitted && this.form() && this.pendingRequest === 0) {
                    $(this.currentForm).trigger("submit");
                    // Remove the hidden input that was used as a replacement for the
                    // missing submit button. The hidden input is added by `handle()`
                    // to ensure that the value of the used submit button is passed on
                    // for scripted submits triggered by this method
                    if (this.submitButton) $("input:hidden[name='" + this.submitButton.name + "']", this.currentForm).remove();
                    this.formSubmitted = false;
                } else if (!valid && this.pendingRequest === 0 && this.formSubmitted) {
                    $(this.currentForm).triggerHandler("invalid-form", [
                        this
                    ]);
                    this.formSubmitted = false;
                }
            },
            abortRequest: function(element) {
                var port;
                if (this.pending[element.name]) {
                    port = this.elementAjaxPort(element);
                    $.ajaxAbort(port);
                    this.pendingRequest--;
                    // Sometimes synchronization fails, make sure pendingRequest is never < 0
                    if (this.pendingRequest < 0) this.pendingRequest = 0;
                    delete this.pending[element.name];
                    $(element).removeClass(this.settings.pendingClass);
                }
            },
            previousValue: function(element, method) {
                method = typeof method === "string" && method || "remote";
                return $.data(element, "previousValue") || $.data(element, "previousValue", {
                    old: null,
                    valid: true,
                    message: this.defaultMessage(element, {
                        method: method
                    })
                });
            },
            // Cleans up all forms and elements, removes validator-specific events
            destroy: function() {
                this.resetForm();
                $(this.currentForm).off(".validate").removeData("validator").find(".validate-equalTo-blur").off(".validate-equalTo").removeClass("validate-equalTo-blur").find(".validate-lessThan-blur").off(".validate-lessThan").removeClass("validate-lessThan-blur").find(".validate-lessThanEqual-blur").off(".validate-lessThanEqual").removeClass("validate-lessThanEqual-blur").find(".validate-greaterThanEqual-blur").off(".validate-greaterThanEqual").removeClass("validate-greaterThanEqual-blur").find(".validate-greaterThan-blur").off(".validate-greaterThan").removeClass("validate-greaterThan-blur");
            }
        },
        classRuleSettings: {
            required: {
                required: true
            },
            email: {
                email: true
            },
            url: {
                url: true
            },
            date: {
                date: true
            },
            dateISO: {
                dateISO: true
            },
            number: {
                number: true
            },
            digits: {
                digits: true
            },
            creditcard: {
                creditcard: true
            }
        },
        addClassRules: function(className, rules) {
            if (className.constructor === String) this.classRuleSettings[className] = rules;
            else $.extend(this.classRuleSettings, className);
        },
        classRules: function(element) {
            var rules = {}, classes = $(element).attr("class");
            if (classes) $.each(classes.split(" "), function() {
                if (this in $.validator.classRuleSettings) $.extend(rules, $.validator.classRuleSettings[this]);
            });
            return rules;
        },
        normalizeAttributeRule: function(rules, type, method, value) {
            // Convert the value to a number for number inputs, and for text for backwards compability
            // allows type="date" and others to be compared as strings
            if (/min|max|step/.test(method) && (type === null || /number|range|text/.test(type))) {
                value = Number(value);
                // Support Opera Mini, which returns NaN for undefined minlength
                if (isNaN(value)) value = undefined;
            }
            if (value || value === 0) rules[method] = value;
            else if (type === method && type !== "range") // Exception: the jquery validate 'range' method
            // does not test for the html5 'range' type
            rules[type === "date" ? "dateISO" : method] = true;
        },
        attributeRules: function(element) {
            var rules = {}, $element = $(element), type = element.getAttribute("type"), method, value;
            for(method in $.validator.methods){
                // Support for <input required> in both html5 and older browsers
                if (method === "required") {
                    value = element.getAttribute(method);
                    // Some browsers return an empty string for the required attribute
                    // and non-HTML5 browsers might have required="" markup
                    if (value === "") value = true;
                    // Force non-HTML5 browsers to return bool
                    value = !!value;
                } else value = $element.attr(method);
                this.normalizeAttributeRule(rules, type, method, value);
            }
            // 'maxlength' may be returned as -1, 2147483647 ( IE ) and 524288 ( safari ) for text inputs
            if (rules.maxlength && /-1|2147483647|524288/.test(rules.maxlength)) delete rules.maxlength;
            return rules;
        },
        dataRules: function(element) {
            var rules = {}, $element = $(element), type = element.getAttribute("type"), method, value;
            for(method in $.validator.methods){
                value = $element.data("rule" + method.charAt(0).toUpperCase() + method.substring(1).toLowerCase());
                // Cast empty attributes like `data-rule-required` to `true`
                if (value === "") value = true;
                this.normalizeAttributeRule(rules, type, method, value);
            }
            return rules;
        },
        staticRules: function(element) {
            var rules = {}, validator = $.data(element.form, "validator");
            if (validator.settings.rules) rules = $.validator.normalizeRule(validator.settings.rules[element.name]) || {};
            return rules;
        },
        normalizeRules: function(rules, element) {
            // Handle dependency check
            $.each(rules, function(prop, val) {
                // Ignore rule when param is explicitly false, eg. required:false
                if (val === false) {
                    delete rules[prop];
                    return;
                }
                if (val.param || val.depends) {
                    var keepRule = true;
                    switch(typeof val.depends){
                        case "string":
                            keepRule = !!$(val.depends, element.form).length;
                            break;
                        case "function":
                            keepRule = val.depends.call(element, element);
                            break;
                    }
                    if (keepRule) rules[prop] = val.param !== undefined ? val.param : true;
                    else {
                        $.data(element.form, "validator").resetElements($(element));
                        delete rules[prop];
                    }
                }
            });
            // Evaluate parameters
            $.each(rules, function(rule, parameter) {
                rules[rule] = typeof parameter === "function" && rule !== "normalizer" ? parameter(element) : parameter;
            });
            // Clean number parameters
            $.each([
                "minlength",
                "maxlength"
            ], function() {
                if (rules[this]) rules[this] = Number(rules[this]);
            });
            $.each([
                "rangelength",
                "range"
            ], function() {
                var parts;
                if (rules[this]) {
                    if (Array.isArray(rules[this])) rules[this] = [
                        Number(rules[this][0]),
                        Number(rules[this][1])
                    ];
                    else if (typeof rules[this] === "string") {
                        parts = rules[this].replace(/[\[\]]/g, "").split(/[\s,]+/);
                        rules[this] = [
                            Number(parts[0]),
                            Number(parts[1])
                        ];
                    }
                }
            });
            if ($.validator.autoCreateRanges) {
                // Auto-create ranges
                if (rules.min != null && rules.max != null) {
                    rules.range = [
                        rules.min,
                        rules.max
                    ];
                    delete rules.min;
                    delete rules.max;
                }
                if (rules.minlength != null && rules.maxlength != null) {
                    rules.rangelength = [
                        rules.minlength,
                        rules.maxlength
                    ];
                    delete rules.minlength;
                    delete rules.maxlength;
                }
            }
            return rules;
        },
        // Converts a simple string to a {string: true} rule, e.g., "required" to {required:true}
        normalizeRule: function(data) {
            if (typeof data === "string") {
                var transformed = {};
                $.each(data.split(/\s/), function() {
                    transformed[this] = true;
                });
                data = transformed;
            }
            return data;
        },
        // https://jqueryvalidation.org/jQuery.validator.addMethod/
        addMethod: function(name, method, message) {
            $.validator.methods[name] = method;
            $.validator.messages[name] = message !== undefined ? message : $.validator.messages[name];
            if (method.length < 3) $.validator.addClassRules(name, $.validator.normalizeRule(name));
        },
        // https://jqueryvalidation.org/jQuery.validator.methods/
        methods: {
            // https://jqueryvalidation.org/required-method/
            required: function(value, element, param) {
                // Check if dependency is met
                if (!this.depend(param, element)) return "dependency-mismatch";
                if (element.nodeName.toLowerCase() === "select") {
                    // Could be an array for select-multiple or a string, both are fine this way
                    var val = $(element).val();
                    return val && val.length > 0;
                }
                if (this.checkable(element)) return this.getLength(value, element) > 0;
                return value !== undefined && value !== null && value.length > 0;
            },
            // https://jqueryvalidation.org/email-method/
            email: function(value, element) {
                // From https://html.spec.whatwg.org/multipage/forms.html#valid-e-mail-address
                // Retrieved 2014-01-14
                // If you have a problem with this implementation, report a bug against the above spec
                // Or use custom methods to implement your own email validation
                return this.optional(element) || /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(value);
            },
            // https://jqueryvalidation.org/url-method/
            url: function(value, element) {
                // Copyright (c) 2010-2013 Diego Perini, MIT licensed
                // https://gist.github.com/dperini/729294
                // see also https://mathiasbynens.be/demo/url-regex
                // modified to allow protocol-relative URLs
                return this.optional(element) || /^(?:(?:(?:https?|ftp):)?\/\/)(?:(?:[^\]\[?\/<~#`!@$^&*()+=}|:";',>{ ]|%[0-9A-Fa-f]{2})+(?::(?:[^\]\[?\/<~#`!@$^&*()+=}|:";',>{ ]|%[0-9A-Fa-f]{2})*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
            },
            // https://jqueryvalidation.org/date-method/
            date: function() {
                var called = false;
                return function(value, element) {
                    if (!called) {
                        called = true;
                        if (this.settings.debug && window.console) console.warn("The `date` method is deprecated and will be removed in version '2.0.0'.\nPlease don't use it, since it relies on the Date constructor, which\nbehaves very differently across browsers and locales. Use `dateISO`\ninstead or one of the locale specific methods in `localizations/`\nand `additional-methods.js`.");
                    }
                    return this.optional(element) || !/Invalid|NaN/.test(new Date(value).toString());
                };
            }(),
            // https://jqueryvalidation.org/dateISO-method/
            dateISO: function(value, element) {
                return this.optional(element) || /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(value);
            },
            // https://jqueryvalidation.org/number-method/
            number: function(value, element) {
                return this.optional(element) || /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(value);
            },
            // https://jqueryvalidation.org/digits-method/
            digits: function(value, element) {
                return this.optional(element) || /^\d+$/.test(value);
            },
            // https://jqueryvalidation.org/minlength-method/
            minlength: function(value, element, param) {
                var length = Array.isArray(value) ? value.length : this.getLength(value, element);
                return this.optional(element) || length >= param;
            },
            // https://jqueryvalidation.org/maxlength-method/
            maxlength: function(value, element, param) {
                var length = Array.isArray(value) ? value.length : this.getLength(value, element);
                return this.optional(element) || length <= param;
            },
            // https://jqueryvalidation.org/rangelength-method/
            rangelength: function(value, element, param) {
                var length = Array.isArray(value) ? value.length : this.getLength(value, element);
                return this.optional(element) || length >= param[0] && length <= param[1];
            },
            // https://jqueryvalidation.org/min-method/
            min: function(value, element, param) {
                return this.optional(element) || value >= param;
            },
            // https://jqueryvalidation.org/max-method/
            max: function(value, element, param) {
                return this.optional(element) || value <= param;
            },
            // https://jqueryvalidation.org/range-method/
            range: function(value, element, param) {
                return this.optional(element) || value >= param[0] && value <= param[1];
            },
            // https://jqueryvalidation.org/step-method/
            step: function(value, element, param) {
                var type = $(element).attr("type"), errorMessage = "Step attribute on input type " + type + " is not supported.", supportedTypes = [
                    "text",
                    "number",
                    "range"
                ], re = new RegExp("\\b" + type + "\\b"), notSupported = type && !re.test(supportedTypes.join()), decimalPlaces = function(num) {
                    var match = ("" + num).match(/(?:\.(\d+))?$/);
                    if (!match) return 0;
                    // Number of digits right of decimal point.
                    return match[1] ? match[1].length : 0;
                }, toInt = function(num) {
                    return Math.round(num * Math.pow(10, decimals));
                }, valid = true, decimals;
                // Works only for text, number and range input types
                // TODO find a way to support input types date, datetime, datetime-local, month, time and week
                if (notSupported) throw new Error(errorMessage);
                decimals = decimalPlaces(param);
                // Value can't have too many decimals
                if (decimalPlaces(value) > decimals || toInt(value) % toInt(param) !== 0) valid = false;
                return this.optional(element) || valid;
            },
            // https://jqueryvalidation.org/equalTo-method/
            equalTo: function(value, element, param) {
                // Bind to the blur event of the target in order to revalidate whenever the target field is updated
                var target = $(param);
                if (this.settings.onfocusout && target.not(".validate-equalTo-blur").length) target.addClass("validate-equalTo-blur").on("blur.validate-equalTo", function() {
                    $(element).valid();
                });
                return value === target.val();
            },
            // https://jqueryvalidation.org/remote-method/
            remote: function(value, element, param, method) {
                if (this.optional(element)) return "dependency-mismatch";
                method = typeof method === "string" && method || "remote";
                var previous = this.previousValue(element, method), validator, data, optionDataString;
                if (!this.settings.messages[element.name]) this.settings.messages[element.name] = {};
                previous.originalMessage = previous.originalMessage || this.settings.messages[element.name][method];
                this.settings.messages[element.name][method] = previous.message;
                param = typeof param === "string" && {
                    url: param
                } || param;
                optionDataString = $.param($.extend({
                    data: value
                }, param.data));
                if (previous.old === optionDataString) return previous.valid;
                previous.old = optionDataString;
                validator = this;
                this.startRequest(element);
                data = {};
                data[element.name] = value;
                $.ajax($.extend(true, {
                    mode: "abort",
                    port: this.elementAjaxPort(element),
                    dataType: "json",
                    data: data,
                    context: validator.currentForm,
                    success: function(response) {
                        var valid = response === true || response === "true", errors, message, submitted;
                        validator.settings.messages[element.name][method] = previous.originalMessage;
                        if (valid) {
                            submitted = validator.formSubmitted;
                            validator.toHide = validator.errorsFor(element);
                            validator.formSubmitted = submitted;
                            validator.successList.push(element);
                            validator.invalid[element.name] = false;
                            validator.showErrors();
                        } else {
                            errors = {};
                            message = response || validator.defaultMessage(element, {
                                method: method,
                                parameters: value
                            });
                            errors[element.name] = previous.message = message;
                            validator.invalid[element.name] = true;
                            validator.showErrors(errors);
                        }
                        previous.valid = valid;
                        validator.stopRequest(element, valid);
                    }
                }, param));
                return "pending";
            }
        }
    });
    // Ajax mode: abort
    // usage: $.ajax({ mode: "abort"[, port: "uniqueport"]});
    //        $.ajaxAbort( port );
    // if mode:"abort" is used, the previous request on that port (port can be undefined) is aborted via XMLHttpRequest.abort()
    var pendingRequests = {}, ajax;
    // Use a prefilter if available (1.5+)
    if ($.ajaxPrefilter) $.ajaxPrefilter(function(settings, _, xhr) {
        var port = settings.port;
        if (settings.mode === "abort") {
            $.ajaxAbort(port);
            pendingRequests[port] = xhr;
        }
    });
    else {
        // Proxy ajax
        ajax = $.ajax;
        $.ajax = function(settings) {
            var mode = ("mode" in settings ? settings : $.ajaxSettings).mode, port = ("port" in settings ? settings : $.ajaxSettings).port;
            if (mode === "abort") {
                $.ajaxAbort(port);
                pendingRequests[port] = ajax.apply(this, arguments);
                return pendingRequests[port];
            }
            return ajax.apply(this, arguments);
        };
    }
    // Abort the previous request without sending a new one
    $.ajaxAbort = function(port) {
        if (pendingRequests[port]) {
            pendingRequests[port].abort();
            delete pendingRequests[port];
        }
    };
    return $;
});



var $10cKx = parcelRequire("10cKx");
var $6691e7f2ae148562$exports = {};

var $6qd2L = parcelRequire("6qd2L");
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */ (function(global1, factory) {
    $6691e7f2ae148562$exports = factory();
})($6691e7f2ae148562$exports, function() {
    "use strict";
    function objectOrFunction(x) {
        var type = typeof x;
        return x !== null && (type === "object" || type === "function");
    }
    function isFunction(x) {
        return typeof x === "function";
    }
    var _isArray = void 0;
    if (Array.isArray) _isArray = Array.isArray;
    else _isArray = function(x) {
        return Object.prototype.toString.call(x) === "[object Array]";
    };
    var isArray = _isArray;
    var len = 0;
    var vertxNext = void 0;
    var customSchedulerFn = void 0;
    var asap = function asap(callback, arg) {
        queue[len] = callback;
        queue[len + 1] = arg;
        len += 2;
        if (len === 2) {
            // If len is 2, that means that we need to schedule an async flush.
            // If additional callbacks are queued before the queue is flushed, they
            // will be processed by this flush that we are scheduling.
            if (customSchedulerFn) customSchedulerFn(flush);
            else scheduleFlush();
        }
    };
    function setScheduler(scheduleFn) {
        customSchedulerFn = scheduleFn;
    }
    function setAsap(asapFn) {
        asap = asapFn;
    }
    var browserWindow = typeof window !== "undefined" ? window : undefined;
    var browserGlobal = browserWindow || {};
    var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
    var isNode = typeof self === "undefined" && typeof $6qd2L !== "undefined" && ({}).toString.call($6qd2L) === "[object process]";
    // test for web worker but not in IE10
    var isWorker = typeof Uint8ClampedArray !== "undefined" && typeof importScripts !== "undefined" && typeof MessageChannel !== "undefined";
    // node
    function useNextTick() {
        // node version 0.10.x displays a deprecation warning when nextTick is used recursively
        // see https://github.com/cujojs/when/issues/410 for details
        return function() {
            return $6qd2L.nextTick(flush);
        };
    }
    // vertx
    function useVertxTimer() {
        if (typeof vertxNext !== "undefined") return function() {
            vertxNext(flush);
        };
        return useSetTimeout();
    }
    function useMutationObserver() {
        var iterations = 0;
        var observer = new BrowserMutationObserver(flush);
        var node = document.createTextNode("");
        observer.observe(node, {
            characterData: true
        });
        return function() {
            node.data = iterations = ++iterations % 2;
        };
    }
    // web worker
    function useMessageChannel() {
        var channel = new MessageChannel();
        channel.port1.onmessage = flush;
        return function() {
            return channel.port2.postMessage(0);
        };
    }
    function useSetTimeout() {
        // Store setTimeout reference so es6-promise will be unaffected by
        // other code modifying setTimeout (like sinon.useFakeTimers())
        var globalSetTimeout = setTimeout;
        return function() {
            return globalSetTimeout(flush, 1);
        };
    }
    var queue = new Array(1000);
    function flush() {
        for(var i = 0; i < len; i += 2){
            var callback = queue[i];
            var arg = queue[i + 1];
            callback(arg);
            queue[i] = undefined;
            queue[i + 1] = undefined;
        }
        len = 0;
    }
    function attemptVertx() {
        try {
            var vertx = Function("return this")().require("vertx");
            vertxNext = vertx.runOnLoop || vertx.runOnContext;
            return useVertxTimer();
        } catch (e) {
            return useSetTimeout();
        }
    }
    var scheduleFlush = void 0;
    // Decide what async method to use to triggering processing of queued callbacks:
    if (isNode) scheduleFlush = useNextTick();
    else if (BrowserMutationObserver) scheduleFlush = useMutationObserver();
    else if (isWorker) scheduleFlush = useMessageChannel();
    else if (browserWindow === undefined && true) scheduleFlush = attemptVertx();
    else scheduleFlush = useSetTimeout();
    function then(onFulfillment, onRejection) {
        var parent = this;
        var child = new this.constructor(noop);
        if (child[PROMISE_ID] === undefined) makePromise(child);
        var _state = parent._state;
        if (_state) {
            var callback = arguments[_state - 1];
            asap(function() {
                return invokeCallback(_state, child, callback, parent._result);
            });
        } else subscribe(parent, child, onFulfillment, onRejection);
        return child;
    }
    /**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/ function resolve$1(object) {
        /*jshint validthis:true */ var Constructor = this;
        if (object && typeof object === "object" && object.constructor === Constructor) return object;
        var promise = new Constructor(noop);
        resolve(promise, object);
        return promise;
    }
    var PROMISE_ID = Math.random().toString(36).substring(2);
    function noop() {}
    var PENDING = void 0;
    var FULFILLED = 1;
    var REJECTED = 2;
    function selfFulfillment() {
        return new TypeError("You cannot resolve a promise with itself");
    }
    function cannotReturnOwn() {
        return new TypeError("A promises callback cannot return that same promise.");
    }
    function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
        try {
            then$$1.call(value, fulfillmentHandler, rejectionHandler);
        } catch (e) {
            return e;
        }
    }
    function handleForeignThenable(promise, thenable, then$$1) {
        asap(function(promise) {
            var sealed = false;
            var error = tryThen(then$$1, thenable, function(value) {
                if (sealed) return;
                sealed = true;
                if (thenable !== value) resolve(promise, value);
                else fulfill(promise, value);
            }, function(reason) {
                if (sealed) return;
                sealed = true;
                reject(promise, reason);
            }, "Settle: " + (promise._label || " unknown promise"));
            if (!sealed && error) {
                sealed = true;
                reject(promise, error);
            }
        }, promise);
    }
    function handleOwnThenable(promise, thenable) {
        if (thenable._state === FULFILLED) fulfill(promise, thenable._result);
        else if (thenable._state === REJECTED) reject(promise, thenable._result);
        else subscribe(thenable, undefined, function(value) {
            return resolve(promise, value);
        }, function(reason) {
            return reject(promise, reason);
        });
    }
    function handleMaybeThenable(promise, maybeThenable, then$$1) {
        if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) handleOwnThenable(promise, maybeThenable);
        else {
            if (then$$1 === undefined) fulfill(promise, maybeThenable);
            else if (isFunction(then$$1)) handleForeignThenable(promise, maybeThenable, then$$1);
            else fulfill(promise, maybeThenable);
        }
    }
    function resolve(promise, value) {
        if (promise === value) reject(promise, selfFulfillment());
        else if (objectOrFunction(value)) {
            var then$$1 = void 0;
            try {
                then$$1 = value.then;
            } catch (error) {
                reject(promise, error);
                return;
            }
            handleMaybeThenable(promise, value, then$$1);
        } else fulfill(promise, value);
    }
    function publishRejection(promise) {
        if (promise._onerror) promise._onerror(promise._result);
        publish(promise);
    }
    function fulfill(promise, value) {
        if (promise._state !== PENDING) return;
        promise._result = value;
        promise._state = FULFILLED;
        if (promise._subscribers.length !== 0) asap(publish, promise);
    }
    function reject(promise, reason) {
        if (promise._state !== PENDING) return;
        promise._state = REJECTED;
        promise._result = reason;
        asap(publishRejection, promise);
    }
    function subscribe(parent, child, onFulfillment, onRejection) {
        var _subscribers = parent._subscribers;
        var length = _subscribers.length;
        parent._onerror = null;
        _subscribers[length] = child;
        _subscribers[length + FULFILLED] = onFulfillment;
        _subscribers[length + REJECTED] = onRejection;
        if (length === 0 && parent._state) asap(publish, parent);
    }
    function publish(promise) {
        var subscribers = promise._subscribers;
        var settled = promise._state;
        if (subscribers.length === 0) return;
        var child = void 0, callback = void 0, detail = promise._result;
        for(var i = 0; i < subscribers.length; i += 3){
            child = subscribers[i];
            callback = subscribers[i + settled];
            if (child) invokeCallback(settled, child, callback, detail);
            else callback(detail);
        }
        promise._subscribers.length = 0;
    }
    function invokeCallback(settled, promise, callback, detail) {
        var hasCallback = isFunction(callback), value = void 0, error = void 0, succeeded = true;
        if (hasCallback) {
            try {
                value = callback(detail);
            } catch (e) {
                succeeded = false;
                error = e;
            }
            if (promise === value) {
                reject(promise, cannotReturnOwn());
                return;
            }
        } else value = detail;
        if (promise._state !== PENDING) ;
        else if (hasCallback && succeeded) resolve(promise, value);
        else if (succeeded === false) reject(promise, error);
        else if (settled === FULFILLED) fulfill(promise, value);
        else if (settled === REJECTED) reject(promise, value);
    }
    function initializePromise(promise, resolver) {
        try {
            resolver(function resolvePromise(value) {
                resolve(promise, value);
            }, function rejectPromise(reason) {
                reject(promise, reason);
            });
        } catch (e) {
            reject(promise, e);
        }
    }
    var id = 0;
    function nextId() {
        return id++;
    }
    function makePromise(promise) {
        promise[PROMISE_ID] = id++;
        promise._state = undefined;
        promise._result = undefined;
        promise._subscribers = [];
    }
    function validationError() {
        return new Error("Array Methods must be provided an Array");
    }
    var Enumerator = function() {
        function Enumerator(Constructor, input) {
            this._instanceConstructor = Constructor;
            this.promise = new Constructor(noop);
            if (!this.promise[PROMISE_ID]) makePromise(this.promise);
            if (isArray(input)) {
                this.length = input.length;
                this._remaining = input.length;
                this._result = new Array(this.length);
                if (this.length === 0) fulfill(this.promise, this._result);
                else {
                    this.length = this.length || 0;
                    this._enumerate(input);
                    if (this._remaining === 0) fulfill(this.promise, this._result);
                }
            } else reject(this.promise, validationError());
        }
        Enumerator.prototype._enumerate = function _enumerate(input) {
            for(var i = 0; this._state === PENDING && i < input.length; i++)this._eachEntry(input[i], i);
        };
        Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
            var c = this._instanceConstructor;
            var resolve$$1 = c.resolve;
            if (resolve$$1 === resolve$1) {
                var _then = void 0;
                var error = void 0;
                var didError = false;
                try {
                    _then = entry.then;
                } catch (e) {
                    didError = true;
                    error = e;
                }
                if (_then === then && entry._state !== PENDING) this._settledAt(entry._state, i, entry._result);
                else if (typeof _then !== "function") {
                    this._remaining--;
                    this._result[i] = entry;
                } else if (c === Promise$1) {
                    var promise = new c(noop);
                    if (didError) reject(promise, error);
                    else handleMaybeThenable(promise, entry, _then);
                    this._willSettleAt(promise, i);
                } else this._willSettleAt(new c(function(resolve$$1) {
                    return resolve$$1(entry);
                }), i);
            } else this._willSettleAt(resolve$$1(entry), i);
        };
        Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
            var promise = this.promise;
            if (promise._state === PENDING) {
                this._remaining--;
                if (state === REJECTED) reject(promise, value);
                else this._result[i] = value;
            }
            if (this._remaining === 0) fulfill(promise, this._result);
        };
        Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
            var enumerator = this;
            subscribe(promise, undefined, function(value) {
                return enumerator._settledAt(FULFILLED, i, value);
            }, function(reason) {
                return enumerator._settledAt(REJECTED, i, reason);
            });
        };
        return Enumerator;
    }();
    /**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/ function all(entries) {
        return new Enumerator(this, entries).promise;
    }
    /**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/ function race(entries) {
        /*jshint validthis:true */ var Constructor = this;
        if (!isArray(entries)) return new Constructor(function(_, reject) {
            return reject(new TypeError("You must pass an array to race."));
        });
        else return new Constructor(function(resolve, reject) {
            var length = entries.length;
            for(var i = 0; i < length; i++)Constructor.resolve(entries[i]).then(resolve, reject);
        });
    }
    /**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/ function reject$1(reason) {
        /*jshint validthis:true */ var Constructor = this;
        var promise = new Constructor(noop);
        reject(promise, reason);
        return promise;
    }
    function needsResolver() {
        throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
    }
    function needsNew() {
        throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
    }
    /**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/ var Promise$1 = function() {
        function Promise(resolver) {
            this[PROMISE_ID] = nextId();
            this._result = this._state = undefined;
            this._subscribers = [];
            if (noop !== resolver) {
                typeof resolver !== "function" && needsResolver();
                this instanceof Promise ? initializePromise(this, resolver) : needsNew();
            }
        }
        /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */ /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */ Promise.prototype.catch = function _catch(onRejection) {
            return this.then(null, onRejection);
        };
        /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */ Promise.prototype.finally = function _finally(callback) {
            var promise = this;
            var constructor = promise.constructor;
            if (isFunction(callback)) return promise.then(function(value) {
                return constructor.resolve(callback()).then(function() {
                    return value;
                });
            }, function(reason) {
                return constructor.resolve(callback()).then(function() {
                    throw reason;
                });
            });
            return promise.then(callback, callback);
        };
        return Promise;
    }();
    Promise$1.prototype.then = then;
    Promise$1.all = all;
    Promise$1.race = race;
    Promise$1.resolve = resolve$1;
    Promise$1.reject = reject$1;
    Promise$1._setScheduler = setScheduler;
    Promise$1._setAsap = setAsap;
    Promise$1._asap = asap;
    /*global self*/ function polyfill() {
        var local = void 0;
        if (typeof $parcel$global !== "undefined") local = $parcel$global;
        else if (typeof self !== "undefined") local = self;
        else try {
            local = Function("return this")();
        } catch (e) {
            throw new Error("polyfill failed because global object is unavailable in this environment");
        }
        var P = local.Promise;
        if (P) {
            var promiseToString = null;
            try {
                promiseToString = Object.prototype.toString.call(P.resolve());
            } catch (e) {
            // silently ignored
            }
            if (promiseToString === "[object Promise]" && !P.cast) return;
        }
        local.Promise = Promise$1;
    }
    // Strange compat..
    Promise$1.polyfill = polyfill;
    Promise$1.Promise = Promise$1;
    return Promise$1;
});


var $0e58699405760943$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $6qd2L = parcelRequire("6qd2L");
var $0e58699405760943$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $0e58699405760943$var$formatRegExp = /%[sdj%]/g;
$0e58699405760943$exports.format = function(f) {
    if (!$0e58699405760943$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($0e58699405760943$var$inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($0e58699405760943$var$formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($0e58699405760943$var$isNull(x) || !$0e58699405760943$var$isObject(x)) str += " " + x;
    else str += " " + $0e58699405760943$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
$0e58699405760943$exports.deprecate = function(fn, msg) {
    if (typeof $6qd2L !== "undefined" && $6qd2L.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $6qd2L === "undefined") return function() {
        return $0e58699405760943$exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($6qd2L.throwDeprecation) throw new Error(msg);
            else if ($6qd2L.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $0e58699405760943$var$debugs = {};
var $0e58699405760943$var$debugEnvRegex = /^$/;
var $0e58699405760943$var$debugEnv;
$0e58699405760943$exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$0e58699405760943$var$debugs[set]) {
        if ($0e58699405760943$var$debugEnvRegex.test(set)) {
            var pid = $6qd2L.pid;
            $0e58699405760943$var$debugs[set] = function() {
                var msg = $0e58699405760943$exports.format.apply($0e58699405760943$exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else $0e58699405760943$var$debugs[set] = function() {};
    }
    return $0e58699405760943$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $0e58699405760943$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $0e58699405760943$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($0e58699405760943$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    $0e58699405760943$exports._extend(ctx, opts);
    // set default options
    if ($0e58699405760943$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($0e58699405760943$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($0e58699405760943$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($0e58699405760943$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $0e58699405760943$var$stylizeWithColor;
    return $0e58699405760943$var$formatValue(ctx, obj, ctx.depth);
}
$0e58699405760943$exports.inspect = $0e58699405760943$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$0e58699405760943$var$inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$0e58699405760943$var$inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function $0e58699405760943$var$stylizeWithColor(str, styleType) {
    var style = $0e58699405760943$var$inspect.styles[styleType];
    if (style) return "\x1b[" + $0e58699405760943$var$inspect.colors[style][0] + "m" + str + "\x1b[" + $0e58699405760943$var$inspect.colors[style][1] + "m";
    else return str;
}
function $0e58699405760943$var$stylizeNoColor(str, styleType) {
    return str;
}
function $0e58699405760943$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $0e58699405760943$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $0e58699405760943$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== $0e58699405760943$exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$0e58699405760943$var$isString(ret)) ret = $0e58699405760943$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $0e58699405760943$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $0e58699405760943$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($0e58699405760943$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $0e58699405760943$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($0e58699405760943$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($0e58699405760943$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($0e58699405760943$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($0e58699405760943$var$isError(value)) return $0e58699405760943$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if ($0e58699405760943$var$isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($0e58699405760943$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($0e58699405760943$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($0e58699405760943$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($0e58699405760943$var$isError(value)) base = " " + $0e58699405760943$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($0e58699405760943$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $0e58699405760943$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $0e58699405760943$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $0e58699405760943$var$reduceToSingleString(output, base, braces);
}
function $0e58699405760943$var$formatPrimitive(ctx, value) {
    if ($0e58699405760943$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($0e58699405760943$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($0e58699405760943$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($0e58699405760943$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($0e58699405760943$var$isNull(value)) return ctx.stylize("null", "null");
}
function $0e58699405760943$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $0e58699405760943$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($0e58699405760943$var$hasOwnProperty(value, String(i))) output.push($0e58699405760943$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($0e58699405760943$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $0e58699405760943$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$0e58699405760943$var$hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($0e58699405760943$var$isNull(recurseTimes)) str = $0e58699405760943$var$formatValue(ctx, desc.value, null);
            else str = $0e58699405760943$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").slice(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($0e58699405760943$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $0e58699405760943$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
$0e58699405760943$exports.types = (parcelRequire("4sa5r"));
function $0e58699405760943$var$isArray(ar) {
    return Array.isArray(ar);
}
$0e58699405760943$exports.isArray = $0e58699405760943$var$isArray;
function $0e58699405760943$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
$0e58699405760943$exports.isBoolean = $0e58699405760943$var$isBoolean;
function $0e58699405760943$var$isNull(arg) {
    return arg === null;
}
$0e58699405760943$exports.isNull = $0e58699405760943$var$isNull;
function $0e58699405760943$var$isNullOrUndefined(arg) {
    return arg == null;
}
$0e58699405760943$exports.isNullOrUndefined = $0e58699405760943$var$isNullOrUndefined;
function $0e58699405760943$var$isNumber(arg) {
    return typeof arg === "number";
}
$0e58699405760943$exports.isNumber = $0e58699405760943$var$isNumber;
function $0e58699405760943$var$isString(arg) {
    return typeof arg === "string";
}
$0e58699405760943$exports.isString = $0e58699405760943$var$isString;
function $0e58699405760943$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
$0e58699405760943$exports.isSymbol = $0e58699405760943$var$isSymbol;
function $0e58699405760943$var$isUndefined(arg) {
    return arg === void 0;
}
$0e58699405760943$exports.isUndefined = $0e58699405760943$var$isUndefined;
function $0e58699405760943$var$isRegExp(re) {
    return $0e58699405760943$var$isObject(re) && $0e58699405760943$var$objectToString(re) === "[object RegExp]";
}
$0e58699405760943$exports.isRegExp = $0e58699405760943$var$isRegExp;
$0e58699405760943$exports.types.isRegExp = $0e58699405760943$var$isRegExp;
function $0e58699405760943$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
$0e58699405760943$exports.isObject = $0e58699405760943$var$isObject;
function $0e58699405760943$var$isDate(d) {
    return $0e58699405760943$var$isObject(d) && $0e58699405760943$var$objectToString(d) === "[object Date]";
}
$0e58699405760943$exports.isDate = $0e58699405760943$var$isDate;
$0e58699405760943$exports.types.isDate = $0e58699405760943$var$isDate;
function $0e58699405760943$var$isError(e) {
    return $0e58699405760943$var$isObject(e) && ($0e58699405760943$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
$0e58699405760943$exports.isError = $0e58699405760943$var$isError;
$0e58699405760943$exports.types.isNativeError = $0e58699405760943$var$isError;
function $0e58699405760943$var$isFunction(arg) {
    return typeof arg === "function";
}
$0e58699405760943$exports.isFunction = $0e58699405760943$var$isFunction;
function $0e58699405760943$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
$0e58699405760943$exports.isPrimitive = $0e58699405760943$var$isPrimitive;

$0e58699405760943$exports.isBuffer = (parcelRequire("7Tl5t"));
function $0e58699405760943$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $0e58699405760943$var$pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var $0e58699405760943$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function $0e58699405760943$var$timestamp() {
    var d = new Date();
    var time = [
        $0e58699405760943$var$pad(d.getHours()),
        $0e58699405760943$var$pad(d.getMinutes()),
        $0e58699405760943$var$pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        $0e58699405760943$var$months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
$0e58699405760943$exports.log = function() {
    console.log("%s - %s", $0e58699405760943$var$timestamp(), $0e58699405760943$exports.format.apply($0e58699405760943$exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ $0e58699405760943$exports.inherits = (parcelRequire("9M38k"));
$0e58699405760943$exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$0e58699405760943$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $0e58699405760943$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $0e58699405760943$var$kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
$0e58699405760943$exports.promisify = function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if ($0e58699405760943$var$kCustomPromisifiedSymbol && original[$0e58699405760943$var$kCustomPromisifiedSymbol]) {
        var fn = original[$0e58699405760943$var$kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $0e58699405760943$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($0e58699405760943$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $0e58699405760943$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $0e58699405760943$var$getOwnPropertyDescriptors(original));
};
$0e58699405760943$exports.promisify.custom = $0e58699405760943$var$kCustomPromisifiedSymbol;
function $0e58699405760943$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $0e58699405760943$var$callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $6qd2L.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $6qd2L.nextTick($0e58699405760943$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $0e58699405760943$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
$0e58699405760943$exports.callbackify = $0e58699405760943$var$callbackify;



var $10cKx = parcelRequire("10cKx");
class $752d59648741b237$export$2e2bcd8739ae039 {
    static alert(data) {
        const opts = typeof data === "string" ? {
            message: data
        } : data;
        if (!opts.title) opts.title = "";
        const html = opts.message || opts.messageHTML || "";
        let elt = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))("#Alerts");
        if (elt.length == 0) {
            elt = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))("<div id='Alerts'><div class='mask'></div><div class='modal'><div class='close'><i class='fa-solid fa-xmark fa-fw'></i></div><div class='body'></div><div>");
            (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))("body").append(elt);
            function dismiss() {
                elt.hide();
                opts.callback && opts.callback();
            }
            elt.on("click", ".mask", dismiss);
            elt.on("click", ".modal .close", dismiss);
        }
        elt.find(".body").html(html);
        elt.show();
    }
    static async confirmation(opts) {
        (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))("#Confirmation").remove();
        return new Promise((resolve, reject)=>{
            let elt = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))("#Confirmation");
            function onButton(evt) {
                const selected = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(evt.target).text();
                elt.remove();
                resolve(selected);
            }
            elt = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))("<div id='Confirmation'><div class='mask'></div><div class='modal'><div class='body'></div><div class='footer'></div></div>");
            (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))("body").append(elt);
            for (const option of opts.options)(0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))("<button>").addClass("option").text(option).appendTo(elt.find(".footer"));
            elt.on("click", ".modal .footer button", onButton);
            const html = opts.message || opts.messageHTML || "";
            elt.find(".body").html(html);
            elt.show();
        });
    }
}


var $be181f338a50077e$exports = {};



(function(root, factory) {
    "use strict";
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("stacktrace", [
        "error-stack-parser",
        "stack-generator",
        "stacktrace-gps"
    ], factory);
    else $be181f338a50077e$exports = factory((parcelRequire("dB6J2")), (parcelRequire("kaS8w")), (parcelRequire("6F6u5")));
})($be181f338a50077e$exports, function StackTrace(ErrorStackParser, StackGenerator, StackTraceGPS) {
    var _options = {
        filter: function(stackframe) {
            // Filter out stackframes for this library by default
            return (stackframe.functionName || "").indexOf("StackTrace$$") === -1 && (stackframe.functionName || "").indexOf("ErrorStackParser$$") === -1 && (stackframe.functionName || "").indexOf("StackTraceGPS$$") === -1 && (stackframe.functionName || "").indexOf("StackGenerator$$") === -1;
        },
        sourceCache: {}
    };
    var _generateError = function StackTrace$$GenerateError() {
        try {
            // Error must be thrown to get stack in IE
            throw new Error();
        } catch (err) {
            return err;
        }
    };
    /**
     * Merge 2 given Objects. If a conflict occurs the second object wins.
     * Does not do deep merges.
     *
     * @param {Object} first base object
     * @param {Object} second overrides
     * @returns {Object} merged first and second
     * @private
     */ function _merge(first, second) {
        var target = {};
        [
            first,
            second
        ].forEach(function(obj) {
            for(var prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) target[prop] = obj[prop];
            return target;
        });
        return target;
    }
    function _isShapedLikeParsableError(err) {
        return err.stack || err["opera#sourceloc"];
    }
    function _filtered(stackframes, filter) {
        if (typeof filter === "function") return stackframes.filter(filter);
        return stackframes;
    }
    return {
        /**
         * Get a backtrace from invocation point.
         *
         * @param {Object} opts
         * @returns {Array} of StackFrame
         */ get: function StackTrace$$get(opts) {
            var err = _generateError();
            return _isShapedLikeParsableError(err) ? this.fromError(err, opts) : this.generateArtificially(opts);
        },
        /**
         * Get a backtrace from invocation point.
         * IMPORTANT: Does not handle source maps or guess function names!
         *
         * @param {Object} opts
         * @returns {Array} of StackFrame
         */ getSync: function StackTrace$$getSync(opts) {
            opts = _merge(_options, opts);
            var err = _generateError();
            var stack = _isShapedLikeParsableError(err) ? ErrorStackParser.parse(err) : StackGenerator.backtrace(opts);
            return _filtered(stack, opts.filter);
        },
        /**
         * Given an error object, parse it.
         *
         * @param {Error} error object
         * @param {Object} opts
         * @returns {Promise} for Array[StackFrame}
         */ fromError: function StackTrace$$fromError(error, opts) {
            opts = _merge(_options, opts);
            var gps = new StackTraceGPS(opts);
            return new Promise((function(resolve) {
                var stackframes = _filtered(ErrorStackParser.parse(error), opts.filter);
                resolve(Promise.all(stackframes.map(function(sf) {
                    return new Promise(function(resolve) {
                        function resolveOriginal() {
                            resolve(sf);
                        }
                        gps.pinpoint(sf).then(resolve, resolveOriginal)["catch"](resolveOriginal);
                    });
                })));
            }).bind(this));
        },
        /**
         * Use StackGenerator to generate a backtrace.
         *
         * @param {Object} opts
         * @returns {Promise} of Array[StackFrame]
         */ generateArtificially: function StackTrace$$generateArtificially(opts) {
            opts = _merge(_options, opts);
            var stackFrames = StackGenerator.backtrace(opts);
            if (typeof opts.filter === "function") stackFrames = stackFrames.filter(opts.filter);
            return Promise.resolve(stackFrames);
        },
        /**
         * Given a function, wrap it such that invocations trigger a callback that
         * is called with a stack trace.
         *
         * @param {Function} fn to be instrumented
         * @param {Function} callback function to call with a stack trace on invocation
         * @param {Function} errback optional function to call with error if unable to get stack trace.
         * @param {Object} thisArg optional context object (e.g. window)
         */ instrument: function StackTrace$$instrument(fn, callback, errback, thisArg) {
            if (typeof fn !== "function") throw new Error("Cannot instrument non-function object");
            else if (typeof fn.__stacktraceOriginalFn === "function") // Already instrumented, return given Function
            return fn;
            var instrumented = (function StackTrace$$instrumented() {
                try {
                    this.get().then(callback, errback)["catch"](errback);
                    return fn.apply(thisArg || this, arguments);
                } catch (e) {
                    if (_isShapedLikeParsableError(e)) this.fromError(e).then(callback, errback)["catch"](errback);
                    throw e;
                }
            }).bind(this);
            instrumented.__stacktraceOriginalFn = fn;
            return instrumented;
        },
        /**
         * Given a function that has been instrumented,
         * revert the function to it's original (non-instrumented) state.
         *
         * @param {Function} fn to de-instrument
         */ deinstrument: function StackTrace$$deinstrument(fn) {
            if (typeof fn !== "function") throw new Error("Cannot de-instrument non-function object");
            else if (typeof fn.__stacktraceOriginalFn === "function") return fn.__stacktraceOriginalFn;
            else // Function not instrumented, return original
            return fn;
        },
        /**
         * Given an error message and Array of StackFrames, serialize and POST to given URL.
         *
         * @param {Array} stackframes
         * @param {String} url
         * @param {String} errorMsg
         * @param {Object} requestOptions
         */ report: function StackTrace$$report(stackframes, url, errorMsg, requestOptions) {
            return new Promise(function(resolve, reject) {
                var req = new XMLHttpRequest();
                req.onerror = reject;
                req.onreadystatechange = function onreadystatechange() {
                    if (req.readyState === 4) {
                        if (req.status >= 200 && req.status < 400) resolve(req.responseText);
                        else reject(new Error("POST to " + url + " failed with status: " + req.status));
                    }
                };
                req.open("post", url);
                // Set request headers
                req.setRequestHeader("Content-Type", "application/json");
                if (requestOptions && typeof requestOptions.headers === "object") {
                    var headers = requestOptions.headers;
                    for(var header in headers)if (Object.prototype.hasOwnProperty.call(headers, header)) req.setRequestHeader(header, headers[header]);
                }
                var reportPayload = {
                    stack: stackframes
                };
                if (errorMsg !== undefined && errorMsg !== null) reportPayload.message = errorMsg;
                req.send(JSON.stringify(reportPayload));
            });
        }
    };
});



var $10cKx = parcelRequire("10cKx");
class $a187c2fe64638fd7$export$7f7cbe89f1eacd2 {
    constructor(){
        this.depth = 0;
        const html = `
    <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
`;
        this.elt = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(html);
    }
    attach(document1) {
        const body = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(document1).find("body");
        body.append(this.elt);
        this.elt.data("spinner", this);
        this.config();
    }
    push() {
        this.depth++;
        this.config();
    }
    pop() {
        this.depth--;
        this.config();
    }
    config() {
        if (this.depth > 0) this.elt.show();
        else this.elt.hide();
    }
    static find() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(document).find(".lds-ring").data("spinner");
    }
    static pushSpinner() {
        const s = $a187c2fe64638fd7$export$7f7cbe89f1eacd2.find();
        s && s.push();
        return ()=>{
            s && s.pop();
        };
    }
}



var $jBGyA = parcelRequire("jBGyA");

class $4cb3d7cd62bf3322$export$b4ba47569ccac746 {
    constructor(params, server){
        this.params = params;
        this.server = server;
    }
    uploadFile(file) {
        const filename = file.name;
        if (/^image\//i.test(file.type)) {
            // Resize image
            const p = new (0, $6691e7f2ae148562$exports.Promise)((resolve, reject)=>{
                const reader = new FileReader();
                // Set up event listeners
                reader.onloadend = ()=>{
                    const process = this.processImage(reader.result, file.name, file.type);
                    process.then((data)=>{
                        resolve(data);
                    });
                    process.catch((error)=>{
                        reject(error);
                    });
                };
                reader.onerror = ()=>{
                    const process = this.uploadBlob(file, filename);
                    process.then((data)=>{
                        resolve(data);
                    });
                    process.catch((error)=>{
                        reject(error);
                    });
                };
                // Kick off process
                reader.readAsDataURL(file);
            });
            return p;
        } else return this.uploadBlob(file, filename);
    }
    ajaxToPromise(ajax) {
        const p = new (0, $6691e7f2ae148562$exports.Promise)((resolve, reject)=>{
            ajax.then((data)=>{
                resolve(data);
            });
            ajax.fail((data)=>{
                reject(data);
            });
        });
        return p;
    }
    processImage(dataURL, name, type) {
        console.log("processImage " + name + ", " + type);
        if (dataURL instanceof ArrayBuffer || !dataURL) // Don't know how to process....
        return new (0, $6691e7f2ae148562$exports.Promise)((resolve, reject)=>{
            reject("Can't process dataURL");
        });
        // Create image with no src to start
        const image = new Image();
        // ---------------------
        // Setup ready to receive image once loaded
        const uploader = this;
        const p = new (0, $6691e7f2ae148562$exports.Promise)((resolve, reject)=>{
            image.onload = ()=>{
                // @ts-ignore type declaration for EXIF appears to be wrong
                (0, (/*@__PURE__*/$parcel$interopDefault($jBGyA))).getData(image, function() {
                    // @ts-ignore
                    const me = this;
                    const make = (0, (/*@__PURE__*/$parcel$interopDefault($jBGyA))).getTag(me, "Make");
                    const model = (0, (/*@__PURE__*/$parcel$interopDefault($jBGyA))).getTag(me, "Model");
                    const orientation = (0, (/*@__PURE__*/$parcel$interopDefault($jBGyA))).getTag(me, "Orientation");
                    const width = image.width;
                    const height = image.height;
                    const maxHeight = uploader.params.maxHeight;
                    const maxWidth = uploader.params.maxWidth;
                    const ratioV = maxHeight && height > maxHeight ? maxHeight / height : 1;
                    const ratioH = maxWidth && width > maxWidth ? maxWidth / width : 1;
                    const ratio = Math.min(ratioV, ratioH);
                    const newHeight = height * ratio;
                    const newWidth = width * ratio;
                    // console.log("processImage make=" + make + "; model=" + model + "; orientation=" + orientation + "; width = " + width + "; height = " + height + "; newWidth = " + newWidth + "; newHeight = " + newHeight);
                    const canvas = uploader.drawImage(image, orientation, newWidth, newHeight);
                    const d = canvas.toDataURL("image/jpeg");
                    uploader.uploadDataURL(d, name).then((data)=>{
                        console.log("Done uploading data URL");
                        resolve(data);
                    });
                });
            };
            image.onerror = (err)=>{
                reject(err);
            };
        });
        // ---------------------
        // Trigger image load
        image.src = dataURL;
        return p;
    }
    uploadDataURL(dataURL, filename) {
        console.log("uploading dataURL " + dataURL.substring(0, 10) + "...");
        var formData = new FormData();
        formData.append("dataURL", dataURL);
        formData.append("filename", filename);
        return this.uploadFormData(formData);
    }
    uploadBlob(blob, filename) {
        console.log("uploading blob...");
        var formData = new FormData();
        formData.append("file", blob);
        formData.append("filename", filename);
        return this.uploadFormData(formData);
    }
    uploadFormData(formData) {
        const out = this.server.ajax({
            url: this.params.url,
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            method: "POST"
        });
        return out;
    }
    drawImage(img, orientation, width, height) {
        if (!/^[1-8]$/.test(orientation)) orientation = 1;
        let x = 0;
        let y = 0;
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = width;
        canvas.height = height;
        if (ctx == null) // Can't draw
        throw "Can't create canvas";
        ctx.save();
        /*
        The following does not seem to work, gives wrongly oriented images.

        switch (+orientation) {
            // 1 = The 0th row is at the visual top of the image, and the 0th column is the visual left-hand side.
            case 1:
                break;

            // 2 = The 0th row is at the visual top of the image, and the 0th column is the visual right-hand side.
            case 2:
                ctx.translate(width, 0);
                ctx.scale(-1, 1);
                break;

            // 3 = The 0th row is at the visual bottom of the image, and the 0th column is the visual right-hand side.
            case 3:
                ctx.translate(width, height);
                ctx.rotate(180 / 180 * Math.PI);
                break;

            // 4 = The 0th row is at the visual bottom of the image, and the 0th column is the visual left-hand side.
            case 4:
                ctx.translate(0, height);
                ctx.scale(1, -1);
                break;

            // 5 = The 0th row is the visual left-hand side of the image, and the 0th column is the visual top.
            case 5:
                canvas.width = height;
                canvas.height = width;
                ctx.rotate(90 / 180 * Math.PI);
                ctx.scale(1, -1);
                break;

            // 6 = The 0th row is the visual right-hand side of the image, and the 0th column is the visual top.
            case 6:
                canvas.width = height;
                canvas.height = width;
                ctx.rotate(90 / 180 * Math.PI);
                ctx.translate(0, -height);
                break;

            // 7 = The 0th row is the visual right-hand side of the image, and the 0th column is the visual bottom.
            case 7:
                canvas.width = height;
                canvas.height = width;
                ctx.rotate(270 / 180 * Math.PI);
                ctx.translate(-width, height);
                ctx.scale(1, -1);
                break;

            // 8 = The 0th row is the visual left-hand side of the image, and the 0th column is the visual bottom.
            case 8:
                canvas.width = height;
                canvas.height = width;
                ctx.translate(0, width);
                ctx.rotate(270 / 180 * Math.PI);
                break;
        }
         */ ctx.drawImage(img, x, y, width, height);
        ctx.restore();
        return canvas;
    }
}




class $cea34b64a270482f$export$d8d954cf74d9d0e3 {
    constructor(server, listener){
        this.server = server;
        this.listener = listener;
    }
    uploadFile(file) {
        const filename = file.name;
        return this.uploadBlob(file, filename);
    }
    uploadBlob(blob, filename) {
        console.log("uploading blob...");
        var formData = new FormData();
        formData.append("file", blob);
        formData.append("filename", filename);
        return this.uploadFormData(formData);
    }
    uploadFormData(formData) {
        const me = this;
        const now = Date.now();
        const progressListener = (e)=>{
            const time = (Date.now() - now) / 1000;
            const percent = e.lengthComputable ? Math.round(100 * e.loaded / e.total) + "%" : "NA";
            console.log(`Uploaded ${percent} : ${e.loaded} of ${e.total} (computable=${e.lengthComputable}) after ${time} seconds`);
            this.listener && this.listener(percent !== "100%" ? `Uploading... ${percent}` : "Processing");
        };
        // Processing on server is asynchronous.
        const out = new (0, $6691e7f2ae148562$exports.Promise)((resolve, reject)=>{
            const url_ = this.server.ajax({
                url: `api/s3`,
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                method: "POST"
            }, {
                timeoutMs: 3600000,
                uploadProgressListener: progressListener
            });
            url_.catch((err)=>{
                reject(err);
            });
            url_.then((url)=>{
                this.listener && this.listener("Processing...");
                const until = Date.now() + 300000;
                const test = ()=>{
                    const fail = ()=>{
                        const retry = Date.now() < until;
                        if (retry) setTimeout(test, 5000);
                        else reject("Upload failed (timeout)");
                    };
                    me.testURL(url, 5000).then((ok)=>{
                        if (ok) {
                            this.listener && this.listener("");
                            resolve(url);
                        } else fail();
                    });
                };
                test();
            });
        });
        const pop = (0, $a187c2fe64638fd7$export$7f7cbe89f1eacd2).pushSpinner();
        out.finally(pop);
        return out;
    }
    testURL(url, timeoutMS) {
        return new (0, $6691e7f2ae148562$exports.Promise)((resolve, reject)=>{
            const req = new XMLHttpRequest();
            req.timeout = timeoutMS;
            req.onreadystatechange = ()=>{
                if (req.readyState === 4) resolve(req.status == 200);
            };
            req.open("HEAD", url, true);
            req.send(null);
        });
    }
}


const $b306c6aaaa6be045$export$f2b782965eea3685 = "clear_cache";
const $b306c6aaaa6be045$var$VOLATILE = "volatile";
function $b306c6aaaa6be045$var$encodePathComponent(x) {
    // Tomcat chokes on even url-encoded slashes in path components.
    // So as a workaround, we transport slashes as <something else>.
    // This means that we can't represent a the <something else> in a URL in this system,
    // but we are very unlikely to want to and it's a much smaller problem than not being able
    // to represent a slash...
    const y = x && x.replace ? x.replace("/", "<<SLASH>>") : x;
    return encodeURIComponent(y);
}
function $b306c6aaaa6be045$export$7086db7f8cfa1126() {
    const href = window.location.href;
    const index = href.indexOf("#");
    return index == -1 ? href : href.substr(0, index);
}
function $b306c6aaaa6be045$var$paramsToQueryString(params) {
    const keys = Object.keys(params);
    if (keys.length == 0) return "";
    return "?" + keys.map((key)=>key + "=" + encodeURIComponent(params[key])).join("&");
}
class $b306c6aaaa6be045$export$2e2bcd8739ae039 {
    static instance() {
        if ($b306c6aaaa6be045$export$2e2bcd8739ae039.INSTANCE == null) $b306c6aaaa6be045$export$2e2bcd8739ae039.INSTANCE = new $b306c6aaaa6be045$export$2e2bcd8739ae039();
        return $b306c6aaaa6be045$export$2e2bcd8739ae039.INSTANCE;
    }
    setUser(user) {
        this.resolveUser && this.resolveUser(user);
    }
    getUser() {
        return this.user_;
    }
    constructor(){
        this.user_ = new (0, $6691e7f2ae148562$exports.Promise)((resolve, reject)=>{
            this.resolveUser = resolve;
        });
        /**
     * Private cache of GET responses.
     */ this.cache = {};
        this.defaultOpts = {
            noAuthRedirects: false
        };
        this.runtimeParams_ = new (0, $6691e7f2ae148562$exports.Promise)((resolve, reject)=>{
            this.runtimeParamsResolver = resolve;
            this.ping("params"); // side effect is to populate runtime params
        });
        this.runtimeParams_.then((params)=>{
            if (params["wrb.client.noAuthRedirects"]) this.defaultOpts.noAuthRedirects = true;
        });
    }
    /**
     * Set default request options
     * @param opts
     * @return previous default request options
     */ setRequestOpts(opts) {
        const r = this.defaultOpts;
        this.defaultOpts = opts;
        return r;
    }
    ping(msg) {
        // @ts-ignore
        const clientVersion = window && window.wrb_git || {
            "version": "?",
            "branch": "?"
        };
        const l = $b306c6aaaa6be045$var$calcLocalStorageSize();
        const data = {
            msg: msg,
            client: clientVersion,
            ls: l.size,
            lc: l.cnt
        };
        const ping_ = this.ajax({
            method: "GET",
            url: "api/ping",
            dataType: "json",
            data: data,
            contentType: "application/json; charset=utf-8"
        }, {
            silent: true
        });
        ping_.then((ping)=>{
            // capture client-side params
            if (ping && ping.params) this.runtimeParamsResolver && this.runtimeParamsResolver(ping.params);
        });
        return ping_;
    }
    loginRemembered() {
        return this.ajax({
            method: "GET",
            url: "api/login"
        });
    }
    /**
     * @return true if user didn't exist (ie, new signup)
     */ signup(data) {
        return this.ajax({
            method: "POST",
            url: "api/signup",
            data: JSON.stringify(data),
            contentType: "application/json; charset=utf-8"
        });
    }
    login(data) {
        return this.ajax({
            method: "POST",
            url: "api/login",
            data: JSON.stringify(data),
            contentType: "application/json; charset=utf-8"
        });
    }
    logout() {
        return this.ajax({
            method: "POST",
            url: "api/logout",
            contentType: "application/json; charset=utf-8"
        });
    }
    changePassword(data) {
        return this.ajax({
            method: "POST",
            url: "api/security/change-password",
            data: JSON.stringify(data),
            contentType: "application/json; charset=utf-8"
        });
    }
    getUsers() {
        return this.ajax({
            method: "GET",
            url: `api/users`,
            contentType: "application/json; charset=utf-8"
        });
    }
    saveUser(user) {
        return this.ajax({
            method: "POST",
            url: `api/users`,
            data: JSON.stringify(user),
            contentType: "application/json; charset=utf-8"
        });
    }
    uploadFile(file) {
        const uploader = new (0, $4cb3d7cd62bf3322$export$b4ba47569ccac746)({
            url: "api/docs",
            maxWidth: 800,
            maxHeight: 800
        }, this);
        return uploader.uploadFile(file);
    }
    uploadToS3(file, listener) {
        const uploader = new (0, $cea34b64a270482f$export$d8d954cf74d9d0e3)(this, listener);
        return uploader.uploadFile(file);
    }
    fetchLibraries() {
        return this.ajax({
            method: "GET",
            url: `api/libraries`,
            contentType: "application/json; charset=utf-8"
        });
    }
    fetchRecordings(lib) {
        return this.ajax({
            method: "GET",
            url: `api/recordings?library=${encodeURIComponent(lib)}`,
            contentType: "application/json; charset=utf-8"
        });
    }
    fetchRecording(id) {
        return this.ajax({
            method: "GET",
            url: `api/recordings/${id}`,
            contentType: "application/json; charset=utf-8"
        });
    }
    fetchRecordingByToken(token) {
        return this.ajax({
            method: "GET",
            url: `api/recordings/token/${token}`,
            contentType: "application/json; charset=utf-8"
        });
    }
    saveRecording(recording, main_url, sample_url) {
        recording.url = main_url;
        // @ts-ignore
        recording["sample_url"] = sample_url;
        return this.ajax({
            method: "POST",
            url: `api/recordings`,
            data: JSON.stringify(recording),
            contentType: "application/json; charset=utf-8"
        });
    }
    // -------------------------------
    fetchShopCatalogue() {
        return this.ajax({
            method: "GET",
            url: `api/shop/catalogue`,
            contentType: "application/json; charset=utf-8"
        });
    }
    createPaymentIntent(cents, description) {
        const data = {
            cents: cents
        };
        if (description) data.description = description;
        return this.ajax({
            method: "POST",
            url: `api/payments/intent`,
            data: JSON.stringify(data),
            contentType: "application/json; charset=utf-8"
        });
    }
    purchase(paymentIntent) {
        return this.ajax({
            method: "POST",
            url: `api/shop/purchase`,
            data: JSON.stringify(paymentIntent),
            contentType: "application/json; charset=utf-8"
        });
    }
    getBalance() {
        return this.ajax({
            method: "GET",
            url: `api/balance`,
            contentType: "application/json; charset=utf-8"
        }, {
            noAuthRedirects: true
        });
    }
    getPractichordToken() {
        return this.ajax({
            method: "GET",
            url: `api/practichord`,
            contentType: "application/json; charset=utf-8"
        });
    }
    addRecording(r) {
        return this.ajax({
            method: "POST",
            url: `api/shop/add-recording`,
            data: JSON.stringify({
                id: r.id
            }),
            contentType: "application/json; charset=utf-8"
        });
    }
    saveMarks(r, marks) {
        return this.ajax({
            method: "POST",
            url: `api/recordings/${r.id}/marks`,
            data: JSON.stringify(marks),
            contentType: "application/json; charset=utf-8"
        }, {
            silent: true
        });
    }
    saveRepitch(r, cents) {
        return this.ajax({
            method: "POST",
            url: `api/recordings/${r.id}/repitch`,
            data: JSON.stringify({
                cents: cents
            }),
            contentType: "application/json; charset=utf-8"
        });
    }
    setActivation(r, active) {
        return this.ajax({
            method: "POST",
            url: `api/recordings/${r.id}/activation`,
            data: JSON.stringify({
                active: active
            }),
            contentType: "application/json; charset=utf-8"
        });
    }
    setActivationByToken(token, active) {
        return this.ajax({
            method: "POST",
            url: `api/recordings/token/${token}/activation`,
            data: JSON.stringify({
                active: active
            }),
            contentType: "application/json; charset=utf-8"
        });
    }
    getFakebookUrl() {
        return this.getUser().then((user)=>{
            if (!user || !user.username) return false;
            return `api/fakebook?${encodeURIComponent(user.username)}`;
        });
    }
    // -------------------------------
    getSalesSummaryReport(from, to) {
        const data = {
            from: from,
            to: to
        };
        return this.ajax({
            method: "GET",
            url: `api/reports/sales/summary`,
            data: data,
            contentType: "application/json; charset=utf-8"
        });
    }
    getSalesDetailsReport(from, to) {
        const data = {
            from: from,
            to: to
        };
        return this.ajax({
            method: "GET",
            url: `api/reports/sales/details`,
            data: data,
            contentType: "application/json; charset=utf-8"
        });
    }
    getSalesDetailsCsvUrl(from, to) {
        return `api/reports/sales/details.csv?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`;
    }
    // -------------------------------
    sendReset(username) {
        return this.ajax({
            method: "POST",
            url: `api/security/send-reset`,
            data: JSON.stringify(username),
            contentType: "application/json; charset=utf-8"
        });
    }
    // ------------------------------
    // debugging
    log(msg) {
        console.log(msg);
        return this.ajax({
            method: "POST",
            url: "json/log",
            data: msg
        }, {
            silent: true
        });
    }
    trace(msg) {
        const stack_ = (0, (/*@__PURE__*/$parcel$interopDefault($be181f338a50077e$exports))).get();
        stack_.then((stack)=>{
            for (const line of stack)msg = msg + "\n  " + line.toString();
            console.log("------------------------");
            console.log(msg);
            console.log("------------------------");
            this.log(msg);
        });
    }
    // ------------------------------
    // Misc.
    /**
     * Returns absolute URL, base of server app
     * This works for the web app and the mobile app.
     */ getBaseUrl() {
        // @ts-ignore
        const url = window.location.href;
        // Remove hash part and trailing slash, any query string
        let baseUrl = url.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/(([^\/\.]+\.[^\/\.]+))?$/, "");
        return baseUrl;
    }
    getShortBaseUrl() {
        return this.runtimeParams_.then((params)=>{
            return params["wrb.client.short_url"];
        });
    }
    /**
     * Wrap ajax calls so we can intercept if necessary.
     * @param settings
     */ ajax(settings, opts) {
        const options = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx))).extend({}, this.defaultOpts, opts || {});
        const l = options.uploadProgressListener;
        if (l) settings.xhr = ()=>{
            const xhr = new XMLHttpRequest();
            xhr.upload.addEventListener("progress", l);
            return xhr;
        };
        // @ts-ignore
        const baseurl = this.getBaseUrl();
        const method = settings.method || "GET";
        const url = settings.url;
        const absUrl = baseurl + "/" + url;
        // Don't cache if settings.data is set (ie, query string)
        const useCache = method == "GET" && url && !settings.data && !options.noCache && url !== "json/ping" && url.indexOf("?") == -1;
        const cacheKey = options.cachePrefix ? options.cachePrefix + ":" + url : url;
        if (useCache) {
            // check cache
            const cached = this.cache[cacheKey];
            if (cached) // this.debug(`Server cache: ${method} ${url}`);
            return cached;
        }
        // @ts-ignore
        const isMobile = window.dk_mobile;
        const useOfflineCache = useCache && isMobile;
        if (method == "POST") this.clearCache();
        else settings.cache = false;
        // this.debug(`Server fetch: ${method} ${absUrl}`);
        // const ctx = this.ctx;
        // idempotence - for payment required retries
        if (url && url.indexOf(baseurl) != 0) settings.url = absUrl;
        const start = Date.now();
        const cache = this.cache;
        let counter = 0;
        const popSpinner = options.silent ? ()=>{} : (0, $a187c2fe64638fd7$export$7f7cbe89f1eacd2).pushSpinner();
        const p = new (0, $6691e7f2ae148562$exports.Promise)((resolve, reject)=>{
            sendData.apply(this);
            function sendData() {
                const id = ++counter;
                settings.xhrFields = {
                    withCredentials: true
                };
                if (opts && opts.timeoutMs !== undefined) settings.timeout = opts.timeoutMs;
                // Aggressive anti-caching to overcome Internet Explorer's aggressive caching
                settings.cache = options.browserCaching;
                const xhr = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx))).ajax(settings);
                xhr.then((data, textStatus, response)=>{
                    const delay = Date.now() - start;
                    // console.log(`Server received ${url} after ${delay} ms`);
                    const update = response.getResponseHeader("X-wrb-update");
                    // @ts-ignore
                    const update0 = window.wrb_git && window.wrb_git.update;
                    if (update && update0 != update) (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))("body").addClass("update-pending");
                    resolve(data);
                });
                xhr.fail((data)=>{
                    if (options.silent) {
                        reject("silent error");
                        return;
                    }
                    console.log("sendData fail " + id);
                    let error = undefined;
                    let reload = false;
                    console.log("Ajax fail, readyState=" + data.readyState + ", status=" + data.status + " " + data.statusText + ", URL=" + url);
                    console.log("Ajax fail data: " + (0, $0e58699405760943$exports.inspect)(data));
                    this.trace("Ajax fail trace: ");
                    if (data.readyState == 0) {
                        // Network error...
                        // Consider retrying request if its a GET and not too long has elapsed since we started.
                        const retry = method == "GET" && Date.now() - start < 30000 && counter < 30;
                        if (retry) {
                            setTimeout(()=>{
                                console.log("Retrying... " + id);
                                sendData.apply(this);
                            }, 1000);
                            // Leave fail handler, without resolving outer promise.
                            xhr.abort();
                            return;
                        }
                        // Network error. We could put some retry logic in here
                        error = "There is a problem with the network or the server. Please try again in a few minutes";
                    } else if (data.status == 401) {
                        if (!options || !options.noAuthRedirects) // Login required
                        reload = true;
                    } else {
                        let handled = false;
                        if (options.errorCallback && data.responseJSON) handled = options.errorCallback(data.responseJSON);
                        if (!handled) {
                            if (data.responseJSON && data.responseJSON.error) error = data.responseJSON.error;
                            else // Unknown error
                            error = "An unknown error has ocurred...";
                        }
                    }
                    if (reload) {
                        window.location.href = "#/login";
                        window.location.reload();
                    }
                    if (error) this.error(error);
                    reject(error);
                });
            }
        });
        if (useCache) cache[cacheKey] = p;
        p.finally(()=>{
            popSpinner();
        });
        return p;
    }
    error(msg) {
        // Display directly. This could be refactored out of the server class, eg via events.
        console.log("ERROR", msg);
        if (typeof msg == "string") msg = [
            msg
        ];
        // Format array of messages into HTML
        const ol = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))("<ol>").addClass("server-error-list");
        (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(msg).each((idx)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))("<li>").text(msg[idx]).appendTo(ol);
        });
        (0, $752d59648741b237$export$2e2bcd8739ae039).alert({
            messageHTML: ol[0].outerHTML
        });
    }
    qa(err) {
        const id = Date.now();
        this.ajax({
            method: "POST",
            url: "api/qa/" + id,
            data: err
        }, {
            silent: true
        });
        return id;
    }
    debug(msg) {
        console.log(msg);
    }
    /**
     * Clear the local cache (not the offline cache)
     */ clearCache(ts) {
        const ts2 = ts || Date.now();
        const cachesize = Object.keys(this.cache).length;
        console.log("clearCache ts=" + ts + "; cachesize=" + cachesize);
        // Crude - invalidate entire cache
        this.cache = {};
        // if we are the originator, trigger cross-tabs refresh with same value
        if (!ts) window.localStorage.setItem($b306c6aaaa6be045$export$f2b782965eea3685, ts2.toString());
    }
    clearCachePrefix(prefix) {
        console.log("clearCacheclearCachePrefix " + prefix);
        const keys = Object.keys(this.cache).filter((key)=>key.indexOf(prefix) == 0);
        for (const key of keys){
            console.log("clearCacheclearCachePrefix => " + key);
            delete this.cache[key];
        }
    }
    clearVolatileCache() {
        this.clearCachePrefix($b306c6aaaa6be045$var$VOLATILE);
    }
    // ------------------------------
    /**
     * Payment nonces are transported as http headers along with the business payload in the http body.
     */ addPaymentNonce(settings, paymentNonce) {
        if (paymentNonce == undefined) return;
        const headers = settings.headers || {};
        headers["X-TP-payment-nonce"] = paymentNonce;
        settings.headers = headers;
    }
    /**
     * A "dry run" can be executed by adding a special HTTP header to post requests
     */ dryrun(settings) {
        const headers = settings.headers || {};
        headers["X-TP-dryrun"] = "true";
        settings.headers = headers;
    }
}
function $b306c6aaaa6be045$var$calcLocalStorageSize() {
    let size = 0;
    let cnt = 0;
    for(let i = 0; i < window.localStorage.length; i++){
        const key = window.localStorage.key(i);
        if (key != null) {
            const val = window.localStorage[key];
            cnt++;
            if (val && val.length) size += val.length;
        }
    }
    return {
        size: size,
        cnt: cnt
    };
}
function $b306c6aaaa6be045$export$e394a0c530ae5631() {
    return "talc-";
}



var $10cKx = parcelRequire("10cKx");

var $adf743fdeabced27$exports = {};

var $adf743fdeabced27$var$tokenize = function(/*String*/ str, /*RegExp*/ re, /*Function?*/ parseDelim, /*Object?*/ instance) {
    // summary:
    //    Split a string by a regular expression with the ability to capture the delimeters
    // parseDelim:
    //    Each group (excluding the 0 group) is passed as a parameter. If the function returns
    //    a value, it's added to the list of tokens.
    // instance:
    //    Used as the "this' instance when calling parseDelim
    var tokens = [];
    var match, content, lastIndex = 0;
    while(match = re.exec(str)){
        content = str.slice(lastIndex, re.lastIndex - match[0].length);
        if (content.length) tokens.push(content);
        if (parseDelim) {
            var parsed = parseDelim.apply(instance, match.slice(1).concat(tokens.length));
            if (typeof parsed != "undefined") {
                if (parsed.specifier === "%") tokens.push("%");
                else tokens.push(parsed);
            }
        }
        lastIndex = re.lastIndex;
    }
    content = str.slice(lastIndex);
    if (content.length) tokens.push(content);
    return tokens;
};
var $adf743fdeabced27$var$Formatter = function(/*String*/ format) {
    this._mapped = false;
    this._format = format;
    this._tokens = $adf743fdeabced27$var$tokenize(format, this._re, this._parseDelim, this);
};
$adf743fdeabced27$var$Formatter.prototype._re = /\%(?:\(([\w_.]+)\)|([1-9]\d*)\$)?([0 +\-\#]*)(\*|\d+)?(\.)?(\*|\d+)?[hlL]?([\%bscdeEfFgGioOuxX])/g;
$adf743fdeabced27$var$Formatter.prototype._parseDelim = function(mapping, intmapping, flags, minWidth, period, precision, specifier) {
    if (mapping) this._mapped = true;
    return {
        mapping: mapping,
        intmapping: intmapping,
        flags: flags,
        _minWidth: minWidth,
        period: period,
        _precision: precision,
        specifier: specifier
    };
};
$adf743fdeabced27$var$Formatter.prototype._specifiers = {
    b: {
        base: 2,
        isInt: true
    },
    o: {
        base: 8,
        isInt: true
    },
    x: {
        base: 16,
        isInt: true
    },
    X: {
        extend: [
            "x"
        ],
        toUpper: true
    },
    d: {
        base: 10,
        isInt: true
    },
    i: {
        extend: [
            "d"
        ]
    },
    u: {
        extend: [
            "d"
        ],
        isUnsigned: true
    },
    c: {
        setArg: function(token) {
            if (!isNaN(token.arg)) {
                var num = parseInt(token.arg);
                if (num < 0 || num > 127) throw new Error("invalid character code passed to %c in printf");
                token.arg = isNaN(num) ? "" + num : String.fromCharCode(num);
            }
        }
    },
    s: {
        setMaxWidth: function(token) {
            token.maxWidth = token.period == "." ? token.precision : -1;
        }
    },
    e: {
        isDouble: true,
        doubleNotation: "e"
    },
    E: {
        extend: [
            "e"
        ],
        toUpper: true
    },
    f: {
        isDouble: true,
        doubleNotation: "f"
    },
    F: {
        extend: [
            "f"
        ]
    },
    g: {
        isDouble: true,
        doubleNotation: "g"
    },
    G: {
        extend: [
            "g"
        ],
        toUpper: true
    },
    O: {
        isObject: true
    }
};
$adf743fdeabced27$var$Formatter.prototype.format = function(/*mixed...*/ filler) {
    if (this._mapped && typeof filler != "object") throw new Error("format requires a mapping");
    var str = "";
    var position = 0;
    for(var i = 0, token; i < this._tokens.length; i++){
        token = this._tokens[i];
        if (typeof token == "string") str += token;
        else {
            if (this._mapped) {
                // Identify value of property defined in `token.mapping`
                var tokens = token.mapping.split(".");
                var value = filler;
                for(var j = 0, c = tokens.length; j < c; j++){
                    value = value[tokens[j]];
                    if (typeof value === "undefined") break;
                }
                if (typeof value == "undefined") throw new Error("missing key " + token.mapping);
                token.arg = value;
            } else {
                if (token.intmapping) position = parseInt(token.intmapping) - 1;
                if (position >= arguments.length) throw new Error("got " + arguments.length + " printf arguments, insufficient for '" + this._format + "'");
                token.arg = arguments[position++];
            }
            if (!token.compiled) {
                token.compiled = true;
                token.sign = "";
                token.zeroPad = false;
                token.rightJustify = false;
                token.alternative = false;
                var flags = {};
                for(var fi = token.flags.length; fi--;){
                    var flag = token.flags.charAt(fi);
                    flags[flag] = true;
                    switch(flag){
                        case " ":
                            token.sign = " ";
                            break;
                        case "+":
                            token.sign = "+";
                            break;
                        case "0":
                            token.zeroPad = flags["-"] ? false : true;
                            break;
                        case "-":
                            token.rightJustify = true;
                            token.zeroPad = false;
                            break;
                        case "#":
                            token.alternative = true;
                            break;
                        default:
                            throw Error("bad formatting flag '" + token.flags.charAt(fi) + "'");
                    }
                }
                token.minWidth = token._minWidth ? parseInt(token._minWidth) : 0;
                token.maxWidth = -1;
                token.toUpper = false;
                token.isUnsigned = false;
                token.isInt = false;
                token.isDouble = false;
                token.isObject = false;
                token.precision = 1;
                if (token.period == ".") {
                    if (token._precision) token.precision = parseInt(token._precision);
                    else token.precision = 0;
                }
                var mixins = this._specifiers[token.specifier];
                if (typeof mixins == "undefined") throw new Error("unexpected specifier '" + token.specifier + "'");
                if (mixins.extend) {
                    var s = this._specifiers[mixins.extend];
                    for(var k in s)mixins[k] = s[k];
                    delete mixins.extend;
                }
                for(var l in mixins)token[l] = mixins[l];
            }
            if (typeof token.setArg == "function") token.setArg(token);
            if (typeof token.setMaxWidth == "function") token.setMaxWidth(token);
            if (token._minWidth == "*") {
                if (this._mapped) throw new Error("* width not supported in mapped formats");
                token.minWidth = parseInt(arguments[position++]);
                if (isNaN(token.minWidth)) throw new Error("the argument for * width at position " + position + " is not a number in " + this._format);
                // negative width means rightJustify
                if (token.minWidth < 0) {
                    token.rightJustify = true;
                    token.minWidth = -token.minWidth;
                }
            }
            if (token._precision == "*" && token.period == ".") {
                if (this._mapped) throw new Error("* precision not supported in mapped formats");
                token.precision = parseInt(arguments[position++]);
                if (isNaN(token.precision)) throw Error("the argument for * precision at position " + position + " is not a number in " + this._format);
                // negative precision means unspecified
                if (token.precision < 0) {
                    token.precision = 1;
                    token.period = "";
                }
            }
            if (token.isInt) {
                // a specified precision means no zero padding
                if (token.period == ".") token.zeroPad = false;
                this.formatInt(token);
            } else if (token.isDouble) {
                if (token.period != ".") token.precision = 6;
                this.formatDouble(token);
            } else if (token.isObject) this.formatObject(token);
            this.fitField(token);
            str += "" + token.arg;
        }
    }
    return str;
};
$adf743fdeabced27$var$Formatter.prototype._zeros10 = "0000000000";
$adf743fdeabced27$var$Formatter.prototype._spaces10 = "          ";
$adf743fdeabced27$var$Formatter.prototype.formatInt = function(token) {
    var i = parseInt(token.arg);
    if (!isFinite(i)) {
        // allow this only if arg is number
        if (typeof token.arg != "number") throw new Error("format argument '" + token.arg + "' not an integer; parseInt returned " + i);
        //return '' + i;
        i = 0;
    }
    // if not base 10, make negatives be positive
    // otherwise, (-10).toString(16) is '-a' instead of 'fffffff6'
    if (i < 0 && (token.isUnsigned || token.base != 10)) i = 0xffffffff + i + 1;
    if (i < 0) {
        token.arg = (-i).toString(token.base);
        this.zeroPad(token);
        token.arg = "-" + token.arg;
    } else {
        token.arg = i.toString(token.base);
        // need to make sure that argument 0 with precision==0 is formatted as ''
        if (!i && !token.precision) token.arg = "";
        else this.zeroPad(token);
        if (token.sign) token.arg = token.sign + token.arg;
    }
    if (token.base == 16) {
        if (token.alternative) token.arg = "0x" + token.arg;
        token.arg = token.toUpper ? token.arg.toUpperCase() : token.arg.toLowerCase();
    }
    if (token.base == 8) {
        if (token.alternative && token.arg.charAt(0) != "0") token.arg = "0" + token.arg;
    }
};
$adf743fdeabced27$var$Formatter.prototype.formatDouble = function(token) {
    var f = parseFloat(token.arg);
    if (!isFinite(f)) {
        // allow this only if arg is number
        if (typeof token.arg != "number") throw new Error("format argument '" + token.arg + "' not a float; parseFloat returned " + f);
        // C99 says that for 'f':
        //   infinity -> '[-]inf' or '[-]infinity' ('[-]INF' or '[-]INFINITY' for 'F')
        //   NaN -> a string  starting with 'nan' ('NAN' for 'F')
        // this is not commonly implemented though.
        //return '' + f;
        f = 0;
    }
    switch(token.doubleNotation){
        case "e":
            token.arg = f.toExponential(token.precision);
            break;
        case "f":
            token.arg = f.toFixed(token.precision);
            break;
        case "g":
            // C says use 'e' notation if exponent is < -4 or is >= prec
            // ECMAScript for toPrecision says use exponential notation if exponent is >= prec,
            // though step 17 of toPrecision indicates a test for < -6 to force exponential.
            if (Math.abs(f) < 0.0001) //print('forcing exponential notation for f=' + f);
            token.arg = f.toExponential(token.precision > 0 ? token.precision - 1 : token.precision);
            else token.arg = f.toPrecision(token.precision);
            // In C, unlike 'f', 'gG' removes trailing 0s from fractional part, unless alternative format flag ('#').
            // But ECMAScript formats toPrecision as 0.00100000. So remove trailing 0s.
            if (!token.alternative) {
                //print('replacing trailing 0 in \'' + s + '\'');
                token.arg = token.arg.replace(/(\..*[^0])0*e/, "$1e");
                // if fractional part is entirely 0, remove it and decimal point
                token.arg = token.arg.replace(/\.0*e/, "e").replace(/\.0$/, "");
            }
            break;
        default:
            throw new Error("unexpected double notation '" + token.doubleNotation + "'");
    }
    // C says that exponent must have at least two digits.
    // But ECMAScript does not; toExponential results in things like '1.000000e-8' and '1.000000e+8'.
    // Note that s.replace(/e([\+\-])(\d)/, 'e$10$2') won't work because of the '$10' instead of '$1'.
    // And replace(re, func) isn't supported on IE50 or Safari1.
    token.arg = token.arg.replace(/e\+(\d)$/, "e+0$1").replace(/e\-(\d)$/, "e-0$1");
    // if alt, ensure a decimal point
    if (token.alternative) {
        token.arg = token.arg.replace(/^(\d+)$/, "$1.");
        token.arg = token.arg.replace(/^(\d+)e/, "$1.e");
    }
    if (f >= 0 && token.sign) token.arg = token.sign + token.arg;
    token.arg = token.toUpper ? token.arg.toUpperCase() : token.arg.toLowerCase();
};
$adf743fdeabced27$var$Formatter.prototype.formatObject = function(token) {
    // If no precision is specified, then reset it to null (infinite depth).
    var precision = token.period === "." ? token.precision : null;
    // Historically, inspect was called with 3 options
    // token.arg = util.inspect(token.arg, !token.alternative, precision, token.sign);
    // Now using an object but not sure colors make any sense here
    token.arg = $0e58699405760943$exports.inspect(token.arg, {
        showHidden: !token.alternative,
        depth: precision,
        colors: token.sign,
        compact: true
    });
};
$adf743fdeabced27$var$Formatter.prototype.zeroPad = function(token, /*Int*/ length) {
    length = arguments.length == 2 ? length : token.precision;
    var negative = false;
    if (typeof token.arg != "string") token.arg = "" + token.arg;
    if (token.arg.substr(0, 1) === "-") {
        negative = true;
        token.arg = token.arg.substr(1);
    }
    var tenless = length - 10;
    while(token.arg.length < tenless)token.arg = token.rightJustify ? token.arg + this._zeros10 : this._zeros10 + token.arg;
    var pad = length - token.arg.length;
    token.arg = token.rightJustify ? token.arg + this._zeros10.substring(0, pad) : this._zeros10.substring(0, pad) + token.arg;
    if (negative) token.arg = "-" + token.arg;
};
$adf743fdeabced27$var$Formatter.prototype.fitField = function(token) {
    if (token.maxWidth >= 0 && token.arg.length > token.maxWidth) token.arg = token.arg.substring(0, token.maxWidth);
    if (token.zeroPad) {
        this.zeroPad(token, token.minWidth);
        return;
    }
    this.spacePad(token);
};
$adf743fdeabced27$var$Formatter.prototype.spacePad = function(token, /*Int*/ length) {
    length = arguments.length == 2 ? length : token.minWidth;
    if (typeof token.arg != "string") token.arg = "" + token.arg;
    var tenless = length - 10;
    while(token.arg.length < tenless)token.arg = token.rightJustify ? token.arg + this._spaces10 : this._spaces10 + token.arg;
    var pad = length - token.arg.length;
    token.arg = token.rightJustify ? token.arg + this._spaces10.substring(0, pad) : this._spaces10.substring(0, pad) + token.arg;
};

$adf743fdeabced27$exports = function() {
    var args = Array.prototype.slice.call(arguments), stream, format;
    if (args[0] instanceof (parcelRequire("g5acy")).Stream) stream = args.shift();
    format = args.shift();
    var formatter = new $adf743fdeabced27$var$Formatter(format);
    var string = formatter.format.apply(formatter, args);
    if (stream) stream.write(string);
    else return string;
};
$adf743fdeabced27$exports.Formatter = $adf743fdeabced27$var$Formatter;


function $82cf23e1ef1fc3af$export$c755ec8933ea1108() {
    const hash = window.location.hash || "#";
    const url = hash.replace(/^#/, "");
    return url;
}
function $82cf23e1ef1fc3af$export$93ea666e31027e44(h) {
    const url0 = window.location.href;
    const url = url0.replace(/(#.*)?$/, "#" + h);
    return url;
}
function $82cf23e1ef1fc3af$export$bb654e07daaf8c3a(url) {
    const url2 = url.replace(/^\//, "");
    const path = url2.split("/").map((s)=>decodeURIComponent(s));
    return path;
}
function $82cf23e1ef1fc3af$export$12d4ceab885e6b01(h) {
    window.location.hash = h ? "#" + h : "#";
}
function $82cf23e1ef1fc3af$export$9bf2691bda54425c(h) {
    const url = $82cf23e1ef1fc3af$export$93ea666e31027e44(h);
    window.history.replaceState(null, "", url);
}
function $82cf23e1ef1fc3af$export$54048630ffcff79a(form, json) {
    const formData = form.serializeArray();
    for(const i in formData){
        const field = form.find("*[name='" + formData[i].name + "']");
        const valRaw = formData[i].value;
        // Type conversions:
        // If the field has class "number" then the value is parsed as a number.
        // Additionally if it has class "integer" then it is parsed as integer
        // Any checkboxes with the class "boolean" are serialized as either true or false.
        // Note that this is different to normal checkbox behaviour in which the
        // control is not submitted if not checked.
        const isNumber = field.hasClass("number");
        const isInteger = isNumber && field.hasClass("number");
        const isMoney = isNumber && field.hasClass("money");
        const isDate = field.hasClass("datefield");
        const isBoolean = field.hasClass("boolean");
        const isMultiple = field[0].nodeName == "SELECT" && field.attr("multiple") !== undefined;
        let val;
        if (isNumber) {
            let val0 = valRaw;
            if (isMoney && val0) val0 = val0.replace("$", "");
            const re = isInteger ? / *-?[0-9]+ */ : / *-?([0-9]+|[0-9]*\.[0-9]+ *)/;
            if (val0 != null && val0.match(re)) val = Number(val0);
            else val = null;
        } else if (isDate) {
            // Convert dd/mm/yyyy to yyyy-mm-dd
            if (valRaw && valRaw.match(/\//)) val = $82cf23e1ef1fc3af$export$6b862160d295c8e(valRaw);
            else val = valRaw;
        } else if (isBoolean) {
            // expected values are "true", "false" and "" (or null)
            if (valRaw === "true") val = true;
            if (valRaw === "false") val = false;
        } else val = valRaw;
        if (isMultiple) {
            if (json[formData[i].name] === undefined) json[formData[i].name] = [];
            if (json[formData[i].name].push) json[formData[i].name].push(val);
            else // maybe name conflict? anyway we don't want to crash
            json[formData[i].name] = val;
        } else // normal case
        json[formData[i].name] = val;
        // Now handle checkboxes of type boolean
        const booleans = form.find("input.boolean[type=checkbox]").not(":disabled");
        booleans.each((i, b)=>{
            const name = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(b).attr("name");
            const val = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(b).is(":checked") ? true : false;
            json[name] = val;
        });
    }
}
const $82cf23e1ef1fc3af$export$39707c0c09d84b88 = "dksess";
const $82cf23e1ef1fc3af$var$USER_COOKIE = "dkuser";
function $82cf23e1ef1fc3af$export$c6f6c483211be892(url) {
    if (!url) window.location.reload();
    else {
        const absUrl = window.location.href.replace(/#.*/, "") + "#" + url;
        window.location.href = absUrl;
        window.location.reload();
    }
}
function $82cf23e1ef1fc3af$export$305c28c51975b541(url) {
    const absUrl = window.location.href.replace(/#.*/, "") + "#" + url;
    window.open(absUrl);
}
function $82cf23e1ef1fc3af$export$3ddec199482be5a9(d) {
    if (!d) return d;
    const bits = d.trim().split(/-/);
    return bits[2] + "/" + bits[1] + "/" + bits[0];
}
function $82cf23e1ef1fc3af$export$6b862160d295c8e(d) {
    if (!d) return d;
    const bits = d.trim().split(/\//);
    return bits[2] + "-" + bits[1] + "-" + bits[0];
}
function $82cf23e1ef1fc3af$export$e22c6d286fcd3199(ts) {
    const then = ts * 1000;
    const now = Date.now();
    const diff = now - then;
    // Segment rendering according to age:
    // < 1 hour - x minutes ago
    // < 24 hours - x hours ago
    // then dd/mm/yyyy
    const minutes = diff / 1000 / 60;
    const hours = minutes / 60;
    if (hours < 1) {
        const mins = Math.floor(minutes);
        return mins + " " + $82cf23e1ef1fc3af$export$4e35d5c922a95490(mins, "minute", "minutes") + " ago";
    }
    if (hours < 24) {
        const h = Math.floor(hours);
        return h + " " + $82cf23e1ef1fc3af$export$4e35d5c922a95490(h, "hour", "hours") + " ago";
    }
    function r(x) {
        const s = x.toString();
        return s.length < 2 ? "0" + s : s;
    }
    const d = new Date(then);
    return r(d.getDate()) + "/" + r(d.getMonth() + 1) + "/" + r(d.getFullYear());
}
function $82cf23e1ef1fc3af$export$69eb827a8361beae(ts) {
    const then = ts * 1000;
    const d = new Date(then);
    return d.getDate();
}
function $82cf23e1ef1fc3af$export$ba33a95610daa3c5(ts) {
    const then = ts * 1000;
    const d = new Date(then);
    const m = d.getMonth();
    return $82cf23e1ef1fc3af$export$2e59fa295abca125[m];
}
function $82cf23e1ef1fc3af$export$e857bfc5ad222e12(cents) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($adf743fdeabced27$exports)))((cents < 0 ? "-" : "") + "$%.2f", Math.abs(cents) / 100);
}
function $82cf23e1ef1fc3af$export$828b1701c210b8bc(dollars) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($adf743fdeabced27$exports)))((dollars < 0 ? "-" : "") + "$%.2f", Math.abs(dollars));
}
function $82cf23e1ef1fc3af$export$48606025842571ea(euros) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($adf743fdeabced27$exports)))((euros < 0 ? "-" : "") + "%.2f\u20AC", Math.abs(euros));
}
function $82cf23e1ef1fc3af$export$a1bd3674078e2988(credits) {
    return credits !== undefined && credits > 100000;
}
function $82cf23e1ef1fc3af$export$2bf51cf47fafb61d(credits) {
    if ($82cf23e1ef1fc3af$export$a1bd3674078e2988(credits)) return "unlimited TALC credits";
    else if (credits == 1) return "1 TALC credit";
    else return credits + " TALC credits";
}
function $82cf23e1ef1fc3af$export$caf7db48861492aa(dollars) {
    let cents = undefined;
    dollars = dollars && dollars.replace("$", "");
    if (dollars && dollars.length > 0) cents = Math.round(+dollars * 100);
    return cents;
}
const $82cf23e1ef1fc3af$export$2e59fa295abca125 = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
function $82cf23e1ef1fc3af$export$4e35d5c922a95490(x, singular, plural) {
    return x == 1 ? singular : plural;
}
const $82cf23e1ef1fc3af$export$5f9775991cbaa94f = new (0, $6691e7f2ae148562$exports.Promise)((resolve, reject)=>resolve());
function $82cf23e1ef1fc3af$export$c5df72896f647f8(arg) {
    return new (0, $6691e7f2ae148562$exports.Promise)((resolve, reject)=>resolve(arg));
}
function $82cf23e1ef1fc3af$export$e20fbacbb41798b(button, promise) {
    (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(button).prop("disabled", true);
    promise.finally(()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(button).prop("disabled", false);
    });
}
function $82cf23e1ef1fc3af$export$a4627e546088548d(x) {
    const json = JSON.stringify(x);
    const out = JSON.parse(json);
    return out;
}
function $82cf23e1ef1fc3af$export$4187d1fb91d367f(scriptUrl) {
    return new (0, $6691e7f2ae148562$exports.Promise)((resolve, reject)=>{
        const scriptElement = document.createElement("script");
        scriptElement.src = scriptUrl;
        scriptElement.onload = resolve;
        document.body.appendChild(scriptElement);
    });
}
function $82cf23e1ef1fc3af$export$3f99968195accfaf(elt, duration) {
    if (duration === undefined) duration = 100;
    const offset = elt.offset();
    if (offset) (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))("html, body").animate({
        scrollTop: offset.top
    }, duration);
}
function $82cf23e1ef1fc3af$export$a07a5eb373ddf1f6(genre) {
    switch(genre){
        case "tango":
            return "T";
        case "vals":
            return "V";
        case "milonga":
            return "M";
        default:
            return "-";
    }
}
function $82cf23e1ef1fc3af$export$36eb8ca84de29e07(artist) {
    if (!artist) return "";
    const bits = artist.split(/, voc. /);
    function a(name) {
        const parts = name.split(/ /);
        const out = [];
        for(let i = 0; i < parts.length - 1; i++)if (parts[i].length < 3) out.push(parts[i]);
        out.push(parts[parts.length - 1]);
        return out.join(" ");
    }
    return bits.map(a).join("/");
}
function $82cf23e1ef1fc3af$export$26e685d98fdeb12f(d) {
    return d && d.replace(/([0-9]{4})-[0-9]{2}-[0-9]{2}/g, "$1");
}
function $82cf23e1ef1fc3af$export$114ad5b630363e5c(r) {
    const a = r;
    a.shortGenre = $82cf23e1ef1fc3af$export$a07a5eb373ddf1f6(r.genre);
    a.shortArtist = $82cf23e1ef1fc3af$export$36eb8ca84de29e07(r.artist);
    a.shortDate = $82cf23e1ef1fc3af$export$26e685d98fdeb12f(r.recording_date);
}
function $82cf23e1ef1fc3af$export$157b27307c5a0381(elt) {
    // @ts-ignore
    const elementTop = elt.offset().top;
    // @ts-ignore
    const elementBottom = elementTop + elt.outerHeight();
    const viewportTop = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(window).scrollTop();
    // @ts-ignore
    const viewportBottom = viewportTop + (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(window).height();
    // @ts-ignore
    return elementBottom > viewportTop && elementTop < viewportBottom;
}


class $4f991c42613b920c$export$5593b284a7b9fb1b {
    isRoot() {
        return false;
    }
    /**
     * @return true if the function has "zero" navigation (eg, login page)
     */ isZero() {
        return false;
    }
    /**
     * Override to return a custom page template
     */ pageTemplate() {
        return undefined;
    }
    /**
     * Most functions aren't available offline. Subclasses can override this to indicate that they
     * are offline enabled.
     */ offlineEnabled() {
        return false;
    }
    /**
     * Functions can be "cacheable", which means that new instances are not created each time the
     * URL is visited. This is good for maintaining model state.
     */ isCacheable() {
        return false;
    }
    refresh() {
    // NOP
    }
}
const $4f991c42613b920c$export$87cd0a661ace5c06 = "admin";
const $4f991c42613b920c$export$a7d6ff1965d6fac9 = "editor";
const $4f991c42613b920c$export$3cc7ce77e26c67cb = "member";
const $4f991c42613b920c$export$c7a47299927a834c = "none";
const $4f991c42613b920c$export$8e77a375f9a5908e = [
    $4f991c42613b920c$export$87cd0a661ace5c06,
    $4f991c42613b920c$export$a7d6ff1965d6fac9,
    $4f991c42613b920c$export$3cc7ce77e26c67cb,
    $4f991c42613b920c$export$c7a47299927a834c
];






var $10cKx = parcelRequire("10cKx");



function $64c8de52dd72edd4$export$cc3fdd528b56c4a9(ex) {
    try {
        (0, (/*@__PURE__*/$parcel$interopDefault($be181f338a50077e$exports))).fromError(ex).then((stack)=>{
            let msg = ex.message;
            for (const line of stack)msg = msg + "\n  " + line.toString();
            console.log("------------------------");
            console.log(msg);
            console.log("------------------------");
            const id = (0, $b306c6aaaa6be045$export$2e2bcd8739ae039).instance().qa(msg);
            (0, $752d59648741b237$export$2e2bcd8739ae039).alert({
                message: "An internal error has occurred. \nBug tracking id " + id
            });
        });
    } catch (oops) {
        console.log("StackTrace.fromError failed...");
        console.log(oops);
    }
}
function $64c8de52dd72edd4$export$2778fa94011ee241(msg) {
    try {
        const stack_ = (0, (/*@__PURE__*/$parcel$interopDefault($be181f338a50077e$exports))).get();
        stack_.then((stack)=>{
            console.log("------------------------");
            console.log("STACK: " + msg);
            for (const line of stack)console.log(line);
            console.log("------------------------");
        });
    } catch (oops) {
        console.log("StackTrace.fromError failed...");
        console.log(oops);
    }
}


class $f55c403e2549a503$export$2e2bcd8739ae039 {
    static #_ = this.id = 1;
    constructor(classname){
        this.uuid = this.genUuid();
        /**
     * Stuff that should be executed once the DOM has been updated.
     */ this.afterUpdateQueue = undefined;
        this.classname = classname;
    }
    setParent(parent) {
        this.parent = parent;
    }
    getParent() {
        return this.parent;
    }
    getRoot() {
        if (this.parent) return this.parent.getRoot();
        else return this;
    }
    getUuid() {
        return this.uuid;
    }
    getHtmlClass() {
        return undefined;
    }
    /**
     * Find the element corresponding to this view.
     */ elt() {
        const doc = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(document);
        const elt = doc.find("#" + this.uuid);
        return elt;
    }
    /**
     * Return true if this View is rendered in the DOM
     */ rendered() {
        return this.elt().length > 0;
    }
    /**
     * Update the page with a re-rendered version of this view.
     */ update(selector) {
        try {
            this.afterUpdateQueue = this.afterUpdateQueue || [];
            const x = this.render();
            this.replaceElements(x, selector);
            for (const fn of this.afterUpdateQueue)fn();
            this.afterUpdateQueue = undefined;
        } catch (ex) {
            (0, $64c8de52dd72edd4$export$cc3fdd528b56c4a9)(ex);
        }
    }
    replaceElements(rendered, selector) {
        const elt = this.elt();
        const replace = (sel)=>{
            const src = sel ? rendered.find(sel).addBack(sel) : rendered;
            const target = sel ? elt.find(sel).addBack(sel) : elt;
            target.replaceWith(src);
        };
        if (typeof selector === "undefined") replace();
        else {
            if (typeof selector === "string") selector = [
                selector
            ];
            for (let sel of selector)replace(sel);
        }
    }
    render() {
        let $out = this.render0();
        if ($out.length > 1) {
            const wrapper = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))("<div>");
            wrapper.append($out);
            $out = wrapper;
        }
        $out.attr("id", this.getUuid());
        if (this.classname) $out.addClass(this.classname);
        $out.addClass("widget");
        $out.data("view", this);
        return $out;
    }
    /**
     * This is intented to be called within "render" methods, to invoke code that
     * requires the elements to be present in the DOM.
     */ afterUpdate(fn) {
        if (this.afterUpdateQueue) {
            this.afterUpdateQueue.push(fn);
            return;
        }
        if (this.parent) {
            this.parent.afterUpdate(fn);
            return;
        }
        // Whoops nowhere to put the postUpdate. We must be not in an update phase.
        // Assume we are a top-level component and create the queue.
        // Note that this won't work eg if we are a lower-level component but not
        // yet with an assigned parent.
        this.afterUpdateQueue = [
            fn
        ];
    }
    pug(template, locals) {
        // detect jQuery objects to replace
        locals = locals || {};
        const locals1 = {};
        const subs = {};
        for(const i in locals){
            const val = locals[i];
            if (val instanceof $f55c403e2549a503$export$2e2bcd8739ae039) {
                // View, so render first
                // Side effect: parent of val is set to this if not already set.
                // This means that the render method can see the tree.
                if (!val.parent) val.setParent(this);
                const id = val.getUuid();
                const str = `<div id='${id}'></div>`;
                subs[id] = val.render();
                locals1[i] = str;
            } else if (val && val.attr && val.attr("id")) {
                // JQuery object
                const id = val.attr("id");
                const str = `<div id='${id}'></div>`;
                subs[id] = val;
                locals1[i] = str;
            } else // Nothing special, just use literal value
            locals1[i] = val;
        }
        // Add uuid
        locals1.uuid = this.getUuid();
        // @ts-ignore
        locals1.serverUrl = window.aidka_server_url || ".";
        try {
            const html = template(locals1) || "<div></div>";
            const out = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(html);
            for(var id in subs){
                const sel = "#" + id;
                const found = out.find(sel).addBack(sel);
                found.replaceWith(subs[id]);
            }
            return out;
        } catch (ex) {
            (0, $64c8de52dd72edd4$export$cc3fdd528b56c4a9)(ex);
            return (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))("<div>").text("Error in " + this.classname);
        }
    }
    /**
     * Register a listener for this widget.
     * @param widgetSelector is a jQuery selector that identifies the widget (eg, the classname)
     * @param events the events to listen for, eg "click"
     * @param selector_data is a jQuery selector which is used to filter events
     * @param handler will be invoked when a matching event is received.
     */ static on(widgetSelector, events, selector_data, handler) {
        (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(document).on(events, selector_data, function(event) {
            // Find instance
            const source = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(event.target);
            const widget = source.closest(widgetSelector);
            if (widget.length == 0) // Not us
            return;
            const view = widget.data("view");
            if (!view) // Wrong element - maybe ambiguous selector.
            return;
            const elt = this;
            try {
                handler.call(view, view, event, elt);
            } catch (ex) {
                (0, $64c8de52dd72edd4$export$cc3fdd528b56c4a9)(ex);
            }
        });
        return this;
    }
    genUuid() {
        return "v-" + $f55c403e2549a503$export$2e2bcd8739ae039.id++;
    }
    notify(n) {
        if (this.parent) this.parent.notify(n);
    }
}
class $f55c403e2549a503$export$14834abbfce3b8cd {
    constructor(n){
        this.name = n;
    }
}


var $18ded15152d8f7db$export$2e2bcd8739ae039 = $18ded15152d8f7db$var$template;
function $18ded15152d8f7db$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $18ded15152d8f7db$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $18ded15152d8f7db$var$pug_escape(e) {
    var a = "" + e, t = $18ded15152d8f7db$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $18ded15152d8f7db$var$pug_match_html = /["&<>]/;
function $18ded15152d8f7db$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(username1) {
        pug_html = pug_html + '<div class="yingyang"><form class="login-form with-validation"><input' + (' class="form-control" type="text" name="username"' + $18ded15152d8f7db$var$pug_attr("value", username1, true, true) + ' placeholder="Username"' + $18ded15152d8f7db$var$pug_attr("autofocus", true, true, true) + " required") + '><input class="form-control" type="password" name="password" placeholder="Password" required><button class="login form-control">Log in</button><a class="clickable forgot-password" href="#">Send password reset</a><a class="clickable" href="#/signup">Create an account</a></form></div>';
    }).call(this, "username" in locals_for_with ? locals_for_with.username : typeof username !== "undefined" ? username : undefined);
    return pug_html;
}




class $340c9e737fc54ace$export$1582048ca8384970 extends (0, $f55c403e2549a503$export$2e2bcd8739ae039) {
    static #_ = this.classname = "login-view";
    constructor(app, username, password){
        super($340c9e737fc54ace$export$1582048ca8384970.classname);
        this.server = (0, $b306c6aaaa6be045$export$2e2bcd8739ae039).instance();
        this.app = app;
        if (username && password) {
            const data = {
                username: username,
                password: password
            };
            this.server.login(data).then((user)=>{
                if (user) {
                    this.app.setUser(user);
                    window.location.hash = "/home";
                }
            });
        }
    }
    render0() {
        const data = {};
        const out = this.pug((0, $18ded15152d8f7db$export$2e2bcd8739ae039), data);
        out.find(".with-validation").validate({
            rules: {
                username: "required",
                password: "required"
            }
        });
        return out;
    }
    login() {
        const form = this.elt().find(".login-form");
        if (!form.valid()) return;
        const data = {};
        (0, $82cf23e1ef1fc3af$export$54048630ffcff79a)(form, data);
        this.server.login(data).then((user)=>{
            if (user) {
                this.app.setUser(user);
                window.location.hash = "/home";
            } else // Problems
            (0, $752d59648741b237$export$2e2bcd8739ae039).alert("Login failed");
        });
    }
    forgotPassword() {
        const form = this.elt().find(".login-form");
        const data = {};
        (0, $82cf23e1ef1fc3af$export$54048630ffcff79a)(form, data);
        if (data.username) this.server.sendReset(data.username).then(()=>{
            (0, $752d59648741b237$export$2e2bcd8739ae039).alert("An email with a password reset link has been sent to your email address.");
        });
        else (0, $752d59648741b237$export$2e2bcd8739ae039).alert("Put your username in the username field and try again.");
    }
}
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $340c9e737fc54ace$export$1582048ca8384970.classname, "click", ".login", function(that, event, elt) {
    event.preventDefault();
    that.login();
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $340c9e737fc54ace$export$1582048ca8384970.classname, "click", ".forgot-password", function(that, event, elt) {
    event.preventDefault();
    that.forgotPassword();
});






var $10cKx = parcelRequire("10cKx");
class $dd083c60ad74755d$export$2e2bcd8739ae039 extends (0, $f55c403e2549a503$export$2e2bcd8739ae039) {
    constructor(attachPoint, classname){
        super(classname);
        this.attachPoint = attachPoint;
    }
    updatePage(force) {
        if (!this.rendered() || force) {
            const elt = this.elt();
            const page = this.render();
            const body = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(this.attachPoint);
            body.empty().append(page);
            console.log("Page attach to DOM");
            return true;
        } else return false;
    }
}




var $d6bdd02f01bfd87f$export$2e2bcd8739ae039 = $d6bdd02f01bfd87f$var$template;
function $d6bdd02f01bfd87f$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $d6bdd02f01bfd87f$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $d6bdd02f01bfd87f$var$pug_classes(s, r) {
    return Array.isArray(s) ? $d6bdd02f01bfd87f$var$pug_classes_array(s, r) : s && "object" == typeof s ? $d6bdd02f01bfd87f$var$pug_classes_object(s) : s || "";
}
function $d6bdd02f01bfd87f$var$pug_classes_array(r, a) {
    for(var s, e = "", u = "", c = Array.isArray(a), g = 0; g < r.length; g++)(s = $d6bdd02f01bfd87f$var$pug_classes(r[g])) && (c && a[g] && (s = $d6bdd02f01bfd87f$var$pug_escape(s)), e = e + u + s, u = " ");
    return e;
}
function $d6bdd02f01bfd87f$var$pug_classes_object(r) {
    var a = "", n = "";
    for(var o in r)o && r[o] && $d6bdd02f01bfd87f$var$pug_has_own_property.call(r, o) && (a = a + n + o, n = " ");
    return a;
}
function $d6bdd02f01bfd87f$var$pug_escape(e) {
    var a = "" + e, t = $d6bdd02f01bfd87f$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $d6bdd02f01bfd87f$var$pug_has_own_property = Object.prototype.hasOwnProperty;
var $d6bdd02f01bfd87f$var$pug_match_html = /["&<>]/;
function $d6bdd02f01bfd87f$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(content1, functionLinks1, hashUrl1, sidebar1, user1) {
        pug_html = pug_html + '<div class="app">';
        if (sidebar1) {
            pug_html = pug_html + '<div class="header"><a class="hamburger app-sidebar__toggle" href="#"></a><div class="update-avail">update app</div></div><div class="sidebar"><img class="icon" src="images/icon.webp"><div class="update-avail clickable">update app</div>';
            if (functionLinks1) {
                pug_html = pug_html + "<ol>";
                var currentSection = undefined;
                (function() {
                    var $$obj = functionLinks1;
                    if ("number" == typeof $$obj.length) for(var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++){
                        var link = $$obj[pug_index0];
                        if (!link.roles || user1 && link.roles.indexOf(user1.role) >= 0) {
                            if (currentSection && link.section && currentSection != link.section) pug_html = pug_html + "<li><hr></li>";
                            currentSection = link.section;
                            pug_html = pug_html + "<li><a" + ($d6bdd02f01bfd87f$var$pug_attr("class", $d6bdd02f01bfd87f$var$pug_classes([
                                "function-link",
                                {
                                    "active-function": link.url == hashUrl1
                                }
                            ], [
                                false,
                                true
                            ]), false, true) + $d6bdd02f01bfd87f$var$pug_attr("href", `#${link.url}`, true, true)) + ">" + $d6bdd02f01bfd87f$var$pug_escape(null == (pug_interp = link.name) ? "" : pug_interp) + "</a></li>";
                        }
                    }
                    else {
                        var $$l = 0;
                        for(var pug_index0 in $$obj){
                            $$l++;
                            var link = $$obj[pug_index0];
                            if (!link.roles || user1 && link.roles.indexOf(user1.role) >= 0) {
                                if (currentSection && link.section && currentSection != link.section) pug_html = pug_html + "<li><hr></li>";
                                currentSection = link.section;
                                pug_html = pug_html + "<li><a" + ($d6bdd02f01bfd87f$var$pug_attr("class", $d6bdd02f01bfd87f$var$pug_classes([
                                    "function-link",
                                    {
                                        "active-function": link.url == hashUrl1
                                    }
                                ], [
                                    false,
                                    true
                                ]), false, true) + $d6bdd02f01bfd87f$var$pug_attr("href", `#${link.url}`, true, true)) + ">" + $d6bdd02f01bfd87f$var$pug_escape(null == (pug_interp = link.name) ? "" : pug_interp) + "</a></li>";
                            }
                        }
                    }
                }).call(this);
                pug_html = pug_html + "</ol>";
            }
            pug_html = pug_html + "</div>";
        }
        pug_html = pug_html + "<main" + $d6bdd02f01bfd87f$var$pug_attr("class", $d6bdd02f01bfd87f$var$pug_classes([
            "app-content",
            {
                "no-sidebar": !sidebar1
            }
        ], [
            false,
            true
        ]), false, true) + "><div>" + (null == (pug_interp = content1) ? "" : pug_interp) + "</div></main></div>";
    }).call(this, "content" in locals_for_with ? locals_for_with.content : typeof content !== "undefined" ? content : undefined, "functionLinks" in locals_for_with ? locals_for_with.functionLinks : typeof functionLinks !== "undefined" ? functionLinks : undefined, "hashUrl" in locals_for_with ? locals_for_with.hashUrl : typeof hashUrl !== "undefined" ? hashUrl : undefined, "sidebar" in locals_for_with ? locals_for_with.sidebar : typeof sidebar !== "undefined" ? sidebar : undefined, "user" in locals_for_with ? locals_for_with.user : typeof user !== "undefined" ? user : undefined);
    return pug_html;
}




var $10cKx = parcelRequire("10cKx");
function $2d7ae41bccdde491$export$2e2bcd8739ae039() {
    (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(document).on("keyup", function(event) {
        if (event.key === "Escape") (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(".js-modal").removeClass("active");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(document).on("click", ".js-modal-trigger", function(event) {
        const trigger = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(this);
        const origin = event.target;
        const sel = trigger.data("target");
        const modal = sel ? (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(sel) : trigger.closest(".js-modal");
        if (modal.length) {
            // If event came from within the modal itself,
            // and the trigger is outside the modal, ignore.
            // This could happen eg if the modal is located as a descendant of the trigger.
            const eventFromInside = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx))).contains(modal[0], origin);
            const triggerOutside = !(0, (/*@__PURE__*/$parcel$interopDefault($10cKx))).contains(modal[0], trigger[0]);
            if (eventFromInside && triggerOutside) return;
            event.stopPropagation();
            event.preventDefault();
        }
        modal.toggleClass("active");
    // --------------------------------
    });
}
function $2d7ae41bccdde491$export$825602dfec049146(elt) {
    elt.removeClass("active");
}



class $0dea84b3737d8e06$export$2e2bcd8739ae039 extends (0, $dd083c60ad74755d$export$2e2bcd8739ae039) {
    static #_ = this.classname = "talc-page";
    // --------------------
    constructor(app){
        super(".page", $0dea84b3737d8e06$export$2e2bcd8739ae039.classname);
        this.server = (0, $b306c6aaaa6be045$export$2e2bcd8739ae039).instance();
        this.sidebar = true;
        this.app = app;
        // Inits...
        (0, $2d7ae41bccdde491$export$2e2bcd8739ae039)();
    }
    setContent(content) {
        this.content = content;
        content.setParent(this);
    }
    setSidebarVisible(visible) {
        this.sidebar = visible;
    }
    render0() {
        const data = this.getRenderData();
        const out = this.pug(this.customTemplate || (0, $d6bdd02f01bfd87f$export$2e2bcd8739ae039), data);
        return out;
    }
    getRenderData() {
        let functionLinks = [];
        const user = this.app.getUser();
        const l = [
            {
                section: "Music",
                name: "About the project",
                url: "/project"
            },
            {
                section: "Music",
                name: "Library",
                url: "/library"
            },
            {
                section: "Music",
                name: "Fake book",
                url: "/fakebook"
            },
            {
                section: "Music",
                name: "Practichord",
                url: "/practichord"
            },
            {
                section: "Account",
                name: "Account",
                url: "/account"
            },
            /*
            {
                section: "Admin",
                name: "Users",
                url: "/users",
                roles: [ ROLE_ADMIN ],
            },

             */ {
                section: "Admin",
                name: "Reports",
                url: "/reports",
                roles: [
                    (0, $4f991c42613b920c$export$87cd0a661ace5c06)
                ]
            },
            {
                section: "Admin",
                name: "Upload",
                url: "/upload",
                roles: [
                    (0, $4f991c42613b920c$export$87cd0a661ace5c06)
                ]
            },
            {
                section: "Admin",
                name: "About",
                url: "/about",
                roles: [
                    (0, $4f991c42613b920c$export$87cd0a661ace5c06)
                ]
            }
        ];
        functionLinks = [
            ...functionLinks,
            ...l
        ];
        if (user) functionLinks.push({
            section: "Logout",
            name: "Log out",
            url: "/logout",
            roles: [
                user.role
            ]
        });
        else functionLinks.push({
            section: "Logout",
            name: "Log in",
            url: "/login"
        });
        const data = {
            content: this.content,
            functionLinks: functionLinks,
            user: this.app.getUser(),
            hashUrl: (0, $82cf23e1ef1fc3af$export$c755ec8933ea1108)(),
            sidebar: this.sidebar
        };
        return data;
    }
    notify(n) {
        super.notify(n);
        if (n instanceof $0dea84b3737d8e06$export$a987bf33bf60d3c0) {
            this.app.setUser(undefined);
            this.app.gotoUrl("/login");
        } else if (n instanceof $0dea84b3737d8e06$export$79dd4b1fcf658a20) this.app.gotoUrl("/");
    }
    toggleSidebar() {
        this.elt().find(".sidebar").toggleClass("expanded");
    }
    collapseSidebar() {
        this.elt().find(".sidebar").removeClass("expanded");
    }
}
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $0dea84b3737d8e06$export$2e2bcd8739ae039.classname, "click", ".app-sidebar__toggle", function(that, event, elt) {
    event.preventDefault();
    that.toggleSidebar();
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $0dea84b3737d8e06$export$2e2bcd8739ae039.classname, "click", ".app-content", function(that, event, elt) {
    that.collapseSidebar();
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $0dea84b3737d8e06$export$2e2bcd8739ae039.classname, "click", ".update-avail", function(that, event, elt) {
    window.location.reload();
});
class $0dea84b3737d8e06$export$a987bf33bf60d3c0 extends (0, $f55c403e2549a503$export$14834abbfce3b8cd) {
    constructor(){
        super("LogoutNotification");
    }
}
class $0dea84b3737d8e06$export$79dd4b1fcf658a20 extends (0, $f55c403e2549a503$export$14834abbfce3b8cd) {
    constructor(){
        super("goto-home");
    }
}


var $0b9b0dd1ac2bed82$export$2e2bcd8739ae039 = $0b9b0dd1ac2bed82$var$template;
function $0b9b0dd1ac2bed82$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    pug_html = pug_html + '<div class="function-body"><p>Really log out?</p><button class="logout">Yes, log out</button></div>';
    return pug_html;
}


class $8a60047beae3de8c$export$33d505abb8fae046 extends (0, $f55c403e2549a503$export$2e2bcd8739ae039) {
    static #_ = this.classname = "logout-view";
    constructor(){
        super($8a60047beae3de8c$export$33d505abb8fae046.classname);
    }
    render0() {
        const data = {};
        const out = this.pug((0, $0b9b0dd1ac2bed82$export$2e2bcd8739ae039), data);
        return out;
    }
    logout() {
        (0, $b306c6aaaa6be045$export$2e2bcd8739ae039).instance().logout().finally(()=>{
            const nav = new (0, $0dea84b3737d8e06$export$a987bf33bf60d3c0)();
            this.notify(nav);
        });
    }
}
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $8a60047beae3de8c$export$33d505abb8fae046.classname, "click", ".logout", function(that, event, elt) {
    event.preventDefault();
    that.logout();
});



var $340081ad1a2627d0$export$2e2bcd8739ae039 = $340081ad1a2627d0$var$template;
function $340081ad1a2627d0$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(form1) {
        pug_html = pug_html + "<div>" + (null == (pug_interp = form1) ? "" : pug_interp) + "</div>";
    }).call(this, "form" in locals_for_with ? locals_for_with.form : typeof form !== "undefined" ? form : undefined);
    return pug_html;
}




var $a3e616dd2b09861c$export$2e2bcd8739ae039 = $a3e616dd2b09861c$var$template;
function $a3e616dd2b09861c$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $a3e616dd2b09861c$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $a3e616dd2b09861c$var$pug_escape(e) {
    var a = "" + e, t = $a3e616dd2b09861c$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $a3e616dd2b09861c$var$pug_match_html = /["&<>]/;
function $a3e616dd2b09861c$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(family_name1, given_name1, signedUp1, verbose1) {
        pug_html = pug_html + "<div>";
        if (!signedUp1) {
            pug_html = pug_html + '<form class="signup-form with-validation">';
            if (verbose1) pug_html = pug_html + '<p>To access the paid features of this platform, create an account below\nand then head to the "Account" section for payment.</p>';
            pug_html = pug_html + "<input" + (' class="form-control" type="text" name="given_name"' + $a3e616dd2b09861c$var$pug_attr("value", given_name1, true, true) + ' placeholder="Given name"' + $a3e616dd2b09861c$var$pug_attr("autofocus", true, true, true) + " required") + "><input" + (' class="form-control" type="text" name="family_name"' + $a3e616dd2b09861c$var$pug_attr("value", family_name1, true, true) + ' placeholder="Family name" required') + '><input class="form-control" type="email" name="email" placeholder="Email" required><button class="signup form-control">Sign up</button></form>';
        } else if (verbose1) pug_html = pug_html + '<div class="post-signup"><p>An email has been sent to your email address with a link to verify your accoumt.</p><p>Click on that link to finish the signup process and access Tango a la Carta!</p></div>';
        pug_html = pug_html + "</div>";
    }).call(this, "family_name" in locals_for_with ? locals_for_with.family_name : typeof family_name !== "undefined" ? family_name : undefined, "given_name" in locals_for_with ? locals_for_with.given_name : typeof given_name !== "undefined" ? given_name : undefined, "signedUp" in locals_for_with ? locals_for_with.signedUp : typeof signedUp !== "undefined" ? signedUp : undefined, "verbose" in locals_for_with ? locals_for_with.verbose : typeof verbose !== "undefined" ? verbose : undefined);
    return pug_html;
}



class $03487221bbbf5d25$export$cc15cfe224a6a69b extends (0, $f55c403e2549a503$export$2e2bcd8739ae039) {
    static #_ = this.classname = "signup-form-view";
    constructor(verbose){
        super($03487221bbbf5d25$export$cc15cfe224a6a69b.classname);
        this.server = (0, $b306c6aaaa6be045$export$2e2bcd8739ae039).instance();
        this.signedUp = false;
        this.autologin = false;
        this.verbose = verbose;
    }
    render0() {
        const data = {
            signedUp: this.signedUp,
            verbose: this.verbose
        };
        const out = this.pug((0, $a3e616dd2b09861c$export$2e2bcd8739ae039), data);
        out.find(".with-validation").validate({
            rules: {
                given_name: "required",
                family_name: "required",
                email: "required"
            }
        });
        return out;
    }
    signup() {
        const form = this.elt().find(".signup-form");
        if (!form.valid()) return;
        const data = {
            auto_login: this.autologin
        };
        (0, $82cf23e1ef1fc3af$export$54048630ffcff79a)(form, data);
        this.server.signup(data).then((newUser)=>{
            this.signedUp = true;
            this.update();
            this.notify(new $03487221bbbf5d25$export$3dfe41357127b5d7(data.email, newUser));
        });
    }
}
class $03487221bbbf5d25$export$3dfe41357127b5d7 extends (0, $f55c403e2549a503$export$14834abbfce3b8cd) {
    constructor(email, newUser){
        super("SignupNotification");
        this.email = email;
        this.newUser = newUser;
    }
}
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $03487221bbbf5d25$export$cc15cfe224a6a69b.classname, "click", ".signup", function(that, event, elt) {
    event.preventDefault();
    that.signup();
});


class $c0d7094d25b12cf8$export$25f3896ea1e09820 extends (0, $f55c403e2549a503$export$2e2bcd8739ae039) {
    static #_ = this.classname = "signup-view";
    constructor(){
        super($c0d7094d25b12cf8$export$25f3896ea1e09820.classname);
        this.form = new (0, $03487221bbbf5d25$export$cc15cfe224a6a69b)(true);
    }
    render0() {
        const data = {
            form: this.form
        };
        const out = this.pug((0, $340081ad1a2627d0$export$2e2bcd8739ae039), data);
        return out;
    }
}


class $6b59c41a709d585a$export$86bb705faf90e12f extends (0, $4f991c42613b920c$export$5593b284a7b9fb1b) {
    constructor(app, username, password){
        super();
        this.v = new (0, $340c9e737fc54ace$export$1582048ca8384970)(app, username, password);
    }
    view() {
        return this.v;
    }
    url() {
        return `/login`;
    }
}
class $6b59c41a709d585a$export$80da5d51d48c4f6e extends (0, $4f991c42613b920c$export$5593b284a7b9fb1b) {
    constructor(app){
        super();
        this.v = new (0, $8a60047beae3de8c$export$33d505abb8fae046)();
    }
    view() {
        return this.v;
    }
    url() {
        return `/logout`;
    }
}
class $6b59c41a709d585a$export$ab82e13210c014d2 extends (0, $4f991c42613b920c$export$5593b284a7b9fb1b) {
    constructor(){
        super();
        this.v = new (0, $c0d7094d25b12cf8$export$25f3896ea1e09820)();
    }
    view() {
        return this.v;
    }
    url() {
        return `/signup`;
    }
}





var $fa3b4c4530b800e6$export$2e2bcd8739ae039 = $fa3b4c4530b800e6$var$template;
function $fa3b4c4530b800e6$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $fa3b4c4530b800e6$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $fa3b4c4530b800e6$var$pug_classes(s, r) {
    return Array.isArray(s) ? $fa3b4c4530b800e6$var$pug_classes_array(s, r) : s && "object" == typeof s ? $fa3b4c4530b800e6$var$pug_classes_object(s) : s || "";
}
function $fa3b4c4530b800e6$var$pug_classes_array(r, a) {
    for(var s, e = "", u = "", c = Array.isArray(a), g = 0; g < r.length; g++)(s = $fa3b4c4530b800e6$var$pug_classes(r[g])) && (c && a[g] && (s = $fa3b4c4530b800e6$var$pug_escape(s)), e = e + u + s, u = " ");
    return e;
}
function $fa3b4c4530b800e6$var$pug_classes_object(r) {
    var a = "", n = "";
    for(var o in r)o && r[o] && $fa3b4c4530b800e6$var$pug_has_own_property.call(r, o) && (a = a + n + o, n = " ");
    return a;
}
function $fa3b4c4530b800e6$var$pug_escape(e) {
    var a = "" + e, t = $fa3b4c4530b800e6$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $fa3b4c4530b800e6$var$pug_has_own_property = Object.prototype.hasOwnProperty;
var $fa3b4c4530b800e6$var$pug_match_html = /["&<>]/;
function $fa3b4c4530b800e6$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(edit_user1, roles1, users1) {
        pug_mixins["options"] = pug_interp = function(available, selected) {
            var block = this && this.block, attributes = this && this.attributes || {};
            (function() {
                var $$obj = available;
                if ("number" == typeof $$obj.length) for(var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++){
                    var v = $$obj[pug_index0];
                    pug_html = pug_html + "<option" + ($fa3b4c4530b800e6$var$pug_attr("value", v, true, true) + $fa3b4c4530b800e6$var$pug_attr("selected", v == selected, true, true)) + ">" + $fa3b4c4530b800e6$var$pug_escape(null == (pug_interp = v) ? "" : pug_interp) + "</option>";
                }
                else {
                    var $$l = 0;
                    for(var pug_index0 in $$obj){
                        $$l++;
                        var v = $$obj[pug_index0];
                        pug_html = pug_html + "<option" + ($fa3b4c4530b800e6$var$pug_attr("value", v, true, true) + $fa3b4c4530b800e6$var$pug_attr("selected", v == selected, true, true)) + ">" + $fa3b4c4530b800e6$var$pug_escape(null == (pug_interp = v) ? "" : pug_interp) + "</option>";
                    }
                }
            }).call(this);
        };
        pug_html = pug_html + '<div class="function-body">';
        if (users1) {
            pug_html = pug_html + '<div><table class="users"><thead><tr><th>Username</th><th>Role</th><th></th><th></th></tr><tbody></tbody>';
            (function() {
                var $$obj = users1;
                if ("number" == typeof $$obj.length) for(var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++){
                    var user = $$obj[pug_index3];
                    pug_html = pug_html + "<tr><td>" + $fa3b4c4530b800e6$var$pug_escape(null == (pug_interp = user.username) ? "" : pug_interp) + "</td><td>" + $fa3b4c4530b800e6$var$pug_escape(null == (pug_interp = user.role) ? "" : pug_interp) + "</td><td><a" + (' class="edit" href="#"' + $fa3b4c4530b800e6$var$pug_attr("data-user", user, true, true)) + ">edit</a></td></tr>";
                }
                else {
                    var $$l = 0;
                    for(var pug_index3 in $$obj){
                        $$l++;
                        var user = $$obj[pug_index3];
                        pug_html = pug_html + "<tr><td>" + $fa3b4c4530b800e6$var$pug_escape(null == (pug_interp = user.username) ? "" : pug_interp) + "</td><td>" + $fa3b4c4530b800e6$var$pug_escape(null == (pug_interp = user.role) ? "" : pug_interp) + "</td><td><a" + (' class="edit" href="#"' + $fa3b4c4530b800e6$var$pug_attr("data-user", user, true, true)) + ">edit</a></td></tr>";
                    }
                }
            }).call(this);
            pug_html = pug_html + '</thead></table><button class="add-user">Add user</button><form' + ($fa3b4c4530b800e6$var$pug_attr("class", $fa3b4c4530b800e6$var$pug_classes([
                "editor",
                "with-validation",
                {
                    "display-none": edit_user1 == null
                }
            ], [
                false,
                false,
                true
            ]), false, true) + ' autocomplete="off"') + '><hr><div class="fields"><input' + (' class="form-control" name="username"' + $fa3b4c4530b800e6$var$pug_attr("value", edit_user1 && edit_user1.username, true, true) + ' placeholder="Username"') + '><input class="form-control" type="password" name="password" placeholder="Password"><input class="form-control" type="password" name="password2" placeholder="Repeat password"><select class="form-control" name="role">';
            pug_mixins["options"](roles1, edit_user1 && edit_user1.role);
            pug_html = pug_html + '</select></div><button class="save-user">Save</button></form></div>';
        }
        pug_html = pug_html + "</div>";
    }).call(this, "edit_user" in locals_for_with ? locals_for_with.edit_user : typeof edit_user !== "undefined" ? edit_user : undefined, "roles" in locals_for_with ? locals_for_with.roles : typeof roles !== "undefined" ? roles : undefined, "users" in locals_for_with ? locals_for_with.users : typeof users !== "undefined" ? users : undefined);
    return pug_html;
}



var $10cKx = parcelRequire("10cKx");



class $a8cc242c7ae6f42d$export$a91f3ad8dde8adcb extends (0, $f55c403e2549a503$export$2e2bcd8739ae039) {
    static #_ = this.classname = "users-view";
    constructor(){
        super($a8cc242c7ae6f42d$export$a91f3ad8dde8adcb.classname);
        this.server = (0, $b306c6aaaa6be045$export$2e2bcd8739ae039).instance();
        this.new_user = true;
        this.refresh();
    }
    refresh() {
        const status_ = this.server.getUsers();
        status_.then((users)=>{
            this.users = users;
            this.update();
        });
    }
    render0() {
        const data = {
            users: this.users,
            edit_user: this.edit_user,
            new_user: this.new_user,
            roles: (0, $4f991c42613b920c$export$8e77a375f9a5908e)
        };
        const out = this.pug((0, $fa3b4c4530b800e6$export$2e2bcd8739ae039), data);
        out.find(".with-validation").validate({
            rules: {
                "username": "required"
            }
        });
        return out;
    }
    editUser(user) {
        this.new_user = !user;
        this.edit_user = user || {};
        this.update();
    }
    saveUser() {
        const form = this.elt().find("form.editor");
        const user = {};
        (0, $82cf23e1ef1fc3af$export$54048630ffcff79a)(form, user);
        const save_ = this.server.saveUser(user);
        // @ts-ignore
        if ((user["password"] || user["password2"]) && user["password"] != user["password2"]) {
            (0, $752d59648741b237$export$2e2bcd8739ae039).alert("Passswords must match");
            return;
        }
        save_.then((users)=>{
            this.users = users;
            this.new_user = false;
            this.edit_user = undefined;
            this.update();
        });
    }
}
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $a8cc242c7ae6f42d$export$a91f3ad8dde8adcb.classname, "click", ".add-user", function(that, event, elt) {
    event.preventDefault();
    that.editUser(undefined);
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $a8cc242c7ae6f42d$export$a91f3ad8dde8adcb.classname, "click", ".edit", function(that, event, elt) {
    event.preventDefault();
    const user = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(elt).data("user");
    that.editUser(user);
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $a8cc242c7ae6f42d$export$a91f3ad8dde8adcb.classname, "click", ".save-user", function(that, event, elt) {
    event.preventDefault();
    that.saveUser();
});


class $64ec5918e5fbfcc4$export$c362ea7fa71b0b0b extends (0, $4f991c42613b920c$export$5593b284a7b9fb1b) {
    constructor(){
        super();
        this.v = new (0, $a8cc242c7ae6f42d$export$a91f3ad8dde8adcb)();
    }
    view() {
        return this.v;
    }
    url() {
        return `/users`;
    }
}





var $7ec9acb48f80e5f2$export$2e2bcd8739ae039 = $7ec9acb48f80e5f2$var$template;
function $7ec9acb48f80e5f2$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(paymentElementView1) {
        pug_html = pug_html + '<div><h1>Online payment via Stripe</h1><a class="refresh clickable">Clear</a><form class="amount-form with-validation"><input class="form-control" name="amount" placeholder="Amount ($AUD)" type="number"><input class="form-control" name="description" placeholder="Description (optional)"><button class="form-control create-payment-intent">Create payment request</button></form><div>' + (null == (pug_interp = paymentElementView1) ? "" : pug_interp) + "</div></div>";
    }).call(this, "paymentElementView" in locals_for_with ? locals_for_with.paymentElementView : typeof paymentElementView !== "undefined" ? paymentElementView : undefined);
    return pug_html;
}




var $379175fb97ec16da$export$2e2bcd8739ae039 = $379175fb97ec16da$var$template;
function $379175fb97ec16da$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $379175fb97ec16da$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $379175fb97ec16da$var$pug_escape(e) {
    var a = "" + e, t = $379175fb97ec16da$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $379175fb97ec16da$var$pug_match_html = /["&<>]/;
function $379175fb97ec16da$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(submit_message1, uuid1) {
        pug_html = pug_html + '<div><form class="payment-form"><div style="max-width: 500px"><div style="float: right">Total to charge:\n<span class="amount"></span></div><span class="description"></span></div><div class="payment-element-container"><div' + $379175fb97ec16da$var$pug_attr("id", `${uuid1}-payment-element`, true, true) + '></div></div><button class="form-control submit-payment" disabled>' + $379175fb97ec16da$var$pug_escape(null == (pug_interp = submit_message1) ? "" : pug_interp) + '</button><div class="status"></div><div class="message"></div></form></div>';
    }).call(this, "submit_message" in locals_for_with ? locals_for_with.submit_message : typeof submit_message !== "undefined" ? submit_message : undefined, "uuid" in locals_for_with ? locals_for_with.uuid : typeof uuid !== "undefined" ? uuid : undefined);
    return pug_html;
}




class $64b74dc488fa391c$export$b8dbac763e5ae10a extends (0, $f55c403e2549a503$export$2e2bcd8739ae039) {
    static #_ = this.classname = "payment-element-view";
    constructor(){
        super($64b74dc488fa391c$export$b8dbac763e5ae10a.classname);
        this.server = (0, $b306c6aaaa6be045$export$2e2bcd8739ae039).instance();
        this.stripe = undefined;
        this.elements = undefined;
        this.paymentElement = undefined;
        this.submit_message = "Submit payment";
        this.promise = this.newPromise();
    }
    getPromise() {
        return this.promise;
    }
    newPromise() {
        return this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    refresh() {
        this.clientSecret = undefined;
        this.stripe = undefined;
        this.elements = undefined;
        this.paymentElement = undefined;
        this.update();
    }
    createIntent(euros, description) {
        const cents = parseInt("" + euros * 100);
        const intent_ = this.server.createPaymentIntent(cents, description);
        const params_ = this.server.runtimeParams_;
        Promise.all([
            intent_,
            params_
        ]).then(([secret, params])=>{
            this.elt().find(".amount").text(euros + "\u20AC");
            description && this.elt().find(".description").text(description);
            this.elt().find("input[name='amount']").prop("disabled", true);
            const payment_form = this.elt().find("form.payment-form");
            payment_form.show();
            this.clientSecret = secret.toString();
            const publishableKey = params["talc.client.stripe.publishable_key"];
            // @ts-ignore
            this.stripe = new Stripe(publishableKey);
            const options = {
                clientSecret: this.clientSecret
            };
            this.elements = this.stripe.elements(options);
            this.paymentElement = this.elements.create("card", {
                hidePostalCode: true,
                disableLink: true
            });
            const uuid = this.getUuid();
            const id = `#${uuid}-payment-element`;
            const elt = this.elt().find(id)[0];
            if (this.paymentElement) {
                this.paymentElement.mount(elt);
                this.paymentElement.on("change", (evt)=>{
                    this.paymentEvent(evt);
                });
            }
        });
        return intent_;
    }
    paymentEvent(evt) {
        const complete = evt.complete;
        this.elt().find(".submit-payment").prop("disabled", !complete);
    }
    render0() {
        const data = {
            submit_message: this.submit_message
        };
        const out = this.pug((0, $379175fb97ec16da$export$2e2bcd8739ae039), data);
        out.find(".with-validation").validate({
            rules: {
                "amount": {
                    "required": true,
                    "number": true
                }
            }
        });
        return out;
    }
    pay() {
        this.elt().find(".status").text("");
        this.elt().find(".message").text("");
        const pop = (0, $a187c2fe64638fd7$export$7f7cbe89f1eacd2).pushSpinner();
        const try_ = this.stripe.confirmCardPayment(this.clientSecret, {
            payment_method: {
                card: this.paymentElement
            }
        });
        try_.then((x)=>{
            console.log("TRY", x);
            const p = x.paymentIntent;
            const status = p && p.status;
            const error = x.error;
            const msg = error && error.message;
            status && this.elt().find(".status").text(status);
            msg && this.elt().find(".message").text(msg);
            if (error) this.reject && this.reject(error);
            else {
                this.elt().find(".payment-element-container").hide();
                this.elt().find(".submit-payment").hide();
                this.resolve && this.resolve(x);
            }
        });
        try_.catch((err)=>{
            console.log("ERR", err);
            this.elt().find(".message").text(err);
            (0, $82cf23e1ef1fc3af$export$3f99968195accfaf)(this.elt().find(".message"));
            this.reject && this.reject(err);
        });
        try_.finally(()=>{
            pop();
        });
        return try_;
    }
}
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $64b74dc488fa391c$export$b8dbac763e5ae10a.classname, "click", "button.submit-payment", function(that, event, elt) {
    event.preventDefault();
    that.pay();
});


class $ad96d19fb5ef8efe$export$180763f11fee4f88 extends (0, $f55c403e2549a503$export$2e2bcd8739ae039) {
    static #_ = this.classname = "payment-view";
    constructor(){
        super($ad96d19fb5ef8efe$export$180763f11fee4f88.classname);
        this.server = (0, $b306c6aaaa6be045$export$2e2bcd8739ae039).instance();
        this.paymentElementView = new (0, $64b74dc488fa391c$export$b8dbac763e5ae10a)();
    }
    refresh() {
        this.update();
        this.paymentElementView.refresh();
    }
    createIntent() {
        const valid = this.elt().find("form.with-validation").valid();
        if (!valid) return;
        const amt = this.elt().find("input[name='amount']").val();
        if (!amt) return;
        let dollars = Number.parseFloat(amt);
        this.elt().find("input[name='amount']").val(dollars);
        const cents = parseInt("" + dollars * 100);
        dollars = cents / 100;
        const description = this.elt().find("input[name='description']").val() || undefined;
        this.paymentElementView.createIntent(dollars, description);
        this.elt().find(".amount-form").hide();
    }
    render0() {
        const data = {
            paymentElementView: this.paymentElementView
        };
        const out = this.pug((0, $7ec9acb48f80e5f2$export$2e2bcd8739ae039), data);
        out.find(".with-validation").validate({
            rules: {
                "amount": {
                    "required": true,
                    "number": true
                }
            }
        });
        return out;
    }
}
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $ad96d19fb5ef8efe$export$180763f11fee4f88.classname, "submit", ".amount-form", function(that, event, elt) {
    event.preventDefault();
    that.createIntent();
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $ad96d19fb5ef8efe$export$180763f11fee4f88.classname, "click", ".refresh", function(that, event, elt) {
    event.preventDefault();
    that.refresh();
});


class $5cf8a5c9dfa17926$export$e46142227cb75e03 extends (0, $4f991c42613b920c$export$5593b284a7b9fb1b) {
    constructor(){
        super();
        this.v = new (0, $ad96d19fb5ef8efe$export$180763f11fee4f88)();
    }
    view() {
        return this.v;
    }
    url() {
        return `/payment`;
    }
}





var $85fb7da850074534$export$2e2bcd8739ae039 = $85fb7da850074534$var$template;
function $85fb7da850074534$var$pug_escape(e) {
    var a = "" + e, t = $85fb7da850074534$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $85fb7da850074534$var$pug_match_html = /["&<>]/;
function $85fb7da850074534$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(admin1, baseUrl1, clientVersion1, serverVersion1) {
        pug_html = pug_html + '<div class="function-body"><div class="tile about"><div class="tile-body"><table class="table table-bordered"><tbody><tr class="noprint"><th>Client</th><td>' + $85fb7da850074534$var$pug_escape(null == (pug_interp = clientVersion1.version) ? "" : pug_interp) + " / " + $85fb7da850074534$var$pug_escape(null == (pug_interp = clientVersion1.branch) ? "" : pug_interp) + " / " + $85fb7da850074534$var$pug_escape(null == (pug_interp = clientVersion1.commit) ? "" : pug_interp) + "</td></tr>";
        if (serverVersion1) pug_html = pug_html + '<tr class="noprint"><th>Server</th><td>' + $85fb7da850074534$var$pug_escape(null == (pug_interp = serverVersion1.version) ? "" : pug_interp) + " / " + $85fb7da850074534$var$pug_escape(null == (pug_interp = serverVersion1.branch) ? "" : pug_interp) + " / " + $85fb7da850074534$var$pug_escape(null == (pug_interp = serverVersion1.commit) ? "" : pug_interp) + "</td></tr>";
        pug_html = pug_html + "<tr><th>Server URL</th><td>" + $85fb7da850074534$var$pug_escape(null == (pug_interp = baseUrl1) ? "" : pug_interp) + "</td></tr></tbody></table>";
        if (admin1) pug_html = pug_html + '<ul class="noprint"><li><a href="api/params" target="_blank">View runtime parameters</a></li><li><a href="api/changelog" target="_blank">View changelog</a></li></ul>';
        pug_html = pug_html + "</div></div></div>";
    }).call(this, "admin" in locals_for_with ? locals_for_with.admin : typeof admin !== "undefined" ? admin : undefined, "baseUrl" in locals_for_with ? locals_for_with.baseUrl : typeof baseUrl !== "undefined" ? baseUrl : undefined, "clientVersion" in locals_for_with ? locals_for_with.clientVersion : typeof clientVersion !== "undefined" ? clientVersion : undefined, "serverVersion" in locals_for_with ? locals_for_with.serverVersion : typeof serverVersion !== "undefined" ? serverVersion : undefined);
    return pug_html;
}



var $10cKx = parcelRequire("10cKx");
var $5f46435f1db83a7e$export$185802fd694ee1f5;
var $5f46435f1db83a7e$export$f87f6982d1fd4f81;
var $5f46435f1db83a7e$export$723e4939e5a27c8;
// only svg for now.
var $5f46435f1db83a7e$export$f84e8e69fd4488a5;
var $522cdb5011344644$exports = {};
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
$522cdb5011344644$exports = function() {
    return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};


/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $8ea83a9eb926b32b$export$185802fd694ee1f5;
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $43d5deeb6d91f10d$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $43d5deeb6d91f10d$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $43d5deeb6d91f10d$export$ed1d66da50968976;
var $43d5deeb6d91f10d$export$6733b14783f975c2;
var $43d5deeb6d91f10d$export$ce5b1274f8597fa0;
var $43d5deeb6d91f10d$export$43dd553ecded716d;
let $43d5deeb6d91f10d$var$toSJISFunction;
const $43d5deeb6d91f10d$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$43d5deeb6d91f10d$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$43d5deeb6d91f10d$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $43d5deeb6d91f10d$var$CODEWORDS_COUNT[version];
};
$43d5deeb6d91f10d$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$43d5deeb6d91f10d$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== "function") throw new Error('"toSJISFunc" is not a valid function.');
    $43d5deeb6d91f10d$var$toSJISFunction = f;
};
$43d5deeb6d91f10d$export$ce5b1274f8597fa0 = function() {
    return typeof $43d5deeb6d91f10d$var$toSJISFunction !== "undefined";
};
$43d5deeb6d91f10d$export$43dd553ecded716d = function toSJIS(kanji) {
    return $43d5deeb6d91f10d$var$toSJISFunction(kanji);
};


var $a5d1389200d634d1$export$61196ced6d74a310;
var $a5d1389200d634d1$export$3a1a48c8f6ef640e;
var $a5d1389200d634d1$export$3722cfe417b6ed86;
var $a5d1389200d634d1$export$7f8ddf7c7c20b3cd;
var $a5d1389200d634d1$export$1ea939691cdc45b8;
var $a5d1389200d634d1$export$6788812c4e6611e6;
$a5d1389200d634d1$export$61196ced6d74a310 = {
    bit: 1
};
$a5d1389200d634d1$export$3a1a48c8f6ef640e = {
    bit: 0
};
$a5d1389200d634d1$export$3722cfe417b6ed86 = {
    bit: 3
};
$a5d1389200d634d1$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $a5d1389200d634d1$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "l":
        case "low":
            return $a5d1389200d634d1$export$61196ced6d74a310;
        case "m":
        case "medium":
            return $a5d1389200d634d1$export$3a1a48c8f6ef640e;
        case "q":
        case "quartile":
            return $a5d1389200d634d1$export$3722cfe417b6ed86;
        case "h":
        case "high":
            return $a5d1389200d634d1$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error("Unknown EC Level: " + string);
    }
}
$a5d1389200d634d1$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
};
$a5d1389200d634d1$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($a5d1389200d634d1$export$1ea939691cdc45b8(value)) return value;
    try {
        return $a5d1389200d634d1$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};


var $5cc02d912059cc44$exports = {};
function $5cc02d912059cc44$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$5cc02d912059cc44$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$5cc02d912059cc44$exports = $5cc02d912059cc44$var$BitBuffer;


var $805902ebf0943615$exports = {};
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $805902ebf0943615$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $805902ebf0943615$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $805902ebf0943615$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $805902ebf0943615$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $805902ebf0943615$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
$805902ebf0943615$exports = $805902ebf0943615$var$BitMatrix;


/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $b11cc3fe51a56c63$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $b11cc3fe51a56c63$export$c39457c570f2b189;

var $b11cc3fe51a56c63$require$getSymbolSize = $43d5deeb6d91f10d$export$8d4a06d3facd414b;
$b11cc3fe51a56c63$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $b11cc3fe51a56c63$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$b11cc3fe51a56c63$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $b11cc3fe51a56c63$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};


/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $ec2073a085b63ae6$export$c39457c570f2b189;

var $ec2073a085b63ae6$require$getSymbolSize = $43d5deeb6d91f10d$export$8d4a06d3facd414b;
const $ec2073a085b63ae6$var$FINDER_PATTERN_SIZE = 7;
$ec2073a085b63ae6$export$c39457c570f2b189 = function getPositions(version) {
    const size = $ec2073a085b63ae6$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $ec2073a085b63ae6$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $ec2073a085b63ae6$var$FINDER_PATTERN_SIZE
        ]
    ];
};


/**
 * Data mask pattern reference
 * @type {Object}
 */ var $bf0950684611e804$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $bf0950684611e804$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $bf0950684611e804$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $bf0950684611e804$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $bf0950684611e804$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $bf0950684611e804$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $bf0950684611e804$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $bf0950684611e804$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $bf0950684611e804$export$fe9625aaceb0e563;
$bf0950684611e804$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $bf0950684611e804$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$bf0950684611e804$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$bf0950684611e804$export$6788812c4e6611e6 = function from(value) {
    return $bf0950684611e804$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$bf0950684611e804$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $bf0950684611e804$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $bf0950684611e804$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $bf0950684611e804$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $bf0950684611e804$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$bf0950684611e804$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $bf0950684611e804$var$PenaltyScores.N2;
};
$bf0950684611e804$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $bf0950684611e804$var$PenaltyScores.N3;
};
$bf0950684611e804$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $bf0950684611e804$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $bf0950684611e804$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $bf0950684611e804$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $bf0950684611e804$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $bf0950684611e804$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $bf0950684611e804$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $bf0950684611e804$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $bf0950684611e804$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $bf0950684611e804$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $bf0950684611e804$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error("bad maskPattern:" + maskPattern);
    }
}
$bf0950684611e804$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $bf0950684611e804$var$getMaskAt(pattern, row, col));
    }
};
$bf0950684611e804$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($bf0950684611e804$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $bf0950684611e804$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $bf0950684611e804$export$a5fd3a02c14d0b3e(data) + $bf0950684611e804$export$9a9385107a518e46(data) + $bf0950684611e804$export$ade754353f0dc75e(data) + $bf0950684611e804$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $bf0950684611e804$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};


/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $b5dfbcbb2fc7a5a4$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $b5dfbcbb2fc7a5a4$export$683d1b3e8a1a8438;

const $b5dfbcbb2fc7a5a4$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $b5dfbcbb2fc7a5a4$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$b5dfbcbb2fc7a5a4$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $a5d1389200d634d1$export$61196ced6d74a310:
            return $b5dfbcbb2fc7a5a4$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $a5d1389200d634d1$export$3a1a48c8f6ef640e:
            return $b5dfbcbb2fc7a5a4$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $a5d1389200d634d1$export$3722cfe417b6ed86:
            return $b5dfbcbb2fc7a5a4$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $a5d1389200d634d1$export$7f8ddf7c7c20b3cd:
            return $b5dfbcbb2fc7a5a4$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$b5dfbcbb2fc7a5a4$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $a5d1389200d634d1$export$61196ced6d74a310:
            return $b5dfbcbb2fc7a5a4$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $a5d1389200d634d1$export$3a1a48c8f6ef640e:
            return $b5dfbcbb2fc7a5a4$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $a5d1389200d634d1$export$3722cfe417b6ed86:
            return $b5dfbcbb2fc7a5a4$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $a5d1389200d634d1$export$7f8ddf7c7c20b3cd:
            return $b5dfbcbb2fc7a5a4$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};


var $a24e80323c1b2444$exports = {};
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $279580f9d1204353$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $279580f9d1204353$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $279580f9d1204353$export$7b8be06a973a9d05;
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $5d913459492ccd0e$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $5d913459492ccd0e$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $5d913459492ccd0e$export$6e3a27864ab166fe;
const $5d913459492ccd0e$var$EXP_TABLE = new Uint8Array(512);
const $5d913459492ccd0e$var$LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $5d913459492ccd0e$var$EXP_TABLE[i] = x;
        $5d913459492ccd0e$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$5d913459492ccd0e$var$EXP_TABLE[i] = $5d913459492ccd0e$var$EXP_TABLE[i - 255];
})();
$5d913459492ccd0e$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return $5d913459492ccd0e$var$LOG_TABLE[n];
};
$5d913459492ccd0e$export$b310ec824aaee37f = function exp(n) {
    return $5d913459492ccd0e$var$EXP_TABLE[n];
};
$5d913459492ccd0e$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $5d913459492ccd0e$var$EXP_TABLE[$5d913459492ccd0e$var$LOG_TABLE[x] + $5d913459492ccd0e$var$LOG_TABLE[y]];
};


$279580f9d1204353$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $5d913459492ccd0e$export$6e3a27864ab166fe(p1[i], p2[j]);
    return coeff;
};
$279580f9d1204353$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $5d913459492ccd0e$export$6e3a27864ab166fe(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$279580f9d1204353$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $279580f9d1204353$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $5d913459492ccd0e$export$b310ec824aaee37f(i)
    ]));
    return poly;
};


function $a24e80323c1b2444$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $a24e80323c1b2444$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $279580f9d1204353$export$7b8be06a973a9d05(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $a24e80323c1b2444$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $279580f9d1204353$export$842a2cf37af977e1(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
$a24e80323c1b2444$exports = $a24e80323c1b2444$var$ReedSolomonEncoder;


/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $d03a5392c6eaafbc$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $d03a5392c6eaafbc$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $d03a5392c6eaafbc$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $d03a5392c6eaafbc$export$eee5438974ef6f0e;



/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $62017f662f4f550f$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $62017f662f4f550f$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $62017f662f4f550f$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $62017f662f4f550f$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $62017f662f4f550f$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $62017f662f4f550f$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $62017f662f4f550f$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $62017f662f4f550f$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $62017f662f4f550f$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $62017f662f4f550f$export$6788812c4e6611e6;
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $22af29bd735da6fb$export$1ea939691cdc45b8;
$22af29bd735da6fb$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};


var $dc713f33f2c9be8b$export$a4d452c2363c8e12;
var $dc713f33f2c9be8b$export$9df7c29d562bab83;
var $dc713f33f2c9be8b$export$8f4bf8f7eb581284;
var $dc713f33f2c9be8b$export$4d318981b5a83836;
var $dc713f33f2c9be8b$export$376a9ed239d6c1c8;
var $dc713f33f2c9be8b$export$175f16aef75a4569;
var $dc713f33f2c9be8b$export$50b7f9bf92c74274;
var $dc713f33f2c9be8b$export$4ba5f52893b4ac97;
const $dc713f33f2c9be8b$var$numeric = "[0-9]+";
const $dc713f33f2c9be8b$var$alphanumeric = "[A-Z $%*+\\-./:]+";
let $dc713f33f2c9be8b$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$dc713f33f2c9be8b$var$kanji = $dc713f33f2c9be8b$var$kanji.replace(/u/g, "\\u");
const $dc713f33f2c9be8b$var$byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + $dc713f33f2c9be8b$var$kanji + ")(?:.|[\r\n]))+";
$dc713f33f2c9be8b$export$a4d452c2363c8e12 = new RegExp($dc713f33f2c9be8b$var$kanji, "g");
$dc713f33f2c9be8b$export$9df7c29d562bab83 = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
$dc713f33f2c9be8b$export$8f4bf8f7eb581284 = new RegExp($dc713f33f2c9be8b$var$byte, "g");
$dc713f33f2c9be8b$export$4d318981b5a83836 = new RegExp($dc713f33f2c9be8b$var$numeric, "g");
$dc713f33f2c9be8b$export$376a9ed239d6c1c8 = new RegExp($dc713f33f2c9be8b$var$alphanumeric, "g");
const $dc713f33f2c9be8b$var$TEST_KANJI = new RegExp("^" + $dc713f33f2c9be8b$var$kanji + "$");
const $dc713f33f2c9be8b$var$TEST_NUMERIC = new RegExp("^" + $dc713f33f2c9be8b$var$numeric + "$");
const $dc713f33f2c9be8b$var$TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
$dc713f33f2c9be8b$export$175f16aef75a4569 = function testKanji(str) {
    return $dc713f33f2c9be8b$var$TEST_KANJI.test(str);
};
$dc713f33f2c9be8b$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $dc713f33f2c9be8b$var$TEST_NUMERIC.test(str);
};
$dc713f33f2c9be8b$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $dc713f33f2c9be8b$var$TEST_ALPHANUMERIC.test(str);
};


$62017f662f4f550f$export$4d318981b5a83836 = {
    id: "Numeric",
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$62017f662f4f550f$export$376a9ed239d6c1c8 = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$62017f662f4f550f$export$8f4bf8f7eb581284 = {
    id: "Byte",
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$62017f662f4f550f$export$a4d452c2363c8e12 = {
    id: "Kanji",
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$62017f662f4f550f$export$bb410559a65d3418 = {
    bit: -1
};
$62017f662f4f550f$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
    if (!$22af29bd735da6fb$export$1ea939691cdc45b8(version)) throw new Error("Invalid version: " + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$62017f662f4f550f$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($dc713f33f2c9be8b$export$50b7f9bf92c74274(dataStr)) return $62017f662f4f550f$export$4d318981b5a83836;
    else if ($dc713f33f2c9be8b$export$4ba5f52893b4ac97(dataStr)) return $62017f662f4f550f$export$376a9ed239d6c1c8;
    else if ($dc713f33f2c9be8b$export$175f16aef75a4569(dataStr)) return $62017f662f4f550f$export$a4d452c2363c8e12;
    else return $62017f662f4f550f$export$8f4bf8f7eb581284;
};
$62017f662f4f550f$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error("Invalid mode");
};
$62017f662f4f550f$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $62017f662f4f550f$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "numeric":
            return $62017f662f4f550f$export$4d318981b5a83836;
        case "alphanumeric":
            return $62017f662f4f550f$export$376a9ed239d6c1c8;
        case "kanji":
            return $62017f662f4f550f$export$a4d452c2363c8e12;
        case "byte":
            return $62017f662f4f550f$export$8f4bf8f7eb581284;
        default:
            throw new Error("Unknown mode: " + string);
    }
}
$62017f662f4f550f$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($62017f662f4f550f$export$1ea939691cdc45b8(value)) return value;
    try {
        return $62017f662f4f550f$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};



// Generator polynomial used to encode version information
const $d03a5392c6eaafbc$var$G18 = 7973;
const $d03a5392c6eaafbc$var$G18_BCH = $43d5deeb6d91f10d$export$ed1d66da50968976($d03a5392c6eaafbc$var$G18);
function $d03a5392c6eaafbc$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $d03a5392c6eaafbc$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $d03a5392c6eaafbc$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $62017f662f4f550f$export$e79764af6ffaeb8d(mode, version) + 4;
}
function $d03a5392c6eaafbc$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $d03a5392c6eaafbc$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $d03a5392c6eaafbc$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $d03a5392c6eaafbc$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $d03a5392c6eaafbc$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $62017f662f4f550f$export$bb410559a65d3418)) return currentVersion;
    }
    return undefined;
}
$d03a5392c6eaafbc$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($22af29bd735da6fb$export$1ea939691cdc45b8(value)) return parseInt(value, 10);
    return defaultValue;
};
$d03a5392c6eaafbc$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$22af29bd735da6fb$export$1ea939691cdc45b8(version)) throw new Error("Invalid QR Code version");
    // Use Byte mode as default
    if (typeof mode === "undefined") mode = $62017f662f4f550f$export$8f4bf8f7eb581284;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $43d5deeb6d91f10d$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $b5dfbcbb2fc7a5a4$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $62017f662f4f550f$export$bb410559a65d3418) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $d03a5392c6eaafbc$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $62017f662f4f550f$export$4d318981b5a83836:
            return Math.floor(usableBits / 10 * 3);
        case $62017f662f4f550f$export$376a9ed239d6c1c8:
            return Math.floor(usableBits / 11 * 2);
        case $62017f662f4f550f$export$a4d452c2363c8e12:
            return Math.floor(usableBits / 13);
        case $62017f662f4f550f$export$8f4bf8f7eb581284:
        default:
            return Math.floor(usableBits / 8);
    }
};
$d03a5392c6eaafbc$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $a5d1389200d634d1$export$6788812c4e6611e6(errorCorrectionLevel, $a5d1389200d634d1$export$3a1a48c8f6ef640e);
    if (Array.isArray(data)) {
        if (data.length > 1) return $d03a5392c6eaafbc$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $d03a5392c6eaafbc$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$d03a5392c6eaafbc$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$22af29bd735da6fb$export$1ea939691cdc45b8(version) || version < 7) throw new Error("Invalid QR Code version");
    let d = version << 12;
    while($43d5deeb6d91f10d$export$ed1d66da50968976(d) - $d03a5392c6eaafbc$var$G18_BCH >= 0)d ^= $d03a5392c6eaafbc$var$G18 << $43d5deeb6d91f10d$export$ed1d66da50968976(d) - $d03a5392c6eaafbc$var$G18_BCH;
    return version << 12 | d;
};


/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $02d13488c4d2936a$export$eee5438974ef6f0e;

const $02d13488c4d2936a$var$G15 = 1335;
const $02d13488c4d2936a$var$G15_MASK = 21522;
const $02d13488c4d2936a$var$G15_BCH = $43d5deeb6d91f10d$export$ed1d66da50968976($02d13488c4d2936a$var$G15);
$02d13488c4d2936a$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($43d5deeb6d91f10d$export$ed1d66da50968976(d) - $02d13488c4d2936a$var$G15_BCH >= 0)d ^= $02d13488c4d2936a$var$G15 << $43d5deeb6d91f10d$export$ed1d66da50968976(d) - $02d13488c4d2936a$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $02d13488c4d2936a$var$G15_MASK;
};



/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $2698c09f8304755d$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $2698c09f8304755d$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $2698c09f8304755d$export$89ab1afb9839589b;

var $5722bfb9aa740cf6$exports = {};

function $5722bfb9aa740cf6$var$NumericData(data) {
    this.mode = $62017f662f4f550f$export$4d318981b5a83836;
    this.data = data.toString();
}
$5722bfb9aa740cf6$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$5722bfb9aa740cf6$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$5722bfb9aa740cf6$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $5722bfb9aa740cf6$var$NumericData.getBitsLength(this.data.length);
};
$5722bfb9aa740cf6$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
$5722bfb9aa740cf6$exports = $5722bfb9aa740cf6$var$NumericData;


var $e2672c16f3753d38$exports = {};

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $e2672c16f3753d38$var$ALPHA_NUM_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function $e2672c16f3753d38$var$AlphanumericData(data) {
    this.mode = $62017f662f4f550f$export$376a9ed239d6c1c8;
    this.data = data;
}
$e2672c16f3753d38$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$e2672c16f3753d38$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$e2672c16f3753d38$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $e2672c16f3753d38$var$AlphanumericData.getBitsLength(this.data.length);
};
$e2672c16f3753d38$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $e2672c16f3753d38$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $e2672c16f3753d38$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($e2672c16f3753d38$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
$e2672c16f3753d38$exports = $e2672c16f3753d38$var$AlphanumericData;


var $dc5612147e8f2f63$exports = {};
var $89f59c9542ed9061$exports = {};
"use strict";
$89f59c9542ed9061$exports = function encodeUtf8(input) {
    var result = [];
    var size = input.length;
    for(var index = 0; index < size; index++){
        var point = input.charCodeAt(index);
        if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
            var second = input.charCodeAt(index + 1);
            if (second >= 0xDC00 && second <= 0xDFFF) {
                // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                index += 1;
            }
        }
        // US-ASCII
        if (point < 0x80) {
            result.push(point);
            continue;
        }
        // 2-byte UTF-8
        if (point < 0x800) {
            result.push(point >> 6 | 192);
            result.push(point & 63 | 128);
            continue;
        }
        // 3-byte UTF-8
        if (point < 0xD800 || point >= 0xE000 && point < 0x10000) {
            result.push(point >> 12 | 224);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // 4-byte UTF-8
        if (point >= 0x10000 && point <= 0x10FFFF) {
            result.push(point >> 18 | 240);
            result.push(point >> 12 & 63 | 128);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // Invalid character
        result.push(0xEF, 0xBF, 0xBD);
    }
    return new Uint8Array(result).buffer;
};



function $dc5612147e8f2f63$var$ByteData(data) {
    this.mode = $62017f662f4f550f$export$8f4bf8f7eb581284;
    if (typeof data === "string") data = $89f59c9542ed9061$exports(data);
    this.data = new Uint8Array(data);
}
$dc5612147e8f2f63$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$dc5612147e8f2f63$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$dc5612147e8f2f63$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $dc5612147e8f2f63$var$ByteData.getBitsLength(this.data.length);
};
$dc5612147e8f2f63$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
$dc5612147e8f2f63$exports = $dc5612147e8f2f63$var$ByteData;


var $809f979ad7a65555$exports = {};


function $809f979ad7a65555$var$KanjiData(data) {
    this.mode = $62017f662f4f550f$export$a4d452c2363c8e12;
    this.data = data;
}
$809f979ad7a65555$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$809f979ad7a65555$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$809f979ad7a65555$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $809f979ad7a65555$var$KanjiData.getBitsLength(this.data.length);
};
$809f979ad7a65555$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $43d5deeb6d91f10d$export$43dd553ecded716d(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error("Invalid SJIS character: " + this.data[i] + "\n" + "Make sure your charset is UTF-8");
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
$809f979ad7a65555$exports = $809f979ad7a65555$var$KanjiData;




var $e655dea0b319f81b$exports = {};
"use strict";
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $e655dea0b319f81b$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $e655dea0b319f81b$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === "undefined";
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== "undefined" && typeof costs[d] === "undefined") {
            var msg = [
                "Could not find a path from ",
                s,
                " to ",
                d,
                "."
            ].join("");
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $e655dea0b319f81b$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $e655dea0b319f81b$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $e655dea0b319f81b$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
$e655dea0b319f81b$exports = $e655dea0b319f81b$var$dijkstra;


/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $2698c09f8304755d$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $2698c09f8304755d$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $2698c09f8304755d$var$getSegmentsFromString(dataStr) {
    const numSegs = $2698c09f8304755d$var$getSegments($dc713f33f2c9be8b$export$4d318981b5a83836, $62017f662f4f550f$export$4d318981b5a83836, dataStr);
    const alphaNumSegs = $2698c09f8304755d$var$getSegments($dc713f33f2c9be8b$export$376a9ed239d6c1c8, $62017f662f4f550f$export$376a9ed239d6c1c8, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($43d5deeb6d91f10d$export$ce5b1274f8597fa0()) {
        byteSegs = $2698c09f8304755d$var$getSegments($dc713f33f2c9be8b$export$8f4bf8f7eb581284, $62017f662f4f550f$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = $2698c09f8304755d$var$getSegments($dc713f33f2c9be8b$export$a4d452c2363c8e12, $62017f662f4f550f$export$a4d452c2363c8e12, dataStr);
    } else {
        byteSegs = $2698c09f8304755d$var$getSegments($dc713f33f2c9be8b$export$9df7c29d562bab83, $62017f662f4f550f$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $2698c09f8304755d$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $62017f662f4f550f$export$4d318981b5a83836:
            return $5722bfb9aa740cf6$exports.getBitsLength(length);
        case $62017f662f4f550f$export$376a9ed239d6c1c8:
            return $e2672c16f3753d38$exports.getBitsLength(length);
        case $62017f662f4f550f$export$a4d452c2363c8e12:
            return $809f979ad7a65555$exports.getBitsLength(length);
        case $62017f662f4f550f$export$8f4bf8f7eb581284:
            return $dc5612147e8f2f63$exports.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $2698c09f8304755d$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $2698c09f8304755d$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $62017f662f4f550f$export$4d318981b5a83836:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $62017f662f4f550f$export$376a9ed239d6c1c8,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $62017f662f4f550f$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $62017f662f4f550f$export$376a9ed239d6c1c8:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $62017f662f4f550f$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $62017f662f4f550f$export$a4d452c2363c8e12:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $62017f662f4f550f$export$8f4bf8f7eb581284,
                        length: $2698c09f8304755d$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $62017f662f4f550f$export$8f4bf8f7eb581284:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $62017f662f4f550f$export$8f4bf8f7eb581284,
                        length: $2698c09f8304755d$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $2698c09f8304755d$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        "start"
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = "" + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $2698c09f8304755d$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $2698c09f8304755d$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $2698c09f8304755d$var$getSegmentBitsLength(node.length, node.mode) + 4 + $62017f662f4f550f$export$e79764af6ffaeb8d(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $2698c09f8304755d$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $62017f662f4f550f$export$1bd4c93ffb42e55e(data);
    mode = $62017f662f4f550f$export$6788812c4e6611e6(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $62017f662f4f550f$export$8f4bf8f7eb581284 && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + " cannot be encoded with mode " + $62017f662f4f550f$export$f84e8e69fd4488a5(mode) + ".\n Suggested mode is: " + $62017f662f4f550f$export$f84e8e69fd4488a5(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $62017f662f4f550f$export$a4d452c2363c8e12 && !$43d5deeb6d91f10d$export$ce5b1274f8597fa0()) mode = $62017f662f4f550f$export$8f4bf8f7eb581284;
    switch(mode){
        case $62017f662f4f550f$export$4d318981b5a83836:
            return new $5722bfb9aa740cf6$exports(data);
        case $62017f662f4f550f$export$376a9ed239d6c1c8:
            return new $e2672c16f3753d38$exports(data);
        case $62017f662f4f550f$export$a4d452c2363c8e12:
            return new $809f979ad7a65555$exports(data);
        case $62017f662f4f550f$export$8f4bf8f7eb581284:
            return new $dc5612147e8f2f63$exports(data);
    }
}
$2698c09f8304755d$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === "string") acc.push($2698c09f8304755d$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($2698c09f8304755d$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$2698c09f8304755d$export$3004f64547af360e = function fromString(data, version) {
    const segs = $2698c09f8304755d$var$getSegmentsFromString(data, $43d5deeb6d91f10d$export$ce5b1274f8597fa0());
    const nodes = $2698c09f8304755d$var$buildNodes(segs);
    const graph = $2698c09f8304755d$var$buildGraph(nodes, version);
    const path = $e655dea0b319f81b$exports.find_path(graph.map, "start", "end");
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $2698c09f8304755d$export$571d59b505e6bb4e($2698c09f8304755d$var$mergeSegments(optimizedSegs));
};
$2698c09f8304755d$export$89ab1afb9839589b = function rawSplit(data) {
    return $2698c09f8304755d$export$571d59b505e6bb4e($2698c09f8304755d$var$getSegmentsFromString(data, $43d5deeb6d91f10d$export$ce5b1274f8597fa0()));
};


/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $8ea83a9eb926b32b$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $ec2073a085b63ae6$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $8ea83a9eb926b32b$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $8ea83a9eb926b32b$var$setupAlignmentPattern(matrix, version) {
    const pos = $b11cc3fe51a56c63$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $8ea83a9eb926b32b$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $d03a5392c6eaafbc$export$eee5438974ef6f0e(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $8ea83a9eb926b32b$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $02d13488c4d2936a$export$eee5438974ef6f0e(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $8ea83a9eb926b32b$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $8ea83a9eb926b32b$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $5cc02d912059cc44$exports();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $62017f662f4f550f$export$e79764af6ffaeb8d(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $43d5deeb6d91f10d$export$b05dac13c7a35c32(version);
    const ecTotalCodewords = $b5dfbcbb2fc7a5a4$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $8ea83a9eb926b32b$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $8ea83a9eb926b32b$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $43d5deeb6d91f10d$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $b5dfbcbb2fc7a5a4$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $b5dfbcbb2fc7a5a4$export$41a1fc627aca72b9(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $a24e80323c1b2444$exports(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $8ea83a9eb926b32b$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $2698c09f8304755d$export$571d59b505e6bb4e(data);
    else if (typeof data === "string") {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $2698c09f8304755d$export$89ab1afb9839589b(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $d03a5392c6eaafbc$export$264e969aa7a8ff7e(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $2698c09f8304755d$export$3004f64547af360e(data, estimatedVersion || 40);
    } else throw new Error("Invalid data");
    // Get the min version that can contain data
    const bestVersion = $d03a5392c6eaafbc$export$264e969aa7a8ff7e(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error("The amount of data is too big to be stored in a QR Code");
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
    const dataBits = $8ea83a9eb926b32b$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $43d5deeb6d91f10d$export$8d4a06d3facd414b(version);
    const modules = new $805902ebf0943615$exports(moduleCount);
    // Add function modules
    $8ea83a9eb926b32b$var$setupFinderPattern(modules, version);
    $8ea83a9eb926b32b$var$setupTimingPattern(modules);
    $8ea83a9eb926b32b$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $8ea83a9eb926b32b$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $8ea83a9eb926b32b$var$setupVersionInfo(modules, version);
    // Add data codewords
    $8ea83a9eb926b32b$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $bf0950684611e804$export$fe9625aaceb0e563(modules, $8ea83a9eb926b32b$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $bf0950684611e804$export$a1c9aa9c0e8ba394(maskPattern, modules);
    // Replace format info bits with correct values
    $8ea83a9eb926b32b$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$8ea83a9eb926b32b$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === "undefined" || data === "") throw new Error("No input text");
    let errorCorrectionLevel = $a5d1389200d634d1$export$3a1a48c8f6ef640e;
    let version;
    let mask;
    if (typeof options !== "undefined") {
        // Use higher error correction level as default
        errorCorrectionLevel = $a5d1389200d634d1$export$6788812c4e6611e6(options.errorCorrectionLevel, $a5d1389200d634d1$export$3a1a48c8f6ef640e);
        version = $d03a5392c6eaafbc$export$6788812c4e6611e6(options.version);
        mask = $bf0950684611e804$export$6788812c4e6611e6(options.maskPattern);
        if (options.toSJISFunc) $43d5deeb6d91f10d$export$6733b14783f975c2(options.toSJISFunc);
    }
    return $8ea83a9eb926b32b$var$createSymbol(data, version, errorCorrectionLevel, mask);
};


var $04cc8a56acf0746c$export$b3890eb0ae9dca99;
var $04cc8a56acf0746c$export$c3e5526bbaf70a25;
var $735d207369fb8bfa$export$d2312e68e1f5ad00;
var $735d207369fb8bfa$export$5cdac61cf538712e;
var $735d207369fb8bfa$export$c3a1a1f268a8142b;
var $735d207369fb8bfa$export$83136f57c739c5f3;
function $735d207369fb8bfa$var$hex2rgba(hex) {
    if (typeof hex === "number") hex = hex.toString();
    if (typeof hex !== "string") throw new Error("Color should be defined as hex string");
    let hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error("Invalid hex color: " + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push("F", "F");
    const hexValue = parseInt(hexCode.join(""), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: "#" + hexCode.slice(0, 6).join("")
    };
}
$735d207369fb8bfa$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $735d207369fb8bfa$var$hex2rgba(options.color.dark || "#000000ff"),
            light: $735d207369fb8bfa$var$hex2rgba(options.color.light || "#ffffffff")
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$735d207369fb8bfa$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$735d207369fb8bfa$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $735d207369fb8bfa$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$735d207369fb8bfa$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $735d207369fb8bfa$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};


function $04cc8a56acf0746c$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + "px";
    canvas.style.width = size + "px";
}
function $04cc8a56acf0746c$var$getCanvasElement() {
    try {
        return document.createElement("canvas");
    } catch (e) {
        throw new Error("You need to specify a canvas element");
    }
}
$04cc8a56acf0746c$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $04cc8a56acf0746c$var$getCanvasElement();
    opts = $735d207369fb8bfa$export$d2312e68e1f5ad00(opts);
    const size = $735d207369fb8bfa$export$c3a1a1f268a8142b(qrData.modules.size, opts);
    const ctx = canvasEl.getContext("2d");
    const image = ctx.createImageData(size, size);
    $735d207369fb8bfa$export$83136f57c739c5f3(image.data, qrData, opts);
    $04cc8a56acf0746c$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$04cc8a56acf0746c$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $04cc8a56acf0746c$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || "image/png";
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};


var $d58b5f06327883c1$export$b3890eb0ae9dca99;

function $d58b5f06327883c1$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $d58b5f06327883c1$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== "undefined") str += " " + y;
    return str;
}
function $d58b5f06327883c1$var$qrToPath(data, size, margin) {
    let path = "";
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $d58b5f06327883c1$var$svgCmd("M", col + margin, 0.5 + row + margin) : $d58b5f06327883c1$var$svgCmd("m", moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $d58b5f06327883c1$var$svgCmd("h", lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$d58b5f06327883c1$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $735d207369fb8bfa$export$d2312e68e1f5ad00(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? "" : "<path " + $d58b5f06327883c1$var$getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
    const path = "<path " + $d58b5f06327883c1$var$getColorAttrib(opts.color.dark, "stroke") + ' d="' + $d58b5f06327883c1$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
    const width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
    if (typeof cb === "function") cb(null, svgTag);
    return svgTag;
};


function $5f46435f1db83a7e$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === "function";
    if (!isLastArgCb && !$522cdb5011344644$exports()) throw new Error("Callback required as last argument");
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error("Too few arguments provided");
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error("Too few arguments provided");
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $8ea83a9eb926b32b$export$185802fd694ee1f5(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $8ea83a9eb926b32b$export$185802fd694ee1f5(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$5f46435f1db83a7e$export$185802fd694ee1f5 = $8ea83a9eb926b32b$export$185802fd694ee1f5;
$5f46435f1db83a7e$export$f87f6982d1fd4f81 = $5f46435f1db83a7e$var$renderCanvas.bind(null, $04cc8a56acf0746c$export$b3890eb0ae9dca99);
$5f46435f1db83a7e$export$723e4939e5a27c8 = $5f46435f1db83a7e$var$renderCanvas.bind(null, $04cc8a56acf0746c$export$c3e5526bbaf70a25);
$5f46435f1db83a7e$export$f84e8e69fd4488a5 = $5f46435f1db83a7e$var$renderCanvas.bind(null, function(data, _, opts) {
    return $d58b5f06327883c1$export$b3890eb0ae9dca99(data, opts);
});


class $7ccf5fcf21c48f25$export$c498b58ec6d7eda2 extends (0, $4f991c42613b920c$export$5593b284a7b9fb1b) {
    constructor(admin){
        super();
        this.v = new $7ccf5fcf21c48f25$var$AboutView(admin);
    }
    view() {
        return this.v;
    }
    url() {
        return "/about";
    }
    offlineEnabled() {
        return true;
    }
}
class $7ccf5fcf21c48f25$var$AboutView extends (0, $f55c403e2549a503$export$2e2bcd8739ae039) {
    static #_ = this.classname = "about-view";
    constructor(admin){
        super($7ccf5fcf21c48f25$var$AboutView.classname);
        this.server = (0, $b306c6aaaa6be045$export$2e2bcd8739ae039).instance();
        this.admin = admin;
        // @ts-ignore
        this.clientVersion = window && window.wrb_git || {
            "version": "dev",
            "branch": "dev"
        };
        (0, $b306c6aaaa6be045$export$2e2bcd8739ae039).instance().ping("about").then((p)=>{
            this.serverVersion = p;
            this.update();
        });
        this.server.getShortBaseUrl().then((url)=>{
            this.shortUrl = url;
            this.update();
        });
    }
    render0() {
        const trunc = function(s) {
            return s ? s.substring(0, 8) : "";
        };
        const branch = function(b) {
            return b && b != "master" ? b : "";
        };
        const data = {
            baseUrl: this.server.getBaseUrl(),
            shortUrl: this.shortUrl,
            trunc: trunc,
            branch: branch,
            clientVersion: this.clientVersion,
            serverVersion: this.serverVersion,
            admin: this.admin
        };
        const out = this.pug((0, $85fb7da850074534$export$2e2bcd8739ae039), data);
        if (this.shortUrl) this.afterUpdate(()=>{
            const width = this.elt().find(".qrcode").width();
            const canvases = this.elt().find("canvas");
            canvases.each((idx, c)=>{
                const canvas = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(c);
                const url = canvas.data("url");
                console.log("canvas width ", width);
                (0, $5f46435f1db83a7e$export$f87f6982d1fd4f81)(c, url, {
                    errorCorrectionLevel: "high",
                    width: width
                }, (err)=>console.log(err));
            });
        });
        return out;
    }
}





var $3bb3c72b4be73ae0$export$2e2bcd8739ae039 = $3bb3c72b4be73ae0$var$template;
function $3bb3c72b4be73ae0$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    pug_html = pug_html + '<div class="function-body"><p>The password reset link you clicked is no longer valid. If you still need to reset your password,\nplease return to the login page and request another password reset link\nvia the "Forgot password" function.</p><div><a class="btn btn-primary" href="#/login">Go to login</a></div></div>';
    return pug_html;
}




var $5eff4edca43730c6$export$2e2bcd8739ae039 = $5eff4edca43730c6$var$template;
function $5eff4edca43730c6$var$pug_escape(e) {
    var a = "" + e, t = $5eff4edca43730c6$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $5eff4edca43730c6$var$pug_match_html = /["&<>]/;
function $5eff4edca43730c6$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(isNew1, isReset1) {
        pug_html = pug_html + '<div class="function-body"><h3>';
        if (isNew1) pug_html = pug_html + "Welcome to TALC!";
        else pug_html = pug_html + "Change password";
        pug_html = pug_html + '</h3><form class="with-validation change-password-form">';
        if (isNew1) pug_html = pug_html + "<p>Please set a password for your TALC account.</p>";
        var title = isNew1 ? "Password" : "New password";
        if (!isReset1) pug_html = pug_html + '<label>Current password</label><input type="password" name="currentPassword" required>';
        pug_html = pug_html + "<label>" + $5eff4edca43730c6$var$pug_escape(null == (pug_interp = title) ? "" : pug_interp) + '</label><input type="password" name="newPassword" required id="newPassword"><label>' + $5eff4edca43730c6$var$pug_escape(null == (pug_interp = title) ? "" : pug_interp) + ' (repeat)</label><input type="password" name="newPassword2" required equalTo="#newPassword"><button class="change-password action update" type="button">';
        if (isNew1) pug_html = pug_html + "Set password";
        else pug_html = pug_html + "Update password";
        pug_html = pug_html + "</button></form></div>";
    }).call(this, "isNew" in locals_for_with ? locals_for_with.isNew : typeof isNew !== "undefined" ? isNew : undefined, "isReset" in locals_for_with ? locals_for_with.isReset : typeof isReset !== "undefined" ? isReset : undefined);
    return pug_html;
}





class $a293585b41880388$export$c5112b3a47b1d3da extends (0, $f55c403e2549a503$export$2e2bcd8739ae039) {
    static #_ = this.classname = "change-password-view";
    constructor(userId, isReset, isNew){
        super($a293585b41880388$export$c5112b3a47b1d3da.classname);
        this.server = (0, $b306c6aaaa6be045$export$2e2bcd8739ae039).instance();
        this.userId = userId;
        this.isReset = isReset;
        this.isNew = isNew ? true : false;
    }
    render0() {
        const data = {
            isReset: this.isReset || this.userId,
            isNew: this.isNew
        };
        const out = this.pug((0, $5eff4edca43730c6$export$2e2bcd8739ae039), data);
        // @ts-ignore jquery-validation
        out.find(".change-password-form").validate();
        return out;
    }
    changePassword() {
        const form = this.elt().find("form.change-password-form");
        // @ts-ignore
        if (!form.valid()) return;
        const data0 = {};
        (0, $82cf23e1ef1fc3af$export$54048630ffcff79a)(form, data0);
        const data = {
            currentPassword: data0["currentPassword"],
            newPassword: data0["newPassword"]
        };
        if (this.userId) data.userId = +this.userId;
        this.server.changePassword(data).then(()=>{
            (0, $752d59648741b237$export$2e2bcd8739ae039).alert({
                message: "Password changed",
                callback: ()=>{
                    const home = new (0, $0dea84b3737d8e06$export$79dd4b1fcf658a20)();
                    this.notify(home);
                }
            });
        });
    }
}
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $a293585b41880388$export$c5112b3a47b1d3da.classname, "click", "button.change-password", function(that, event, elt) {
    event.preventDefault();
    that.changePassword();
});


class $17280a69343940fd$export$adc9431b3de9dba2 extends (0, $4f991c42613b920c$export$5593b284a7b9fb1b) {
    view() {
        return this.v;
    }
    url() {
        return "/security/change-password";
    }
    constructor(...args){
        super(...args);
        this.v = new (0, $a293585b41880388$export$c5112b3a47b1d3da)();
    }
}
class $17280a69343940fd$export$f1f8b7c044a665c3 extends (0, $4f991c42613b920c$export$5593b284a7b9fb1b) {
    constructor(userId, isNew){
        super();
        this.userId = userId;
        this.v = new (0, $a293585b41880388$export$c5112b3a47b1d3da)(userId, true, isNew);
    }
    view() {
        return this.v;
    }
    url() {
        return "/security/reset-password" + (this.userId ? "/" + this.userId : "");
    }
    isRoot() {
        return true;
    }
    isZero() {
        return true;
    }
}
class $17280a69343940fd$export$d54d005f8904e82a extends (0, $4f991c42613b920c$export$5593b284a7b9fb1b) {
    view() {
        return this.v;
    }
    url() {
        return "/security/reset-fail";
    }
    isRoot() {
        return true;
    }
    isZero() {
        return true;
    }
    constructor(...args){
        super(...args);
        this.v = new $17280a69343940fd$var$ResetFailView();
    }
}
class $17280a69343940fd$var$ResetFailView extends (0, $f55c403e2549a503$export$2e2bcd8739ae039) {
    static #_ = this.classname = "reset-fail-view";
    constructor(){
        super($17280a69343940fd$var$ResetFailView.classname);
        this.server = (0, $b306c6aaaa6be045$export$2e2bcd8739ae039).instance();
    }
    render0() {
        const template = (0, $3bb3c72b4be73ae0$export$2e2bcd8739ae039);
        const out = this.pug(template, {});
        return out;
    }
}




var $427e2b35b39e9953$export$2e2bcd8739ae039 = $427e2b35b39e9953$var$template;
function $427e2b35b39e9953$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $427e2b35b39e9953$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $427e2b35b39e9953$var$pug_classes(s, r) {
    return Array.isArray(s) ? $427e2b35b39e9953$var$pug_classes_array(s, r) : s && "object" == typeof s ? $427e2b35b39e9953$var$pug_classes_object(s) : s || "";
}
function $427e2b35b39e9953$var$pug_classes_array(r, a) {
    for(var s, e = "", u = "", c = Array.isArray(a), g = 0; g < r.length; g++)(s = $427e2b35b39e9953$var$pug_classes(r[g])) && (c && a[g] && (s = $427e2b35b39e9953$var$pug_escape(s)), e = e + u + s, u = " ");
    return e;
}
function $427e2b35b39e9953$var$pug_classes_object(r) {
    var a = "", n = "";
    for(var o in r)o && r[o] && $427e2b35b39e9953$var$pug_has_own_property.call(r, o) && (a = a + n + o, n = " ");
    return a;
}
function $427e2b35b39e9953$var$pug_escape(e) {
    var a = "" + e, t = $427e2b35b39e9953$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $427e2b35b39e9953$var$pug_has_own_property = Object.prototype.hasOwnProperty;
var $427e2b35b39e9953$var$pug_match_html = /["&<>]/;
function $427e2b35b39e9953$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(filter1, libraries1, library1, recordings1) {
        pug_mixins["options"] = pug_interp = function(available, selected) {
            var block = this && this.block, attributes = this && this.attributes || {};
            (function() {
                var $$obj = available;
                if ("number" == typeof $$obj.length) for(var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++){
                    var v = $$obj[pug_index0];
                    pug_html = pug_html + "<option" + ($427e2b35b39e9953$var$pug_attr("value", v, true, true) + $427e2b35b39e9953$var$pug_attr("selected", v == selected, true, true)) + ">" + $427e2b35b39e9953$var$pug_escape(null == (pug_interp = v) ? "" : pug_interp) + "</option>";
                }
                else {
                    var $$l = 0;
                    for(var pug_index0 in $$obj){
                        $$l++;
                        var v = $$obj[pug_index0];
                        pug_html = pug_html + "<option" + ($427e2b35b39e9953$var$pug_attr("value", v, true, true) + $427e2b35b39e9953$var$pug_attr("selected", v == selected, true, true)) + ">" + $427e2b35b39e9953$var$pug_escape(null == (pug_interp = v) ? "" : pug_interp) + "</option>";
                    }
                }
            }).call(this);
        };
        pug_html = pug_html + '<div class="function-body">';
        if (recordings1) {
            pug_html = pug_html + '<div class="card">';
            if (libraries1 && libraries1.length > 1) {
                pug_html = pug_html + '<div class="controls"><label>Library:</label><select class="library" name="library">';
                pug_mixins["options"](libraries1, library1);
                pug_html = pug_html + "</select><label>Filter:</label><input" + (' class="filter" name="filter"' + $427e2b35b39e9953$var$pug_attr("value", filter1, true, true)) + '><button class="autoplay">Autoplay</button></div><hr>';
            }
            pug_html = pug_html + '<ul class="tracks">';
            (function() {
                var $$obj = recordings1;
                if ("number" == typeof $$obj.length) for(var index = 0, $$l = $$obj.length; index < $$l; index++){
                    var track = $$obj[index];
                    pug_html = pug_html + "<li" + $427e2b35b39e9953$var$pug_attr("class", $427e2b35b39e9953$var$pug_classes([
                        {
                            inLibrary: track.inLibrary,
                            inactive: !track.active
                        }
                    ], [
                        true
                    ]), false, true) + "><a" + ($427e2b35b39e9953$var$pug_attr("class", $427e2b35b39e9953$var$pug_classes([
                        "track track-" + track.id
                    ], [
                        true
                    ]), false, true) + $427e2b35b39e9953$var$pug_attr("href", `#/player/${track.id}`, true, true) + $427e2b35b39e9953$var$pug_attr("data-track", track.id, true, true) + $427e2b35b39e9953$var$pug_attr("data-idx", index, true, true)) + '><div class="genre"><div class="long">' + $427e2b35b39e9953$var$pug_escape(null == (pug_interp = track.genre) ? "" : pug_interp) + '</div><div class="short">' + $427e2b35b39e9953$var$pug_escape(null == (pug_interp = track.shortGenre) ? "" : pug_interp) + '</div></div><div class="artist">' + $427e2b35b39e9953$var$pug_escape(null == (pug_interp = track.artist) ? "" : pug_interp) + '</div><div class="date"><div class="long">' + $427e2b35b39e9953$var$pug_escape(null == (pug_interp = track.recording_date) ? "" : pug_interp) + '&nbsp;</div><div class="short">' + $427e2b35b39e9953$var$pug_escape(null == (pug_interp = track.shortDate) ? "" : pug_interp) + '&nbsp;</div></div><div class="title">' + $427e2b35b39e9953$var$pug_escape(null == (pug_interp = track.title) ? "" : pug_interp) + "</div></a></li>";
                }
                else {
                    var $$l = 0;
                    for(var index in $$obj){
                        $$l++;
                        var track = $$obj[index];
                        pug_html = pug_html + "<li" + $427e2b35b39e9953$var$pug_attr("class", $427e2b35b39e9953$var$pug_classes([
                            {
                                inLibrary: track.inLibrary,
                                inactive: !track.active
                            }
                        ], [
                            true
                        ]), false, true) + "><a" + ($427e2b35b39e9953$var$pug_attr("class", $427e2b35b39e9953$var$pug_classes([
                            "track track-" + track.id
                        ], [
                            true
                        ]), false, true) + $427e2b35b39e9953$var$pug_attr("href", `#/player/${track.id}`, true, true) + $427e2b35b39e9953$var$pug_attr("data-track", track.id, true, true) + $427e2b35b39e9953$var$pug_attr("data-idx", index, true, true)) + '><div class="genre"><div class="long">' + $427e2b35b39e9953$var$pug_escape(null == (pug_interp = track.genre) ? "" : pug_interp) + '</div><div class="short">' + $427e2b35b39e9953$var$pug_escape(null == (pug_interp = track.shortGenre) ? "" : pug_interp) + '</div></div><div class="artist">' + $427e2b35b39e9953$var$pug_escape(null == (pug_interp = track.artist) ? "" : pug_interp) + '</div><div class="date"><div class="long">' + $427e2b35b39e9953$var$pug_escape(null == (pug_interp = track.recording_date) ? "" : pug_interp) + '&nbsp;</div><div class="short">' + $427e2b35b39e9953$var$pug_escape(null == (pug_interp = track.shortDate) ? "" : pug_interp) + '&nbsp;</div></div><div class="title">' + $427e2b35b39e9953$var$pug_escape(null == (pug_interp = track.title) ? "" : pug_interp) + "</div></a></li>";
                    }
                }
            }).call(this);
            pug_html = pug_html + '<li class="infinite"></li></ul></div>';
        }
        pug_html = pug_html + "</div>";
    }).call(this, "filter" in locals_for_with ? locals_for_with.filter : typeof filter !== "undefined" ? filter : undefined, "libraries" in locals_for_with ? locals_for_with.libraries : typeof libraries !== "undefined" ? libraries : undefined, "library" in locals_for_with ? locals_for_with.library : typeof library !== "undefined" ? library : undefined, "recordings" in locals_for_with ? locals_for_with.recordings : typeof recordings !== "undefined" ? recordings : undefined);
    return pug_html;
}



/**
 * Abstraction on top of something like localStorage.
 *
 * One issue is that iOS might clear out localStorage. So we hedge our bets by using this facade
 */ 
class $7d54c20022f864e4$export$2e2bcd8739ae039 {
    static instance() {
        if ($7d54c20022f864e4$export$2e2bcd8739ae039.INSTANCE == null) $7d54c20022f864e4$export$2e2bcd8739ae039.INSTANCE = new $7d54c20022f864e4$export$2e2bcd8739ae039();
        return $7d54c20022f864e4$export$2e2bcd8739ae039.INSTANCE;
    }
    get(key0) {
        const key = (0, $b306c6aaaa6be045$export$e394a0c530ae5631)() + key0;
        const str = window.localStorage.getItem(key);
        if (str == null) return null;
        return JSON.parse(str);
    }
    set(key0, value) {
        const key = (0, $b306c6aaaa6be045$export$e394a0c530ae5631)() + key0;
        if (value == null) window.localStorage.removeItem(key);
        else {
            const str = JSON.stringify(value);
            try {
                window.localStorage.setItem(key, str);
            } catch (e) {
                // eg QuotaExceededError
                console.trace("Failed to set LocalDB", key, e);
                try {
                    window.localStorage.clear();
                } catch (e) {
                    console.trace("Failed to clear LocalDB", e);
                }
            }
        }
    }
}



const $42cb568d269912f0$var$INITIAL_RENDER_TO = 30;
let $42cb568d269912f0$var$scrollhandler = undefined;
jQuery(document).on("scroll", (event)=>{
    $42cb568d269912f0$var$scrollhandler && $42cb568d269912f0$var$scrollhandler(event);
});
class $42cb568d269912f0$export$2e2bcd8739ae039 extends (0, $f55c403e2549a503$export$2e2bcd8739ae039) {
    static #_ = this.classname = "library-view";
    constructor(){
        super($42cb568d269912f0$export$2e2bcd8739ae039.classname);
        this.server = (0, $b306c6aaaa6be045$export$2e2bcd8739ae039).instance();
        this.libraries = [];
        this.library = (0, $7d54c20022f864e4$export$2e2bcd8739ae039).instance().get("library") || "TALC";
        this.filter = "";
        this.renderTo = $42cb568d269912f0$var$INITIAL_RENDER_TO;
        this.server.fetchLibraries().then((libs)=>{
            this.libraries = libs;
            let library = this.library;
            if (libs.indexOf(this.library) == -1 && libs.length > 0) library = libs[0];
            this.setLibrary(library);
            this.update();
        });
    }
    render0() {
        const data = {
            recordings: (this.filtered || []).slice(0, this.renderTo),
            library: this.library,
            libraries: this.libraries,
            filter: this.filter
        };
        const out = this.pug((0, $427e2b35b39e9953$export$2e2bcd8739ae039), data);
        $42cb568d269912f0$var$scrollhandler = (event)=>this.scroll(event);
        return out;
    }
    scroll(event) {
        $42cb568d269912f0$var$scrollhandler = undefined;
        const elt = this.elt();
        if (!elt) return;
        const infinite = elt.find(".infinite");
        if ((0, $82cf23e1ef1fc3af$export$157b27307c5a0381)(infinite)) {
            const page = $42cb568d269912f0$var$INITIAL_RENDER_TO;
            const recordings = (this.filtered || []).slice(this.renderTo, this.renderTo + page);
            const items = this.renderSlice(recordings);
            items.insertBefore(infinite);
            if (items.length == 0) infinite.remove();
            this.renderTo += $42cb568d269912f0$var$INITIAL_RENDER_TO;
        }
        $42cb568d269912f0$var$scrollhandler = (event)=>this.scroll(event);
    }
    renderSlice(recordings) {
        const data = {
            recordings: recordings,
            library: this.library,
            libraries: this.libraries,
            filter: this.filter
        };
        const out = this.pug((0, $427e2b35b39e9953$export$2e2bcd8739ae039), data);
        const items = out.find(".tracks li");
        return items;
    }
    setLibrary(lib) {
        this.library = lib;
        (0, $7d54c20022f864e4$export$2e2bcd8739ae039).instance().set("library", this.library);
        this.server.fetchRecordings(this.library).then((recordings)=>{
            this.recordings = recordings;
            this.recordings.forEach((r)=>(0, $82cf23e1ef1fc3af$export$114ad5b630363e5c)(r));
            this.setFilter(this.filter);
            this.update();
        });
    }
    setFilter(f0) {
        f0 = (f0 || "").trim();
        if (this.filter !== f0) this.renderTo = $42cb568d269912f0$var$INITIAL_RENDER_TO;
        this.filter = f0;
        const f = (this.filter || "").toLowerCase();
        this.filtered = (this.recordings || []).filter((r)=>{
            if (!f) return true;
            const a = r;
            if (!a.json) a.json = JSON.stringify(r).toLowerCase();
            return a.json.indexOf(f) > -1;
        });
        this.update(".tracks");
    }
    autoplay() {
        if (!this.recordings) return;
        const idx = Math.floor(Math.random() * this.recordings.length);
        const id = this.recordings[idx].id;
        const url = `#/player/${id}/autoplay`;
        window.location.href = url;
    }
}
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $42cb568d269912f0$export$2e2bcd8739ae039.classname, "change", "select.library", function(that, event, elt) {
    event.preventDefault();
    const lib = jQuery(elt).val();
    that.setLibrary(lib);
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $42cb568d269912f0$export$2e2bcd8739ae039.classname, "input", "input.filter", function(that, event, elt) {
    event.preventDefault();
    const f = jQuery(elt).val();
    that.setFilter(f);
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $42cb568d269912f0$export$2e2bcd8739ae039.classname, "click", ".autoplay", function(that, event, elt) {
    event.preventDefault();
    that.autoplay();
});


class $2b0cda06d85bb7c7$export$c0609c134f241cf3 extends (0, $4f991c42613b920c$export$5593b284a7b9fb1b) {
    constructor(){
        super();
        this.v = new (0, $42cb568d269912f0$export$2e2bcd8739ae039)();
    }
    view() {
        return this.v;
    }
    url() {
        return `/library`;
    }
}




var $10cKx = parcelRequire("10cKx");


var $dfafb99aea214f6f$export$2e2bcd8739ae039 = $dfafb99aea214f6f$var$template;
function $dfafb99aea214f6f$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $dfafb99aea214f6f$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $dfafb99aea214f6f$var$pug_classes(s, r) {
    return Array.isArray(s) ? $dfafb99aea214f6f$var$pug_classes_array(s, r) : s && "object" == typeof s ? $dfafb99aea214f6f$var$pug_classes_object(s) : s || "";
}
function $dfafb99aea214f6f$var$pug_classes_array(r, a) {
    for(var s, e = "", u = "", c = Array.isArray(a), g = 0; g < r.length; g++)(s = $dfafb99aea214f6f$var$pug_classes(r[g])) && (c && a[g] && (s = $dfafb99aea214f6f$var$pug_escape(s)), e = e + u + s, u = " ");
    return e;
}
function $dfafb99aea214f6f$var$pug_classes_object(r) {
    var a = "", n = "";
    for(var o in r)o && r[o] && $dfafb99aea214f6f$var$pug_has_own_property.call(r, o) && (a = a + n + o, n = " ");
    return a;
}
function $dfafb99aea214f6f$var$pug_escape(e) {
    var a = "" + e, t = $dfafb99aea214f6f$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $dfafb99aea214f6f$var$pug_has_own_property = Object.prototype.hasOwnProperty;
var $dfafb99aea214f6f$var$pug_match_html = /["&<>]/;
function $dfafb99aea214f6f$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(admin1, balance1, editor1, left_right_controls1, leftright1, marks1, plural1, recording1, renderCredits1, renderTimestamp1, repitchCents1, review_url1, unlimitedCredits1, user1) {
        pug_html = pug_html + '<div class="function-body">';
        if (recording1) {
            pug_html = pug_html + "<h2" + $dfafb99aea214f6f$var$pug_attr("class", $dfafb99aea214f6f$var$pug_classes([
                {
                    inactive: !recording1.active
                }
            ], [
                true
            ]), false, true) + ">" + $dfafb99aea214f6f$var$pug_escape(null == (pug_interp = recording1.title) ? "" : pug_interp) + "</h2><h3>" + $dfafb99aea214f6f$var$pug_escape(null == (pug_interp = recording1.artist) ? "" : pug_interp) + " " + $dfafb99aea214f6f$var$pug_escape(null == (pug_interp = recording1.recording_date || "") ? "" : pug_interp) + "</h3>";
            if (recording1.repitch_cents) pug_html = pug_html + '<div class="repitch-comment">(repitched by ' + $dfafb99aea214f6f$var$pug_escape(null == (pug_interp = recording1.repitch_cents) ? "" : pug_interp) + " cents)</div>";
            if (!recording1.inLibrary) {
                pug_html = pug_html + '<div class="purchase-option">';
                if (user1) {
                    pug_html = pug_html + "<p><strong>This recording is not in your library. The video is a short sample of the full recording.</strong>";
                    if (balance1) {
                        if (balance1.credits > 0) {
                            pug_html = pug_html + "<p>You have " + $dfafb99aea214f6f$var$pug_escape(null == (pug_interp = renderCredits1(balance1.credits)) ? "" : pug_interp) + "\n\navailable and can add this recording to your library";
                            if (!unlimitedCredits1(balance1.credits)) pug_html = pug_html + "\nwith the button below for " + $dfafb99aea214f6f$var$pug_escape(null == (pug_interp = recording1.price) ? "" : pug_interp) + " " + $dfafb99aea214f6f$var$pug_escape(null == (pug_interp = recording1.library) ? "" : pug_interp) + " " + $dfafb99aea214f6f$var$pug_escape(null == (pug_interp = plural1(recording1.price, "credit", "credits")) ? "" : pug_interp) + ".";
                            else pug_html = pug_html + "\nwith the button below.";
                            pug_html = pug_html + '</p><button class="add-recording">Add to library</button>';
                        } else pug_html = pug_html + '<p>You don\'t have any credits but can purchase them in the <a class="clickable" href="#/account">Account</a> section.\nThis recording requires ' + $dfafb99aea214f6f$var$pug_escape(null == (pug_interp = recording1.price) ? "" : pug_interp) + " " + $dfafb99aea214f6f$var$pug_escape(null == (pug_interp = recording1.library) ? "" : pug_interp) + " " + $dfafb99aea214f6f$var$pug_escape(null == (pug_interp = plural1(recording1.price, "credit", "credits")) ? "" : pug_interp) + " to purchase access.</p>";
                    }
                    pug_html = pug_html + "</p>";
                } else pug_html = pug_html + '<p><strong>To see the full recording and access the special viewing tools (tempo change, section marking and looping)\nyou need to create an free account and purchase credits.\n<button class="create-account"><a href="#/signup">Create account</a></button></strong></p>';
                pug_html = pug_html + "</div>";
            }
            pug_html = pug_html + '<div class="video-container"><video-js class="video-js"></video-js><div class="marks"><canvas width="1000" height="150"></canvas></div></div><div class="controls"><button class="rewind">Rewind</button><button class="play">Play</button><button class="pause">Pause</button>';
            if (recording1.inLibrary) {
                pug_html = pug_html + '<button class="add-mark">Add mark</button><button class="loop">Loop</button><button class="edit-marks">Edit marks</button>';
                if (recording1.library == "Old" || recording1.library == "Big" || recording1.library == "Bury") pug_html = pug_html + '<button class="repitch">Fix pitch</button>';
            }
            pug_html = pug_html + "</div>";
            if (left_right_controls1) pug_html = pug_html + '<div class="controls"><label>Left/right<input' + (' class="leftright" type="range" min="-1" max="1" step="0.01"' + $dfafb99aea214f6f$var$pug_attr("value", leftright1, true, true)) + "></label></div>";
            if (admin1 || editor1) {
                pug_html = pug_html + '<div class="controls">';
                if (recording1.active) pug_html = pug_html + '<button class="inactive activation" data-active="0">Hide from public</button>';
                if (!recording1.active) pug_html = pug_html + '<button class="inactive activation" data-active="1">Make public</button>';
                if (admin1) pug_html = pug_html + '<button class="edit-recording">Edit recording</button>';
                pug_html = pug_html + "</div>";
                if (review_url1) pug_html = pug_html + '<div class="controls"><span>Review URL for Orlando:\n<a' + $dfafb99aea214f6f$var$pug_attr("href", review_url1, true, true) + ">" + $dfafb99aea214f6f$var$pug_escape(null == (pug_interp = review_url1) ? "" : pug_interp) + "</a></span></div>";
            }
            pug_html = pug_html + '<div class="repitch-container hidden"><input' + (' class="cents"' + $dfafb99aea214f6f$var$pug_attr("value", repitchCents1, true, true)) + '><button class="saveRepitch">Save this cents change</button><button class="cancelRepitch">Cancel pitch change</button></div><div class="leadsheet"></div><div class="edit-marks-container modal-container"><div class="mask"></div><div class="modal"><div class="body"><ol class="edit-marks-list">';
            (function() {
                var $$obj = marks1;
                if ("number" == typeof $$obj.length) for(var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++){
                    var mark = $$obj[pug_index0];
                    pug_html = pug_html + "<li><input" + (' class="mark-value"' + $dfafb99aea214f6f$var$pug_attr("value", renderTimestamp1(mark), true, true) + ' size="8"') + '><a class="delete" href="#">X</a></li>';
                }
                else {
                    var $$l = 0;
                    for(var pug_index0 in $$obj){
                        $$l++;
                        var mark = $$obj[pug_index0];
                        pug_html = pug_html + "<li><input" + (' class="mark-value"' + $dfafb99aea214f6f$var$pug_attr("value", renderTimestamp1(mark), true, true) + ' size="8"') + '><a class="delete" href="#">X</a></li>';
                    }
                }
            }).call(this);
            pug_html = pug_html + '</ol></div><div class="footer"><button class="done">Done</button></div></div></div>';
        }
        pug_html = pug_html + "</div>";
    }).call(this, "admin" in locals_for_with ? locals_for_with.admin : typeof admin !== "undefined" ? admin : undefined, "balance" in locals_for_with ? locals_for_with.balance : typeof balance !== "undefined" ? balance : undefined, "editor" in locals_for_with ? locals_for_with.editor : typeof editor !== "undefined" ? editor : undefined, "left_right_controls" in locals_for_with ? locals_for_with.left_right_controls : typeof left_right_controls !== "undefined" ? left_right_controls : undefined, "leftright" in locals_for_with ? locals_for_with.leftright : typeof leftright !== "undefined" ? leftright : undefined, "marks" in locals_for_with ? locals_for_with.marks : typeof marks !== "undefined" ? marks : undefined, "plural" in locals_for_with ? locals_for_with.plural : typeof plural !== "undefined" ? plural : undefined, "recording" in locals_for_with ? locals_for_with.recording : typeof recording !== "undefined" ? recording : undefined, "renderCredits" in locals_for_with ? locals_for_with.renderCredits : typeof renderCredits !== "undefined" ? renderCredits : undefined, "renderTimestamp" in locals_for_with ? locals_for_with.renderTimestamp : typeof renderTimestamp !== "undefined" ? renderTimestamp : undefined, "repitchCents" in locals_for_with ? locals_for_with.repitchCents : typeof repitchCents !== "undefined" ? repitchCents : undefined, "review_url" in locals_for_with ? locals_for_with.review_url : typeof review_url !== "undefined" ? review_url : undefined, "unlimitedCredits" in locals_for_with ? locals_for_with.unlimitedCredits : typeof unlimitedCredits !== "undefined" ? unlimitedCredits : undefined, "user" in locals_for_with ? locals_for_with.user : typeof user !== "undefined" ? user : undefined);
    return pug_html;
}





// Loaded via <script> tag, create shortcut to access PDF.js exports.
// @ts-ignore
const { pdfjsLib: $d6f0e570c44705a9$var$pdfjsLib } = globalThis;
// The workerSrc property shall be specified.
$d6f0e570c44705a9$var$pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.3.136/pdf.worker.mjs";
let $d6f0e570c44705a9$var$videoid = 0;
// Global list for disposal - this implementation implies that we can only have one player at a time.
const $d6f0e570c44705a9$var$players = [];
// Global space bar handler
let $d6f0e570c44705a9$var$spaceBarHandler = undefined;
(0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(document).on("keyup keydown", function(e) {
    if (e.key == " ") $d6f0e570c44705a9$var$spaceBarHandler && $d6f0e570c44705a9$var$spaceBarHandler(e);
});
function $d6f0e570c44705a9$var$renderTimestamp(x) {
    const minutes = Math.floor(x / 60);
    const seconds = Math.floor(x - minutes * 60);
    const tenths = Math.floor((x - minutes * 60 - seconds) * 10);
    return minutes + ":" + String(seconds).padStart(2, "0") + "." + String(tenths).padStart(1, "0");
}
class $d6f0e570c44705a9$export$2e2bcd8739ae039 extends (0, $f55c403e2549a503$export$2e2bcd8739ae039) {
    static #_ = this.classname = "player-view";
    constructor(id, user, role, autoplay){
        super($d6f0e570c44705a9$export$2e2bcd8739ae039.classname);
        this.server = (0, $b306c6aaaa6be045$export$2e2bcd8739ae039).instance();
        this.marks = [];
        this.looping = false;
        this.start = 0;
        this.end = 0;
        this.redraw = undefined;
        this.repitching = false;
        this.repitchCents = 0;
        this.repitchCentsBase = 0;
        this.autoplay = false;
        this.leftright = 0;
        this.id = id;
        this.user = user;
        this.role = role;
        this.autoplay = autoplay;
        this.refresh();
    }
    sortMarks() {
        this.marks = this.marks.sort((a, b)=>{
            return a - b;
        });
        if (this.recording) this.server.saveMarks(this.recording, this.marks);
    }
    refresh() {
        this.server.fetchRecording(this.id).then((recording)=>{
            this.recording = recording;
            this.marks = this.recording.marks || [];
            this.repitchCentsBase = this.repitchCents = this.recording.repitch_cents || 0;
            this.setRecordingOnPlayer();
            this.update();
            this.config();
        });
        this.server.getBalance().then((balance)=>{
            this.balance = balance;
            this.update(".purchase-option");
        });
    }
    render0() {
        $d6f0e570c44705a9$var$spaceBarHandler = (event)=>{
            const e = this.elt();
            const p = this.player;
            if (e.find(".edit-marks-container").is(":visible")) return;
            if (!e.is(":visible")) return;
            if (p) {
                event.stopPropagation();
                event.preventDefault();
                if (event.type == "keyup") {
                    p.paused() ? p.play() : p.pause();
                    this.config();
                }
            }
        };
        const data = {
            left_right_controls: this.recording && this.recording.left_right,
            recording: this.recording,
            balance: this.balance,
            marks: this.marks,
            renderTimestamp: $d6f0e570c44705a9$var$renderTimestamp,
            renderCredits: (0, $82cf23e1ef1fc3af$export$2bf51cf47fafb61d),
            unlimitedCredits: (0, $82cf23e1ef1fc3af$export$a1bd3674078e2988),
            repitchCents: this.repitchCents,
            plural: (0, $82cf23e1ef1fc3af$export$4e35d5c922a95490),
            user: this.user,
            admin: this.role == (0, $4f991c42613b920c$export$87cd0a661ace5c06),
            editor: this.role == (0, $4f991c42613b920c$export$a7d6ff1965d6fac9)
        };
        const token = this.recording && this.recording.token;
        if (token) data.review_url = (0, $82cf23e1ef1fc3af$export$93ea666e31027e44)(`/review/${token}`);
        const out = this.pug((0, $dfafb99aea214f6f$export$2e2bcd8739ae039), data);
        this.afterUpdate(()=>{
            const v = this.elt().find("video-js");
            if (v.length == 1 && !v.data("initted")) {
                const id = this.getUuid() + "-video-" + ++$d6f0e570c44705a9$var$videoid;
                v.attr("id", id);
                v.data("initted", true);
                const configOptions = (newOpts)=>{
                    this.elt().find(".loop-a").text(newOpts.start ? "A " + Math.round(newOpts.start * 10) / 10 : "A");
                    this.elt().find(".loop-b").text(newOpts.end ? "B " + Math.round(newOpts.end * 10) / 10 : "B");
                };
                // @ts-ignore
                this.player = videojs(v[0], {
                    preload: true,
                    fluid: true,
                    controls: true,
                    playbackRates: [
                        0.2,
                        0.3,
                        0.4,
                        0.5,
                        0.6,
                        0.7,
                        0.8,
                        0.9,
                        1
                    ],
                    plugins: {
                        abLoopPlugin: {
                            createButtons: true,
                            onOptionsChange: function(optionDetails, api, player) {
                                console.log("options changed: ", player.id(), optionDetails);
                                configOptions(optionDetails.newOpts);
                            }
                        }
                    }
                });
                this.player.crossOrigin = "anonymous";
                const videoElt = this.elt().find("video");
                const vid = videoElt[0];
                vid.crossOrigin = "anonymous";
                if (this.recording) {
                    if (this.recording.left_right) this.setupLeftRight();
                    else this.setupMono();
                }
                for (const p of $d6f0e570c44705a9$var$players)p.dispose();
                $d6f0e570c44705a9$var$players.length = 0;
                $d6f0e570c44705a9$var$players.push(this.player);
                if (this.recording) this.setRecordingOnPlayer();
                this.player.on([
                    "play",
                    "seeked",
                    "pause",
                    "ready",
                    "durationchange"
                ], ()=>{
                    this.config();
                });
            }
            this.showLeadSheet();
        });
        return out;
    }
    setupLeftRight() {
        const videoElt = this.elt().find("video");
        const vid = videoElt[0];
        const audioCtx = new AudioContext({
            latencyHint: "interactive"
        });
        console.log(`baseLatency=${audioCtx.baseLatency}`);
        const source = audioCtx.createMediaElementSource(vid);
        source.channelInterpretation = "discrete";
        const gainL = audioCtx.createGain();
        const gainR = audioCtx.createGain();
        const gainLL = audioCtx.createGain();
        const gainLR = audioCtx.createGain();
        const gainRL = audioCtx.createGain();
        const gainRR = audioCtx.createGain();
        const merger = new ChannelMergerNode(audioCtx, {
            numberOfInputs: 2,
            channelInterpretation: "discrete"
        });
        const splitter = new ChannelSplitterNode(audioCtx, {
            numberOfOutputs: 2,
            channelInterpretation: "discrete"
        });
        // Connect to source
        // Connect the source to the splitter
        source.connect(splitter, 0, 0);
        splitter.connect(gainL, 0);
        splitter.connect(gainR, 1);
        gainL.connect(gainLL);
        gainL.connect(gainLR);
        gainR.connect(gainRL);
        gainR.connect(gainRR);
        const gain = audioCtx.createGain();
        if (this.recording && this.recording.db_adjust != null) gain.gain.value = Math.pow(10, this.recording.db_adjust / 20);
        merger.connect(gain, 0, 0);
        gain.connect(audioCtx.destination, 0, 0);
        gainLL.connect(merger, 0, 0);
        gainLR.connect(merger, 0, 1);
        gainRL.connect(merger, 0, 0);
        gainRR.connect(merger, 0, 1);
        gainLL.gain.value = 0.6;
        gainLR.gain.value = 0.4;
        gainRL.gain.value = 0.6;
        gainRR.gain.value = 0.4;
        this.configPanning = ()=>{
            const v = this.leftright || 0;
            const v0 = Math.abs(v);
            const g = 1 - v0;
            if (v < 0) {
                gainL.gain.value = g;
                gainR.gain.value = 1;
            } else if (v > 0) {
                gainL.gain.value = 1;
                gainR.gain.value = g;
            } else {
                gainL.gain.value = 1;
                gainR.gain.value = 1;
            }
        };
        this.configPanning();
    }
    setupMono() {
        const videoElt = this.elt().find("video");
        const vid = videoElt[0];
        const audioCtx = new AudioContext({
            latencyHint: "interactive"
        });
        console.log(`baseLatency=${audioCtx.baseLatency}`);
        const source = audioCtx.createMediaElementSource(vid);
        source.channelInterpretation = "discrete";
        const gain = audioCtx.createGain();
        if (this.recording && this.recording.db_adjust != null) gain.gain.value = Math.pow(10, this.recording.db_adjust / 20);
        source.connect(gain, 0, 0);
        gain.connect(audioCtx.destination, 0, 0);
    }
    async showLeadSheet() {
        if (!this.recording || !this.recording.pages) return;
        const url = await this.server.getFakebookUrl();
        if (!url) return;
        let canvas0 = this.elt().find(".leadsheet canvas");
        if (canvas0.data("recordingid") == this.recording.id) return;
        canvas0.remove();
        canvas0 = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))("<canvas>").appendTo(this.elt().find(".leadsheet"));
        canvas0.data("recordingid", this.recording.id);
        const pagenum = this.recording.pages.replace(/[,-].*/, "");
        const fakebook = $d6f0e570c44705a9$var$pdfjsLib.getDocument(url);
        const pdf = await fakebook.promise;
        const page = await pdf.getPage(+pagenum);
        const scale = 1.5;
        const viewport = page.getViewport({
            scale: scale,
            dontFlip: false
        });
        const outputScale = window.devicePixelRatio || 1;
        const canvas = canvas0[0];
        const context = canvas.getContext("2d");
        if (!context) return;
        canvas.width = Math.floor(viewport.width * outputScale);
        canvas.height = Math.floor(viewport.height * outputScale);
        canvas.style.width = Math.floor(viewport.width) + "px";
        canvas.style.height = Math.floor(viewport.height) + "px";
        const transform = outputScale !== 1 ? [
            outputScale,
            0,
            0,
            outputScale,
            0,
            0
        ] : null;
        const renderContext = {
            canvasContext: context,
            transform: transform,
            viewport: viewport
        };
        page.render(renderContext);
    }
    drawCanvas() {
        const canvas = this.elt().find("canvas");
        if (canvas.length == 0) return;
        const ctx = canvas[0].getContext("2d");
        if (!ctx) return;
        const width = canvas[0].width;
        const height = canvas[0].height;
        ctx.fillStyle = "rgb(255 255 255)";
        ctx.fillRect(0, 0, width, height);
        if (!this.player) return;
        const pos = this.player.currentTime();
        const duration = this.player.duration();
        const looping = this.looping;
        if (looping) {
            ctx.fillStyle = "#a0a0a0";
            ctx.fillRect(this.start / duration * width, 0, (this.end - this.start) / duration * width, height);
        }
        ctx.fillStyle = "rgb(255 0 0)";
        for (const mark of this.marks)ctx.fillRect(mark / duration * width, 0, 1, height);
        const x = pos / duration * width;
        ctx.fillStyle = "rgb(0 0 0)";
        ctx.fillRect(x, 0, 1, height);
        if (!this.player.paused()) {
            if (this.redraw) window.cancelAnimationFrame(this.redraw);
            this.redraw = window.requestAnimationFrame(()=>{
                this.drawCanvas();
            });
        }
    }
    setRecordingOnPlayer() {
        if (this.recording && this.player) {
            this.leftright = 0;
            console.log("Set recording", this.recording);
            this.player.src({
                src: this.recording.url,
                type: "video/mp4"
            });
            this.looping = false;
            const p = this.player && this.player.abLoopPlugin;
            if (p) p.disable();
            this.config();
            if (this.autoplay) {
                this.player.ready(()=>{
                    this.play();
                });
                this.player.on("ended", ()=>{
                    if (this.recording && this.recording.library) this.server.fetchRecordings(this.recording.library).then((rs)=>{
                        const idx = Math.floor(Math.random() * rs.length);
                        const id = rs[idx].id;
                        window.location.href = `#/player/${id}/autoplay`;
                    });
                });
            }
        }
    }
    loop() {
        const p = this.player && this.player.abLoopPlugin;
        if (!p) this.looping = false;
        else {
            this.looping = !this.looping;
            if (this.looping) {
                this.setLoop();
                this.looping = true;
                p.enable();
            } else p.disable();
        }
        this.config();
    }
    setLoop() {
        const p = this.player && this.player.abLoopPlugin;
        if (!p) return;
        const pos = this.player.currentTime();
        const duration = this.player.duration();
        const marks = [
            0,
            ...this.marks,
            duration
        ];
        for(let i = 0; i < marks.length - 1; i++)if (marks[i] <= pos && marks[i + 1] >= pos) {
            p.setStart(marks[i]);
            p.setEnd(marks[i + 1]);
            this.start = marks[i];
            this.end = marks[i + 1];
            return;
        }
    }
    config() {
        const playing = this.player && !this.player.paused();
        const e = this.elt();
        e.find("button.loop").toggleClass("looping", this.looping);
        e.find("button.add-mark").prop("disabled", !this.player || this.player.paused());
        e.find("button.edit-marks").prop("disabled", this.marks.length == 0);
        e.find("button.play").prop("disabled", playing);
        e.find("button.pause").prop("disabled", !playing);
        e.find("button.repitch").prop("disabled", this.repitching);
        e.find(".repitch-container").toggle(this.repitching);
        this.drawCanvas();
    }
    async purchase() {
        if (!this.recording) return;
        const YES = "Yes, add";
        const unlimited = this.balance && (0, $82cf23e1ef1fc3af$export$a1bd3674078e2988)(this.balance.credits);
        const buy = ()=>{
            if (this.recording) this.server.addRecording(this.recording).then(()=>{
                this.refresh();
            });
        };
        if (unlimited) buy();
        else {
            const r = await (0, $752d59648741b237$export$2e2bcd8739ae039).confirmation({
                title: `Add to library`,
                message: `Really add to library? This will use ${(0, $82cf23e1ef1fc3af$export$2bf51cf47fafb61d)(this.recording.price || 0)}.`,
                options: [
                    YES,
                    "No, don't add"
                ]
            });
            if (r == YES && this.recording) buy();
        }
    }
    addMark() {
        if (!this.player) return;
        const pos = this.player.currentTime();
        if (this.marks.filter((x)=>x == pos).length > 0) return;
        this.marks.push(+pos);
        this.sortMarks();
        this.config();
        this.update(".edit-marks-list");
    }
    editMarks(show) {
        if (show) this.elt().find(".edit-marks-container").show();
        else {
            const inputs = this.elt().find(".edit-marks-container .edit-marks-list input.mark-value");
            this.marks.length = 0;
            inputs.each((idx, elt)=>{
                const val = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(elt).val();
                if (val.length > 0) {
                    const bits = val.split(/:/);
                    let x = 0;
                    let y;
                    while((y = bits.shift()) !== undefined)x = x * 60 + +y;
                    if (x) this.marks.push(x);
                }
            });
            this.sortMarks();
            this.setLoop();
            this.elt().find(".edit-marks-container").hide();
            this.update(".edit-marks-list");
            this.config();
        }
    }
    seekX(x) {
        const canvas = this.elt().find(".marks canvas")[0];
        if (!this.player || !canvas) return;
        const rect = canvas.getBoundingClientRect();
        const duration = this.player.duration();
        const pos = (x - rect.left) / rect.width * duration;
        this.player.currentTime(pos);
    }
    rewind() {
        const pos = this.looping ? this.start : 0;
        this.player && this.player.currentTime(pos);
    }
    play() {
        this.player && this.player.play();
        this.config();
    }
    pause() {
        this.player && this.player.pause();
        this.config();
    }
    repitch() {
        this.repitching = true;
        this.config();
        const vid = this.elt().find("video");
        vid[0].preservesPitch = false;
    }
    cancelRepitch() {
        this.repitching = false;
        this.config();
        const vid = this.elt().find("video");
        vid[0].preservesPitch = true;
    }
    saveRepitch() {
        if (!this.recording) return;
        this.repitching = false;
        this.config();
        this.server.saveRepitch(this.recording, +this.repitchCents).then(()=>{
            this.refresh();
        });
    }
    setRepitchCents(cents) {
        this.repitchCents = cents;
        if (!this.repitching) return;
        const rate = Math.exp((+cents - this.repitchCentsBase) / 1200 * Math.log(2));
        const vid = this.elt().find("video");
        vid[0].playbackRate = rate;
    }
    async setActivation(active) {
        if (!this.recording) return;
        const done = await this.server.setActivation(this.recording, active);
        this.refresh();
    }
    editRecording() {
        if (!this.recording) return;
        const url = `#/upload/${this.recording.id}`;
        window.location.href = url;
    }
    configLeftRight(val) {
        if (val !== undefined) this.leftright = val;
        this.configPanning && this.configPanning();
    }
}
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $d6f0e570c44705a9$export$2e2bcd8739ae039.classname, "click", ".add-recording", function(that, event, elt) {
    event.preventDefault();
    that.purchase();
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $d6f0e570c44705a9$export$2e2bcd8739ae039.classname, "click", ".add-mark", function(that, event, elt) {
    event.preventDefault();
    that.addMark();
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $d6f0e570c44705a9$export$2e2bcd8739ae039.classname, "click", ".loop", function(that, event, elt) {
    event.preventDefault();
    that.loop();
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $d6f0e570c44705a9$export$2e2bcd8739ae039.classname, "click", ".edit-marks", function(that, event, elt) {
    event.preventDefault();
    that.editMarks(true);
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $d6f0e570c44705a9$export$2e2bcd8739ae039.classname, "click", ".edit-marks-container .done", function(that, event, elt) {
    event.preventDefault();
    that.editMarks(false);
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $d6f0e570c44705a9$export$2e2bcd8739ae039.classname, "click", "button.rewind", function(that, event, elt) {
    event.preventDefault();
    that.rewind();
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $d6f0e570c44705a9$export$2e2bcd8739ae039.classname, "click", "button.play", function(that, event, elt) {
    event.preventDefault();
    that.play();
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $d6f0e570c44705a9$export$2e2bcd8739ae039.classname, "click", "button.pause", function(that, event, elt) {
    event.preventDefault();
    that.pause();
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $d6f0e570c44705a9$export$2e2bcd8739ae039.classname, "click", ".marks canvas", function(that, event, elt) {
    event.preventDefault();
    that.seekX(event.clientX);
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $d6f0e570c44705a9$export$2e2bcd8739ae039.classname, "click", ".edit-marks-list a.delete", function(that, event, elt) {
    event.preventDefault();
    (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(elt).closest("li").remove();
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $d6f0e570c44705a9$export$2e2bcd8739ae039.classname, "click", "button.repitch", function(that, event, elt) {
    event.preventDefault();
    that.repitch();
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $d6f0e570c44705a9$export$2e2bcd8739ae039.classname, "change", "input.cents", function(that, event, elt) {
    event.preventDefault();
    const cents = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(elt).val();
    that.setRepitchCents(cents);
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $d6f0e570c44705a9$export$2e2bcd8739ae039.classname, "click", "button.saveRepitch", function(that, event, elt) {
    event.preventDefault();
    that.saveRepitch();
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $d6f0e570c44705a9$export$2e2bcd8739ae039.classname, "click", "button.cancelRepitch", function(that, event, elt) {
    event.preventDefault();
    that.cancelRepitch();
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $d6f0e570c44705a9$export$2e2bcd8739ae039.classname, "click", "button.activation", function(that, event, elt) {
    event.preventDefault();
    const active = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(elt).data("active") ? true : false;
    that.setActivation(active);
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $d6f0e570c44705a9$export$2e2bcd8739ae039.classname, "click", "button.edit-recording", function(that, event, elt) {
    event.preventDefault();
    that.editRecording();
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $d6f0e570c44705a9$export$2e2bcd8739ae039.classname, "input", ".leftright", function(that, event, elt) {
    event.preventDefault();
    const val = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(elt).val();
    that.configLeftRight(val);
});


class $e3f4902815efaaad$export$d9a32f4c3d782fcb extends (0, $4f991c42613b920c$export$5593b284a7b9fb1b) {
    constructor(id, user, role, autoplay){
        super();
        this.id = id;
        this.v = new (0, $d6f0e570c44705a9$export$2e2bcd8739ae039)(id, user, role, autoplay);
    }
    view() {
        return this.v;
    }
    url() {
        return `/player/${encodeURIComponent(this.id)}`;
    }
}





var $3842119847827e17$export$2e2bcd8739ae039 = $3842119847827e17$var$template;
function $3842119847827e17$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $3842119847827e17$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $3842119847827e17$var$pug_escape(e) {
    var a = "" + e, t = $3842119847827e17$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $3842119847827e17$var$pug_match_html = /["&<>]/;
function $3842119847827e17$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(balance1, items1, paymentElementView1, renderCredits1, renderEuros1, result1) {
        pug_html = pug_html + '<div class="function-body"><div class="balance">';
        if (balance1) pug_html = pug_html + "<p>You have " + $3842119847827e17$var$pug_escape(null == (pug_interp = renderCredits1(balance1.credits)) ? "" : pug_interp) + " in your account.</p>";
        pug_html = pug_html + '</div><p>TALC credits are needed to obtain access to maestro Dibelo\'s recordings. Currently each recording requires 10 TALC credits to unlock the full recording and also access the special features (eg looping) useful for practice.</p><p>We are proud to also be authorized resellers of Mark Wyman\'s Big Tango Fake book. This is a PDF, downloadable from the "Fake Book" section once you have purchased it below. Note that just purchasing the Big Tango Fake Book does not unlock any of Maestro Dibelo\'s recordings.</p><p>And, we are pleased to offer the Practichord app to support your practice. The free version is available at no cost, but the paid version is well worth it and unlocks all keys (the free version only operates in the key of C)</p><form class="shop"><ol class="shop-items">';
        (function() {
            var $$obj = items1 || [];
            if ("number" == typeof $$obj.length) for(var idx = 0, $$l = $$obj.length; idx < $$l; idx++){
                var item = $$obj[idx];
                pug_html = pug_html + '<li class="shop-item"><label><input' + (' type="radio" name="shop_item_idx"' + $3842119847827e17$var$pug_attr("value", idx, true, true)) + ">\n" + $3842119847827e17$var$pug_escape(null == (pug_interp = item.description) ? "" : pug_interp) + " - " + $3842119847827e17$var$pug_escape(null == (pug_interp = renderEuros1(item.cents / 100)) ? "" : pug_interp) + "</label></li>";
            }
            else {
                var $$l = 0;
                for(var idx in $$obj){
                    $$l++;
                    var item = $$obj[idx];
                    pug_html = pug_html + '<li class="shop-item"><label><input' + (' type="radio" name="shop_item_idx"' + $3842119847827e17$var$pug_attr("value", idx, true, true)) + ">\n" + $3842119847827e17$var$pug_escape(null == (pug_interp = item.description) ? "" : pug_interp) + " - " + $3842119847827e17$var$pug_escape(null == (pug_interp = renderEuros1(item.cents / 100)) ? "" : pug_interp) + "</label></li>";
                }
            }
        }).call(this);
        pug_html = pug_html + "</ol><div>" + (null == (pug_interp = paymentElementView1) ? "" : pug_interp) + '</div><div class="result-section">';
        if (result1) pug_html = pug_html + '<p class="result">' + $3842119847827e17$var$pug_escape(null == (pug_interp = result1) ? "" : pug_interp) + "</p>";
        pug_html = pug_html + "</div></form></div>";
    }).call(this, "balance" in locals_for_with ? locals_for_with.balance : typeof balance !== "undefined" ? balance : undefined, "items" in locals_for_with ? locals_for_with.items : typeof items !== "undefined" ? items : undefined, "paymentElementView" in locals_for_with ? locals_for_with.paymentElementView : typeof paymentElementView !== "undefined" ? paymentElementView : undefined, "renderCredits" in locals_for_with ? locals_for_with.renderCredits : typeof renderCredits !== "undefined" ? renderCredits : undefined, "renderEuros" in locals_for_with ? locals_for_with.renderEuros : typeof renderEuros !== "undefined" ? renderEuros : undefined, "result" in locals_for_with ? locals_for_with.result : typeof result !== "undefined" ? result : undefined);
    return pug_html;
}




var $10cKx = parcelRequire("10cKx");

class $306ae29876ad482b$export$fc14f7024165eccb extends (0, $f55c403e2549a503$export$2e2bcd8739ae039) {
    static #_ = this.classname = "account-view";
    constructor(){
        super($306ae29876ad482b$export$fc14f7024165eccb.classname);
        this.server = (0, $b306c6aaaa6be045$export$2e2bcd8739ae039).instance();
        this.paymentElementView = new (0, $64b74dc488fa391c$export$b8dbac763e5ae10a)();
        this.listenForPayment();
        this.server.fetchShopCatalogue().then((items)=>{
            this.items = items;
            this.update();
        });
        this.refresh();
    }
    refresh() {
        this.server.getBalance().then((b)=>{
            this.balance = b;
            this.update(".balance");
        });
    }
    listenForPayment() {
        const paid_ = this.paymentElementView.getPromise();
        paid_.then((x)=>{
            const pi = x.paymentIntent;
            const amtCents = pi.amount;
            const currency = pi.amount;
            const status = pi.status;
            if (status == "succeeded") this.addOrder(pi);
        });
        paid_.catch(()=>{
            this.paymentElementView.newPromise();
            this.listenForPayment();
        });
    }
    async addOrder(paymentIntent) {
        const data = await this.server.purchase(paymentIntent);
        this.result = data.result;
        this.update(".result-section");
        this.refresh();
    }
    render0() {
        const data = {
            balance: this.balance,
            items: this.items,
            paymentElementView: this.paymentElementView,
            renderCredits: (0, $82cf23e1ef1fc3af$export$2bf51cf47fafb61d),
            renderEuros: (0, $82cf23e1ef1fc3af$export$48606025842571ea),
            result: this.result
        };
        const out = this.pug((0, $3842119847827e17$export$2e2bcd8739ae039), data);
        return out;
    }
    setChoice(idx) {
        if (!this.items) return;
        const item = this.items[idx];
        const intent_ = this.paymentElementView.createIntent(item.cents / 100, item.description);
        intent_.then(()=>{
            const pelt = this.paymentElementView.elt();
            const offset = pelt && pelt.offset();
            if (offset) (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))("html, body").animate({
                scrollTop: offset.top
            }, 100);
        });
    }
}
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $306ae29876ad482b$export$fc14f7024165eccb.classname, "change", "input[name='shop_item_idx']", function(that, event, elt) {
    event.preventDefault();
    const idx = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(elt).val();
    that.setChoice(idx);
});


class $1af4a577d4938c38$export$2e494e966dc19a91 extends (0, $4f991c42613b920c$export$5593b284a7b9fb1b) {
    constructor(){
        super();
        this.v = new (0, $306ae29876ad482b$export$fc14f7024165eccb)();
    }
    view() {
        return this.v;
    }
    url() {
        return `/account`;
    }
}




var $c5c05078a785689e$export$2e2bcd8739ae039 = $c5c05078a785689e$var$template;
function $c5c05078a785689e$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    pug_html = pug_html + '<div class="banner1"><h1>Tango a la Carta</h1></div><div class="function-body"><div class="blurb"><p>The recordings in this platform are a showcase of playing tango <em>a la parrilla</em>,\nmeaning, improvised without a fixed arrangement.</p><p>The project was born out of an idea of Ruth Rozeelar\'s\n(<a class="clickable" href="https://www.bandoneon-international.org/">https://www.ruth-rozelaar.co.uk/</a>),\nto go on tour with the great bandoneon master Orlando Dibelo and perform at milongas, playing tunes\non request by the dancers present, who could choose from a palette of several hundred tangos, valses and milongas.</p><p>As preparation for the tour, Ruth asked maestro Dibelo to demonstrate many tunes, and we were\nlucky to be able to record him playing in this <em>a la parrilla</em> style and present the results here.</p><p>These recordings are intended as study material for anyone who is interested in learning to play tango\n<em>a la parrilla</em>. The platform has facilities for playing the recordings back at slow speeds,\nas well as defining playback loops for practising specific sections.</p><p>With Tango a la Carta, you can play along with maestro Dibelo, enjoy his infectious and\nvivacious style, and learn the improvisational elements that make up this style.</p><p>We offer access to the recordings on a paid basis. The proceeds from sale of access to the recordings\ngo the artist (maestro Dibelo).</p><p>We hope that you find this to be a valuable resource that supports your tango <em>a la parrilla</em> journey.</p><p>Also, we are very happy to be official resellers of Mark Wyman\'s wonderful Tango Fake Book, which\nhas an absolute wealth of material for supporting tango <em>a la parrilla</em>.</p><p>Options for purchasing recording credits and also Mark Wyman\'s Tango Fake Book are available in the\n<a class="clickable" href="#/account">Account</a> section.</p><p>You can contact Ruth at <a class="clickable" href="https://www.ruth-rozelaar.co.uk/contact/">https://www.ruth-rozelaar.co.uk/contact/</a></p></div></div>';
    return pug_html;
}


class $283a314c23da9d02$export$f9e668fcf42dbb0d extends (0, $4f991c42613b920c$export$5593b284a7b9fb1b) {
    constructor(){
        super();
        this.v = new $283a314c23da9d02$var$AboutProjectView();
    }
    view() {
        return this.v;
    }
    url() {
        return "/project";
    }
    offlineEnabled() {
        return true;
    }
}
class $283a314c23da9d02$var$AboutProjectView extends (0, $f55c403e2549a503$export$2e2bcd8739ae039) {
    static #_ = this.classname = "about-the-project-view";
    constructor(){
        super($283a314c23da9d02$var$AboutProjectView.classname);
    }
    render0() {
        const data = {};
        const out = this.pug((0, $c5c05078a785689e$export$2e2bcd8739ae039), data);
        return out;
    }
}




var $3a55113dc6cb3c83$export$2e2bcd8739ae039 = $3a55113dc6cb3c83$var$template;
function $3a55113dc6cb3c83$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $3a55113dc6cb3c83$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $3a55113dc6cb3c83$var$pug_escape(e) {
    var a = "" + e, t = $3a55113dc6cb3c83$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $3a55113dc6cb3c83$var$pug_match_html = /["&<>]/;
function $3a55113dc6cb3c83$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(emailed1, item1, payment1, renderEuros1, signup1, url1) {
        pug_html = pug_html + '<div class="function-body"><div class="blurb"><p>The Tango a la Carta recordings are all played "a la parrilla", meaning improvised in the moment\nwithout a fixed arrangement. The only written point of reference used is the lead-sheet\nin Mark Wyman\'s\n<a class="clickable" href="http://www.harmonk.com/index.html">Big Tango Fake Book.</a>\nThis is an invaluable and inspiring collection lead-sheets of hundreds of tango tunes, and the\nrecordings in this site are a testament to the creative possibilities that the lead sheets open up.</p><p>We are very happy to be authorised resellers of the Big Tango Fake Book.</p>';
        if (url1) {
            pug_html = pug_html + '<p class="download">You can download the fakebook\n<a' + (' class="clickable link"' + $3a55113dc6cb3c83$var$pug_attr("href", url1, true, true)) + ">here.</a></p>";
            if (emailed1) pug_html = pug_html + "<p>We have also sent you an email with this download link.</p>";
        } else if (emailed1) pug_html = pug_html + "<p>We have sent you an email with a link to download the your copy of the Big Tango Fake Book.</p>";
        pug_html = pug_html + "</div>";
        if (item1) {
            pug_html = pug_html + '<p class="cardless-card text-centre">You can purchase an official copy of the Big Tango Fake Book here, for ' + $3a55113dc6cb3c83$var$pug_escape(null == (pug_interp = renderEuros1(item1.cents / 100)) ? "" : pug_interp) + ".</p>";
            if (signup1) pug_html = pug_html + '<p class="cardless-card text-centre">To sell you a copy of the Big Tango Fake Book  need your name and email address.</p><div>' + (null == (pug_interp = signup1) ? "" : pug_interp) + "</div>";
            if (payment1) pug_html = pug_html + "<p></p><div>" + (null == (pug_interp = payment1) ? "" : pug_interp) + "</div>";
        }
        pug_html = pug_html + "</div>";
    }).call(this, "emailed" in locals_for_with ? locals_for_with.emailed : typeof emailed !== "undefined" ? emailed : undefined, "item" in locals_for_with ? locals_for_with.item : typeof item !== "undefined" ? item : undefined, "payment" in locals_for_with ? locals_for_with.payment : typeof payment !== "undefined" ? payment : undefined, "renderEuros" in locals_for_with ? locals_for_with.renderEuros : typeof renderEuros !== "undefined" ? renderEuros : undefined, "signup" in locals_for_with ? locals_for_with.signup : typeof signup !== "undefined" ? signup : undefined, "url" in locals_for_with ? locals_for_with.url : typeof url !== "undefined" ? url : undefined);
    return pug_html;
}







const $d55f5ee1892d0c94$var$BIG_TANGO_FAKE_BOOK = "Big Tango Fake Book";
class $d55f5ee1892d0c94$export$2e2bcd8739ae039 extends (0, $f55c403e2549a503$export$2e2bcd8739ae039) {
    static #_ = this.classname = "fakebook-view";
    constructor(){
        super($d55f5ee1892d0c94$export$2e2bcd8739ae039.classname);
        this.server = (0, $b306c6aaaa6be045$export$2e2bcd8739ae039).instance();
        this.url = undefined;
        this.item = undefined;
        this.setup();
    }
    async setup() {
        this.user = await this.server.loginRemembered();
        if (this.user) {
            const result = await this.server.getBalance();
            // @ts-ignore
            const balances = result.balances;
            if (balances) {
                const accts = Object.keys(balances).filter((acct)=>acct == $d55f5ee1892d0c94$var$BIG_TANGO_FAKE_BOOK);
                const acct = accts[0];
                const balance = acct && balances[acct];
                if (balance > 0) this.url = await this.server.getFakebookUrl();
            }
            this.signup = undefined;
        } else {
            this.signup = new (0, $03487221bbbf5d25$export$cc15cfe224a6a69b)(false);
            this.signup.autologin = true;
        }
        if (!this.url) {
            const catalogue = await this.server.fetchShopCatalogue();
            const fb = catalogue.filter((i)=>i.description && i.description == $d55f5ee1892d0c94$var$BIG_TANGO_FAKE_BOOK);
            if (fb.length > 0) this.item = fb[0];
            if (this.item && this.item.cents && this.user) {
                this.paymentElementView = new (0, $64b74dc488fa391c$export$b8dbac763e5ae10a)();
                this.paymentElementView.createIntent(this.item.cents / 100, $d55f5ee1892d0c94$var$BIG_TANGO_FAKE_BOOK);
                this.listenForPayment();
            }
        }
        this.update();
    }
    render0() {
        const data = {
            url: this.url,
            item: this.item,
            signup: this.signup,
            payment: this.paymentElementView,
            result: this.result,
            renderEuros: (0, $82cf23e1ef1fc3af$export$48606025842571ea)
        };
        const out = this.pug((0, $3a55113dc6cb3c83$export$2e2bcd8739ae039), data);
        return out;
    }
    notify(n) {
        if (n instanceof (0, $03487221bbbf5d25$export$3dfe41357127b5d7)) this.signedUp(n);
        super.notify(n);
    }
    async signedUp(n) {
        if (n.newUser) // New user, set up again to proceed with payment
        this.setup();
        else // User already exists
        (0, $752d59648741b237$export$2e2bcd8739ae039).alert({
            message: "There is already a registered user with this email. Please log in first and proceed to the Account page to make your purchase."
        });
    }
    listenForPayment() {
        if (!this.paymentElementView) return;
        const paid_ = this.paymentElementView.getPromise();
        paid_.then((x)=>{
            const pi = x.paymentIntent;
            const amtCents = pi.amount;
            const currency = pi.amount;
            const status = pi.status;
            if (status == "succeeded") this.addOrder(pi);
        });
        paid_.catch(()=>{
            this.paymentElementView && this.paymentElementView.newPromise();
            this.listenForPayment();
        });
    }
    async addOrder(paymentIntent) {
        const data = await this.server.purchase(paymentIntent);
        this.result = data.result;
        this.update(".result-section");
        this.setup();
    }
}


class $d1f868cdd3cb4b4b$export$79d5df92b7d91620 extends (0, $4f991c42613b920c$export$5593b284a7b9fb1b) {
    constructor(){
        super();
        this.v = new (0, $d55f5ee1892d0c94$export$2e2bcd8739ae039)();
    }
    view() {
        return this.v;
    }
    url() {
        return `/fakebook`;
    }
}




var $609108221ded3b14$export$2e2bcd8739ae039 = $609108221ded3b14$var$template;
function $609108221ded3b14$var$pug_escape(e) {
    var a = "" + e, t = $609108221ded3b14$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $609108221ded3b14$var$pug_match_html = /["&<>]/;
function $609108221ded3b14$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(token1) {
        pug_html = pug_html + '<div class="function-body"><div class="blurb"><p>This Practichord app helps you study chord progressions and voicings, providing many playful exercises, laying, step by step, the foundations for \'A La Parrilla\' style playing.</p><p>Useful for players of all levels.</p><p>Any speed, any tonality! (** extended version)</p><p>The basic version is free, and the extended version can be purchased for \u20AC10</p><p>To access the app, use this link:</p><p><a class="clickable" href="https://bandoneon.ing/practice/" target="_blank">https://bandoneon.ing/practice/</a></p>';
        if (token1 === false) pug_html = pug_html + '<p>You can purchase a registration token for the Practichord app in the\n<a class="clickable" href="#/account">Account</a>\nsection.</p>';
        if (token1) pug_html = pug_html + '<p>Your registration key for Practichord is:</p><pre class="registration-key">' + $609108221ded3b14$var$pug_escape(null == (pug_interp = token1) ? "" : pug_interp) + "</pre><p>You can cut/paste this token into the 'Register' section of Practichord (button at top of the Practichord screen) to access the extended version of Practichord.</p>";
        pug_html = pug_html + "</div></div>";
    }).call(this, "token" in locals_for_with ? locals_for_with.token : typeof token !== "undefined" ? token : undefined);
    return pug_html;
}



class $1b16c8f2ee77a76a$export$2e2bcd8739ae039 extends (0, $f55c403e2549a503$export$2e2bcd8739ae039) {
    static #_ = this.classname = "practichord-view";
    constructor(){
        super($1b16c8f2ee77a76a$export$2e2bcd8739ae039.classname);
        this.server = (0, $b306c6aaaa6be045$export$2e2bcd8739ae039).instance();
        this.token = undefined;
        this.setup();
    }
    async setup() {
        const result = await this.server.getPractichordToken();
        // @ts-ignore
        this.token = result.token || false;
        this.update();
    }
    render0() {
        const data = {
            token: this.token
        };
        const out = this.pug((0, $609108221ded3b14$export$2e2bcd8739ae039), data);
        return out;
    }
}


class $b92b7a0b03ecf11e$export$83e4dde1c0387ebc extends (0, $4f991c42613b920c$export$5593b284a7b9fb1b) {
    constructor(){
        super();
        this.v = new (0, $1b16c8f2ee77a76a$export$2e2bcd8739ae039)();
    }
    view() {
        return this.v;
    }
    url() {
        return `/practichord`;
    }
}




var $821d9f21d3d01da4$export$2e2bcd8739ae039 = $821d9f21d3d01da4$var$template;
function $821d9f21d3d01da4$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $821d9f21d3d01da4$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $821d9f21d3d01da4$var$pug_escape(e) {
    var a = "" + e, t = $821d9f21d3d01da4$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $821d9f21d3d01da4$var$pug_match_html = /["&<>]/;
function $821d9f21d3d01da4$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(formatDate1, from1, salesDetailsData1, salesSummaryData1, to1) {
        pug_html = pug_html + '<div class="function-body"><form class="report-form with-validation"><div class="dates section"><div class="grid"><div><label>From</label><input' + (' class="form-control datefield" name="from"' + $821d9f21d3d01da4$var$pug_attr("value", formatDate1(from1), true, true)) + "></div><div><label>To</label><input" + (' class="form-control datefield" name="to"' + $821d9f21d3d01da4$var$pug_attr("value", formatDate1(to1), true, true)) + '></div></div></div><button class="action sales-summary">Sales summary</button><button class="action sales-details">Sales details</button></form><div class="results">';
        if (salesSummaryData1) {
            pug_html = pug_html + "<h2>Sales summary</h2>";
            if (salesSummaryData1.length > 0) {
                pug_html = pug_html + '<table class="sales-summary"><thead><th>Type</th><th>Euros</th><th>Number of transactions</th></thead>';
                (function() {
                    var $$obj = salesSummaryData1;
                    if ("number" == typeof $$obj.length) for(var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++){
                        var line = $$obj[pug_index0];
                        pug_html = pug_html + "<tr><td>" + $821d9f21d3d01da4$var$pug_escape(null == (pug_interp = line.type) ? "" : pug_interp) + "</td><td>" + $821d9f21d3d01da4$var$pug_escape(null == (pug_interp = line.euros) ? "" : pug_interp) + "</td><td>" + $821d9f21d3d01da4$var$pug_escape(null == (pug_interp = line.txns) ? "" : pug_interp) + "</td></tr>";
                    }
                    else {
                        var $$l = 0;
                        for(var pug_index0 in $$obj){
                            $$l++;
                            var line = $$obj[pug_index0];
                            pug_html = pug_html + "<tr><td>" + $821d9f21d3d01da4$var$pug_escape(null == (pug_interp = line.type) ? "" : pug_interp) + "</td><td>" + $821d9f21d3d01da4$var$pug_escape(null == (pug_interp = line.euros) ? "" : pug_interp) + "</td><td>" + $821d9f21d3d01da4$var$pug_escape(null == (pug_interp = line.txns) ? "" : pug_interp) + "</td></tr>";
                        }
                    }
                }).call(this);
                pug_html = pug_html + "</table>";
            } else pug_html = pug_html + "<p>No sales in the selected period</p>";
        }
        if (salesDetailsData1) {
            pug_html = pug_html + "<h2>Sales details</h2>";
            if (salesDetailsData1.length > 0) {
                pug_html = pug_html + '<a class="sales-details-csv clickable">Download as CSV file</a><br><table class="sales-details"><thead><th>Date</th><th>Amt</th><th>Description</th><th>Name</th><th>Email</th></thead>';
                (function() {
                    var $$obj = salesDetailsData1;
                    if ("number" == typeof $$obj.length) for(var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++){
                        var line = $$obj[pug_index1];
                        pug_html = pug_html + "<tr><td>" + $821d9f21d3d01da4$var$pug_escape(null == (pug_interp = line.ts) ? "" : pug_interp) + "</td><td>" + $821d9f21d3d01da4$var$pug_escape(null == (pug_interp = line.amt) ? "" : pug_interp) + " " + $821d9f21d3d01da4$var$pug_escape(null == (pug_interp = line.type == "euros" ? "\u20AC" : line.type) ? "" : pug_interp) + "</td><td>" + $821d9f21d3d01da4$var$pug_escape(null == (pug_interp = line.desc) ? "" : pug_interp) + "</td><td>" + $821d9f21d3d01da4$var$pug_escape(null == (pug_interp = line.name) ? "" : pug_interp) + "</td><td>" + $821d9f21d3d01da4$var$pug_escape(null == (pug_interp = line.email) ? "" : pug_interp) + "</td></tr>";
                    }
                    else {
                        var $$l = 0;
                        for(var pug_index1 in $$obj){
                            $$l++;
                            var line = $$obj[pug_index1];
                            pug_html = pug_html + "<tr><td>" + $821d9f21d3d01da4$var$pug_escape(null == (pug_interp = line.ts) ? "" : pug_interp) + "</td><td>" + $821d9f21d3d01da4$var$pug_escape(null == (pug_interp = line.amt) ? "" : pug_interp) + " " + $821d9f21d3d01da4$var$pug_escape(null == (pug_interp = line.type == "euros" ? "\u20AC" : line.type) ? "" : pug_interp) + "</td><td>" + $821d9f21d3d01da4$var$pug_escape(null == (pug_interp = line.desc) ? "" : pug_interp) + "</td><td>" + $821d9f21d3d01da4$var$pug_escape(null == (pug_interp = line.name) ? "" : pug_interp) + "</td><td>" + $821d9f21d3d01da4$var$pug_escape(null == (pug_interp = line.email) ? "" : pug_interp) + "</td></tr>";
                        }
                    }
                }).call(this);
                pug_html = pug_html + "</table>";
            } else pug_html = pug_html + "<p>No sales in the selected period</p>";
        }
        pug_html = pug_html + "</div></div>";
    }).call(this, "formatDate" in locals_for_with ? locals_for_with.formatDate : typeof formatDate !== "undefined" ? formatDate : undefined, "from" in locals_for_with ? locals_for_with.from : typeof from !== "undefined" ? from : undefined, "salesDetailsData" in locals_for_with ? locals_for_with.salesDetailsData : typeof salesDetailsData !== "undefined" ? salesDetailsData : undefined, "salesSummaryData" in locals_for_with ? locals_for_with.salesSummaryData : typeof salesSummaryData !== "undefined" ? salesSummaryData : undefined, "to" in locals_for_with ? locals_for_with.to : typeof to !== "undefined" ? to : undefined);
    return pug_html;
}


/**
 * Parse ddmmyyyy date into JSONDate (yyyy-mm-dd)
 * @param d
 */ function $78d3e8b7d5e47526$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $78d3e8b7d5e47526$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $78d3e8b7d5e47526$export$2e2bcd8739ae039(o);
}


function $b320e4b5494ae3f6$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $b741822595cea3a4$export$2e2bcd8739ae039(value) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $78d3e8b7d5e47526$export$2e2bcd8739ae039)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}




function $2285621ea3fa8491$export$2e2bcd8739ae039(argument) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $78d3e8b7d5e47526$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $c891abca0473dd2d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $b741822595cea3a4$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}


function $e988ad2ce58d9c6e$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $cd9d55142ab92e73$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $e988ad2ce58d9c6e$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $3ed9f5de8fc7a4e8$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $e988ad2ce58d9c6e$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $cd9d55142ab92e73$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $4bf5d6a9545895ce$var$MILLISECONDS_IN_DAY = 86400000;
function $4bf5d6a9545895ce$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $4bf5d6a9545895ce$var$MILLISECONDS_IN_DAY) + 1;
}





function $d78f02d3a8ed773a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $ec21f9a77b67097d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $d78f02d3a8ed773a$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $d78f02d3a8ed773a$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $1227796d448c0cba$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $ec21f9a77b67097d$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $d78f02d3a8ed773a$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $2aaca0b5e621bcb8$var$MILLISECONDS_IN_WEEK = 604800000;
function $2aaca0b5e621bcb8$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $d78f02d3a8ed773a$export$2e2bcd8739ae039)(date).getTime() - (0, $1227796d448c0cba$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $2aaca0b5e621bcb8$var$MILLISECONDS_IN_WEEK) + 1;
}







var $bac751230e4fc222$var$defaultOptions = {};
function $bac751230e4fc222$export$430a3269e24b912e() {
    return $bac751230e4fc222$var$defaultOptions;
}
function $bac751230e4fc222$export$95365be1b0704abc(newOptions) {
    $bac751230e4fc222$var$defaultOptions = newOptions;
}


function $4da6ce6e331a379d$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $bac751230e4fc222$export$430a3269e24b912e)();
    var weekStartsOn = (0, $e988ad2ce58d9c6e$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $bde2a4d7c75e3bf6$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $bac751230e4fc222$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $e988ad2ce58d9c6e$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $4da6ce6e331a379d$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $4da6ce6e331a379d$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $649512878ed71410$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $bac751230e4fc222$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $e988ad2ce58d9c6e$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $bde2a4d7c75e3bf6$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $4da6ce6e331a379d$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $8e15e1d41b5594be$var$MILLISECONDS_IN_WEEK = 604800000;
function $8e15e1d41b5594be$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $4da6ce6e331a379d$export$2e2bcd8739ae039)(date, options).getTime() - (0, $649512878ed71410$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $8e15e1d41b5594be$var$MILLISECONDS_IN_WEEK) + 1;
}



function $7e1e49f3280ac08a$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $d05abe6e05e9075a$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $d05abe6e05e9075a$export$2e2bcd8739ae039 = $d05abe6e05e9075a$var$formatters;


var $dabc1a88c48a0b4a$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $dabc1a88c48a0b4a$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $d05abe6e05e9075a$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $bde2a4d7c75e3bf6$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $ec21f9a77b67097d$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $d05abe6e05e9075a$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $8e15e1d41b5594be$export$2e2bcd8739ae039)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $2aaca0b5e621bcb8$export$2e2bcd8739ae039)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $d05abe6e05e9075a$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $4bf5d6a9545895ce$export$2e2bcd8739ae039)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $dabc1a88c48a0b4a$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $dabc1a88c48a0b4a$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $dabc1a88c48a0b4a$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $dabc1a88c48a0b4a$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $dabc1a88c48a0b4a$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $dabc1a88c48a0b4a$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $d05abe6e05e9075a$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $d05abe6e05e9075a$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $d05abe6e05e9075a$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $d05abe6e05e9075a$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $d05abe6e05e9075a$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $dabc1a88c48a0b4a$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $dabc1a88c48a0b4a$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $dabc1a88c48a0b4a$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $dabc1a88c48a0b4a$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $dabc1a88c48a0b4a$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $dabc1a88c48a0b4a$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $dabc1a88c48a0b4a$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $dabc1a88c48a0b4a$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $dabc1a88c48a0b4a$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $dabc1a88c48a0b4a$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $dabc1a88c48a0b4a$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(minutes, 2);
}
function $dabc1a88c48a0b4a$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $dabc1a88c48a0b4a$var$formatTimezone(offset, dirtyDelimiter);
}
function $dabc1a88c48a0b4a$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $7e1e49f3280ac08a$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $dabc1a88c48a0b4a$export$2e2bcd8739ae039 = $dabc1a88c48a0b4a$var$formatters;


var $2995e6109b28643a$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $2995e6109b28643a$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $2995e6109b28643a$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $2995e6109b28643a$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $2995e6109b28643a$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $2995e6109b28643a$var$timeLongFormatter(timePattern, formatLong));
};
var $2995e6109b28643a$var$longFormatters = {
    p: $2995e6109b28643a$var$timeLongFormatter,
    P: $2995e6109b28643a$var$dateTimeLongFormatter
};
var $2995e6109b28643a$export$2e2bcd8739ae039 = $2995e6109b28643a$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $34df346d5c5052d9$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $227232e093313922$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $227232e093313922$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $227232e093313922$export$c6cc36aa33304772(token) {
    return $227232e093313922$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $227232e093313922$export$c6b49d6dceb604a1(token) {
    return $227232e093313922$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $227232e093313922$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $9d3b8f1bbb60dc8e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $9d3b8f1bbb60dc8e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $9d3b8f1bbb60dc8e$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $9d3b8f1bbb60dc8e$export$2e2bcd8739ae039 = $9d3b8f1bbb60dc8e$var$formatDistance;


function $772b9d5c5acb67c6$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $adadf9b5f344c056$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $adadf9b5f344c056$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $adadf9b5f344c056$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $adadf9b5f344c056$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $adadf9b5f344c056$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $adadf9b5f344c056$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $adadf9b5f344c056$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $adadf9b5f344c056$export$2e2bcd8739ae039 = $adadf9b5f344c056$var$formatLong;


var $27b07b6969b3b18a$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $27b07b6969b3b18a$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $27b07b6969b3b18a$var$formatRelativeLocale[token];
};
var $27b07b6969b3b18a$export$2e2bcd8739ae039 = $27b07b6969b3b18a$var$formatRelative;


function $2ca886d2c8d77e4d$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $17da716efdeaa8e3$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $17da716efdeaa8e3$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $17da716efdeaa8e3$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $17da716efdeaa8e3$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $17da716efdeaa8e3$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $17da716efdeaa8e3$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $17da716efdeaa8e3$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $17da716efdeaa8e3$var$localize = {
    ordinalNumber: $17da716efdeaa8e3$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $17da716efdeaa8e3$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $17da716efdeaa8e3$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $17da716efdeaa8e3$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $17da716efdeaa8e3$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $17da716efdeaa8e3$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $17da716efdeaa8e3$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $17da716efdeaa8e3$export$2e2bcd8739ae039 = $17da716efdeaa8e3$var$localize;


function $d8d845ab692d6dea$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $d8d845ab692d6dea$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $d8d845ab692d6dea$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $d8d845ab692d6dea$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $d8d845ab692d6dea$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $85cdfad058df8fd3$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $a0618466070b1817$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $a0618466070b1817$var$parseOrdinalNumberPattern = /\d+/i;
var $a0618466070b1817$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $a0618466070b1817$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $a0618466070b1817$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $a0618466070b1817$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $a0618466070b1817$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $a0618466070b1817$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $a0618466070b1817$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $a0618466070b1817$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $a0618466070b1817$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $a0618466070b1817$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $a0618466070b1817$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $a0618466070b1817$var$matchOrdinalNumberPattern,
        parsePattern: $a0618466070b1817$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a0618466070b1817$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a0618466070b1817$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a0618466070b1817$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a0618466070b1817$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a0618466070b1817$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a0618466070b1817$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a0618466070b1817$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a0618466070b1817$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a0618466070b1817$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $a0618466070b1817$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $a0618466070b1817$export$2e2bcd8739ae039 = $a0618466070b1817$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $b4f914fe53c31e55$var$locale = {
    code: "en-US",
    formatDistance: (0, $9d3b8f1bbb60dc8e$export$2e2bcd8739ae039),
    formatLong: (0, $adadf9b5f344c056$export$2e2bcd8739ae039),
    formatRelative: (0, $27b07b6969b3b18a$export$2e2bcd8739ae039),
    localize: (0, $17da716efdeaa8e3$export$2e2bcd8739ae039),
    match: (0, $a0618466070b1817$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $b4f914fe53c31e55$export$2e2bcd8739ae039 = $b4f914fe53c31e55$var$locale;


var $118b19c6d90f072d$export$2e2bcd8739ae039 = (0, $b4f914fe53c31e55$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $d87b809bda78551e$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $d87b809bda78551e$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $d87b809bda78551e$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $d87b809bda78551e$var$doubleQuoteRegExp = /''/g;
var $d87b809bda78551e$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $d87b809bda78551e$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $bac751230e4fc222$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $118b19c6d90f072d$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $e988ad2ce58d9c6e$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $e988ad2ce58d9c6e$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $c891abca0473dd2d$export$2e2bcd8739ae039)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $34df346d5c5052d9$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $3ed9f5de8fc7a4e8$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($d87b809bda78551e$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $2995e6109b28643a$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($d87b809bda78551e$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $d87b809bda78551e$var$cleanEscapedString(substring);
        var formatter = (0, $dabc1a88c48a0b4a$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $227232e093313922$export$c6b49d6dceb604a1)(substring)) (0, $227232e093313922$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $227232e093313922$export$c6cc36aa33304772)(substring)) (0, $227232e093313922$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($d87b809bda78551e$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $d87b809bda78551e$var$cleanEscapedString(input) {
    var matched = input.match($d87b809bda78551e$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($d87b809bda78551e$var$doubleQuoteRegExp, "'");
}


function $10b4a29ba4211311$export$6b862160d295c8e(d) {
    if (!d) return d;
    const bits = d.trim().split(/\//);
    return bits[2] + "-" + bits[1] + "-" + bits[0];
}
function $10b4a29ba4211311$export$3ae94a2503e890a1(d) {
    if (!d) return d;
    const bits = d.trim().split(/-/);
    return bits[2] + "/" + bits[1] + "/" + bits[0];
}
function $10b4a29ba4211311$export$99d4b17c5144ff29() {
    return (0, $d87b809bda78551e$export$2e2bcd8739ae039)(new Date(), "yyyy-MM-dd");
}
function $10b4a29ba4211311$export$e397c055d51dc134(date) {
    return (0, $d87b809bda78551e$export$2e2bcd8739ae039)(date, "yyyy-MM-dd");
}
function $10b4a29ba4211311$export$bfe4ac50319c1d9b(ts) {
    const date = new Date(ts);
    return (0, $d87b809bda78551e$export$2e2bcd8739ae039)(date, "yyyy-MM-dd HH:mm:SS");
}




class $8fdefe152560acc2$export$534edfd3503bfaa5 extends (0, $f55c403e2549a503$export$2e2bcd8739ae039) {
    static #_ = this.classname = "reports-view";
    constructor(){
        super($8fdefe152560acc2$export$534edfd3503bfaa5.classname);
        this.server = (0, $b306c6aaaa6be045$export$2e2bcd8739ae039).instance();
        this.from = "2023-05-01";
        this.to = (0, $10b4a29ba4211311$export$99d4b17c5144ff29)();
    }
    render0() {
        const data = {
            formatDate: (0, $10b4a29ba4211311$export$3ae94a2503e890a1),
            salesSummaryData: this.salesSummaryData,
            salesDetailsData: this.salesDetailsData
        };
        const out = this.pug((0, $821d9f21d3d01da4$export$2e2bcd8739ae039), data);
        out.find(".with-validation").validate({
            rules: {
                from: "required",
                to: "required"
            }
        });
        this.afterUpdate(()=>{
            this.elt().find("input.datefield").datefield({
                startDay: 1
            });
        });
        return out;
    }
    getDates() {
        const form = this.elt().find("form.report-form");
        if (!form.valid()) return false;
        const data = {};
        (0, $82cf23e1ef1fc3af$export$54048630ffcff79a)(form, data);
        this.from = data.from;
        this.to = data.to;
        return {
            from: data.from,
            to: data.to
        };
    }
    async salesSummary() {
        const dates = this.getDates();
        if (!dates) return;
        this.salesSummaryData = await this.server.getSalesSummaryReport(dates.from, dates.to);
        this.update(".results");
    }
    async salesDetails() {
        const dates = this.getDates();
        if (!dates) return;
        this.salesDetailsData = await this.server.getSalesDetailsReport(dates.from, dates.to);
        this.update(".results");
    }
    async salesDetailsCsv() {
        const dates = this.getDates();
        if (!dates) return;
        const csv = this.server.getSalesDetailsCsvUrl(dates.from, dates.to);
        window.open(csv);
    }
}
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $8fdefe152560acc2$export$534edfd3503bfaa5.classname, "click", ".sales-summary", function(that, event, elt) {
    event.preventDefault();
    that.salesSummary();
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $8fdefe152560acc2$export$534edfd3503bfaa5.classname, "click", ".sales-details", function(that, event, elt) {
    event.preventDefault();
    that.salesDetails();
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $8fdefe152560acc2$export$534edfd3503bfaa5.classname, "click", ".sales-details-csv", function(that, event, elt) {
    event.preventDefault();
    that.salesDetailsCsv();
});


class $e4bf97cefc63c6d1$export$30c81f1004141b83 extends (0, $4f991c42613b920c$export$5593b284a7b9fb1b) {
    constructor(){
        super();
        this.v = new (0, $8fdefe152560acc2$export$534edfd3503bfaa5)();
    }
    view() {
        return this.v;
    }
    url() {
        return `/reports`;
    }
}




var $ea6b767bf9b858ec$export$2e2bcd8739ae039 = $ea6b767bf9b858ec$var$template;
function $ea6b767bf9b858ec$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $ea6b767bf9b858ec$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $ea6b767bf9b858ec$var$pug_escape(e) {
    var a = "" + e, t = $ea6b767bf9b858ec$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $ea6b767bf9b858ec$var$pug_match_html = /["&<>]/;
function $ea6b767bf9b858ec$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(genres1, libraries1, recording1, urls1) {
        pug_mixins["options"] = pug_interp = function(available, selected) {
            var block = this && this.block, attributes = this && this.attributes || {};
            (function() {
                var $$obj = available;
                if ("number" == typeof $$obj.length) for(var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++){
                    var v = $$obj[pug_index0];
                    pug_html = pug_html + "<option" + ($ea6b767bf9b858ec$var$pug_attr("value", v, true, true) + $ea6b767bf9b858ec$var$pug_attr("selected", v == selected, true, true)) + ">" + $ea6b767bf9b858ec$var$pug_escape(null == (pug_interp = v) ? "" : pug_interp) + "</option>";
                }
                else {
                    var $$l = 0;
                    for(var pug_index0 in $$obj){
                        $$l++;
                        var v = $$obj[pug_index0];
                        pug_html = pug_html + "<option" + ($ea6b767bf9b858ec$var$pug_attr("value", v, true, true) + $ea6b767bf9b858ec$var$pug_attr("selected", v == selected, true, true)) + ">" + $ea6b767bf9b858ec$var$pug_escape(null == (pug_interp = v) ? "" : pug_interp) + "</option>";
                    }
                }
            }).call(this);
        };
        pug_html = pug_html + '<div class="function-body">';
        if (recording1) {
            pug_html = pug_html + '<form class="recording with-validation"><div class="line"><label>Library</label><select name="library">';
            pug_mixins["options"](libraries1, recording1.library);
            pug_html = pug_html + '</select></div><div class="line"><label>Title</label><input' + (' name="title"' + $ea6b767bf9b858ec$var$pug_attr("value", recording1.title, true, true)) + '></div><div class="line"><label>Sort title (optional)</label><input' + (' name="sort_title"' + $ea6b767bf9b858ec$var$pug_attr("value", recording1.sort_title, true, true)) + '></div><div class="line"><label>Genre</label><select name="genre">';
            pug_mixins["options"](genres1, recording1.genre);
            pug_html = pug_html + '</select></div><div class="line"><label>Artist</label><input' + (' name="artist"' + $ea6b767bf9b858ec$var$pug_attr("value", recording1.artist, true, true)) + '></div><div class="line"><label>Recording date</label><input' + (' name="recording_date"' + $ea6b767bf9b858ec$var$pug_attr("value", recording1.recording_date, true, true)) + '></div><div class="line"><label>Left/Right channels separate<input' + (' class="boolean" name="left_right" type="checkbox"' + $ea6b767bf9b858ec$var$pug_attr("checked", recording1.left_right, true, true)) + '></label></div><div class="line"><label>dB adjust</label><input' + (' class="number" name="db_adjust"' + $ea6b767bf9b858ec$var$pug_attr("value", recording1.db_adjust, true, true)) + '></div><div class="line"><label>Active<input' + (' class="boolean" name="active" type="checkbox"' + $ea6b767bf9b858ec$var$pug_attr("checked", recording1.active, true, true)) + '></label></div><div class="line"><label>Price (credits)</label><input' + (' class="number integer" name="price"' + $ea6b767bf9b858ec$var$pug_attr("value", recording1.price, true, true)) + '></div></form><div class="files"><div class="line"><label>Main recording</label>';
            if (urls1.main_recording) pug_html = pug_html + '<div class="uploaded-attachment"><a' + $ea6b767bf9b858ec$var$pug_attr("href", urls1.main_recording, true, true) + ">" + $ea6b767bf9b858ec$var$pug_escape(null == (pug_interp = urls1.main_recording) ? "" : pug_interp) + "</a>&emsp;<a" + (' class="remove-attachment"' + $ea6b767bf9b858ec$var$pug_attr("data-url", urls1.main_recording, true, true) + ' name="main_recording"') + ">(remove)</a></div>";
            else pug_html = pug_html + '<input class="upload" type="file" name="main_recording">';
            pug_html = pug_html + '<div class="upload-status"></div></div><div class="line"><label>Sample recording</label>';
            if (urls1.sample_recording) pug_html = pug_html + '<div class="uploaded-attachment"><a' + $ea6b767bf9b858ec$var$pug_attr("href", urls1.sample_recording, true, true) + ">" + $ea6b767bf9b858ec$var$pug_escape(null == (pug_interp = urls1.sample_recording) ? "" : pug_interp) + "</a>&emsp;<a" + (' class="remove-attachment"' + $ea6b767bf9b858ec$var$pug_attr("data-url", urls1.sample_recording, true, true) + ' name="sample_recording"') + ">(remove)</a></div>";
            else pug_html = pug_html + '<input class="upload" type="file" name="sample_recording">';
            pug_html = pug_html + '<div class="upload-status"></div></div></div><button class="save">Save</button>';
        }
        pug_html = pug_html + "</div>";
    }).call(this, "genres" in locals_for_with ? locals_for_with.genres : typeof genres !== "undefined" ? genres : undefined, "libraries" in locals_for_with ? locals_for_with.libraries : typeof libraries !== "undefined" ? libraries : undefined, "recording" in locals_for_with ? locals_for_with.recording : typeof recording !== "undefined" ? recording : undefined, "urls" in locals_for_with ? locals_for_with.urls : typeof urls !== "undefined" ? urls : undefined);
    return pug_html;
}





class $24c5802900c09289$export$7d7393cc4f16cbe0 extends (0, $f55c403e2549a503$export$2e2bcd8739ae039) {
    static #_ = this.classname = "upload-view";
    constructor(id){
        super($24c5802900c09289$export$7d7393cc4f16cbe0.classname);
        this.server = (0, $b306c6aaaa6be045$export$2e2bcd8739ae039).instance();
        this.recording = {};
        this.urls = {};
        if (id) this.server.fetchRecording(id).then((recording)=>{
            this.recording = recording;
            // @ts-ignore
            this.recording["main_recording"] = recording.url;
            this.update();
        });
    }
    setRecording(r) {
        this.recording = r;
        this.update();
    }
    render0() {
        const data = {
            recording: this.recording,
            urls: this.urls,
            libraries: [
                "TALC"
            ],
            genres: [
                "tango",
                "vals",
                "milonga"
            ]
        };
        const out = this.pug((0, $ea6b767bf9b858ec$export$2e2bcd8739ae039), data);
        out.find(".with-validation").validate({
            rules: {
                title: "required",
                artist: "required",
                genre: "required",
                recording_date: "required",
                price: "required"
            }
        });
        return out;
    }
    updateModel() {
        (0, $82cf23e1ef1fc3af$export$54048630ffcff79a)(this.elt().find("form.recording"), this.recording);
    }
    async upload(name, input) {
        const file = input[0].files && input[0].files.length && input[0].files[0];
        if (!file) return;
        const statusElt = input.closest(".line").find(".upload-status");
        const listener = (status)=>{
            statusElt.text(status);
        };
        const url = await this.server.uploadToS3(file, listener);
        this.urls[name] = url;
        this.update(".files");
    }
    async save() {
        this.updateModel();
        const form = this.elt().find(".with-validation");
        if (!form.valid()) return;
        if (!this.urls.main_recording && !this.recording.id) {
            (0, $752d59648741b237$export$2e2bcd8739ae039).alert("Missing main recording");
            return;
        }
        if (!this.urls.sample_recording && !this.recording.id) {
            (0, $752d59648741b237$export$2e2bcd8739ae039).alert("Missing sample recording");
            return;
        }
        const done = await this.server.saveRecording(this.recording, this.urls.main_recording, this.urls.sample_recording);
        (0, $752d59648741b237$export$2e2bcd8739ae039).alert("Saved");
    }
}
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $24c5802900c09289$export$7d7393cc4f16cbe0.classname, "change", "input.upload", function(that, event, elt) {
    event.preventDefault();
    const input = jQuery(elt);
    const name = jQuery(elt).attr("name");
    that.upload(name, input);
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $24c5802900c09289$export$7d7393cc4f16cbe0.classname, "click", ".save", function(that, event, elt) {
    event.preventDefault();
    that.save();
});


class $76c4b9221f73edd9$export$e4eb20ef83591b76 extends (0, $4f991c42613b920c$export$5593b284a7b9fb1b) {
    constructor(id){
        super();
        this.v = new (0, $24c5802900c09289$export$7d7393cc4f16cbe0)(id);
    }
    view() {
        return this.v;
    }
    url() {
        return `/upload`;
    }
}




var $10cKx = parcelRequire("10cKx");


var $349a633187397310$export$2e2bcd8739ae039 = $349a633187397310$var$template;
function $349a633187397310$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $349a633187397310$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $349a633187397310$var$pug_classes(s, r) {
    return Array.isArray(s) ? $349a633187397310$var$pug_classes_array(s, r) : s && "object" == typeof s ? $349a633187397310$var$pug_classes_object(s) : s || "";
}
function $349a633187397310$var$pug_classes_array(r, a) {
    for(var s, e = "", u = "", c = Array.isArray(a), g = 0; g < r.length; g++)(s = $349a633187397310$var$pug_classes(r[g])) && (c && a[g] && (s = $349a633187397310$var$pug_escape(s)), e = e + u + s, u = " ");
    return e;
}
function $349a633187397310$var$pug_classes_object(r) {
    var a = "", n = "";
    for(var o in r)o && r[o] && $349a633187397310$var$pug_has_own_property.call(r, o) && (a = a + n + o, n = " ");
    return a;
}
function $349a633187397310$var$pug_escape(e) {
    var a = "" + e, t = $349a633187397310$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $349a633187397310$var$pug_has_own_property = Object.prototype.hasOwnProperty;
var $349a633187397310$var$pug_match_html = /["&<>]/;
function $349a633187397310$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(recording1) {
        pug_html = pug_html + '<div class="function-body">';
        if (recording1) {
            pug_html = pug_html + "<h2" + $349a633187397310$var$pug_attr("class", $349a633187397310$var$pug_classes([
                {
                    inactive: !recording1.active
                }
            ], [
                true
            ]), false, true) + ">" + $349a633187397310$var$pug_escape(null == (pug_interp = recording1.title) ? "" : pug_interp) + "</h2><h3>" + $349a633187397310$var$pug_escape(null == (pug_interp = recording1.artist) ? "" : pug_interp) + " " + $349a633187397310$var$pug_escape(null == (pug_interp = recording1.recording_date || "") ? "" : pug_interp) + '</h3><div class="video-container"><video-js class="video-js"></video-js><div class="marks"><canvas width="1000" height="150"></canvas></div></div><div class="controls"><button class="rewind">Rebobinar</button><button class="play">Tocar</button><button class="pause">Pausar</button>';
            if (!recording1.active) pug_html = pug_html + '<button class="inactive activation" data-active="1">\xa1Est\xe1 bien!</button>';
            pug_html = pug_html + "</div>";
        }
        pug_html = pug_html + "</div>";
    }).call(this, "recording" in locals_for_with ? locals_for_with.recording : typeof recording !== "undefined" ? recording : undefined);
    return pug_html;
}


// Global list for disposal - this implementation implies that we can only have one player at a time.
const $f0a6b1cd736510e5$var$players = [];
let $f0a6b1cd736510e5$var$videoid = 0;
class $f0a6b1cd736510e5$export$2e2bcd8739ae039 extends (0, $f55c403e2549a503$export$2e2bcd8739ae039) {
    static #_ = this.classname = "review-view";
    constructor(token){
        super($f0a6b1cd736510e5$export$2e2bcd8739ae039.classname);
        this.server = (0, $b306c6aaaa6be045$export$2e2bcd8739ae039).instance();
        this.redraw = undefined;
        this.token = token;
        this.refresh();
    }
    refresh() {
        this.server.fetchRecordingByToken(this.token).then((recording)=>{
            this.recording = recording;
            this.setRecordingOnPlayer();
            this.update();
            this.config();
        });
    }
    render0() {
        const data = {
            left_right_controls: this.recording && this.recording.left_right,
            recording: this.recording
        };
        const out = this.pug((0, $349a633187397310$export$2e2bcd8739ae039), data);
        this.afterUpdate(()=>{
            const v = this.elt().find("video-js");
            if (v.length == 1 && !v.data("initted")) {
                const id = this.getUuid() + "-video-" + ++$f0a6b1cd736510e5$var$videoid;
                v.attr("id", id);
                v.data("initted", true);
                const configOptions = (newOpts)=>{
                    this.elt().find(".loop-a").text(newOpts.start ? "A " + Math.round(newOpts.start * 10) / 10 : "A");
                    this.elt().find(".loop-b").text(newOpts.end ? "B " + Math.round(newOpts.end * 10) / 10 : "B");
                };
                // @ts-ignore
                this.player = videojs(v[0], {
                    preload: true,
                    fluid: true,
                    controls: true,
                    playbackRates: [
                        0.2,
                        0.3,
                        0.4,
                        0.5,
                        0.6,
                        0.7,
                        0.8,
                        0.9,
                        1
                    ],
                    plugins: {
                        abLoopPlugin: {
                            createButtons: true,
                            onOptionsChange: function(optionDetails, api, player) {
                                console.log("options changed: ", player.id(), optionDetails);
                                configOptions(optionDetails.newOpts);
                            }
                        }
                    }
                });
                this.player.crossOrigin = "anonymous";
                const videoElt = this.elt().find("video");
                const vid = videoElt[0];
                vid.crossOrigin = "anonymous";
                for (const p of $f0a6b1cd736510e5$var$players)p.dispose();
                $f0a6b1cd736510e5$var$players.length = 0;
                $f0a6b1cd736510e5$var$players.push(this.player);
                if (this.recording) this.setRecordingOnPlayer();
                this.player.on([
                    "play",
                    "seeked",
                    "pause",
                    "ready",
                    "durationchange"
                ], ()=>{
                    this.config();
                });
            }
        });
        return out;
    }
    drawCanvas() {
        const canvas = this.elt().find("canvas");
        if (canvas.length == 0) return;
        const ctx = canvas[0].getContext("2d");
        if (!ctx) return;
        const width = canvas[0].width;
        const height = canvas[0].height;
        ctx.fillStyle = "rgb(255 255 255)";
        ctx.fillRect(0, 0, width, height);
        if (!this.player) return;
        const pos = this.player.currentTime();
        const duration = this.player.duration();
        ctx.fillStyle = "rgb(255 0 0)";
        const x = pos / duration * width;
        ctx.fillStyle = "rgb(0 0 0)";
        ctx.fillRect(x, 0, 1, height);
        if (!this.player.paused()) {
            if (this.redraw) window.cancelAnimationFrame(this.redraw);
            this.redraw = window.requestAnimationFrame(()=>{
                this.drawCanvas();
            });
        }
    }
    setRecordingOnPlayer() {
        if (this.recording && this.player) {
            console.log("Set recording", this.recording);
            this.player.src({
                src: this.recording.url,
                type: "video/mp4"
            });
            this.config();
        }
    }
    config() {
        const playing = this.player && !this.player.paused();
        const e = this.elt();
        this.drawCanvas();
    }
    seekX(x) {
        const canvas = this.elt().find(".marks canvas")[0];
        if (!this.player || !canvas) return;
        const rect = canvas.getBoundingClientRect();
        const duration = this.player.duration();
        const pos = (x - rect.left) / rect.width * duration;
        this.player.currentTime(pos);
    }
    rewind() {
        const pos = 0;
        this.player && this.player.currentTime(pos);
    }
    play() {
        this.player && this.player.play();
        this.config();
    }
    pause() {
        this.player && this.player.pause();
        this.config();
    }
    async setActivation(active) {
        if (!this.recording) return;
        const done = await this.server.setActivationByToken(this.token, active);
        this.recording.active = active;
        this.update(".controls");
    }
}
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $f0a6b1cd736510e5$export$2e2bcd8739ae039.classname, "click", "button.rewind", function(that, event, elt) {
    event.preventDefault();
    that.rewind();
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $f0a6b1cd736510e5$export$2e2bcd8739ae039.classname, "click", "button.play", function(that, event, elt) {
    event.preventDefault();
    that.play();
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $f0a6b1cd736510e5$export$2e2bcd8739ae039.classname, "click", "button.pause", function(that, event, elt) {
    event.preventDefault();
    that.pause();
});
(0, $f55c403e2549a503$export$2e2bcd8739ae039).on("." + $f0a6b1cd736510e5$export$2e2bcd8739ae039.classname, "click", "button.activation", function(that, event, elt) {
    event.preventDefault();
    const active = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(elt).data("active") ? true : false;
    that.setActivation(active);
});


class $5cc570f941c95c4a$export$f94787e2fdd2cf1 extends (0, $4f991c42613b920c$export$5593b284a7b9fb1b) {
    constructor(token){
        super();
        this.token = token;
        this.v = new (0, $f0a6b1cd736510e5$export$2e2bcd8739ae039)(token);
    }
    view() {
        return this.v;
    }
    url() {
        return `/review/${encodeURIComponent(this.token)}`;
    }
}


class $4cdeddcdef78af28$export$8354032f3852ec50 {
    constructor(app){
        this.fnCache = {};
        this.app = app;
    }
    fromUrl(url, user) {
        let fn = this.fnCache[url];
        if (fn) {
            fn.refresh();
            return fn;
        }
        fn = this.fromUrl0(url, user);
        if (fn.isCacheable()) this.fnCache[url] = fn;
        return fn;
    }
    fromUrl0(url, user) {
        const path = $82cf23e1ef1fc3af$export$bb654e07daaf8c3a(url);
        console.log("fromUrl0", url, user);
        const admin = user && user.admin ? true : false;
        let role = (0, $4f991c42613b920c$export$c7a47299927a834c);
        if (admin) role = (0, $4f991c42613b920c$export$87cd0a661ace5c06);
        else if (user) {
            if (user.username == "Orlando") role = (0, $4f991c42613b920c$export$a7d6ff1965d6fac9);
            else role = (0, $4f991c42613b920c$export$3cc7ce77e26c67cb);
        }
        function match(prefix) {
            const p = url.substr(0, prefix.length);
            return p === prefix;
        }
        if (match("/library")) return new (0, $2b0cda06d85bb7c7$export$c0609c134f241cf3)();
        if (match("/fakebook")) return new (0, $d1f868cdd3cb4b4b$export$79d5df92b7d91620)();
        if (match("/practichord")) return new (0, $b92b7a0b03ecf11e$export$83e4dde1c0387ebc)();
        if (match("/player")) {
            const autoplay = path[2] == "autoplay";
            return new (0, $e3f4902815efaaad$export$d9a32f4c3d782fcb)(path[1], user, role, autoplay);
        }
        if (match("/review")) {
            const token = path[1];
            return new (0, $5cc570f941c95c4a$export$f94787e2fdd2cf1)(path[1]);
        }
        if (match("/account")) {
            if (user) return new (0, $1af4a577d4938c38$export$2e494e966dc19a91)();
            else return new (0, $6b59c41a709d585a$export$ab82e13210c014d2)();
        }
        if (match("/users")) return new (0, $64ec5918e5fbfcc4$export$c362ea7fa71b0b0b)();
        if (match("/reports")) return new (0, $e4bf97cefc63c6d1$export$30c81f1004141b83)();
        if (match("/upload")) {
            const id = path[1];
            return new (0, $76c4b9221f73edd9$export$e4eb20ef83591b76)(id);
        }
        if (match("/payment")) return new (0, $5cf8a5c9dfa17926$export$e46142227cb75e03)();
        if (match("/signup")) return new (0, $6b59c41a709d585a$export$ab82e13210c014d2)();
        if (match("/login")) return new (0, $6b59c41a709d585a$export$86bb705faf90e12f)(this.app, path[1], path[2]);
        if (match("/logout")) return new (0, $6b59c41a709d585a$export$80da5d51d48c4f6e)(this.app);
        if (match("/project")) return new (0, $283a314c23da9d02$export$f9e668fcf42dbb0d)();
        if (match("/about")) {
            const admin = user && user.admin ? true : false;
            return new (0, $7ccf5fcf21c48f25$export$c498b58ec6d7eda2)(admin);
        }
        if (match("/security/reset-password")) {
            const isNew = user && user.new ? true : false;
            return new (0, $17280a69343940fd$export$f1f8b7c044a665c3)(path[2], isNew);
        }
        if (match("/security/change-password")) return new (0, $17280a69343940fd$export$adc9431b3de9dba2)();
        if (match("/security/reset-fail")) return new (0, $17280a69343940fd$export$d54d005f8904e82a)();
        return new (0, $283a314c23da9d02$export$f9e668fcf42dbb0d)();
    }
}



var $10cKx = parcelRequire("10cKx");


console.log("Loading app.ts...");
class $16ffe2bba218fe2b$export$ad5e6f16f7145a22 {
    constructor(){
        this.factory = this.createFactory();
        this.server = (0, $b306c6aaaa6be045$export$2e2bcd8739ae039).instance();
        /**
     * What we currently think the HashUrl should be. If the browser window thinks otherwise, then we
     * need to refresh the view (eg, for back button handling)
     */ this.current = $82cf23e1ef1fc3af$export$c755ec8933ea1108();
        this.inHashChange = false;
        /**
     * Keep track of whether we are currently in the gotoUrl handler or not.
     * If we are, then update to the URL are done via replaceState instead of pushState
     */ this.inGotoUrl = false;
        /**
     * Keep track of function changes. This is a crude mechanism to prevent the "PopFn" notification
     * popping out of the entire app in case someone opens the browser directly into an "edit" page.
     */ this.appFunctionUrls = [];
        this.server.runtimeParams_.then((r)=>{
            const test = r["wrb.client.test"];
            if (test) (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))("body").addClass("test-mode");
        });
        const hashUrl = $82cf23e1ef1fc3af$export$c755ec8933ea1108();
        this.page = this.createPage(hashUrl);
        // Add a spinner to the document
        new (0, $a187c2fe64638fd7$export$7f7cbe89f1eacd2)().attach(document);
        (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(window).on("popstate hashchange", (e)=>this.hashchange(e));
        const remember_ = this.server.loginRemembered();
        remember_.then((user)=>{
            this.setUser(user);
            this.gotoUrl(hashUrl);
        });
    }
    boot() {
        const hashUrl = $82cf23e1ef1fc3af$export$c755ec8933ea1108();
        this.gotoUrl(hashUrl);
    }
    getUser() {
        return this.user;
    }
    setUser(user) {
        this.user = user;
        if (user) this.server.setUser(user);
        this.factory = this.createFactory();
    }
    /**
     * Whenever the hash url changes, this function is called (by the popstate and hashchange listener)
     * If the new hash url is not in sync with the current function (ie, this.current),
     * the function corresponding to the new URL is installed
     */ hashchange(e) {
        if (this.inGotoUrl) return;
        const save = this.inHashChange;
        try {
            this.inHashChange = true;
            const newUrl = $82cf23e1ef1fc3af$export$c755ec8933ea1108();
            console.log(`hashChange from ${this.current} to ${newUrl}`);
            if (newUrl != this.current) this.gotoUrl(newUrl);
        } finally{
            this.inHashChange = save;
        }
    }
    pushFunction(fn) {
        const hashUrl = fn.url();
        $82cf23e1ef1fc3af$export$12d4ceab885e6b01(hashUrl);
        this.setFunction(fn);
    }
    setFunction(fn) {
        if (this.fn == fn) return;
        this.setFunction0(fn);
    }
    popFn() {
        // This could be made more sophisticated, eg use internal state
        const stack = this.appFunctionUrls;
        if (stack.length > 1) {
            this.gotoUrl(stack[stack.length - 2]);
            return true;
        } else return false;
    }
    // -----------------------------------------
    setFunction0(fn) {
        this.server.clearVolatileCache();
        this.fn = fn;
        fn.view().setParent(this.page);
        this.configurePage(fn);
        this.page.update();
        const hash = fn.url();
        this.current = hash;
        const stack = this.appFunctionUrls;
        const top = stack.length > 0 ? stack[stack.length - 1] : undefined;
        const top2 = stack.length > 1 ? stack[stack.length - 2] : undefined;
        if (hash != top) {
            if (hash == top2) stack.pop();
            else stack.push(hash);
        }
        if (this.inHashChange) $82cf23e1ef1fc3af$export$9bf2691bda54425c(hash);
        else $82cf23e1ef1fc3af$export$12d4ceab885e6b01(hash);
    }
    fromUrl(hashUrl) {
        return this.factory.fromUrl(hashUrl, this.user);
    }
    gotoUrl(hashUrl) {
        const wasInGotoUrl = this.inGotoUrl;
        try {
            this.inGotoUrl = true;
            this.current = hashUrl;
            if (!wasInGotoUrl && !this.inHashChange) // We want to actively create a new history entry
            $82cf23e1ef1fc3af$export$12d4ceab885e6b01(hashUrl);
            else // We don't want to create a history entry
            $82cf23e1ef1fc3af$export$9bf2691bda54425c(hashUrl);
            const f = this.factory.fromUrl(hashUrl, this.user);
            this.setFunction(f);
        } finally{
            this.inGotoUrl = wasInGotoUrl;
        }
    }
    render() {
        this.page.updatePage();
    }
}
class $16ffe2bba218fe2b$export$86fbec116b87613f extends $16ffe2bba218fe2b$export$ad5e6f16f7145a22 {
    constructor(){
        super();
    }
    configurePage(fn) {
        const p = this.page;
        p.setContent(fn.view());
        p.customTemplate = fn.pageTemplate();
        p.setSidebarVisible(!fn.isZero());
    }
    createPage(hashUrl) {
        const page = new (0, $0dea84b3737d8e06$export$2e2bcd8739ae039)(this);
        return page;
    }
    createFactory() {
        return new (0, $4cdeddcdef78af28$export$8354032f3852ec50)(this);
    }
}


var $8871f3ea6c7c1795$exports = {};
!function(e, t) {
    $8871f3ea6c7c1795$exports = t();
}(window, function() {
    return function(e) {
        var t = {};
        function n(a) {
            if (t[a]) return t[a].exports;
            var r = t[a] = {
                i: a,
                l: !1,
                exports: {}
            };
            return e[a].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
        }
        return n.m = e, n.c = t, n.d = function(e, t, a) {
            n.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: a
            });
        }, n.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, n.t = function(e, t) {
            if (1 & t && (e = n(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var a = Object.create(null);
            if (n.r(a), Object.defineProperty(a, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var r in e)n.d(a, r, (function(t) {
                return e[t];
            }).bind(null, r));
            return a;
        }, n.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return n.d(t, "a", t), t;
        }, n.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, n.p = "", n(n.s = 0);
    }([
        function(e, t, n) {
            "use strict";
            n.r(t);
            var a = [], r = [
                "Sun",
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat"
            ], i = [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ], o = {
                t: "top",
                r: "right",
                b: "bottom",
                l: "left",
                c: "centered"
            };
            function s() {}
            var l = [
                "click",
                "focusin",
                "keydown",
                "input"
            ];
            function d(e) {
                l.forEach(function(t) {
                    e.addEventListener(t, e === document ? L : Y);
                });
            }
            function c(e) {
                return Array.isArray(e) ? e.map(c) : "[object Object]" === x(e) ? Object.keys(e).reduce(function(t, n) {
                    return t[n] = c(e[n]), t;
                }, {}) : e;
            }
            function u(e, t) {
                var n = e.calendar.querySelector(".qs-overlay"), a = n && !n.classList.contains("qs-hidden");
                t = t || new Date(e.currentYear, e.currentMonth), e.calendar.innerHTML = [
                    h(t, e, a),
                    f(t, e, a),
                    v(e, a)
                ].join(""), a && window.requestAnimationFrame(function() {
                    M(!0, e);
                });
            }
            function h(e, t, n) {
                return [
                    '<div class="qs-controls' + (n ? " qs-blur" : "") + '">',
                    '<div class="qs-arrow qs-left"></div>',
                    '<div class="qs-month-year' + (t.disableYearOverlay ? " qs-disabled-year-overlay" : "") + '">',
                    '<span class="qs-month">' + t.months[e.getMonth()] + "</span>",
                    '<span class="qs-year">' + e.getFullYear() + "</span>",
                    "</div>",
                    '<div class="qs-arrow qs-right"></div>',
                    "</div>"
                ].join("");
            }
            function f(e, t, n) {
                var a = t.currentMonth, r = t.currentYear, i = t.dateSelected, o = t.maxDate, s = t.minDate, l = t.showAllDates, d = t.days, c = t.disabledDates, u = t.startDay, h = t.weekendIndices, f = t.events, v = t.getRange ? t.getRange() : {}, m = +v.start, y = +v.end, p = g(new Date(e).setDate(1)), w = p.getDay() - u, D = w < 0 ? 7 : 0;
                p.setMonth(p.getMonth() + 1), p.setDate(0);
                var b = p.getDate(), q = [], S = D + 7 * ((w + b) / 7 | 0);
                S += (w + b) % 7 ? 7 : 0;
                for(var M = 1; M <= S; M++){
                    var E = (M - 1) % 7, x = d[E], C = M - (w >= 0 ? w : 7 + w), L = new Date(r, a, C), Y = f[+L], j = C < 1 || C > b, O = j ? C < 1 ? -1 : 1 : 0, P = j && !l, k = P ? "" : L.getDate(), N = +L == +i, _ = E === h[0] || E === h[1], I = m !== y, A = "qs-square " + x;
                    Y && !P && (A += " qs-event"), j && (A += " qs-outside-current-month"), !l && j || (A += " qs-num"), N && (A += " qs-active"), (c[+L] || t.disabler(L) || _ && t.noWeekends || s && +L < +s || o && +L > +o) && !P && (A += " qs-disabled"), +g(new Date) == +L && (A += " qs-current"), +L === m && y && I && (A += " qs-range-start"), +L > m && +L < y && (A += " qs-range-middle"), +L === y && m && I && (A += " qs-range-end"), P && (A += " qs-empty", k = ""), q.push('<div class="' + A + '" data-direction="' + O + '">' + k + "</div>");
                }
                var R = d.map(function(e) {
                    return '<div class="qs-square qs-day">' + e + "</div>";
                }).concat(q);
                return R.unshift('<div class="qs-squares' + (n ? " qs-blur" : "") + '">'), R.push("</div>"), R.join("");
            }
            function v(e, t) {
                var n = e.overlayPlaceholder, a = e.overlayButton;
                return [
                    '<div class="qs-overlay' + (t ? "" : " qs-hidden") + '">',
                    "<div>",
                    '<input class="qs-overlay-year" placeholder="' + n + '" inputmode="numeric" />',
                    '<div class="qs-close">&#10005;</div>',
                    "</div>",
                    '<div class="qs-overlay-month-container">' + e.overlayMonths.map(function(e, t) {
                        return '<div class="qs-overlay-month" data-month-num="' + t + '">' + e + "</div>";
                    }).join("") + "</div>",
                    '<div class="qs-submit qs-disabled">' + a + "</div>",
                    "</div>"
                ].join("");
            }
            function m(e, t, n) {
                var a = t.el, r = t.calendar.querySelector(".qs-active"), i = e.textContent, o = t.sibling;
                (a.disabled || a.readOnly) && t.respectDisabledReadOnly || (t.dateSelected = n ? void 0 : new Date(t.currentYear, t.currentMonth, i), r && r.classList.remove("qs-active"), n || e.classList.add("qs-active"), p(a, t, n), n || q(t), o && (y({
                    instance: t,
                    deselect: n
                }), t.first && !o.dateSelected && (o.currentYear = t.currentYear, o.currentMonth = t.currentMonth, o.currentMonthName = t.currentMonthName), u(t), u(o)), t.onSelect(t, n ? void 0 : new Date(t.dateSelected)));
            }
            function y(e) {
                var t = e.instance.first ? e.instance : e.instance.sibling, n = t.sibling;
                t === e.instance ? e.deselect ? (t.minDate = t.originalMinDate, n.minDate = n.originalMinDate) : n.minDate = t.dateSelected : e.deselect ? (n.maxDate = n.originalMaxDate, t.maxDate = t.originalMaxDate) : t.maxDate = n.dateSelected;
            }
            function p(e, t, n) {
                if (!t.nonInput) return n ? e.value = "" : t.formatter !== s ? t.formatter(e, t.dateSelected, t) : void (e.value = t.dateSelected.toDateString());
            }
            function w(e, t, n, a) {
                n || a ? (n && (t.currentYear = +n), a && (t.currentMonth = +a)) : (t.currentMonth += e.contains("qs-right") ? 1 : -1, 12 === t.currentMonth ? (t.currentMonth = 0, t.currentYear++) : -1 === t.currentMonth && (t.currentMonth = 11, t.currentYear--)), t.currentMonthName = t.months[t.currentMonth], u(t), t.onMonthChange(t);
            }
            function D(e) {
                if (!e.noPosition) {
                    var t = e.position.top, n = e.position.right;
                    if (e.position.centered) return e.calendarContainer.classList.add("qs-centered");
                    var a = e.positionedEl.getBoundingClientRect(), r = e.el.getBoundingClientRect(), i = e.calendarContainer.getBoundingClientRect(), o = r.top - a.top + (t ? -1 * i.height : r.height) + "px", s = r.left - a.left + (n ? r.width - i.width : 0) + "px";
                    e.calendarContainer.style.setProperty("top", o), e.calendarContainer.style.setProperty("left", s);
                }
            }
            function b(e) {
                return "[object Date]" === x(e) && "Invalid Date" !== e.toString();
            }
            function g(e) {
                if (b(e) || "number" == typeof e && !isNaN(e)) {
                    var t = new Date(+e);
                    return new Date(t.getFullYear(), t.getMonth(), t.getDate());
                }
            }
            function q(e) {
                e.disabled || !e.calendarContainer.classList.contains("qs-hidden") && !e.alwaysShow && ("overlay" !== e.defaultView && M(!0, e), e.calendarContainer.classList.add("qs-hidden"), e.onHide(e));
            }
            function S(e) {
                e.disabled || (e.calendarContainer.classList.remove("qs-hidden"), "overlay" === e.defaultView && M(!1, e), D(e), e.onShow(e));
            }
            function M(e, t) {
                var n = t.calendar, a = n.querySelector(".qs-overlay"), r = a.querySelector(".qs-overlay-year"), i = n.querySelector(".qs-controls"), o = n.querySelector(".qs-squares");
                e ? (a.classList.add("qs-hidden"), i.classList.remove("qs-blur"), o.classList.remove("qs-blur"), r.value = "") : (a.classList.remove("qs-hidden"), i.classList.add("qs-blur"), o.classList.add("qs-blur"), r.focus());
            }
            function E(e, t, n, a) {
                var r = isNaN(+(new Date).setFullYear(t.value || void 0)), i = r ? null : t.value;
                if (13 === e.which || 13 === e.keyCode || "click" === e.type) a ? w(null, n, i, a) : r || t.classList.contains("qs-disabled") || w(null, n, i);
                else if (n.calendar.contains(t)) n.calendar.querySelector(".qs-submit").classList[r ? "add" : "remove"]("qs-disabled");
            }
            function x(e) {
                return ({}).toString.call(e);
            }
            function C(e) {
                a.forEach(function(t) {
                    t !== e && q(t);
                });
            }
            function L(e) {
                if (!e.__qs_shadow_dom) {
                    var t = e.which || e.keyCode, n = e.type, r = e.target, o = r.classList, s = a.filter(function(e) {
                        return e.calendar.contains(r) || e.el === r;
                    })[0], l = s && s.calendar.contains(r);
                    if (!(s && s.isMobile && s.disableMobile)) {
                        if ("click" === n) {
                            if (!s) return a.forEach(q);
                            if (s.disabled) return;
                            var d = s.calendar, c = s.calendarContainer, h = s.disableYearOverlay, f = s.nonInput, v = d.querySelector(".qs-overlay-year"), y = !!d.querySelector(".qs-hidden"), p = d.querySelector(".qs-month-year").contains(r), D = r.dataset.monthNum;
                            if (s.noPosition && !l) (c.classList.contains("qs-hidden") ? S : q)(s);
                            else if (o.contains("qs-arrow")) w(o, s);
                            else if (p || o.contains("qs-close")) h || M(!y, s);
                            else if (D) E(e, v, s, D);
                            else {
                                if (o.contains("qs-disabled")) return;
                                if (o.contains("qs-num")) {
                                    var b = r.textContent, g = +r.dataset.direction, x = new Date(s.currentYear, s.currentMonth + g, b);
                                    if (g) {
                                        s.currentYear = x.getFullYear(), s.currentMonth = x.getMonth(), s.currentMonthName = i[s.currentMonth], u(s);
                                        for(var L, Y = s.calendar.querySelectorAll('[data-direction="0"]'), j = 0; !L;){
                                            var O = Y[j];
                                            O.textContent === b && (L = O), j++;
                                        }
                                        r = L;
                                    }
                                    return void (+x == +s.dateSelected ? m(r, s, !0) : r.classList.contains("qs-disabled") || m(r, s));
                                }
                                o.contains("qs-submit") ? E(e, v, s) : f && r === s.el && (S(s), C(s));
                            }
                        } else if ("focusin" === n && s) S(s), C(s);
                        else if ("keydown" === n && 9 === t && s) q(s);
                        else if ("keydown" === n && s && !s.disabled) {
                            var P = !s.calendar.querySelector(".qs-overlay").classList.contains("qs-hidden");
                            13 === t && P && l ? E(e, r, s) : 27 === t && P && l && M(!0, s);
                        } else if ("input" === n) {
                            if (!s || !s.calendar.contains(r)) return;
                            var k = s.calendar.querySelector(".qs-submit"), N = r.value.split("").reduce(function(e, t) {
                                return e || "0" !== t ? e + (t.match(/[0-9]/) ? t : "") : "";
                            }, "").slice(0, 4);
                            r.value = N, k.classList[4 === N.length ? "remove" : "add"]("qs-disabled");
                        }
                    }
                }
            }
            function Y(e) {
                L(e), e.__qs_shadow_dom = !0;
            }
            function j(e, t) {
                l.forEach(function(n) {
                    e.removeEventListener(n, t);
                });
            }
            function O() {
                S(this);
            }
            function P() {
                q(this);
            }
            function k(e, t) {
                var n = g(e), a = this.currentYear, r = this.currentMonth, i = this.sibling;
                if (null == e) return this.dateSelected = void 0, p(this.el, this, !0), i && (y({
                    instance: this,
                    deselect: !0
                }), u(i)), u(this), this;
                if (!b(e)) throw new Error("`setDate` needs a JavaScript Date object.");
                if (this.disabledDates[+n] || n < this.minDate || n > this.maxDate) throw new Error("You can't manually set a date that's disabled.");
                this.dateSelected = n, t && (this.currentYear = n.getFullYear(), this.currentMonth = n.getMonth(), this.currentMonthName = this.months[n.getMonth()]), p(this.el, this), i && (y({
                    instance: this
                }), u(i));
                var o = a === n.getFullYear() && r === n.getMonth();
                return o || t ? u(this, n) : o || u(this, new Date(a, r, 1)), this;
            }
            function N(e) {
                return I(this, e, !0);
            }
            function _(e) {
                return I(this, e);
            }
            function I(e, t, n) {
                var a = e.dateSelected, r = e.first, i = e.sibling, o = e.minDate, s = e.maxDate, l = g(t), d = n ? "Min" : "Max";
                function c() {
                    return "original" + d + "Date";
                }
                function h() {
                    return d.toLowerCase() + "Date";
                }
                function f() {
                    return "set" + d;
                }
                function v() {
                    throw new Error("Out-of-range date passed to " + f());
                }
                if (null == t) e[c()] = void 0, i ? (i[c()] = void 0, n ? (r && !a || !r && !i.dateSelected) && (e.minDate = void 0, i.minDate = void 0) : (r && !i.dateSelected || !r && !a) && (e.maxDate = void 0, i.maxDate = void 0)) : e[h()] = void 0;
                else {
                    if (!b(t)) throw new Error("Invalid date passed to " + f());
                    i ? ((r && n && l > (a || s) || r && !n && l < (i.dateSelected || o) || !r && n && l > (i.dateSelected || s) || !r && !n && l < (a || o)) && v(), e[c()] = l, i[c()] = l, (n && (r && !a || !r && !i.dateSelected) || !n && (r && !i.dateSelected || !r && !a)) && (e[h()] = l, i[h()] = l)) : ((n && l > (a || s) || !n && l < (a || o)) && v(), e[h()] = l);
                }
                return i && u(i), u(e), e;
            }
            function A() {
                var e = this.first ? this : this.sibling, t = e.sibling;
                return {
                    start: e.dateSelected,
                    end: t.dateSelected
                };
            }
            function R() {
                var e = this.shadowDom, t = this.positionedEl, n = this.calendarContainer, r = this.sibling, i = this;
                this.inlinePosition && (a.some(function(e) {
                    return e !== i && e.positionedEl === t;
                }) || t.style.setProperty("position", null));
                n.remove(), a = a.filter(function(e) {
                    return e !== i;
                }), r && delete r.sibling, a.length || j(document, L);
                var o = a.some(function(t) {
                    return t.shadowDom === e;
                });
                for(var s in e && !o && j(e, Y), this)delete this[s];
                a.length || l.forEach(function(e) {
                    document.removeEventListener(e, L);
                });
            }
            function F(e, t) {
                var n = new Date(e);
                if (!b(n)) throw new Error("Invalid date passed to `navigate`");
                this.currentYear = n.getFullYear(), this.currentMonth = n.getMonth(), u(this), t && this.onMonthChange(this);
            }
            function B() {
                var e = !this.calendarContainer.classList.contains("qs-hidden"), t = !this.calendarContainer.querySelector(".qs-overlay").classList.contains("qs-hidden");
                e && M(t, this);
            }
            t.default = function(e, t) {
                var n = function(e, t) {
                    var n, l, d = function(e) {
                        var t = c(e);
                        t.events && (t.events = t.events.reduce(function(e, t) {
                            if (!b(t)) throw new Error('"options.events" must only contain valid JavaScript Date objects.');
                            return e[+g(t)] = !0, e;
                        }, {}));
                        [
                            "startDate",
                            "dateSelected",
                            "minDate",
                            "maxDate"
                        ].forEach(function(e) {
                            var n = t[e];
                            if (n && !b(n)) throw new Error('"options.' + e + '" needs to be a valid JavaScript Date object.');
                            t[e] = g(n);
                        });
                        var n = t.position, i = t.maxDate, l = t.minDate, d = t.dateSelected, u = t.overlayPlaceholder, h = t.overlayButton, f = t.startDay, v = t.id;
                        if (t.startDate = g(t.startDate || d || new Date), t.disabledDates = (t.disabledDates || []).reduce(function(e, t) {
                            var n = +g(t);
                            if (!b(t)) throw new Error('You supplied an invalid date to "options.disabledDates".');
                            if (n === +g(d)) throw new Error('"disabledDates" cannot contain the same date as "dateSelected".');
                            return e[n] = 1, e;
                        }, {}), t.hasOwnProperty("id") && null == v) throw new Error("`id` cannot be `null` or `undefined`");
                        if (null != v) {
                            var m = a.filter(function(e) {
                                return e.id === v;
                            });
                            if (m.length > 1) throw new Error("Only two datepickers can share an id.");
                            m.length ? (t.second = !0, t.sibling = m[0]) : t.first = !0;
                        }
                        var y = [
                            "tr",
                            "tl",
                            "br",
                            "bl",
                            "c"
                        ].some(function(e) {
                            return n === e;
                        });
                        if (n && !y) throw new Error('"options.position" must be one of the following: tl, tr, bl, br, or c.');
                        function p(e) {
                            throw new Error('"dateSelected" in options is ' + (e ? "less" : "greater") + ' than "' + (e || "max") + 'Date".');
                        }
                        if (t.position = function(e) {
                            var t = e[0], n = e[1], a = {};
                            a[o[t]] = 1, n && (a[o[n]] = 1);
                            return a;
                        }(n || "bl"), i < l) throw new Error('"maxDate" in options is less than "minDate".');
                        d && (l > d && p("min"), i < d && p());
                        if ([
                            "onSelect",
                            "onShow",
                            "onHide",
                            "onMonthChange",
                            "formatter",
                            "disabler"
                        ].forEach(function(e) {
                            "function" != typeof t[e] && (t[e] = s);
                        }), [
                            "customDays",
                            "customMonths",
                            "customOverlayMonths"
                        ].forEach(function(e, n) {
                            var a = t[e], r = n ? 12 : 7;
                            if (a) {
                                if (!Array.isArray(a) || a.length !== r || a.some(function(e) {
                                    return "string" != typeof e;
                                })) throw new Error('"' + e + '" must be an array with ' + r + " strings.");
                                t[n ? n < 2 ? "months" : "overlayMonths" : "days"] = a;
                            }
                        }), f && f > 0 && f < 7) {
                            var w = (t.customDays || r).slice(), D = w.splice(0, f);
                            t.customDays = w.concat(D), t.startDay = +f, t.weekendIndices = [
                                w.length - 1,
                                w.length
                            ];
                        } else t.startDay = 0, t.weekendIndices = [
                            6,
                            0
                        ];
                        "string" != typeof u && delete t.overlayPlaceholder;
                        "string" != typeof h && delete t.overlayButton;
                        var q = t.defaultView;
                        if (q && "calendar" !== q && "overlay" !== q) throw new Error('options.defaultView must either be "calendar" or "overlay".');
                        return t.defaultView = q || "calendar", t;
                    }(t || {
                        startDate: g(new Date),
                        position: "bl",
                        defaultView: "calendar"
                    }), u = e;
                    if ("string" == typeof u) u = "#" === u[0] ? document.getElementById(u.slice(1)) : document.querySelector(u);
                    else {
                        if ("[object ShadowRoot]" === x(u)) throw new Error("Using a shadow DOM as your selector is not supported.");
                        for(var h, f = u.parentNode; !h;){
                            var v = x(f);
                            "[object HTMLDocument]" === v ? h = !0 : "[object ShadowRoot]" === v ? (h = !0, n = f, l = f.host) : f = f.parentNode;
                        }
                    }
                    if (!u) throw new Error("No selector / element found.");
                    if (a.some(function(e) {
                        return e.el === u;
                    })) throw new Error("A datepicker already exists on that element.");
                    var m = u === document.body, y = n ? u.parentElement || n : m ? document.body : u.parentElement, w = n ? u.parentElement || l : y, D = document.createElement("div"), q = document.createElement("div");
                    D.className = "qs-datepicker-container qs-hidden", q.className = "qs-datepicker";
                    var M = {
                        shadowDom: n,
                        customElement: l,
                        positionedEl: w,
                        el: u,
                        parent: y,
                        nonInput: "INPUT" !== u.nodeName,
                        noPosition: m,
                        position: !m && d.position,
                        startDate: d.startDate,
                        dateSelected: d.dateSelected,
                        disabledDates: d.disabledDates,
                        minDate: d.minDate,
                        maxDate: d.maxDate,
                        noWeekends: !!d.noWeekends,
                        weekendIndices: d.weekendIndices,
                        calendarContainer: D,
                        calendar: q,
                        currentMonth: (d.startDate || d.dateSelected).getMonth(),
                        currentMonthName: (d.months || i)[(d.startDate || d.dateSelected).getMonth()],
                        currentYear: (d.startDate || d.dateSelected).getFullYear(),
                        events: d.events || {},
                        defaultView: d.defaultView,
                        setDate: k,
                        remove: R,
                        setMin: N,
                        setMax: _,
                        show: O,
                        hide: P,
                        navigate: F,
                        toggleOverlay: B,
                        onSelect: d.onSelect,
                        onShow: d.onShow,
                        onHide: d.onHide,
                        onMonthChange: d.onMonthChange,
                        formatter: d.formatter,
                        disabler: d.disabler,
                        months: d.months || i,
                        days: d.customDays || r,
                        startDay: d.startDay,
                        overlayMonths: d.overlayMonths || (d.months || i).map(function(e) {
                            return e.slice(0, 3);
                        }),
                        overlayPlaceholder: d.overlayPlaceholder || "4-digit year",
                        overlayButton: d.overlayButton || "Submit",
                        disableYearOverlay: !!d.disableYearOverlay,
                        disableMobile: !!d.disableMobile,
                        isMobile: "ontouchstart" in window,
                        alwaysShow: !!d.alwaysShow,
                        id: d.id,
                        showAllDates: !!d.showAllDates,
                        respectDisabledReadOnly: !!d.respectDisabledReadOnly,
                        first: d.first,
                        second: d.second
                    };
                    if (d.sibling) {
                        var E = d.sibling, C = M, L = E.minDate || C.minDate, Y = E.maxDate || C.maxDate;
                        C.sibling = E, E.sibling = C, E.minDate = L, E.maxDate = Y, C.minDate = L, C.maxDate = Y, E.originalMinDate = L, E.originalMaxDate = Y, C.originalMinDate = L, C.originalMaxDate = Y, E.getRange = A, C.getRange = A;
                    }
                    d.dateSelected && p(u, M);
                    var j = getComputedStyle(w).position;
                    m || j && "static" !== j || (M.inlinePosition = !0, w.style.setProperty("position", "relative"));
                    var I = a.filter(function(e) {
                        return e.positionedEl === M.positionedEl;
                    });
                    I.some(function(e) {
                        return e.inlinePosition;
                    }) && (M.inlinePosition = !0, I.forEach(function(e) {
                        e.inlinePosition = !0;
                    }));
                    D.appendChild(q), y.appendChild(D), M.alwaysShow && S(M);
                    return M;
                }(e, t);
                if (a.length || d(document), n.shadowDom && (a.some(function(e) {
                    return e.shadowDom === n.shadowDom;
                }) || d(n.shadowDom)), a.push(n), n.second) {
                    var l = n.sibling;
                    y({
                        instance: n,
                        deselect: !n.dateSelected
                    }), y({
                        instance: l,
                        deselect: !l.dateSelected
                    }), u(l);
                }
                return u(n, n.startDate || n.dateSelected), n.alwaysShow && D(n), n;
            };
        }
    ]).default;
});



var $10cKx = parcelRequire("10cKx");


(0, (/*@__PURE__*/$parcel$interopDefault($10cKx))).fn.extend({
    datefield: function(opts) {
        opts = (0, (/*@__PURE__*/$parcel$interopDefault($10cKx))).extend(opts || {}, {
            formatter: (input, date, instance)=>{
                const value = (0, $d87b809bda78551e$export$2e2bcd8739ae039)(date, "dd/MM/yyyy");
                input.value = value // => '31/1/2099'
                ;
                (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(input).trigger("change");
            },
            format: "dd/mm/yyyy"
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(this).each((index, element)=>{
            // Don't double-init
            if ((0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(element).data("datepicker")) return;
            const picker = (0, (/*@__PURE__*/$parcel$interopDefault($8871f3ea6c7c1795$exports)))(element, opts);
            (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(element).data("datepicker", picker);
            (0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))(element).addClass("datefield");
        });
        return this;
    }
});


console.log("Loading main.ts", (0, (/*@__PURE__*/$parcel$interopDefault($10cKx))));
function $c9c33ea82c0377e3$var$init() {
    // @ts-ignore
    window.wrb_git = window.wrb_git || {
        "version": "dev",
        "branch": "dev",
        "commit": "?"
    };
    console.log("INIT");
    const app = new (0, $16ffe2bba218fe2b$export$86fbec116b87613f)();
    app.render();
}
// @ts-ignore
(0, (/*@__PURE__*/$parcel$interopDefault($10cKx)))($c9c33ea82c0377e3$var$init);
console.log("========================");
console.log("Service worker registration...");
if ("serviceWorker" in navigator) ;
else console.log("Service workers are not supported.");
console.log("========================");

})();
//# sourceMappingURL=main.js.map
